// src/generated/runtime.ts
var BASE_PATH = "https://connect.withvayu.com".replace(/\/+$/, "");
var Configuration = class {
  constructor(configuration = {}) {
    this.configuration = configuration;
  }
  set config(configuration) {
    this.configuration = configuration;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || querystring;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const apiKey = this.configuration.apiKey;
    if (apiKey) {
      return typeof apiKey === "function" ? apiKey : () => apiKey;
    }
    return void 0;
  }
  get accessToken() {
    const accessToken = this.configuration.accessToken;
    if (accessToken) {
      return typeof accessToken === "function" ? accessToken : async () => accessToken;
    }
    return void 0;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
};
var DefaultConfig = new Configuration();
var BaseAPI = class _BaseAPI {
  constructor(configuration = DefaultConfig) {
    this.configuration = configuration;
    this.middleware = configuration.middleware;
  }
  static jsonRegex = new RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i");
  middleware;
  withMiddleware(...middlewares) {
    const next = this.clone();
    next.middleware = next.middleware.concat(...middlewares);
    return next;
  }
  withPreMiddleware(...preMiddlewares) {
    const middlewares = preMiddlewares.map((pre) => ({ pre }));
    return this.withMiddleware(...middlewares);
  }
  withPostMiddleware(...postMiddlewares) {
    const middlewares = postMiddlewares.map((post) => ({ post }));
    return this.withMiddleware(...middlewares);
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    if (!mime) {
      return false;
    }
    return _BaseAPI.jsonRegex.test(mime);
  }
  async request(context, initOverrides) {
    const { url, init } = await this.createFetchParams(context, initOverrides);
    const response = await this.fetchApi(url, init);
    if (response && (response.status >= 200 && response.status < 300 || url.includes("oauth"))) {
      return response;
    }
    const parsedError = await response.json();
    throw new ResponseError(response, parsedError.message);
  }
  async createFetchParams(context, initOverrides) {
    let url = this.configuration.basePath + context.path;
    if (context.query !== void 0 && Object.keys(context.query).length !== 0) {
      url += "?" + this.configuration.queryParamsStringify(context.query);
    }
    const headers = Object.assign({}, this.configuration.headers, context.headers);
    Object.keys(headers).forEach((key) => headers[key] === void 0 ? delete headers[key] : {});
    const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async () => initOverrides;
    const initParams = {
      method: context.method,
      headers,
      body: context.body,
      credentials: this.configuration.credentials
    };
    const overriddenInit = {
      ...initParams,
      ...await initOverrideFn({
        init: initParams,
        context
      })
    };
    let body;
    if (isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || isBlob(overriddenInit.body)) {
      body = overriddenInit.body;
    } else if (this.isJsonMime(headers["Content-Type"])) {
      body = JSON.stringify(overriddenInit.body);
    } else {
      body = overriddenInit.body;
    }
    const init = {
      ...overriddenInit,
      body
    };
    return { url, init };
  }
  fetchApi = async (url, init) => {
    let fetchParams = { url, init };
    for (const middleware of this.middleware) {
      if (middleware.pre) {
        fetchParams = await middleware.pre({
          fetch: this.fetchApi,
          ...fetchParams
        }) || fetchParams;
      }
    }
    let response = void 0;
    try {
      response = await (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
    } catch (e) {
      for (const middleware of this.middleware) {
        if (middleware.onError) {
          response = await middleware.onError({
            fetch: this.fetchApi,
            url: fetchParams.url,
            init: fetchParams.init,
            error: e,
            response: response ? response.clone() : void 0
          }) || response;
        }
      }
      if (response === void 0) {
        if (e instanceof Error) {
          throw new FetchError(e, "No response received from server. The request may have failed or timed out.");
        } else {
          throw e;
        }
      }
    }
    for (const middleware of this.middleware) {
      if (middleware.post) {
        response = await middleware.post({
          fetch: this.fetchApi,
          url: fetchParams.url,
          init: fetchParams.init,
          response: response.clone()
        }) || response;
      }
    }
    return response;
  };
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const constructor = this.constructor;
    const next = new constructor(this.configuration);
    next.middleware = this.middleware.slice();
    return next;
  }
};
function isBlob(value) {
  return typeof Blob !== "undefined" && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}
var ResponseError = class extends Error {
  constructor(response, msg) {
    super(msg);
    this.response = response;
  }
  name = "ResponseError";
};
var FetchError = class extends Error {
  constructor(cause, msg) {
    super(msg);
    this.cause = cause;
  }
  name = "FetchError";
};
var RequiredError = class extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
  }
  name = "RequiredError";
};
function exists(json, key) {
  const value = json[key];
  return value !== null && value !== void 0;
}
function querystring(params, prefix = "") {
  return Object.keys(params).map((key) => querystringSingleKey(key, params[key], prefix)).filter((part) => part.length > 0).join("&");
}
function querystringSingleKey(key, value, keyPrefix = "") {
  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
  if (value instanceof Array) {
    const multiValue = value.map((singleValue) => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
    return `${encodeURIComponent(fullKey)}=${multiValue}`;
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
  return Object.keys(data).reduce(
    (acc, key) => ({ ...acc, [key]: fn(data[key]) }),
    {}
  );
}
var JSONApiResponse = class {
  constructor(raw, transformer = (jsonValue) => jsonValue) {
    this.raw = raw;
    this.transformer = transformer;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
};
var VoidApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  async value() {
    return void 0;
  }
};
var BlobApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  async value() {
    return await this.raw.blob();
  }
};

// src/generated/models/AccountSecuritySettings.ts
function AccountSecuritySettingsFromJSON(json) {
  return AccountSecuritySettingsFromJSONTyped(json, false);
}
function AccountSecuritySettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "apiToken": !exists(json, "apiToken") ? void 0 : json["apiToken"],
    "apiThrottlingKey": !exists(json, "apiThrottlingKey") ? void 0 : json["apiThrottlingKey"]
  };
}
function AccountSecuritySettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "apiToken": value.apiToken,
    "apiThrottlingKey": value.apiThrottlingKey
  };
}

// src/generated/models/AccountSettingsAllOfInvoicingSettings.ts
function AccountSettingsAllOfInvoicingSettingsFromJSON(json) {
  return AccountSettingsAllOfInvoicingSettingsFromJSONTyped(json, false);
}
function AccountSettingsAllOfInvoicingSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "hideZeroAmountLineItems": json["hideZeroAmountLineItems"],
    "showConsumptionBreakdown": json["showConsumptionBreakdown"],
    "forceCommitmentBreakdown": json["forceCommitmentBreakdown"],
    "hidePriceBreakdownInInvoicePdf": !exists(json, "hidePriceBreakdownInInvoicePdf") ? void 0 : json["hidePriceBreakdownInInvoicePdf"],
    "showPaymentWalletInfo": json["showPaymentWalletInfo"],
    "issueOnApproval": json["issueOnApproval"],
    "excludeUsdtWallet": !exists(json, "excludeUsdtWallet") ? void 0 : json["excludeUsdtWallet"],
    "sendInvoiceOnApproval": json["sendInvoiceOnApproval"],
    "defaultPaymentDueDays": !exists(json, "defaultPaymentDueDays") ? void 0 : json["defaultPaymentDueDays"],
    "issueOnEndOfMonth": json["issueOnEndOfMonth"],
    "deductCredits": !exists(json, "deductCredits") ? void 0 : json["deductCredits"],
    "showCustomerPortalLink": !exists(json, "showCustomerPortalLink") ? void 0 : json["showCustomerPortalLink"],
    "showProductVariantOnInvoice": !exists(json, "showProductVariantOnInvoice") ? void 0 : json["showProductVariantOnInvoice"],
    "creditOnPrepaidRevision": !exists(json, "creditOnPrepaidRevision") ? void 0 : json["creditOnPrepaidRevision"],
    "restrictPaymentsToCreditPoolBalance": !exists(json, "restrictPaymentsToCreditPoolBalance") ? void 0 : json["restrictPaymentsToCreditPoolBalance"]
  };
}

// src/generated/models/AccountSettingsAllOfMeteringSettings.ts
function AccountSettingsAllOfMeteringSettingsFromJSON(json) {
  return AccountSettingsAllOfMeteringSettingsFromJSONTyped(json, false);
}
function AccountSettingsAllOfMeteringSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "manualMetering": json["manualMetering"]
  };
}

// src/generated/models/AccountSettingsAllOfProductSettingsTieredSubscription.ts
function AccountSettingsAllOfProductSettingsTieredSubscriptionFromJSON(json) {
  return AccountSettingsAllOfProductSettingsTieredSubscriptionFromJSONTyped(json, false);
}
function AccountSettingsAllOfProductSettingsTieredSubscriptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "payInAdvanceOnTierCross": !exists(json, "payInAdvanceOnTierCross") ? void 0 : json["payInAdvanceOnTierCross"]
  };
}

// src/generated/models/AccountSettingsAllOfProductSettings.ts
function AccountSettingsAllOfProductSettingsFromJSON(json) {
  return AccountSettingsAllOfProductSettingsFromJSONTyped(json, false);
}
function AccountSettingsAllOfProductSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "tieredSubscription": !exists(json, "tieredSubscription") ? void 0 : AccountSettingsAllOfProductSettingsTieredSubscriptionFromJSON(json["tieredSubscription"]),
    "treatLastAsDaily": !exists(json, "treatLastAsDaily") ? void 0 : json["treatLastAsDaily"]
  };
}

// src/generated/models/Address.ts
function AddressFromJSON(json) {
  return AddressFromJSONTyped(json, false);
}
function AddressFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "country": !exists(json, "country") ? void 0 : json["country"],
    "city": !exists(json, "city") ? void 0 : json["city"],
    "addressText": !exists(json, "addressText") ? void 0 : json["addressText"],
    "state": !exists(json, "state") ? void 0 : json["state"],
    "postalCode": !exists(json, "postalCode") ? void 0 : json["postalCode"]
  };
}
function AddressToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "country": value.country,
    "city": value.city,
    "addressText": value.addressText,
    "state": value.state,
    "postalCode": value.postalCode
  };
}

// src/generated/models/BankDetails.ts
function BankDetailsFromJSON(json) {
  return BankDetailsFromJSONTyped(json, false);
}
function BankDetailsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "bankName": !exists(json, "bankName") ? void 0 : json["bankName"],
    "routingNumber": !exists(json, "routingNumber") ? void 0 : json["routingNumber"],
    "companyName": !exists(json, "companyName") ? void 0 : json["companyName"],
    "accountNumber": !exists(json, "accountNumber") ? void 0 : json["accountNumber"],
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "swiftCode": !exists(json, "swiftCode") ? void 0 : json["swiftCode"],
    "abaNumber": !exists(json, "abaNumber") ? void 0 : json["abaNumber"],
    "sortCode": !exists(json, "sortCode") ? void 0 : json["sortCode"]
  };
}

// src/generated/models/Period.ts
function PeriodFromJSON(json) {
  return PeriodFromJSONTyped(json, false);
}
function PeriodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startTime": new Date(json["startTime"]),
    "endTime": new Date(json["endTime"])
  };
}
function PeriodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "startTime": value.startTime.toISOString(),
    "endTime": value.endTime.toISOString()
  };
}

// src/generated/models/BillingSettings.ts
function BillingSettingsFromJSON(json) {
  return BillingSettingsFromJSONTyped(json, false);
}
function BillingSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "billingCycle": !exists(json, "billingCycle") ? void 0 : PeriodFromJSON(json["billingCycle"]),
    "decimalPrecision": !exists(json, "decimalPrecision") ? void 0 : json["decimalPrecision"]
  };
}

// src/generated/models/EmailSettingsBillingEmail.ts
function EmailSettingsBillingEmailFromJSON(json) {
  return EmailSettingsBillingEmailFromJSONTyped(json, false);
}
function EmailSettingsBillingEmailFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function EmailSettingsBillingEmailToJSON(value) {
  return value;
}

// src/generated/models/EmailSettings.ts
function EmailSettingsFromJSON(json) {
  return EmailSettingsFromJSONTyped(json, false);
}
function EmailSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "senderAddressOverride": !exists(json, "senderAddressOverride") ? void 0 : json["senderAddressOverride"],
    "bccEmails": !exists(json, "bccEmails") ? void 0 : json["bccEmails"],
    "billingEmail": !exists(json, "billingEmail") ? void 0 : EmailSettingsBillingEmailFromJSON(json["billingEmail"])
  };
}
function EmailSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "senderAddressOverride": value.senderAddressOverride,
    "bccEmails": value.bccEmails,
    "billingEmail": EmailSettingsBillingEmailToJSON(value.billingEmail)
  };
}

// src/generated/models/AccountSettings.ts
function AccountSettingsFromJSON(json) {
  return AccountSettingsFromJSONTyped(json, false);
}
function AccountSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "billingSettings": !exists(json, "billingSettings") ? void 0 : BillingSettingsFromJSON(json["billingSettings"]),
    "bankDetails": !exists(json, "bankDetails") ? void 0 : BankDetailsFromJSON(json["bankDetails"]),
    "invoicingSettings": !exists(json, "invoicingSettings") ? void 0 : AccountSettingsAllOfInvoicingSettingsFromJSON(json["invoicingSettings"]),
    "emailSettings": !exists(json, "emailSettings") ? void 0 : EmailSettingsFromJSON(json["emailSettings"]),
    "securitySettings": !exists(json, "securitySettings") ? void 0 : AccountSecuritySettingsFromJSON(json["securitySettings"]),
    "taxId": !exists(json, "taxId") ? void 0 : json["taxId"],
    "enabledFeatures": !exists(json, "enabledFeatures") ? void 0 : json["enabledFeatures"],
    "inboundEmailLocalPart": !exists(json, "inboundEmailLocalPart") ? void 0 : json["inboundEmailLocalPart"],
    "inboundEmailAllowedSenders": !exists(json, "inboundEmailAllowedSenders") ? void 0 : json["inboundEmailAllowedSenders"],
    "meteringSettings": !exists(json, "meteringSettings") ? void 0 : AccountSettingsAllOfMeteringSettingsFromJSON(json["meteringSettings"]),
    "productSettings": !exists(json, "productSettings") ? void 0 : AccountSettingsAllOfProductSettingsFromJSON(json["productSettings"]),
    "enabledWorkflowTemplates": !exists(json, "enabledWorkflowTemplates") ? void 0 : json["enabledWorkflowTemplates"],
    "enabledWorkflowActions": !exists(json, "enabledWorkflowActions") ? void 0 : json["enabledWorkflowActions"]
  };
}

// src/generated/models/Contact.ts
function ContactFromJSON(json) {
  return ContactFromJSONTyped(json, false);
}
function ContactFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "title": !exists(json, "title") ? void 0 : json["title"],
    "phone": !exists(json, "phone") ? void 0 : json["phone"],
    "receiveInvoiceEmail": !exists(json, "receiveInvoiceEmail") ? void 0 : json["receiveInvoiceEmail"]
  };
}
function ContactToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "email": value.email,
    "title": value.title,
    "phone": value.phone,
    "receiveInvoiceEmail": value.receiveInvoiceEmail
  };
}

// src/generated/models/Account.ts
function AccountFromJSON(json) {
  return AccountFromJSONTyped(json, false);
}
function AccountFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "logoUrl": !exists(json, "logoUrl") ? void 0 : json["logoUrl"],
    "settings": AccountSettingsFromJSON(json["settings"]),
    "contact": !exists(json, "contact") ? void 0 : ContactFromJSON(json["contact"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/TiersAdvancePaymentConfig.ts
function TiersAdvancePaymentConfigFromJSON(json) {
  return TiersAdvancePaymentConfigFromJSONTyped(json, false);
}
function TiersAdvancePaymentConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "separateLineItems": json["separateLineItems"],
    "payInAdvanceOnTierCross": !exists(json, "payInAdvanceOnTierCross") ? void 0 : json["payInAdvanceOnTierCross"]
  };
}
function TiersAdvancePaymentConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "separateLineItems": value.separateLineItems,
    "payInAdvanceOnTierCross": value.payInAdvanceOnTierCross
  };
}

// src/generated/models/TiersAdvancePayment.ts
function TiersAdvancePaymentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "advancePaymentType": json["advancePaymentType"],
    "advancePaymentConfig": TiersAdvancePaymentConfigFromJSON(json["advancePaymentConfig"])
  };
}
function TiersAdvancePaymentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "advancePaymentType": value.advancePaymentType,
    "advancePaymentConfig": TiersAdvancePaymentConfigToJSON(value.advancePaymentConfig)
  };
}

// src/generated/models/AdvancePayment.ts
function AdvancePaymentFromJSON(json) {
  return AdvancePaymentFromJSONTyped(json, false);
}
function AdvancePaymentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["advancePaymentType"]) {
    case "Tiers":
      return { ...TiersAdvancePaymentFromJSONTyped(json, true), advancePaymentType: "Tiers" };
    default:
      throw new Error(`No variant of AdvancePayment exists with 'advancePaymentType=${json["advancePaymentType"]}'`);
  }
}
function AdvancePaymentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["advancePaymentType"]) {
    case "Tiers":
      return TiersAdvancePaymentToJSON(value);
    default:
      throw new Error(`No variant of AdvancePayment exists with 'advancePaymentType=${value["advancePaymentType"]}'`);
  }
}

// src/generated/models/AdvancedFilter.ts
function AdvancedFilterFromJSON(json) {
  return AdvancedFilterFromJSONTyped(json, false);
}
function AdvancedFilterFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "filterOperator": json["filterOperator"],
    "field": json["field"],
    "value": !exists(json, "value") ? void 0 : json["value"]
  };
}

// src/generated/models/AggregationWithoutFieldMethodSql.ts
function AggregationWithoutFieldMethodSqlFromJSON(json) {
  return AggregationWithoutFieldMethodSqlFromJSONTyped(json, false);
}
function AggregationWithoutFieldMethodSqlFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "selectExpression": json["selectExpression"],
    "whereExpression": !exists(json, "whereExpression") ? void 0 : json["whereExpression"]
  };
}
function AggregationWithoutFieldMethodSqlToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "selectExpression": value.selectExpression,
    "whereExpression": value.whereExpression
  };
}

// src/generated/models/AggregationAverageMethod.ts
function AggregationAverageMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "sql": !exists(json, "sql") ? void 0 : AggregationWithoutFieldMethodSqlFromJSON(json["sql"]),
    "field": json["field"],
    "operator": json["operator"]
  };
}
function AggregationAverageMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "instanceKey": value.instanceKey,
    "sql": AggregationWithoutFieldMethodSqlToJSON(value.sql),
    "field": value.field,
    "operator": value.operator
  };
}

// src/generated/models/AggregationDistinctMethod.ts
function AggregationDistinctMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "sql": !exists(json, "sql") ? void 0 : AggregationWithoutFieldMethodSqlFromJSON(json["sql"]),
    "field": json["field"],
    "operator": json["operator"]
  };
}
function AggregationDistinctMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "instanceKey": value.instanceKey,
    "sql": AggregationWithoutFieldMethodSqlToJSON(value.sql),
    "field": value.field,
    "operator": value.operator
  };
}

// src/generated/models/AggregationFirstMethod.ts
function AggregationFirstMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "sql": !exists(json, "sql") ? void 0 : AggregationWithoutFieldMethodSqlFromJSON(json["sql"]),
    "field": json["field"],
    "operator": json["operator"]
  };
}
function AggregationFirstMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "instanceKey": value.instanceKey,
    "sql": AggregationWithoutFieldMethodSqlToJSON(value.sql),
    "field": value.field,
    "operator": value.operator
  };
}

// src/generated/models/AggregationLastMethod.ts
function AggregationLastMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "sql": !exists(json, "sql") ? void 0 : AggregationWithoutFieldMethodSqlFromJSON(json["sql"]),
    "field": json["field"],
    "operator": json["operator"]
  };
}
function AggregationLastMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "instanceKey": value.instanceKey,
    "sql": AggregationWithoutFieldMethodSqlToJSON(value.sql),
    "field": value.field,
    "operator": value.operator
  };
}

// src/generated/models/AggregationMaxMethod.ts
function AggregationMaxMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "sql": !exists(json, "sql") ? void 0 : AggregationWithoutFieldMethodSqlFromJSON(json["sql"]),
    "field": json["field"],
    "operator": json["operator"]
  };
}
function AggregationMaxMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "instanceKey": value.instanceKey,
    "sql": AggregationWithoutFieldMethodSqlToJSON(value.sql),
    "field": value.field,
    "operator": value.operator
  };
}

// src/generated/models/AggregationMinMethod.ts
function AggregationMinMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "sql": !exists(json, "sql") ? void 0 : AggregationWithoutFieldMethodSqlFromJSON(json["sql"]),
    "field": json["field"],
    "operator": json["operator"]
  };
}
function AggregationMinMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "instanceKey": value.instanceKey,
    "sql": AggregationWithoutFieldMethodSqlToJSON(value.sql),
    "field": value.field,
    "operator": value.operator
  };
}

// src/generated/models/AggregationSumMethod.ts
function AggregationSumMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "sql": !exists(json, "sql") ? void 0 : AggregationWithoutFieldMethodSqlFromJSON(json["sql"]),
    "field": json["field"],
    "operator": json["operator"]
  };
}
function AggregationSumMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "instanceKey": value.instanceKey,
    "sql": AggregationWithoutFieldMethodSqlToJSON(value.sql),
    "field": value.field,
    "operator": value.operator
  };
}

// src/generated/models/AggregationWithoutFieldMethod.ts
function AggregationWithoutFieldMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "sql": !exists(json, "sql") ? void 0 : AggregationWithoutFieldMethodSqlFromJSON(json["sql"]),
    "operator": json["operator"]
  };
}
function AggregationWithoutFieldMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "instanceKey": value.instanceKey,
    "sql": AggregationWithoutFieldMethodSqlToJSON(value.sql),
    "operator": value.operator
  };
}

// src/generated/models/AggregationMethod.ts
function AggregationMethodFromJSON(json) {
  return AggregationMethodFromJSONTyped(json, false);
}
function AggregationMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["operator"]) {
    case "Average":
      return { ...AggregationAverageMethodFromJSONTyped(json, true), operator: "Average" };
    case "Count":
      return { ...AggregationWithoutFieldMethodFromJSONTyped(json, true), operator: "Count" };
    case "Distinct":
      return { ...AggregationDistinctMethodFromJSONTyped(json, true), operator: "Distinct" };
    case "First":
      return { ...AggregationFirstMethodFromJSONTyped(json, true), operator: "First" };
    case "Last":
      return { ...AggregationLastMethodFromJSONTyped(json, true), operator: "Last" };
    case "Max":
      return { ...AggregationMaxMethodFromJSONTyped(json, true), operator: "Max" };
    case "Min":
      return { ...AggregationMinMethodFromJSONTyped(json, true), operator: "Min" };
    case "Sum":
      return { ...AggregationSumMethodFromJSONTyped(json, true), operator: "Sum" };
    default:
      throw new Error(`No variant of AggregationMethod exists with 'operator=${json["operator"]}'`);
  }
}
function AggregationMethodToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["operator"]) {
    case "Average":
      return AggregationAverageMethodToJSON(value);
    case "Count":
      return AggregationWithoutFieldMethodToJSON(value);
    case "Distinct":
      return AggregationDistinctMethodToJSON(value);
    case "First":
      return AggregationFirstMethodToJSON(value);
    case "Last":
      return AggregationLastMethodToJSON(value);
    case "Max":
      return AggregationMaxMethodToJSON(value);
    case "Min":
      return AggregationMinMethodToJSON(value);
    case "Sum":
      return AggregationSumMethodToJSON(value);
    default:
      throw new Error(`No variant of AggregationMethod exists with 'operator=${value["operator"]}'`);
  }
}

// src/generated/models/NotificationEntity.ts
function NotificationEntityFromJSON(json) {
  return NotificationEntityFromJSONTyped(json, false);
}
function NotificationEntityFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/AnonymousCustomerNotificationEntity.ts
function AnonymousCustomerNotificationEntityFromJSON(json) {
  return AnonymousCustomerNotificationEntityFromJSONTyped(json, false);
}
function AnonymousCustomerNotificationEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "entityId": json["entityId"],
    "type": NotificationEntityFromJSON(json["type"])
  };
}

// src/generated/models/AnonymousNotificationMetadata.ts
function AnonymousNotificationMetadataFromJSON(json) {
  return AnonymousNotificationMetadataFromJSONTyped(json, false);
}
function AnonymousNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerName": json["customerName"],
    "date": new Date(json["date"])
  };
}

// src/generated/models/AnonymousCustomerNotification.ts
function AnonymousCustomerNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": AnonymousNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/AnrokBackfillTransactionsRequest.ts
function AnrokBackfillTransactionsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "scope": value.scope
  };
}

// src/generated/models/AnrokConnectRequest.ts
function AnrokConnectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "apiKey": value.apiKey,
    "defaultExternalProductId": value.defaultExternalProductId
  };
}

// src/generated/models/AnrokIntegrationSettingsSchemaIntegrationConfigurationAuthConfig.ts
function AnrokIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json) {
  return AnrokIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, false);
}
function AnrokIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "apiKey": json["apiKey"]
  };
}

// src/generated/models/AnrokIntegrationSettingsSchemaIntegrationConfigurationGeneralConfig.ts
function AnrokIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json) {
  return AnrokIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, false);
}
function AnrokIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "defaultExternalProductId": json["defaultExternalProductId"],
    "defaultTaxMethod": !exists(json, "defaultTaxMethod") ? void 0 : json["defaultTaxMethod"]
  };
}

// src/generated/models/AnrokIntegrationSettingsSchemaIntegrationConfiguration.ts
function AnrokIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json) {
  return AnrokIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, false);
}
function AnrokIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "generalConfig": AnrokIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json["generalConfig"]),
    "authConfig": AnrokIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json["authConfig"]),
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/AnrokIntegrationSettingsSchema.ts
function AnrokIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": AnrokIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/ApplyCreditsRequest.ts
function ApplyCreditsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceId": value.invoiceId,
    "creditAmount": value.creditAmount
  };
}

// src/generated/models/AssignPaymentToInvoiceRequest.ts
function AssignPaymentToInvoiceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceId": value.invoiceId
  };
}

// src/generated/models/AssignPaymentToInvoiceResponse.ts
function AssignPaymentToInvoiceResponseFromJSON(json) {
  return AssignPaymentToInvoiceResponseFromJSONTyped(json, false);
}
function AssignPaymentToInvoiceResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "paymentId": json["paymentId"]
  };
}

// src/generated/models/CustomerRevenueBreakdown.ts
function CustomerRevenueBreakdownFromJSON(json) {
  return CustomerRevenueBreakdownFromJSONTyped(json, false);
}
function CustomerRevenueBreakdownFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": json["total"],
    "subtotal": json["subtotal"],
    "overage": json["overage"],
    "discount": json["discount"],
    "creditsUsed": json["creditsUsed"],
    "tax": json["tax"]
  };
}
function CustomerRevenueBreakdownToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "total": value.total,
    "subtotal": value.subtotal,
    "overage": value.overage,
    "discount": value.discount,
    "creditsUsed": value.creditsUsed,
    "tax": value.tax
  };
}

// src/generated/models/OriginalInvoiceData.ts
function OriginalInvoiceDataFromJSON(json) {
  return OriginalInvoiceDataFromJSONTyped(json, false);
}
function OriginalInvoiceDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "customerId": json["customerId"]
  };
}
function OriginalInvoiceDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "customerId": value.customerId
  };
}

// src/generated/models/SaleTax.ts
function SaleTaxFromJSON(json) {
  return SaleTaxFromJSONTyped(json, false);
}
function SaleTaxFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "finalSaleTax": !exists(json, "finalSaleTax") ? void 0 : json["finalSaleTax"],
    "modifiedSaleTax": !exists(json, "modifiedSaleTax") ? void 0 : json["modifiedSaleTax"],
    "autoSaleTax": !exists(json, "autoSaleTax") ? void 0 : json["autoSaleTax"],
    "autoSaleTaxProvider": !exists(json, "autoSaleTaxProvider") ? void 0 : json["autoSaleTaxProvider"]
  };
}
function SaleTaxToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "finalSaleTax": value.finalSaleTax,
    "modifiedSaleTax": value.modifiedSaleTax,
    "autoSaleTax": value.autoSaleTax,
    "autoSaleTaxProvider": value.autoSaleTaxProvider
  };
}

// src/generated/models/BillingInterval.ts
function BillingIntervalFromJSON(json) {
  return BillingIntervalFromJSONTyped(json, false);
}
function BillingIntervalFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function BillingIntervalToJSON(value) {
  return value;
}

// src/generated/models/CreditPurchaseConfig.ts
function CreditPurchaseConfigFromJSON(json) {
  return CreditPurchaseConfigFromJSONTyped(json, false);
}
function CreditPurchaseConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditTypeId": json["creditTypeId"],
    "name": json["name"],
    "creditKind": json["creditKind"],
    "amount": json["amount"],
    "schedule": json["schedule"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "expiryDate": !exists(json, "expiryDate") ? void 0 : json["expiryDate"] === null ? null : new Date(json["expiryDate"]),
    "expirationPolicy": !exists(json, "expirationPolicy") ? void 0 : json["expirationPolicy"]
  };
}
function CreditPurchaseConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "creditTypeId": value.creditTypeId,
    "name": value.name,
    "creditKind": value.creditKind,
    "amount": value.amount,
    "schedule": value.schedule,
    "price": value.price,
    "expiryDate": value.expiryDate === void 0 ? void 0 : value.expiryDate === null ? null : value.expiryDate.toISOString(),
    "expirationPolicy": value.expirationPolicy
  };
}

// src/generated/models/CommitmentType.ts
function CommitmentTypeFromJSON(json) {
  return CommitmentTypeFromJSONTyped(json, false);
}
function CommitmentTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CommitmentTypeToJSON(value) {
  return value;
}

// src/generated/models/LineItemProductCommitment.ts
function LineItemProductCommitmentFromJSON(json) {
  return LineItemProductCommitmentFromJSONTyped(json, false);
}
function LineItemProductCommitmentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "consumption": json["consumption"],
    "amount": json["amount"],
    "type": CommitmentTypeFromJSON(json["type"]),
    "replenishmentInterval": !exists(json, "replenishmentInterval") ? void 0 : json["replenishmentInterval"]
  };
}
function LineItemProductCommitmentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "consumption": value.consumption,
    "amount": value.amount,
    "type": CommitmentTypeToJSON(value.type),
    "replenishmentInterval": value.replenishmentInterval
  };
}

// src/generated/models/CriterionOperator.ts
function CriterionOperatorFromJSON(json) {
  return CriterionOperatorFromJSONTyped(json, false);
}
function CriterionOperatorFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CriterionOperatorToJSON(value) {
  return value;
}

// src/generated/models/Criterion.ts
function CriterionFromJSON(json) {
  return CriterionFromJSONTyped(json, false);
}
function CriterionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "field": json["field"],
    "operator": CriterionOperatorFromJSON(json["operator"]),
    "value": json["value"]
  };
}
function CriterionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "field": value.field,
    "operator": CriterionOperatorToJSON(value.operator),
    "value": value.value
  };
}

// src/generated/models/Condition.ts
function ConditionFromJSON(json) {
  return ConditionFromJSONTyped(json, false);
}
function ConditionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "criterions": json["criterions"].map(CriterionFromJSON)
  };
}
function ConditionToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "criterions": value.criterions.map(CriterionToJSON)
  };
}

// src/generated/models/Filter.ts
function FilterFromJSON(json) {
  return FilterFromJSONTyped(json, false);
}
function FilterFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "conditions": json["conditions"].map(ConditionFromJSON)
  };
}
function FilterToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "conditions": value.conditions.map(ConditionToJSON)
  };
}

// src/generated/models/NewLineItemProductVariantMeter.ts
function NewLineItemProductVariantMeterFromJSON(json) {
  return NewLineItemProductVariantMeterFromJSONTyped(json, false);
}
function NewLineItemProductVariantMeterFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "meterId": json["meterId"],
    "name": json["name"],
    "eventName": json["eventName"],
    "filter": !exists(json, "filter") ? void 0 : FilterFromJSON(json["filter"]),
    "aggregationMethod": AggregationMethodFromJSON(json["aggregationMethod"]),
    "unitsType": !exists(json, "unitsType") ? void 0 : json["unitsType"]
  };
}
function NewLineItemProductVariantMeterToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "meterId": value.meterId,
    "name": value.name,
    "eventName": value.eventName,
    "filter": FilterToJSON(value.filter),
    "aggregationMethod": AggregationMethodToJSON(value.aggregationMethod),
    "unitsType": value.unitsType
  };
}

// src/generated/models/NewScheduledInstallment.ts
function NewScheduledInstallmentFromJSON(json) {
  return NewScheduledInstallmentFromJSONTyped(json, false);
}
function NewScheduledInstallmentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "scheduledDateStr": json["scheduledDateStr"],
    "amount": json["amount"]
  };
}
function NewScheduledInstallmentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "scheduledDateStr": value.scheduledDateStr,
    "amount": value.amount
  };
}

// src/generated/models/ScheduledInstallmentConfiguration.ts
function ScheduledInstallmentConfigurationFromJSON(json) {
  return ScheduledInstallmentConfigurationFromJSONTyped(json, false);
}
function ScheduledInstallmentConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "totalAmount": json["totalAmount"],
    "installments": json["installments"].map(NewScheduledInstallmentFromJSON)
  };
}
function ScheduledInstallmentConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "totalAmount": value.totalAmount,
    "installments": value.installments.map(NewScheduledInstallmentToJSON)
  };
}

// src/generated/models/TieredSubscriptionPricingConfigurationDiscountConfigurationType.ts
function TieredSubscriptionPricingConfigurationDiscountConfigurationTypeFromJSON(json) {
  return TieredSubscriptionPricingConfigurationDiscountConfigurationTypeFromJSONTyped(json, false);
}
function TieredSubscriptionPricingConfigurationDiscountConfigurationTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function TieredSubscriptionPricingConfigurationDiscountConfigurationTypeToJSON(value) {
  return value;
}

// src/generated/models/TieredSubscriptionPricingConfigurationDiscountConfiguration.ts
function TieredSubscriptionPricingConfigurationDiscountConfigurationFromJSON(json) {
  return TieredSubscriptionPricingConfigurationDiscountConfigurationFromJSONTyped(json, false);
}
function TieredSubscriptionPricingConfigurationDiscountConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "type": TieredSubscriptionPricingConfigurationDiscountConfigurationTypeFromJSON(json["type"]),
    "amountToDeduct": json["amountToDeduct"],
    "recurring": !exists(json, "recurring") ? void 0 : json["recurring"]
  };
}
function TieredSubscriptionPricingConfigurationDiscountConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "type": TieredSubscriptionPricingConfigurationDiscountConfigurationTypeToJSON(value.type),
    "amountToDeduct": value.amountToDeduct,
    "recurring": value.recurring
  };
}

// src/generated/models/CommercialTermsPricingConfiguration.ts
function CommercialTermsPricingConfigurationFromJSON(json) {
  return CommercialTermsPricingConfigurationFromJSONTyped(json, false);
}
function CommercialTermsPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "price": json["price"],
    "shouldCreateSeparateInvoice": json["shouldCreateSeparateInvoice"],
    "shouldSplitAmount": json["shouldSplitAmount"],
    "discountConfiguration": !exists(json, "discountConfiguration") ? void 0 : TieredSubscriptionPricingConfigurationDiscountConfigurationFromJSON(json["discountConfiguration"]),
    "installments": !exists(json, "installments") ? void 0 : json["installments"],
    "scheduledInstallments": !exists(json, "scheduledInstallments") ? void 0 : ScheduledInstallmentConfigurationFromJSON(json["scheduledInstallments"])
  };
}
function CommercialTermsPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "shouldCreateSeparateInvoice": value.shouldCreateSeparateInvoice,
    "shouldSplitAmount": value.shouldSplitAmount,
    "discountConfiguration": TieredSubscriptionPricingConfigurationDiscountConfigurationToJSON(value.discountConfiguration),
    "installments": value.installments,
    "scheduledInstallments": ScheduledInstallmentConfigurationToJSON(value.scheduledInstallments)
  };
}

// src/generated/models/CommercialTermsPricing.ts
function CommercialTermsPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": CommercialTermsPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function CommercialTermsPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": CommercialTermsPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/CommissionPricingConfiguration.ts
function CommissionPricingConfigurationFromJSON(json) {
  return CommissionPricingConfigurationFromJSONTyped(json, false);
}
function CommissionPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "percentage": json["percentage"]
  };
}
function CommissionPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "percentage": value.percentage
  };
}

// src/generated/models/CommissionPricing.ts
function CommissionPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": CommissionPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function CommissionPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": CommissionPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/FixedDeductionPricingConfiguration.ts
function FixedDeductionPricingConfigurationFromJSON(json) {
  return FixedDeductionPricingConfigurationFromJSONTyped(json, false);
}
function FixedDeductionPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "amountToDeduct": json["amountToDeduct"],
    "installments": !exists(json, "installments") ? void 0 : json["installments"]
  };
}
function FixedDeductionPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "amountToDeduct": value.amountToDeduct,
    "installments": value.installments
  };
}

// src/generated/models/FixedDeductionPricing.ts
function FixedDeductionPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": FixedDeductionPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function FixedDeductionPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": FixedDeductionPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/OneTimePricingConfiguration.ts
function OneTimePricingConfigurationFromJSON(json) {
  return OneTimePricingConfigurationFromJSONTyped(json, false);
}
function OneTimePricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "price": json["price"],
    "shouldCreateSeparateInvoice": json["shouldCreateSeparateInvoice"],
    "discountConfiguration": !exists(json, "discountConfiguration") ? void 0 : TieredSubscriptionPricingConfigurationDiscountConfigurationFromJSON(json["discountConfiguration"])
  };
}
function OneTimePricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "shouldCreateSeparateInvoice": value.shouldCreateSeparateInvoice,
    "discountConfiguration": TieredSubscriptionPricingConfigurationDiscountConfigurationToJSON(value.discountConfiguration)
  };
}

// src/generated/models/OneTimePricing.ts
function OneTimePricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": OneTimePricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function OneTimePricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": OneTimePricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/PerUnitPricingConfiguration.ts
function PerUnitPricingConfigurationFromJSON(json) {
  return PerUnitPricingConfigurationFromJSONTyped(json, false);
}
function PerUnitPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "price": json["price"],
    "chunkSize": !exists(json, "chunkSize") ? void 0 : json["chunkSize"],
    "isMeteredCredit": !exists(json, "isMeteredCredit") ? void 0 : json["isMeteredCredit"]
  };
}
function PerUnitPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "chunkSize": value.chunkSize,
    "isMeteredCredit": value.isMeteredCredit
  };
}

// src/generated/models/PerUnitPricing.ts
function PerUnitPricingFromJSON(json) {
  return PerUnitPricingFromJSONTyped(json, false);
}
function PerUnitPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": PerUnitPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function PerUnitPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": PerUnitPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/PercentageDeductionPricingConfiguration.ts
function PercentageDeductionPricingConfigurationFromJSON(json) {
  return PercentageDeductionPricingConfigurationFromJSONTyped(json, false);
}
function PercentageDeductionPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "percentageToDeduct": json["percentageToDeduct"],
    "installments": !exists(json, "installments") ? void 0 : json["installments"]
  };
}
function PercentageDeductionPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "percentageToDeduct": value.percentageToDeduct,
    "installments": value.installments
  };
}

// src/generated/models/PercentageDeductionPricing.ts
function PercentageDeductionPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": PercentageDeductionPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function PercentageDeductionPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": PercentageDeductionPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/RecurringPricingConfiguration.ts
function RecurringPricingConfigurationFromJSON(json) {
  return RecurringPricingConfigurationFromJSONTyped(json, false);
}
function RecurringPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "price": json["price"],
    "upfrontPay": json["upfrontPay"],
    "shouldCreateSeparateInvoice": json["shouldCreateSeparateInvoice"],
    "installments": !exists(json, "installments") ? void 0 : json["installments"],
    "seats": !exists(json, "seats") ? void 0 : json["seats"],
    "discountConfiguration": !exists(json, "discountConfiguration") ? void 0 : TieredSubscriptionPricingConfigurationDiscountConfigurationFromJSON(json["discountConfiguration"])
  };
}
function RecurringPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "upfrontPay": value.upfrontPay,
    "shouldCreateSeparateInvoice": value.shouldCreateSeparateInvoice,
    "installments": value.installments,
    "seats": value.seats,
    "discountConfiguration": TieredSubscriptionPricingConfigurationDiscountConfigurationToJSON(value.discountConfiguration)
  };
}

// src/generated/models/RecurringPricing.ts
function RecurringPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": RecurringPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function RecurringPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": RecurringPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/RefundPricingConfiguration.ts
function RefundPricingConfigurationFromJSON(json) {
  return RefundPricingConfigurationFromJSONTyped(json, false);
}
function RefundPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "price": json["price"],
    "shouldCreateSeparateInvoice": json["shouldCreateSeparateInvoice"]
  };
}
function RefundPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "shouldCreateSeparateInvoice": value.shouldCreateSeparateInvoice
  };
}

// src/generated/models/RefundPricing.ts
function RefundPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": RefundPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function RefundPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": RefundPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/PriceTier.ts
function PriceTierFromJSON(json) {
  return PriceTierFromJSONTyped(json, false);
}
function PriceTierFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "from": json["from"],
    "to": json["to"],
    "price": json["price"],
    "flatRate": !exists(json, "flatRate") ? void 0 : json["flatRate"],
    "chunkSize": !exists(json, "chunkSize") ? void 0 : json["chunkSize"]
  };
}
function PriceTierToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "from": value.from,
    "to": value.to,
    "price": value.price,
    "flatRate": value.flatRate,
    "chunkSize": value.chunkSize
  };
}

// src/generated/models/TieredSubscriptionPricingConfiguration.ts
function TieredSubscriptionPricingConfigurationFromJSON(json) {
  return TieredSubscriptionPricingConfigurationFromJSONTyped(json, false);
}
function TieredSubscriptionPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "tiers": json["tiers"].map(PriceTierFromJSON),
    "isVolume": json["isVolume"],
    "maxUnits": !exists(json, "maxUnits") ? void 0 : json["maxUnits"],
    "useInfinity": !exists(json, "useInfinity") ? void 0 : json["useInfinity"],
    "tierLock": !exists(json, "tierLock") ? void 0 : json["tierLock"],
    "discountConfiguration": !exists(json, "discountConfiguration") ? void 0 : TieredSubscriptionPricingConfigurationDiscountConfigurationFromJSON(json["discountConfiguration"])
  };
}
function TieredSubscriptionPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "tiers": value.tiers.map(PriceTierToJSON),
    "isVolume": value.isVolume,
    "maxUnits": value.maxUnits,
    "useInfinity": value.useInfinity,
    "tierLock": value.tierLock,
    "discountConfiguration": TieredSubscriptionPricingConfigurationDiscountConfigurationToJSON(value.discountConfiguration)
  };
}

// src/generated/models/TieredSubscriptionPricing.ts
function TieredSubscriptionPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": TieredSubscriptionPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function TieredSubscriptionPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": TieredSubscriptionPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/TiersPricingConfiguration.ts
function TiersPricingConfigurationFromJSON(json) {
  return TiersPricingConfigurationFromJSONTyped(json, false);
}
function TiersPricingConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "tiers": json["tiers"].map(PriceTierFromJSON),
    "isVolume": !exists(json, "isVolume") ? void 0 : json["isVolume"],
    "isFlatRate": !exists(json, "isFlatRate") ? void 0 : json["isFlatRate"],
    "isChunked": !exists(json, "isChunked") ? void 0 : json["isChunked"],
    "isRevShare": !exists(json, "isRevShare") ? void 0 : json["isRevShare"],
    "useInfinity": !exists(json, "useInfinity") ? void 0 : json["useInfinity"],
    "tierLock": !exists(json, "tierLock") ? void 0 : json["tierLock"]
  };
}
function TiersPricingConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "tiers": value.tiers.map(PriceTierToJSON),
    "isVolume": value.isVolume,
    "isFlatRate": value.isFlatRate,
    "isChunked": value.isChunked,
    "isRevShare": value.isRevShare,
    "useInfinity": value.useInfinity,
    "tierLock": value.tierLock
  };
}

// src/generated/models/TiersPricing.ts
function TiersPricingFromJSON(json) {
  return TiersPricingFromJSONTyped(json, false);
}
function TiersPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingModel": json["pricingModel"],
    "priceConfiguration": TiersPricingConfigurationFromJSON(json["priceConfiguration"])
  };
}
function TiersPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": TiersPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/Pricing.ts
function PricingFromJSON(json) {
  return PricingFromJSONTyped(json, false);
}
function PricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["pricingModel"]) {
    case "CommercialTerms":
      return { ...CommercialTermsPricingFromJSONTyped(json, true), pricingModel: "CommercialTerms" };
    case "Commission":
      return { ...CommissionPricingFromJSONTyped(json, true), pricingModel: "Commission" };
    case "FixedDeduction":
      return { ...FixedDeductionPricingFromJSONTyped(json, true), pricingModel: "FixedDeduction" };
    case "FixedOneTime":
      return { ...OneTimePricingFromJSONTyped(json, true), pricingModel: "FixedOneTime" };
    case "PerUnit":
      return { ...PerUnitPricingFromJSONTyped(json, true), pricingModel: "PerUnit" };
    case "PercentageDeduction":
      return { ...PercentageDeductionPricingFromJSONTyped(json, true), pricingModel: "PercentageDeduction" };
    case "Refund":
      return { ...RefundPricingFromJSONTyped(json, true), pricingModel: "Refund" };
    case "Subscription":
      return { ...RecurringPricingFromJSONTyped(json, true), pricingModel: "Subscription" };
    case "TieredSubscription":
      return { ...TieredSubscriptionPricingFromJSONTyped(json, true), pricingModel: "TieredSubscription" };
    case "Tiers":
      return { ...TiersPricingFromJSONTyped(json, true), pricingModel: "Tiers" };
    default:
      throw new Error(`No variant of Pricing exists with 'pricingModel=${json["pricingModel"]}'`);
  }
}
function PricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["pricingModel"]) {
    case "CommercialTerms":
      return CommercialTermsPricingToJSON(value);
    case "Commission":
      return CommissionPricingToJSON(value);
    case "FixedDeduction":
      return FixedDeductionPricingToJSON(value);
    case "FixedOneTime":
      return OneTimePricingToJSON(value);
    case "PerUnit":
      return PerUnitPricingToJSON(value);
    case "PercentageDeduction":
      return PercentageDeductionPricingToJSON(value);
    case "Refund":
      return RefundPricingToJSON(value);
    case "Subscription":
      return RecurringPricingToJSON(value);
    case "TieredSubscription":
      return TieredSubscriptionPricingToJSON(value);
    case "Tiers":
      return TiersPricingToJSON(value);
    default:
      throw new Error(`No variant of Pricing exists with 'pricingModel=${value["pricingModel"]}'`);
  }
}

// src/generated/models/CreditProductConfiguration.ts
function CreditProductConfigurationFromJSON(json) {
  return CreditProductConfigurationFromJSONTyped(json, false);
}
function CreditProductConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "shouldCreateSeparateInvoice": json["shouldCreateSeparateInvoice"]
  };
}
function CreditProductConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "shouldCreateSeparateInvoice": value.shouldCreateSeparateInvoice
  };
}

// src/generated/models/CreditProductSettings.ts
function CreditProductSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productType": json["productType"],
    "productConfiguration": CreditProductConfigurationFromJSON(json["productConfiguration"])
  };
}
function CreditProductSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productType": value.productType,
    "productConfiguration": CreditProductConfigurationToJSON(value.productConfiguration)
  };
}

// src/generated/models/ServiceProductSettings.ts
function ServiceProductSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productType": json["productType"],
    "productConfiguration": json["productConfiguration"]
  };
}
function ServiceProductSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productType": value.productType,
    "productConfiguration": value.productConfiguration
  };
}

// src/generated/models/ProductSettings.ts
function ProductSettingsFromJSON(json) {
  return ProductSettingsFromJSONTyped(json, false);
}
function ProductSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["productType"]) {
    case "Credit":
      return { ...CreditProductSettingsFromJSONTyped(json, true), productType: "Credit" };
    case "Service":
      return { ...ServiceProductSettingsFromJSONTyped(json, true), productType: "Service" };
    default:
      throw new Error(`No variant of ProductSettings exists with 'productType=${json["productType"]}'`);
  }
}
function ProductSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["productType"]) {
    case "Credit":
      return CreditProductSettingsToJSON(value);
    case "Service":
      return ServiceProductSettingsToJSON(value);
    default:
      throw new Error(`No variant of ProductSettings exists with 'productType=${value["productType"]}'`);
  }
}

// src/generated/models/LineItemProductVariant.ts
function LineItemProductVariantFromJSON(json) {
  return LineItemProductVariantFromJSONTyped(json, false);
}
function LineItemProductVariantFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productVariantId": !exists(json, "productVariantId") ? void 0 : json["productVariantId"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "pricing": PricingFromJSON(json["pricing"]),
    "periodLimit": !exists(json, "periodLimit") ? void 0 : PeriodFromJSON(json["periodLimit"]),
    "settings": !exists(json, "settings") ? void 0 : ProductSettingsFromJSON(json["settings"]),
    "meter": !exists(json, "meter") ? void 0 : NewLineItemProductVariantMeterFromJSON(json["meter"])
  };
}
function LineItemProductVariantToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productVariantId": value.productVariantId,
    "name": value.name,
    "description": value.description,
    "pricing": PricingToJSON(value.pricing),
    "periodLimit": PeriodToJSON(value.periodLimit),
    "settings": ProductSettingsToJSON(value.settings),
    "meter": NewLineItemProductVariantMeterToJSON(value.meter)
  };
}

// src/generated/models/PaymentTerm.ts
function PaymentTermFromJSON(json) {
  return PaymentTermFromJSONTyped(json, false);
}
function PaymentTermFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function PaymentTermToJSON(value) {
  return value;
}

// src/generated/models/ProductCloudProviderSettings.ts
function ProductCloudProviderSettingsFromJSON(json) {
  return ProductCloudProviderSettingsFromJSONTyped(json, false);
}
function ProductCloudProviderSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cloudProvider": !exists(json, "cloudProvider") ? void 0 : json["cloudProvider"],
    "cloudProviderMarketplaceId": !exists(json, "cloudProviderMarketplaceId") ? void 0 : json["cloudProviderMarketplaceId"],
    "dimension": !exists(json, "dimension") ? void 0 : json["dimension"]
  };
}
function ProductCloudProviderSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cloudProvider": value.cloudProvider,
    "cloudProviderMarketplaceId": value.cloudProviderMarketplaceId,
    "dimension": value.dimension
  };
}

// src/generated/models/IntegrationProviders.ts
function IntegrationProvidersFromJSON(json) {
  return IntegrationProvidersFromJSONTyped(json, false);
}
function IntegrationProvidersFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function IntegrationProvidersToJSON(value) {
  return value;
}

// src/generated/models/ProductExternalIntegration.ts
function ProductExternalIntegrationFromJSON(json) {
  return ProductExternalIntegrationFromJSONTyped(json, false);
}
function ProductExternalIntegrationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": IntegrationProvidersFromJSON(json["type"]),
    "id": json["id"],
    "code": !exists(json, "code") ? void 0 : json["code"]
  };
}
function ProductExternalIntegrationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": IntegrationProvidersToJSON(value.type),
    "id": value.id,
    "code": value.code
  };
}

// src/generated/models/ProductAnrokEntityAllOfMetadata.ts
function ProductAnrokEntityAllOfMetadataFromJSON(json) {
  return ProductAnrokEntityAllOfMetadataFromJSONTyped(json, false);
}
function ProductAnrokEntityAllOfMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["productId"]
  };
}
function ProductAnrokEntityAllOfMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productId": value.productId
  };
}

// src/generated/models/SyncStatus.ts
function SyncStatusFromJSON(json) {
  return SyncStatusFromJSONTyped(json, false);
}
function SyncStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function SyncStatusToJSON(value) {
  return value;
}

// src/generated/models/ProductAnrokEntity.ts
function ProductAnrokEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : ProductAnrokEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ProductAnrokEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": ProductAnrokEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/HubspotProductProperties.ts
function HubspotProductPropertiesFromJSON(json) {
  return HubspotProductPropertiesFromJSONTyped(json, false);
}
function HubspotProductPropertiesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "createdate": !exists(json, "createdate") ? void 0 : json["createdate"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "hsLastmodifieddate": !exists(json, "hs_lastmodifieddate") ? void 0 : json["hs_lastmodifieddate"],
    "hsObjectId": !exists(json, "hs_object_id") ? void 0 : json["hs_object_id"],
    "name": json["name"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "hsSku": !exists(json, "hs_sku") ? void 0 : json["hs_sku"],
    "hsRecurringBillingPeriod": !exists(json, "hs_recurring_billing_period") ? void 0 : json["hs_recurring_billing_period"],
    "hsCostOfGoodsSold": !exists(json, "hs_cost_of_goods_sold") ? void 0 : json["hs_cost_of_goods_sold"],
    "hsProductType": !exists(json, "hs_product_type") ? void 0 : json["hs_product_type"],
    "hsRecurringBillingFrequency": !exists(json, "hs_recurring_billing_frequency") ? void 0 : json["hs_recurring_billing_frequency"],
    "hsFolderId": !exists(json, "hs_folder_id") ? void 0 : json["hs_folder_id"]
  };
}
function HubspotProductPropertiesToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "createdate": value.createdate,
    "description": value.description,
    "hs_lastmodifieddate": value.hsLastmodifieddate,
    "hs_object_id": value.hsObjectId,
    "name": value.name,
    "price": value.price,
    "hs_sku": value.hsSku,
    "hs_recurring_billing_period": value.hsRecurringBillingPeriod,
    "hs_cost_of_goods_sold": value.hsCostOfGoodsSold,
    "hs_product_type": value.hsProductType,
    "hs_recurring_billing_frequency": value.hsRecurringBillingFrequency,
    "hs_folder_id": value.hsFolderId
  };
}

// src/generated/models/HubspotProduct.ts
function HubspotProductFromJSON(json) {
  return HubspotProductFromJSONTyped(json, false);
}
function HubspotProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "properties": HubspotProductPropertiesFromJSON(json["properties"]),
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "archived": json["archived"],
    "archivedAt": !exists(json, "archivedAt") ? void 0 : json["archivedAt"]
  };
}
function HubspotProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "properties": HubspotProductPropertiesToJSON(value.properties),
    "createdAt": value.createdAt,
    "updatedAt": value.updatedAt,
    "archived": value.archived,
    "archivedAt": value.archivedAt
  };
}

// src/generated/models/ProductHubspotEntity.ts
function ProductHubspotEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": HubspotProductFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ProductHubspotEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": HubspotProductToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/ProductNetSuiteEntityAllOfMetadataClassMetadata.ts
function ProductNetSuiteEntityAllOfMetadataClassMetadataFromJSON(json) {
  return ProductNetSuiteEntityAllOfMetadataClassMetadataFromJSONTyped(json, false);
}
function ProductNetSuiteEntityAllOfMetadataClassMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"]
  };
}
function ProductNetSuiteEntityAllOfMetadataClassMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name
  };
}

// src/generated/models/ProductNetSuiteEntityAllOfMetadata.ts
function ProductNetSuiteEntityAllOfMetadataFromJSON(json) {
  return ProductNetSuiteEntityAllOfMetadataFromJSONTyped(json, false);
}
function ProductNetSuiteEntityAllOfMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "displayId": !exists(json, "displayId") ? void 0 : json["displayId"],
    "classMetadata": !exists(json, "classMetadata") ? void 0 : ProductNetSuiteEntityAllOfMetadataClassMetadataFromJSON(json["classMetadata"])
  };
}
function ProductNetSuiteEntityAllOfMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "displayId": value.displayId,
    "classMetadata": ProductNetSuiteEntityAllOfMetadataClassMetadataToJSON(value.classMetadata)
  };
}

// src/generated/models/ProductNetSuiteEntity.ts
function ProductNetSuiteEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": ProductNetSuiteEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ProductNetSuiteEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": ProductNetSuiteEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/ProductPaddleEntityAllOfMetadata.ts
function ProductPaddleEntityAllOfMetadataFromJSON(json) {
  return ProductPaddleEntityAllOfMetadataFromJSONTyped(json, false);
}
function ProductPaddleEntityAllOfMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "displayId": !exists(json, "displayId") ? void 0 : json["displayId"]
  };
}
function ProductPaddleEntityAllOfMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "displayId": value.displayId
  };
}

// src/generated/models/ProductPaddleEntity.ts
function ProductPaddleEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": ProductPaddleEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ProductPaddleEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": ProductPaddleEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/ProductQuickBooksEntity.ts
function ProductQuickBooksEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": ProductPaddleEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ProductQuickBooksEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": ProductPaddleEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/ProductXeroEntity.ts
function ProductXeroEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": ProductPaddleEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ProductXeroEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": ProductPaddleEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/ProductIntegrationEntity.ts
function ProductIntegrationEntityFromJSON(json) {
  return ProductIntegrationEntityFromJSONTyped(json, false);
}
function ProductIntegrationEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["integrationProvider"]) {
    case "Anrok":
      return { ...ProductAnrokEntityFromJSONTyped(json, true), integrationProvider: "Anrok" };
    case "Hubspot":
      return { ...ProductHubspotEntityFromJSONTyped(json, true), integrationProvider: "Hubspot" };
    case "NetSuite":
      return { ...ProductNetSuiteEntityFromJSONTyped(json, true), integrationProvider: "NetSuite" };
    case "Paddle":
      return { ...ProductPaddleEntityFromJSONTyped(json, true), integrationProvider: "Paddle" };
    case "QuickBooks":
      return { ...ProductQuickBooksEntityFromJSONTyped(json, true), integrationProvider: "QuickBooks" };
    case "Xero":
      return { ...ProductXeroEntityFromJSONTyped(json, true), integrationProvider: "Xero" };
    default:
      throw new Error(`No variant of ProductIntegrationEntity exists with 'integrationProvider=${json["integrationProvider"]}'`);
  }
}
function ProductIntegrationEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["integrationProvider"]) {
    case "Anrok":
      return ProductAnrokEntityToJSON(value);
    case "Hubspot":
      return ProductHubspotEntityToJSON(value);
    case "NetSuite":
      return ProductNetSuiteEntityToJSON(value);
    case "Paddle":
      return ProductPaddleEntityToJSON(value);
    case "QuickBooks":
      return ProductQuickBooksEntityToJSON(value);
    case "Xero":
      return ProductXeroEntityToJSON(value);
    default:
      throw new Error(`No variant of ProductIntegrationEntity exists with 'integrationProvider=${value["integrationProvider"]}'`);
  }
}

// src/generated/models/LineItemProduct.ts
function LineItemProductFromJSON(json) {
  return LineItemProductFromJSONTyped(json, false);
}
function LineItemProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": !exists(json, "productId") ? void 0 : json["productId"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "basePrice": !exists(json, "basePrice") ? void 0 : json["basePrice"],
    "additionalCharge": !exists(json, "additionalCharge") ? void 0 : json["additionalCharge"],
    "proRata": json["proRata"],
    "rateMultiplier": !exists(json, "rateMultiplier") ? void 0 : json["rateMultiplier"],
    "variants": json["variants"].map(LineItemProductVariantFromJSON),
    "commitment": !exists(json, "commitment") ? void 0 : LineItemProductCommitmentFromJSON(json["commitment"]),
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "accumulationInterval": !exists(json, "accumulationInterval") ? void 0 : json["accumulationInterval"],
    "currencyCommitment": !exists(json, "currencyCommitment") ? void 0 : json["currencyCommitment"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : ProductExternalIntegrationFromJSON(json["externalIntegration"]),
    "cloudProviderSettings": !exists(json, "cloudProviderSettings") ? void 0 : ProductCloudProviderSettingsFromJSON(json["cloudProviderSettings"]),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "creditPurchaseConfig": !exists(json, "creditPurchaseConfig") ? void 0 : CreditPurchaseConfigFromJSON(json["creditPurchaseConfig"])
  };
}
function LineItemProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productId": value.productId,
    "name": value.name,
    "basePrice": value.basePrice,
    "additionalCharge": value.additionalCharge,
    "proRata": value.proRata,
    "rateMultiplier": value.rateMultiplier,
    "variants": value.variants.map(LineItemProductVariantToJSON),
    "commitment": LineItemProductCommitmentToJSON(value.commitment),
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "accumulationInterval": value.accumulationInterval,
    "currencyCommitment": value.currencyCommitment,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "externalIntegration": ProductExternalIntegrationToJSON(value.externalIntegration),
    "cloudProviderSettings": ProductCloudProviderSettingsToJSON(value.cloudProviderSettings),
    "creditTypeIds": value.creditTypeIds,
    "creditPurchaseConfig": CreditPurchaseConfigToJSON(value.creditPurchaseConfig)
  };
}

// src/generated/models/BillingCycleCustomersInner.ts
function BillingCycleCustomersInnerFromJSON(json) {
  return BillingCycleCustomersInnerFromJSONTyped(json, false);
}
function BillingCycleCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"]
  };
}

// src/generated/models/BillingCycleStatus.ts
function BillingCycleStatusFromJSON(json) {
  return BillingCycleStatusFromJSONTyped(json, false);
}
function BillingCycleStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function BillingCycleStatusToJSON(value) {
  return value;
}

// src/generated/models/BillingCycle.ts
function BillingCycleFromJSON(json) {
  return BillingCycleFromJSONTyped(json, false);
}
function BillingCycleFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "billingDay": json["billingDay"],
    "status": BillingCycleStatusFromJSON(json["status"]),
    "customers": json["customers"].map(BillingCycleCustomersInnerFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/Currency.ts
function CurrencyFromJSON(json) {
  return CurrencyFromJSONTyped(json, false);
}
function CurrencyFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CurrencyToJSON(value) {
  return value;
}

// src/generated/models/FullDayPeriod.ts
function FullDayPeriodFromJSON(json) {
  return FullDayPeriodFromJSONTyped(json, false);
}
function FullDayPeriodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startTime": new Date(json["startTime"]),
    "endTime": new Date(json["endTime"])
  };
}

// src/generated/models/InvoiceBillingStatus.ts
function InvoiceBillingStatusFromJSON(json) {
  return InvoiceBillingStatusFromJSONTyped(json, false);
}
function InvoiceBillingStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/InvoiceReviewStatus.ts
function InvoiceReviewStatusFromJSON(json) {
  return InvoiceReviewStatusFromJSONTyped(json, false);
}
function InvoiceReviewStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/BillingCycleInvoice.ts
function BillingCycleInvoiceFromJSON(json) {
  return BillingCycleInvoiceFromJSONTyped(json, false);
}
function BillingCycleInvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "billingCycle": FullDayPeriodFromJSON(json["billingCycle"]),
    "invoiceNumber": json["invoiceNumber"],
    "ref": json["ref"],
    "previousInvoiceAmount": !exists(json, "previousInvoiceAmount") ? void 0 : json["previousInvoiceAmount"],
    "customerName": json["customerName"],
    "customerId": json["customerId"],
    "erpDisplayId": !exists(json, "erpDisplayId") ? void 0 : json["erpDisplayId"],
    "overcharges": json["overcharges"],
    "currency": CurrencyFromJSON(json["currency"]),
    "erpId": !exists(json, "erpId") ? void 0 : json["erpId"],
    "customerExternalId": !exists(json, "customerExternalId") ? void 0 : json["customerExternalId"],
    "paymentTerm": json["paymentTerm"],
    "contractName": !exists(json, "contractName") ? void 0 : json["contractName"]
  };
}

// src/generated/models/ErpMetadata.ts
function ErpMetadataFromJSON(json) {
  return ErpMetadataFromJSONTyped(json, false);
}
function ErpMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "erpId": json["erpId"],
    "erpName": json["erpName"],
    "displayId": !exists(json, "displayId") ? void 0 : json["displayId"],
    "integrationSource": !exists(json, "integrationSource") ? void 0 : json["integrationSource"],
    "code": !exists(json, "code") ? void 0 : json["code"]
  };
}
function ErpMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "erpId": value.erpId,
    "erpName": value.erpName,
    "displayId": value.displayId,
    "integrationSource": value.integrationSource,
    "code": value.code
  };
}

// src/generated/models/NewProductVariant.ts
function NewProductVariantFromJSON(json) {
  return NewProductVariantFromJSONTyped(json, false);
}
function NewProductVariantFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "meterId": !exists(json, "meterId") ? void 0 : json["meterId"],
    "pricing": PricingFromJSON(json["pricing"]),
    "settings": !exists(json, "settings") ? void 0 : ProductSettingsFromJSON(json["settings"]),
    "description": !exists(json, "description") ? void 0 : json["description"],
    "name": json["name"]
  };
}
function NewProductVariantToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "meterId": value.meterId,
    "pricing": PricingToJSON(value.pricing),
    "settings": ProductSettingsToJSON(value.settings),
    "description": value.description,
    "name": value.name
  };
}

// src/generated/models/ProductConfigCommitment.ts
function ProductConfigCommitmentFromJSON(json) {
  return ProductConfigCommitmentFromJSONTyped(json, false);
}
function ProductConfigCommitmentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "amount": json["amount"],
    "type": CommitmentTypeFromJSON(json["type"]),
    "consumption": json["consumption"],
    "replenishmentInterval": !exists(json, "replenishmentInterval") ? void 0 : json["replenishmentInterval"]
  };
}
function ProductConfigCommitmentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "amount": value.amount,
    "type": CommitmentTypeToJSON(value.type),
    "consumption": value.consumption,
    "replenishmentInterval": value.replenishmentInterval
  };
}

// src/generated/models/ProductConfig.ts
function ProductConfigFromJSON(json) {
  return ProductConfigFromJSONTyped(json, false);
}
function ProductConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["productId"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "status": json["status"],
    "basePrice": !exists(json, "basePrice") ? void 0 : json["basePrice"],
    "additionalCharge": !exists(json, "additionalCharge") ? void 0 : json["additionalCharge"],
    "proRata": !exists(json, "proRata") ? void 0 : json["proRata"],
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "chargingCadence": !exists(json, "chargingCadence") ? void 0 : json["chargingCadence"],
    "accumulationInterval": !exists(json, "accumulationInterval") ? void 0 : json["accumulationInterval"],
    "rateMultiplier": !exists(json, "rateMultiplier") ? void 0 : json["rateMultiplier"],
    "currencyCommitment": !exists(json, "currencyCommitment") ? void 0 : json["currencyCommitment"],
    "variantPricingOverrides": !exists(json, "variantPricingOverrides") ? void 0 : json["variantPricingOverrides"] === null ? null : mapValues(json["variantPricingOverrides"], NewProductVariantFromJSON),
    "period": PeriodFromJSON(json["period"]),
    "commitment": !exists(json, "commitment") ? void 0 : ProductConfigCommitmentFromJSON(json["commitment"]),
    "revisionId": !exists(json, "revisionId") ? void 0 : json["revisionId"],
    "cloudProviderSettings": !exists(json, "cloudProviderSettings") ? void 0 : ProductCloudProviderSettingsFromJSON(json["cloudProviderSettings"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}
function ProductConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productId": value.productId,
    "name": value.name,
    "status": value.status,
    "basePrice": value.basePrice,
    "additionalCharge": value.additionalCharge,
    "proRata": value.proRata,
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "chargingCadence": value.chargingCadence,
    "accumulationInterval": value.accumulationInterval,
    "rateMultiplier": value.rateMultiplier,
    "currencyCommitment": value.currencyCommitment,
    "variantPricingOverrides": value.variantPricingOverrides === void 0 ? void 0 : value.variantPricingOverrides === null ? null : mapValues(value.variantPricingOverrides, NewProductVariantToJSON),
    "period": PeriodToJSON(value.period),
    "commitment": ProductConfigCommitmentToJSON(value.commitment),
    "revisionId": value.revisionId,
    "cloudProviderSettings": ProductCloudProviderSettingsToJSON(value.cloudProviderSettings),
    "id": value.id,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString()
  };
}

// src/generated/models/ProductTimeline.ts
function ProductTimelineFromJSON(json) {
  return ProductTimelineFromJSONTyped(json, false);
}
function ProductTimelineFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "period": PeriodFromJSON(json["period"]),
    "productId": json["productId"]
  };
}
function ProductTimelineToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "period": PeriodToJSON(value.period),
    "productId": value.productId
  };
}

// src/generated/models/ProductUpliftConfiguration.ts
function ProductUpliftConfigurationFromJSON(json) {
  return ProductUpliftConfigurationFromJSONTyped(json, false);
}
function ProductUpliftConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "inflationaryUpliftEnabled": json["inflationaryUpliftEnabled"],
    "seatUpliftEnabled": json["seatUpliftEnabled"],
    "commitmentUpliftEnabled": json["commitmentUpliftEnabled"]
  };
}
function ProductUpliftConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "inflationaryUpliftEnabled": value.inflationaryUpliftEnabled,
    "seatUpliftEnabled": value.seatUpliftEnabled,
    "commitmentUpliftEnabled": value.commitmentUpliftEnabled
  };
}

// src/generated/models/Meter.ts
function MeterFromJSON(json) {
  return MeterFromJSONTyped(json, false);
}
function MeterFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventName": json["eventName"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "unitsType": !exists(json, "unitsType") ? void 0 : json["unitsType"],
    "filter": !exists(json, "filter") ? void 0 : FilterFromJSON(json["filter"]),
    "aggregationMethod": AggregationMethodFromJSON(json["aggregationMethod"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "isTaxable": !exists(json, "isTaxable") ? void 0 : json["isTaxable"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"]
  };
}
function MeterToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "eventName": value.eventName,
    "name": value.name,
    "description": value.description,
    "unitsType": value.unitsType,
    "filter": FilterToJSON(value.filter),
    "aggregationMethod": AggregationMethodToJSON(value.aggregationMethod),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "creditTypeIds": value.creditTypeIds,
    "isTaxable": value.isTaxable,
    "id": value.id,
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "accountId": value.accountId
  };
}

// src/generated/models/ProductVariant.ts
function ProductVariantFromJSON(json) {
  return ProductVariantFromJSONTyped(json, false);
}
function ProductVariantFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "meterId": !exists(json, "meterId") ? void 0 : json["meterId"],
    "pricing": PricingFromJSON(json["pricing"]),
    "settings": !exists(json, "settings") ? void 0 : ProductSettingsFromJSON(json["settings"]),
    "description": !exists(json, "description") ? void 0 : json["description"],
    "name": json["name"],
    "productId": json["productId"],
    "meter": MeterFromJSON(json["meter"]),
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}
function ProductVariantToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "meterId": value.meterId,
    "pricing": PricingToJSON(value.pricing),
    "settings": ProductSettingsToJSON(value.settings),
    "description": value.description,
    "name": value.name,
    "productId": value.productId,
    "meter": MeterToJSON(value.meter),
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString()
  };
}

// src/generated/models/Product.ts
function ProductFromJSON(json) {
  return ProductFromJSONTyped(json, false);
}
function ProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "variants": json["variants"].map(ProductVariantFromJSON),
    "basePrice": !exists(json, "basePrice") ? void 0 : json["basePrice"],
    "additionalCharge": !exists(json, "additionalCharge") ? void 0 : json["additionalCharge"],
    "commitment": !exists(json, "commitment") ? void 0 : ProductConfigCommitmentFromJSON(json["commitment"]),
    "advancePayment": !exists(json, "advancePayment") ? void 0 : AdvancePaymentFromJSON(json["advancePayment"]),
    "chargingCadence": !exists(json, "chargingCadence") ? void 0 : json["chargingCadence"],
    "currencyCommitment": !exists(json, "currencyCommitment") ? void 0 : json["currencyCommitment"],
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "accumulationInterval": !exists(json, "accumulationInterval") ? void 0 : json["accumulationInterval"],
    "proRata": json["proRata"],
    "erpMetadata": !exists(json, "erpMetadata") ? void 0 : ErpMetadataFromJSON(json["erpMetadata"]),
    "rateMultiplier": !exists(json, "rateMultiplier") ? void 0 : json["rateMultiplier"],
    "isPeriodicVariants": !exists(json, "isPeriodicVariants") ? void 0 : json["isPeriodicVariants"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "startDate": !exists(json, "startDate") ? void 0 : json["startDate"] === null ? null : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : json["endDate"] === null ? null : new Date(json["endDate"]),
    "catalogProductId": !exists(json, "catalogProductId") ? void 0 : json["catalogProductId"],
    "productConfigs": !exists(json, "productConfigs") ? void 0 : json["productConfigs"] === null ? null : json["productConfigs"].map(ProductConfigFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : ProductExternalIntegrationFromJSON(json["externalIntegration"]),
    "revisionId": !exists(json, "revisionId") ? void 0 : json["revisionId"],
    "cloudProviderSettings": !exists(json, "cloudProviderSettings") ? void 0 : ProductCloudProviderSettingsFromJSON(json["cloudProviderSettings"]),
    "isCalendarAligned": json["isCalendarAligned"],
    "upliftConfiguration": !exists(json, "upliftConfiguration") ? void 0 : ProductUpliftConfigurationFromJSON(json["upliftConfiguration"]),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "creditPurchaseConfig": !exists(json, "creditPurchaseConfig") ? void 0 : CreditPurchaseConfigFromJSON(json["creditPurchaseConfig"]),
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "timeline": !exists(json, "timeline") ? void 0 : ProductTimelineFromJSON(json["timeline"])
  };
}
function ProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "variants": value.variants.map(ProductVariantToJSON),
    "basePrice": value.basePrice,
    "additionalCharge": value.additionalCharge,
    "commitment": ProductConfigCommitmentToJSON(value.commitment),
    "advancePayment": AdvancePaymentToJSON(value.advancePayment),
    "chargingCadence": value.chargingCadence,
    "currencyCommitment": value.currencyCommitment,
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "accumulationInterval": value.accumulationInterval,
    "proRata": value.proRata,
    "erpMetadata": ErpMetadataToJSON(value.erpMetadata),
    "rateMultiplier": value.rateMultiplier,
    "isPeriodicVariants": value.isPeriodicVariants,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "startDate": value.startDate === void 0 ? void 0 : value.startDate === null ? null : value.startDate.toISOString(),
    "endDate": value.endDate === void 0 ? void 0 : value.endDate === null ? null : value.endDate.toISOString(),
    "catalogProductId": value.catalogProductId,
    "productConfigs": value.productConfigs === void 0 ? void 0 : value.productConfigs === null ? null : value.productConfigs.map(ProductConfigToJSON),
    "externalIntegration": ProductExternalIntegrationToJSON(value.externalIntegration),
    "revisionId": value.revisionId,
    "cloudProviderSettings": ProductCloudProviderSettingsToJSON(value.cloudProviderSettings),
    "isCalendarAligned": value.isCalendarAligned,
    "upliftConfiguration": ProductUpliftConfigurationToJSON(value.upliftConfiguration),
    "creditTypeIds": value.creditTypeIds,
    "creditPurchaseConfig": CreditPurchaseConfigToJSON(value.creditPurchaseConfig),
    "createdAt": value.createdAt.toISOString(),
    "updatedAt": value.updatedAt.toISOString(),
    "timeline": ProductTimelineToJSON(value.timeline)
  };
}

// src/generated/models/CatalogProducts.ts
function CatalogProductsFromJSON(json) {
  return CatalogProductsFromJSONTyped(json, false);
}
function CatalogProductsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "isTaxable": !exists(json, "isTaxable") ? void 0 : json["isTaxable"],
    "products": !exists(json, "products") ? void 0 : json["products"].map(ProductFromJSON),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : ProductExternalIntegrationFromJSON(json["externalIntegration"]),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/ChannelType.ts
function ChannelTypeFromJSON(json) {
  return ChannelTypeFromJSONTyped(json, false);
}
function ChannelTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/TieredSubscriptionPricingConfigurationInputDiscountConfiguration.ts
function TieredSubscriptionPricingConfigurationInputDiscountConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "type": TieredSubscriptionPricingConfigurationDiscountConfigurationTypeToJSON(value.type),
    "amountToDeduct": value.amountToDeduct,
    "recurring": value.recurring
  };
}

// src/generated/models/CommercialTermsPricingInputPriceConfiguration.ts
function CommercialTermsPricingInputPriceConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "shouldCreateSeparateInvoice": value.shouldCreateSeparateInvoice,
    "shouldSplitAmount": value.shouldSplitAmount,
    "discountConfiguration": TieredSubscriptionPricingConfigurationInputDiscountConfigurationToJSON(value.discountConfiguration),
    "installments": value.installments,
    "scheduledInstallments": ScheduledInstallmentConfigurationToJSON(value.scheduledInstallments)
  };
}

// src/generated/models/CommercialTermsPricingInput.ts
function CommercialTermsPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": CommercialTermsPricingInputPriceConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/CommissionPricingInput.ts
function CommissionPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": CommissionPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/ProductConsumption.ts
function ProductConsumptionFromJSON(json) {
  return ProductConsumptionFromJSONTyped(json, false);
}
function ProductConsumptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["productId"],
    "productName": json["productName"],
    "provisionedAmount": json["provisionedAmount"],
    "consumedAmount": json["consumedAmount"],
    "usagePercentage": json["usagePercentage"],
    "hasAccess": json["hasAccess"],
    "remainingAmount": !exists(json, "remainingAmount") ? void 0 : json["remainingAmount"],
    "exceededAmount": !exists(json, "exceededAmount") ? void 0 : json["exceededAmount"]
  };
}

// src/generated/models/CommitmentCrossedNotificationMetadata.ts
function CommitmentCrossedNotificationMetadataFromJSON(json) {
  return CommitmentCrossedNotificationMetadataFromJSONTyped(json, false);
}
function CommitmentCrossedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "productConsumption": ProductConsumptionFromJSON(json["productConsumption"]),
    "customerId": json["customerId"]
  };
}

// src/generated/models/CommitmentCrossedNotification.ts
function CommitmentCrossedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": CommitmentCrossedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/NewLineItemProductCommitment.ts
function NewLineItemProductCommitmentFromJSON(json) {
  return NewLineItemProductCommitmentFromJSONTyped(json, false);
}
function NewLineItemProductCommitmentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "consumption": json["consumption"],
    "amount": json["amount"],
    "type": CommitmentTypeFromJSON(json["type"]),
    "replenishmentInterval": !exists(json, "replenishmentInterval") ? void 0 : json["replenishmentInterval"]
  };
}
function NewLineItemProductCommitmentToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "consumption": value.consumption,
    "amount": value.amount,
    "type": CommitmentTypeToJSON(value.type),
    "replenishmentInterval": value.replenishmentInterval
  };
}

// src/generated/models/NewLineItemProductVariant.ts
function NewLineItemProductVariantFromJSON(json) {
  return NewLineItemProductVariantFromJSONTyped(json, false);
}
function NewLineItemProductVariantFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productVariantId": !exists(json, "productVariantId") ? void 0 : json["productVariantId"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "pricing": PricingFromJSON(json["pricing"]),
    "periodLimit": !exists(json, "periodLimit") ? void 0 : PeriodFromJSON(json["periodLimit"]),
    "settings": !exists(json, "settings") ? void 0 : ProductSettingsFromJSON(json["settings"]),
    "meter": !exists(json, "meter") ? void 0 : NewLineItemProductVariantMeterFromJSON(json["meter"])
  };
}
function NewLineItemProductVariantToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productVariantId": value.productVariantId,
    "name": value.name,
    "description": value.description,
    "pricing": PricingToJSON(value.pricing),
    "periodLimit": PeriodToJSON(value.periodLimit),
    "settings": ProductSettingsToJSON(value.settings),
    "meter": NewLineItemProductVariantMeterToJSON(value.meter)
  };
}

// src/generated/models/NewLineItemProduct.ts
function NewLineItemProductFromJSON(json) {
  return NewLineItemProductFromJSONTyped(json, false);
}
function NewLineItemProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": !exists(json, "productId") ? void 0 : json["productId"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "basePrice": !exists(json, "basePrice") ? void 0 : json["basePrice"],
    "additionalCharge": !exists(json, "additionalCharge") ? void 0 : json["additionalCharge"],
    "proRata": json["proRata"],
    "rateMultiplier": !exists(json, "rateMultiplier") ? void 0 : json["rateMultiplier"],
    "variants": json["variants"].map(NewLineItemProductVariantFromJSON),
    "commitment": !exists(json, "commitment") ? void 0 : NewLineItemProductCommitmentFromJSON(json["commitment"]),
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "accumulationInterval": !exists(json, "accumulationInterval") ? void 0 : json["accumulationInterval"],
    "currencyCommitment": !exists(json, "currencyCommitment") ? void 0 : json["currencyCommitment"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : ProductExternalIntegrationFromJSON(json["externalIntegration"]),
    "cloudProviderSettings": !exists(json, "cloudProviderSettings") ? void 0 : ProductCloudProviderSettingsFromJSON(json["cloudProviderSettings"]),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "creditPurchaseConfig": !exists(json, "creditPurchaseConfig") ? void 0 : CreditPurchaseConfigFromJSON(json["creditPurchaseConfig"])
  };
}
function NewLineItemProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productId": value.productId,
    "name": value.name,
    "basePrice": value.basePrice,
    "additionalCharge": value.additionalCharge,
    "proRata": value.proRata,
    "rateMultiplier": value.rateMultiplier,
    "variants": value.variants.map(NewLineItemProductVariantToJSON),
    "commitment": NewLineItemProductCommitmentToJSON(value.commitment),
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "accumulationInterval": value.accumulationInterval,
    "currencyCommitment": value.currencyCommitment,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "externalIntegration": ProductExternalIntegrationToJSON(value.externalIntegration),
    "cloudProviderSettings": ProductCloudProviderSettingsToJSON(value.cloudProviderSettings),
    "creditTypeIds": value.creditTypeIds,
    "creditPurchaseConfig": CreditPurchaseConfigToJSON(value.creditPurchaseConfig)
  };
}

// src/generated/models/CommitmentLineItem.ts
function CommitmentLineItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "isRevised": json["isRevised"],
    "disabled": !exists(json, "disabled") ? void 0 : json["disabled"],
    "modifiedName": json["modifiedName"],
    "modifiedDescription": json["modifiedDescription"],
    "modifiedPrice": !exists(json, "modifiedPrice") ? void 0 : json["modifiedPrice"],
    "percentage": !exists(json, "percentage") ? void 0 : json["percentage"],
    "lineItemPeriod": !exists(json, "lineItemPeriod") ? void 0 : PeriodFromJSON(json["lineItemPeriod"]),
    "originalInvoiceData": !exists(json, "originalInvoiceData") ? void 0 : OriginalInvoiceDataFromJSON(json["originalInvoiceData"]),
    "saleTax": !exists(json, "saleTax") ? void 0 : SaleTaxFromJSON(json["saleTax"]),
    "lineItemProduct": NewLineItemProductFromJSON(json["lineItemProduct"]),
    "type": json["type"],
    "units": json["units"],
    "commitmentTiersUsageMap": json["commitmentTiersUsageMap"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/CommitmentUsageCrossedNotificationMetadata.ts
function CommitmentUsageCrossedNotificationMetadataFromJSON(json) {
  return CommitmentUsageCrossedNotificationMetadataFromJSONTyped(json, false);
}
function CommitmentUsageCrossedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "productConsumption": ProductConsumptionFromJSON(json["productConsumption"]),
    "customerId": json["customerId"],
    "threshold": json["threshold"],
    "pctUsage": json["pctUsage"]
  };
}

// src/generated/models/CommitmentUsageCrossedNotification.ts
function CommitmentUsageCrossedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": CommitmentUsageCrossedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/ConfirmPasswordResetRequest.ts
function ConfirmPasswordResetRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email,
    "newPassword": value.newPassword,
    "verificationCode": value.verificationCode
  };
}

// src/generated/models/ConfirmPasswordResetResponse.ts
function ConfirmPasswordResetResponseFromJSON(json) {
  return ConfirmPasswordResetResponseFromJSONTyped(json, false);
}
function ConfirmPasswordResetResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"]
  };
}

// src/generated/models/ConfirmRequest.ts
function ConfirmRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token,
    "confirmationCode": value.confirmationCode
  };
}

// src/generated/models/ConnactConnectRequest.ts
function ConnactConnectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accessToken": value.accessToken
  };
}

// src/generated/models/ConnactIntegrationSettingsSchemaIntegrationConfigurationAuthConfig.ts
function ConnactIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json) {
  return ConnactIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, false);
}
function ConnactIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accessToken": json["accessToken"]
  };
}

// src/generated/models/ConnactIntegrationSettingsSchemaIntegrationConfiguration.ts
function ConnactIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json) {
  return ConnactIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, false);
}
function ConnactIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "generalConfig": json["generalConfig"],
    "authConfig": ConnactIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json["authConfig"]),
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/ConnactIntegrationSettingsSchema.ts
function ConnactIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": ConnactIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/ContactUsRequest.ts
function ContactUsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email,
    "message": value.message,
    "name": value.name
  };
}

// src/generated/models/ContractHubspotEntity.ts
function ContractHubspotEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ContractHubspotEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": value.metadata,
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/ContractNetSuiteEntity.ts
function ContractNetSuiteEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ContractNetSuiteEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": value.metadata,
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/ContractSalesforceEntity.ts
function ContractSalesforceEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function ContractSalesforceEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": value.metadata,
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/ContractIntegrationEntitiesInner.ts
function ContractIntegrationEntitiesInnerFromJSON(json) {
  return ContractIntegrationEntitiesInnerFromJSONTyped(json, false);
}
function ContractIntegrationEntitiesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["integrationProvider"]) {
    case "Hubspot":
      return { ...ContractHubspotEntityFromJSONTyped(json, true), integrationProvider: "Hubspot" };
    case "NetSuite":
      return { ...ContractNetSuiteEntityFromJSONTyped(json, true), integrationProvider: "NetSuite" };
    case "Salesforce":
      return { ...ContractSalesforceEntityFromJSONTyped(json, true), integrationProvider: "Salesforce" };
    default:
      throw new Error(`No variant of ContractIntegrationEntitiesInner exists with 'integrationProvider=${json["integrationProvider"]}'`);
  }
}
function ContractIntegrationEntitiesInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["integrationProvider"]) {
    case "Hubspot":
      return ContractHubspotEntityToJSON(value);
    case "NetSuite":
      return ContractNetSuiteEntityToJSON(value);
    case "Salesforce":
      return ContractSalesforceEntityToJSON(value);
    default:
      throw new Error(`No variant of ContractIntegrationEntitiesInner exists with 'integrationProvider=${value["integrationProvider"]}'`);
  }
}

// src/generated/models/ContractInvoicesInner.ts
function ContractInvoicesInnerFromJSON(json) {
  return ContractInvoicesInnerFromJSONTyped(json, false);
}
function ContractInvoicesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"])
  };
}

// src/generated/models/ContractLabelsInner.ts
function ContractLabelsInnerFromJSON(json) {
  return ContractLabelsInnerFromJSONTyped(json, false);
}
function ContractLabelsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "color": json["color"],
    "backgroundColor": json["backgroundColor"]
  };
}

// src/generated/models/ContractStatus.ts
function ContractStatusFromJSON(json) {
  return ContractStatusFromJSONTyped(json, false);
}
function ContractStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ContractStatusToJSON(value) {
  return value;
}

// src/generated/models/ContractType.ts
function ContractTypeFromJSON(json) {
  return ContractTypeFromJSONTyped(json, false);
}
function ContractTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function ContractTypeToJSON(value) {
  return value;
}

// src/generated/models/CustomFieldValueValue.ts
function CustomFieldValueValueFromJSON(json) {
  return CustomFieldValueValueFromJSONTyped(json, false);
}
function CustomFieldValueValueFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CustomFieldValueValueToJSON(value) {
  return value;
}

// src/generated/models/CustomFieldValue.ts
function CustomFieldValueFromJSON(json) {
  return CustomFieldValueFromJSONTyped(json, false);
}
function CustomFieldValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customFieldDefinitionId": json["customFieldDefinitionId"],
    "value": !exists(json, "value") ? void 0 : CustomFieldValueValueFromJSON(json["value"]),
    "fieldName": !exists(json, "fieldName") ? void 0 : json["fieldName"]
  };
}
function CustomFieldValueToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "customFieldDefinitionId": value.customFieldDefinitionId,
    "value": CustomFieldValueValueToJSON(value.value),
    "fieldName": value.fieldName
  };
}

// src/generated/models/CrmMetadata.ts
function CrmMetadataFromJSON(json) {
  return CrmMetadataFromJSONTyped(json, false);
}
function CrmMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "crmId": json["crmId"],
    "integrationSource": !exists(json, "integrationSource") ? void 0 : json["integrationSource"]
  };
}
function CrmMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "crmId": value.crmId,
    "integrationSource": value.integrationSource
  };
}

// src/generated/models/CustomerExternalIntegrationInner.ts
function CustomerExternalIntegrationInnerFromJSON(json) {
  return CustomerExternalIntegrationInnerFromJSONTyped(json, false);
}
function CustomerExternalIntegrationInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "id": json["id"],
    "name": json["name"]
  };
}
function CustomerExternalIntegrationInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "id": value.id,
    "name": value.name
  };
}

// src/generated/models/HubspotCustomerEntity.ts
function HubspotCustomerEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function HubspotCustomerEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": value.metadata,
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/MorningCustomerEntityAllOfMetadata.ts
function MorningCustomerEntityAllOfMetadataFromJSON(json) {
  return MorningCustomerEntityAllOfMetadataFromJSONTyped(json, false);
}
function MorningCustomerEntityAllOfMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"]
  };
}
function MorningCustomerEntityAllOfMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name
  };
}

// src/generated/models/MorningCustomerEntity.ts
function MorningCustomerEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : MorningCustomerEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function MorningCustomerEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": MorningCustomerEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/NetSuiteCustomerEntity.ts
function NetSuiteCustomerEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": ProductPaddleEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function NetSuiteCustomerEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": ProductPaddleEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/QuickBooksCustomerEntity.ts
function QuickBooksCustomerEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": ProductPaddleEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function QuickBooksCustomerEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": ProductPaddleEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/SalesforceCustomerEntity.ts
function SalesforceCustomerEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function SalesforceCustomerEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": value.metadata,
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/StripeCustomerEntityAllOfMetadata.ts
function StripeCustomerEntityAllOfMetadataFromJSON(json) {
  return StripeCustomerEntityAllOfMetadataFromJSONTyped(json, false);
}
function StripeCustomerEntityAllOfMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "email": !exists(json, "email") ? void 0 : json["email"]
  };
}
function StripeCustomerEntityAllOfMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "email": value.email
  };
}

// src/generated/models/StripeCustomerEntity.ts
function StripeCustomerEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : StripeCustomerEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function StripeCustomerEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": StripeCustomerEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/XeroCustomerEntity.ts
function XeroCustomerEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": ProductPaddleEntityAllOfMetadataFromJSON(json["metadata"]),
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function XeroCustomerEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": value.integrationProvider,
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": ProductPaddleEntityAllOfMetadataToJSON(value.metadata),
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/CustomerIntegrationEntity.ts
function CustomerIntegrationEntityFromJSON(json) {
  return CustomerIntegrationEntityFromJSONTyped(json, false);
}
function CustomerIntegrationEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["integrationProvider"]) {
    case "Hubspot":
      return { ...HubspotCustomerEntityFromJSONTyped(json, true), integrationProvider: "Hubspot" };
    case "Morning":
      return { ...MorningCustomerEntityFromJSONTyped(json, true), integrationProvider: "Morning" };
    case "NetSuite":
      return { ...NetSuiteCustomerEntityFromJSONTyped(json, true), integrationProvider: "NetSuite" };
    case "QuickBooks":
      return { ...QuickBooksCustomerEntityFromJSONTyped(json, true), integrationProvider: "QuickBooks" };
    case "Salesforce":
      return { ...SalesforceCustomerEntityFromJSONTyped(json, true), integrationProvider: "Salesforce" };
    case "Stripe":
      return { ...StripeCustomerEntityFromJSONTyped(json, true), integrationProvider: "Stripe" };
    case "Xero":
      return { ...XeroCustomerEntityFromJSONTyped(json, true), integrationProvider: "Xero" };
    default:
      throw new Error(`No variant of CustomerIntegrationEntity exists with 'integrationProvider=${json["integrationProvider"]}'`);
  }
}
function CustomerIntegrationEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["integrationProvider"]) {
    case "Hubspot":
      return HubspotCustomerEntityToJSON(value);
    case "Morning":
      return MorningCustomerEntityToJSON(value);
    case "NetSuite":
      return NetSuiteCustomerEntityToJSON(value);
    case "QuickBooks":
      return QuickBooksCustomerEntityToJSON(value);
    case "Salesforce":
      return SalesforceCustomerEntityToJSON(value);
    case "Stripe":
      return StripeCustomerEntityToJSON(value);
    case "Xero":
      return XeroCustomerEntityToJSON(value);
    default:
      throw new Error(`No variant of CustomerIntegrationEntity exists with 'integrationProvider=${value["integrationProvider"]}'`);
  }
}

// src/generated/models/CustomerCloudProviderSettings.ts
function CustomerCloudProviderSettingsFromJSON(json) {
  return CustomerCloudProviderSettingsFromJSONTyped(json, false);
}
function CustomerCloudProviderSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "cloudProvider": !exists(json, "cloudProvider") ? void 0 : json["cloudProvider"],
    "cloudProviderMarketplaceId": !exists(json, "cloudProviderMarketplaceId") ? void 0 : json["cloudProviderMarketplaceId"],
    "customerIdentifier": !exists(json, "customerIdentifier") ? void 0 : json["customerIdentifier"]
  };
}
function CustomerCloudProviderSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "cloudProvider": value.cloudProvider,
    "cloudProviderMarketplaceId": value.cloudProviderMarketplaceId,
    "customerIdentifier": value.customerIdentifier
  };
}

// src/generated/models/CustomerSettingsPaymentProviderMetadata.ts
function CustomerSettingsPaymentProviderMetadataFromJSON(json) {
  return CustomerSettingsPaymentProviderMetadataFromJSONTyped(json, false);
}
function CustomerSettingsPaymentProviderMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "providerExternalId": !exists(json, "providerExternalId") ? void 0 : json["providerExternalId"]
  };
}
function CustomerSettingsPaymentProviderMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "providerExternalId": value.providerExternalId
  };
}

// src/generated/models/CustomerSettingsPayments.ts
function CustomerSettingsPaymentsFromJSON(json) {
  return CustomerSettingsPaymentsFromJSONTyped(json, false);
}
function CustomerSettingsPaymentsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "autoCollectInvoice": !exists(json, "autoCollectInvoice") ? void 0 : json["autoCollectInvoice"]
  };
}
function CustomerSettingsPaymentsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "autoCollectInvoice": value.autoCollectInvoice
  };
}

// src/generated/models/OverageSettings.ts
function OverageSettingsFromJSON(json) {
  return OverageSettingsFromJSONTyped(json, false);
}
function OverageSettingsFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function OverageSettingsToJSON(value) {
  return value;
}

// src/generated/models/CustomerSettings.ts
function CustomerSettingsFromJSON(json) {
  return CustomerSettingsFromJSONTyped(json, false);
}
function CustomerSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "currency": !exists(json, "currency") ? void 0 : json["currency"],
    "taxRate": !exists(json, "taxRate") ? void 0 : json["taxRate"],
    "paymentProvider": !exists(json, "paymentProvider") ? void 0 : json["paymentProvider"],
    "paymentProviderMetadata": !exists(json, "paymentProviderMetadata") ? void 0 : CustomerSettingsPaymentProviderMetadataFromJSON(json["paymentProviderMetadata"]),
    "secondaryPaymentProvider": !exists(json, "secondaryPaymentProvider") ? void 0 : json["secondaryPaymentProvider"],
    "paymentDueDays": !exists(json, "paymentDueDays") ? void 0 : json["paymentDueDays"],
    "payments": !exists(json, "payments") ? void 0 : CustomerSettingsPaymentsFromJSON(json["payments"]),
    "overage": !exists(json, "overage") ? void 0 : OverageSettingsFromJSON(json["overage"]),
    "customerType": !exists(json, "customerType") ? void 0 : json["customerType"],
    "threshold": !exists(json, "threshold") ? void 0 : json["threshold"],
    "wallet": !exists(json, "wallet") ? void 0 : json["wallet"],
    "manualReview": !exists(json, "manualReview") ? void 0 : json["manualReview"],
    "cloudProviderSettings": !exists(json, "cloudProviderSettings") ? void 0 : CustomerCloudProviderSettingsFromJSON(json["cloudProviderSettings"])
  };
}
function CustomerSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "currency": value.currency,
    "taxRate": value.taxRate,
    "paymentProvider": value.paymentProvider,
    "paymentProviderMetadata": CustomerSettingsPaymentProviderMetadataToJSON(value.paymentProviderMetadata),
    "secondaryPaymentProvider": value.secondaryPaymentProvider,
    "paymentDueDays": value.paymentDueDays,
    "payments": CustomerSettingsPaymentsToJSON(value.payments),
    "overage": OverageSettingsToJSON(value.overage),
    "customerType": value.customerType,
    "threshold": value.threshold,
    "wallet": value.wallet,
    "manualReview": value.manualReview,
    "cloudProviderSettings": CustomerCloudProviderSettingsToJSON(value.cloudProviderSettings)
  };
}

// src/generated/models/CustomerSource.ts
function CustomerSourceFromJSON(json) {
  return CustomerSourceFromJSONTyped(json, false);
}
function CustomerSourceFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CustomerSourceToJSON(value) {
  return value;
}

// src/generated/models/CustomerStatus.ts
function CustomerStatusFromJSON(json) {
  return CustomerStatusFromJSONTyped(json, false);
}
function CustomerStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CustomerStatusToJSON(value) {
  return value;
}

// src/generated/models/Customer.ts
function CustomerFromJSON(json) {
  return CustomerFromJSONTyped(json, false);
}
function CustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "aliases": !exists(json, "aliases") ? void 0 : json["aliases"],
    "taxIds": !exists(json, "taxIds") ? void 0 : json["taxIds"],
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "crmMetadata": !exists(json, "crmMetadata") ? void 0 : CrmMetadataFromJSON(json["crmMetadata"]),
    "erpMetadata": !exists(json, "erpMetadata") ? void 0 : ErpMetadataFromJSON(json["erpMetadata"]),
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"] === null ? null : json["contacts"].map(ContactFromJSON),
    "settings": !exists(json, "settings") ? void 0 : CustomerSettingsFromJSON(json["settings"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "status": !exists(json, "status") ? void 0 : CustomerStatusFromJSON(json["status"]),
    "source": !exists(json, "source") ? void 0 : CustomerSourceFromJSON(json["source"]),
    "subsidiaryId": !exists(json, "subsidiaryId") ? void 0 : json["subsidiaryId"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(CustomerIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : json["externalIntegration"] === null ? null : json["externalIntegration"].map(CustomerExternalIntegrationInnerFromJSON),
    "accountOwnerId": !exists(json, "accountOwnerId") ? void 0 : json["accountOwnerId"],
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"]
  };
}

// src/generated/models/ParentAgreementSettings.ts
function ParentAgreementSettingsFromJSON(json) {
  return ParentAgreementSettingsFromJSONTyped(json, false);
}
function ParentAgreementSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productName": json["productName"],
    "productDescription": !exists(json, "productDescription") ? void 0 : json["productDescription"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ProductIntegrationEntityFromJSON)
  };
}
function ParentAgreementSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "productName": value.productName,
    "productDescription": value.productDescription,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ProductIntegrationEntityToJSON)
  };
}

// src/generated/models/IntegrationEntity.ts
function IntegrationEntityFromJSON(json) {
  return IntegrationEntityFromJSONTyped(json, false);
}
function IntegrationEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedAt": new Date(json["updatedAt"]),
    "integrationProvider": IntegrationProvidersFromJSON(json["integrationProvider"]),
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "rawSyncedData": !exists(json, "rawSyncedData") ? void 0 : json["rawSyncedData"]
  };
}
function IntegrationEntityToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "updatedAt": value.updatedAt.toISOString(),
    "integrationProvider": IntegrationProvidersToJSON(value.integrationProvider),
    "integrationExternalId": value.integrationExternalId,
    "syncStatus": SyncStatusToJSON(value.syncStatus),
    "metadata": value.metadata,
    "rawSyncedData": value.rawSyncedData
  };
}

// src/generated/models/PlanDuration.ts
function PlanDurationFromJSON(json) {
  return PlanDurationFromJSONTyped(json, false);
}
function PlanDurationFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function PlanDurationToJSON(value) {
  return value;
}

// src/generated/models/PlanBillingData.ts
function PlanBillingDataFromJSON(json) {
  return PlanBillingDataFromJSONTyped(json, false);
}
function PlanBillingDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "duration": PlanDurationFromJSON(json["duration"]),
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "autoRenewal": json["autoRenewal"],
    "proRated": !exists(json, "proRated") ? void 0 : json["proRated"]
  };
}
function PlanBillingDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "duration": PlanDurationToJSON(value.duration),
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "autoRenewal": value.autoRenewal,
    "proRated": value.proRated
  };
}

// src/generated/models/PlanRawSyncData.ts
function PlanRawSyncDataFromJSON(json) {
  return PlanRawSyncDataFromJSONTyped(json, false);
}
function PlanRawSyncDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationSource": IntegrationProvidersFromJSON(json["integrationSource"])
  };
}
function PlanRawSyncDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integrationSource": IntegrationProvidersToJSON(value.integrationSource)
  };
}

// src/generated/models/PlanStatus.ts
function PlanStatusFromJSON(json) {
  return PlanStatusFromJSONTyped(json, false);
}
function PlanStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function PlanStatusToJSON(value) {
  return value;
}

// src/generated/models/PlanTrial.ts
function PlanTrialFromJSON(json) {
  return PlanTrialFromJSONTyped(json, false);
}
function PlanTrialFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "duration": json["duration"],
    "type": json["type"],
    "free": json["free"]
  };
}
function PlanTrialToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "duration": value.duration,
    "type": value.type,
    "free": value.free
  };
}

// src/generated/models/Plan.ts
function PlanFromJSON(json) {
  return PlanFromJSONTyped(json, false);
}
function PlanFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "products": json["products"].map(ProductFromJSON),
    "billingData": PlanBillingDataFromJSON(json["billingData"]),
    "status": PlanStatusFromJSON(json["status"]),
    "basedFromPlanId": !exists(json, "basedFromPlanId") ? void 0 : json["basedFromPlanId"],
    "trial": !exists(json, "trial") ? void 0 : PlanTrialFromJSON(json["trial"]),
    "purchaseOrder": !exists(json, "purchaseOrder") ? void 0 : json["purchaseOrder"],
    "rawSyncData": !exists(json, "rawSyncData") ? void 0 : PlanRawSyncDataFromJSON(json["rawSyncData"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(IntegrationEntityFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"],
    "revision": json["revision"]
  };
}

// src/generated/models/Contract.ts
function ContractFromJSON(json) {
  return ContractFromJSONTyped(json, false);
}
function ContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startDate": new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "status": ContractStatusFromJSON(json["status"]),
    "contractType": ContractTypeFromJSON(json["contractType"]),
    "parentAgreementSettings": !exists(json, "parentAgreementSettings") ? void 0 : ParentAgreementSettingsFromJSON(json["parentAgreementSettings"]),
    "trialEndDate": !exists(json, "trialEndDate") ? void 0 : new Date(json["trialEndDate"]),
    "cancelledAt": !exists(json, "cancelledAt") ? void 0 : new Date(json["cancelledAt"]),
    "terminatedAt": !exists(json, "terminatedAt") ? void 0 : new Date(json["terminatedAt"]),
    "revisedAt": !exists(json, "revisedAt") ? void 0 : new Date(json["revisedAt"]),
    "initialStartDate": !exists(json, "initialStartDate") ? void 0 : new Date(json["initialStartDate"]),
    "signatureDate": !exists(json, "signatureDate") ? void 0 : new Date(json["signatureDate"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ContractIntegrationEntitiesInnerFromJSON),
    "currencyOverride": !exists(json, "currencyOverride") ? void 0 : CurrencyFromJSON(json["currencyOverride"]),
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "credits": !exists(json, "credits") ? void 0 : json["credits"].map(CreditPurchaseConfigFromJSON),
    "isTrial": !exists(json, "isTrial") ? void 0 : json["isTrial"],
    "accountId": json["accountId"],
    "customer": CustomerFromJSON(json["customer"]),
    "plan": PlanFromJSON(json["plan"]),
    "invoices": !exists(json, "invoices") ? void 0 : json["invoices"].map(ContractInvoicesInnerFromJSON),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/CustomerCreatedIntegrationEntity.ts
function CustomerCreatedIntegrationEntityFromJSON(json) {
  return CustomerCreatedIntegrationEntityFromJSONTyped(json, false);
}
function CustomerCreatedIntegrationEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationExternalId": json["integrationExternalId"],
    "syncStatus": json["syncStatus"]
  };
}

// src/generated/models/CustomerCreatedNotificationMetadata.ts
function CustomerCreatedNotificationMetadataFromJSON(json) {
  return CustomerCreatedNotificationMetadataFromJSONTyped(json, false);
}
function CustomerCreatedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customerId": json["customerId"],
    "name": json["name"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "aliases": json["aliases"],
    "integrationEntities": json["integrationEntities"].map(CustomerCreatedIntegrationEntityFromJSON)
  };
}

// src/generated/models/ContractCreatedNotificationMetadata.ts
function ContractCreatedNotificationMetadataFromJSON(json) {
  return ContractCreatedNotificationMetadataFromJSONTyped(json, false);
}
function ContractCreatedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "contractId": json["contractId"],
    "customerId": json["customerId"],
    "contractName": json["contractName"],
    "status": json["status"],
    "startDate": new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "customer": CustomerCreatedNotificationMetadataFromJSON(json["customer"])
  };
}

// src/generated/models/ContractCreatedNotification.ts
function ContractCreatedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": ContractCreatedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/ContractExpiredNotificationMetadata.ts
function ContractExpiredNotificationMetadataFromJSON(json) {
  return ContractExpiredNotificationMetadataFromJSONTyped(json, false);
}
function ContractExpiredNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "contractEndDate": new Date(json["contractEndDate"]),
    "contractName": json["contractName"],
    "contractId": json["contractId"],
    "customerName": !exists(json, "customerName") ? void 0 : json["customerName"],
    "isTrial": !exists(json, "isTrial") ? void 0 : json["isTrial"]
  };
}

// src/generated/models/ContractExpiredNotification.ts
function ContractExpiredNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": ContractExpiredNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/ContractOverviewProductVariant.ts
function ContractOverviewProductVariantFromJSON(json) {
  return ContractOverviewProductVariantFromJSONTyped(json, false);
}
function ContractOverviewProductVariantFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "meter": !exists(json, "meter") ? void 0 : MeterFromJSON(json["meter"]),
    "pricing": !exists(json, "pricing") ? void 0 : PricingFromJSON(json["pricing"]),
    "name": !exists(json, "name") ? void 0 : json["name"],
    "productId": !exists(json, "productId") ? void 0 : json["productId"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "description": !exists(json, "description") ? void 0 : json["description"],
    "meterId": !exists(json, "meterId") ? void 0 : json["meterId"],
    "settings": !exists(json, "settings") ? void 0 : ProductSettingsFromJSON(json["settings"])
  };
}

// src/generated/models/ContractOverviewProduct.ts
function ContractOverviewProductFromJSON(json) {
  return ContractOverviewProductFromJSONTyped(json, false);
}
function ContractOverviewProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "productConfigs": !exists(json, "productConfigs") ? void 0 : json["productConfigs"] === null ? null : json["productConfigs"].map(ProductConfigFromJSON),
    "variants": json["variants"].map(ContractOverviewProductVariantFromJSON),
    "paymentTerm": !exists(json, "paymentTerm") ? void 0 : PaymentTermFromJSON(json["paymentTerm"]),
    "billingInterval": !exists(json, "billingInterval") ? void 0 : BillingIntervalFromJSON(json["billingInterval"]),
    "proRata": !exists(json, "proRata") ? void 0 : json["proRata"],
    "createdAt": !exists(json, "createdAt") ? void 0 : new Date(json["createdAt"]),
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "basePrice": !exists(json, "basePrice") ? void 0 : json["basePrice"],
    "additionalCharge": !exists(json, "additionalCharge") ? void 0 : json["additionalCharge"],
    "commitment": !exists(json, "commitment") ? void 0 : ProductConfigCommitmentFromJSON(json["commitment"]),
    "timeline": !exists(json, "timeline") ? void 0 : ProductTimelineFromJSON(json["timeline"]),
    "chargingCadence": !exists(json, "chargingCadence") ? void 0 : json["chargingCadence"],
    "currencyCommitment": !exists(json, "currencyCommitment") ? void 0 : json["currencyCommitment"],
    "accumulationInterval": !exists(json, "accumulationInterval") ? void 0 : json["accumulationInterval"],
    "rateMultiplier": !exists(json, "rateMultiplier") ? void 0 : json["rateMultiplier"],
    "isPeriodicVariants": !exists(json, "isPeriodicVariants") ? void 0 : json["isPeriodicVariants"],
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "catalogProductId": !exists(json, "catalogProductId") ? void 0 : json["catalogProductId"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : ProductExternalIntegrationFromJSON(json["externalIntegration"]),
    "revisionId": !exists(json, "revisionId") ? void 0 : json["revisionId"]
  };
}

// src/generated/models/ContractPageDataContract.ts
function ContractPageDataContractFromJSON(json) {
  return ContractPageDataContractFromJSONTyped(json, false);
}
function ContractPageDataContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startDate": new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "status": ContractStatusFromJSON(json["status"]),
    "contractType": ContractTypeFromJSON(json["contractType"]),
    "parentAgreementSettings": !exists(json, "parentAgreementSettings") ? void 0 : ParentAgreementSettingsFromJSON(json["parentAgreementSettings"]),
    "trialEndDate": !exists(json, "trialEndDate") ? void 0 : new Date(json["trialEndDate"]),
    "cancelledAt": !exists(json, "cancelledAt") ? void 0 : new Date(json["cancelledAt"]),
    "terminatedAt": !exists(json, "terminatedAt") ? void 0 : new Date(json["terminatedAt"]),
    "revisedAt": !exists(json, "revisedAt") ? void 0 : new Date(json["revisedAt"]),
    "initialStartDate": !exists(json, "initialStartDate") ? void 0 : new Date(json["initialStartDate"]),
    "signatureDate": !exists(json, "signatureDate") ? void 0 : new Date(json["signatureDate"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ContractIntegrationEntitiesInnerFromJSON),
    "currencyOverride": !exists(json, "currencyOverride") ? void 0 : CurrencyFromJSON(json["currencyOverride"]),
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "credits": !exists(json, "credits") ? void 0 : json["credits"].map(CreditPurchaseConfigFromJSON),
    "isTrial": !exists(json, "isTrial") ? void 0 : json["isTrial"],
    "accountId": json["accountId"],
    "customer": CustomerFromJSON(json["customer"]),
    "plan": PlanFromJSON(json["plan"]),
    "invoices": !exists(json, "invoices") ? void 0 : json["invoices"].map(ContractInvoicesInnerFromJSON),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "isEditable": json["isEditable"],
    "hasSourcePdf": json["hasSourcePdf"],
    "revenue": json["revenue"],
    "totalAmountToPay": json["totalAmountToPay"],
    "wasRenewed": json["wasRenewed"]
  };
}

// src/generated/models/PhaseType.ts
function PhaseTypeFromJSON(json) {
  return PhaseTypeFromJSONTyped(json, false);
}
function PhaseTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function PhaseTypeToJSON(value) {
  return value;
}

// src/generated/models/ContractPageDataVersionsInner.ts
function ContractPageDataVersionsInnerFromJSON(json) {
  return ContractPageDataVersionsInnerFromJSONTyped(json, false);
}
function ContractPageDataVersionsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "revisionId": !exists(json, "revisionId") ? void 0 : json["revisionId"],
    "label": PhaseTypeFromJSON(json["label"]),
    "effectiveAt": new Date(json["effectiveAt"]),
    "name": !exists(json, "name") ? void 0 : json["name"],
    "isNonDeletable": !exists(json, "isNonDeletable") ? void 0 : json["isNonDeletable"],
    "createdAt": new Date(json["createdAt"])
  };
}

// src/generated/models/ContractPageData.ts
function ContractPageDataFromJSON(json) {
  return ContractPageDataFromJSONTyped(json, false);
}
function ContractPageDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract": ContractPageDataContractFromJSON(json["contract"]),
    "versions": json["versions"].map(ContractPageDataVersionsInnerFromJSON)
  };
}

// src/generated/models/ContractProductOverview.ts
function ContractProductOverviewFromJSON(json) {
  return ContractProductOverviewFromJSONTyped(json, false);
}
function ContractProductOverviewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "catalogProductId": !exists(json, "catalogProductId") ? void 0 : json["catalogProductId"],
    "name": json["name"],
    "description": json["description"],
    "totalPrice": json["totalPrice"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(ProductIntegrationEntityFromJSON)
  };
}

// src/generated/models/ContractRenewal.ts
function ContractRenewalFromJSON(json) {
  return ContractRenewalFromJSONTyped(json, false);
}
function ContractRenewalFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "contractId": json["contractId"],
    "effectiveDate": new Date(json["effectiveDate"]),
    "duration": PlanDurationFromJSON(json["duration"])
  };
}

// src/generated/models/NewBillingCycle.ts
function NewBillingCycleToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "billingDay": value.billingDay,
    "status": BillingCycleStatusToJSON(value.status),
    "customersIds": value.customersIds
  };
}

// src/generated/models/CreateBillingCycleRequest.ts
function CreateBillingCycleRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "newBillingCycle": NewBillingCycleToJSON(value.newBillingCycle)
  };
}

// src/generated/models/CreateBillingCycleResponse.ts
function CreateBillingCycleResponseFromJSON(json) {
  return CreateBillingCycleResponseFromJSONTyped(json, false);
}
function CreateBillingCycleResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "billingCycle": BillingCycleFromJSON(json["billingCycle"])
  };
}

// src/generated/models/CreateCatalogProductsRequest.ts
function CreateCatalogProductsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accountId": value.accountId,
    "name": value.name,
    "description": value.description,
    "isTaxable": value.isTaxable,
    "products": value.products === void 0 ? void 0 : value.products.map(ProductToJSON),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "externalIntegration": ProductExternalIntegrationToJSON(value.externalIntegration),
    "creditTypeIds": value.creditTypeIds
  };
}

// src/generated/models/CreateCatalogProductsResponse.ts
function CreateCatalogProductsResponseFromJSON(json) {
  return CreateCatalogProductsResponseFromJSONTyped(json, false);
}
function CreateCatalogProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "catalogProduct": CatalogProductsFromJSON(json["catalogProduct"])
  };
}

// src/generated/models/NewPlanProductsInner.ts
function NewPlanProductsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "variants": value.variants.map(NewProductVariantToJSON),
    "basePrice": value.basePrice,
    "additionalCharge": value.additionalCharge,
    "commitment": ProductConfigCommitmentToJSON(value.commitment),
    "advancePayment": AdvancePaymentToJSON(value.advancePayment),
    "chargingCadence": value.chargingCadence,
    "currencyCommitment": value.currencyCommitment,
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "accumulationInterval": value.accumulationInterval,
    "proRata": value.proRata,
    "erpMetadata": ErpMetadataToJSON(value.erpMetadata),
    "rateMultiplier": value.rateMultiplier,
    "isPeriodicVariants": value.isPeriodicVariants,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "startDate": value.startDate === void 0 ? void 0 : value.startDate === null ? null : value.startDate.toISOString(),
    "endDate": value.endDate === void 0 ? void 0 : value.endDate === null ? null : value.endDate.toISOString(),
    "catalogProductId": value.catalogProductId,
    "productConfigs": value.productConfigs === void 0 ? void 0 : value.productConfigs === null ? null : value.productConfigs.map(ProductConfigToJSON),
    "externalIntegration": ProductExternalIntegrationToJSON(value.externalIntegration),
    "revisionId": value.revisionId,
    "cloudProviderSettings": ProductCloudProviderSettingsToJSON(value.cloudProviderSettings),
    "isCalendarAligned": value.isCalendarAligned,
    "upliftConfiguration": ProductUpliftConfigurationToJSON(value.upliftConfiguration),
    "creditTypeIds": value.creditTypeIds,
    "creditPurchaseConfig": CreditPurchaseConfigToJSON(value.creditPurchaseConfig)
  };
}

// src/generated/models/NewPlan.ts
function NewPlanToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "products": value.products.map(NewPlanProductsInnerToJSON),
    "billingData": PlanBillingDataToJSON(value.billingData),
    "status": PlanStatusToJSON(value.status),
    "basedFromPlanId": value.basedFromPlanId,
    "trial": PlanTrialToJSON(value.trial),
    "purchaseOrder": value.purchaseOrder,
    "rawSyncData": PlanRawSyncDataToJSON(value.rawSyncData),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(IntegrationEntityToJSON)
  };
}

// src/generated/models/CreateContractsRequestOneOfContractsInner.ts
function CreateContractsRequestOneOfContractsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "startDate": value.startDate.toISOString(),
    "endDate": value.endDate === void 0 ? void 0 : value.endDate.toISOString(),
    "customerId": value.customerId,
    "status": ContractStatusToJSON(value.status),
    "contractType": ContractTypeToJSON(value.contractType),
    "parentAgreementSettings": ParentAgreementSettingsToJSON(value.parentAgreementSettings),
    "trialEndDate": value.trialEndDate === void 0 ? void 0 : value.trialEndDate.toISOString(),
    "cancelledAt": value.cancelledAt === void 0 ? void 0 : value.cancelledAt.toISOString(),
    "terminatedAt": value.terminatedAt === void 0 ? void 0 : value.terminatedAt.toISOString(),
    "revisedAt": value.revisedAt === void 0 ? void 0 : value.revisedAt.toISOString(),
    "initialStartDate": value.initialStartDate === void 0 ? void 0 : value.initialStartDate.toISOString(),
    "signatureDate": value.signatureDate === void 0 ? void 0 : value.signatureDate.toISOString(),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ContractIntegrationEntitiesInnerToJSON),
    "currencyOverride": CurrencyToJSON(value.currencyOverride),
    "customFieldValues": value.customFieldValues === void 0 ? void 0 : value.customFieldValues.map(CustomFieldValueToJSON),
    "notes": value.notes,
    "credits": value.credits === void 0 ? void 0 : value.credits.map(CreditPurchaseConfigToJSON),
    "isTrial": value.isTrial,
    "plan": NewPlanToJSON(value.plan)
  };
}

// src/generated/models/CreateContractsRequestOneOf.ts
function instanceOfCreateContractsRequestOneOf(value) {
  let isInstance = true;
  isInstance = isInstance && "creationType" in value;
  isInstance = isInstance && "contracts" in value;
  return isInstance;
}
function CreateContractsRequestOneOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "creationType": value.creationType,
    "contracts": value.contracts.map(CreateContractsRequestOneOfContractsInnerToJSON)
  };
}

// src/generated/models/NewContractWithoutPlanContractsInner.ts
function NewContractWithoutPlanContractsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "startDate": value.startDate.toISOString(),
    "planId": value.planId,
    "customerId": value.customerId,
    "status": ContractStatusToJSON(value.status),
    "contractType": ContractTypeToJSON(value.contractType),
    "parentAgreementSettings": ParentAgreementSettingsToJSON(value.parentAgreementSettings),
    "trialEndDate": value.trialEndDate === void 0 ? void 0 : value.trialEndDate.toISOString(),
    "cancelledAt": value.cancelledAt === void 0 ? void 0 : value.cancelledAt.toISOString(),
    "terminatedAt": value.terminatedAt === void 0 ? void 0 : value.terminatedAt.toISOString(),
    "revisedAt": value.revisedAt === void 0 ? void 0 : value.revisedAt.toISOString(),
    "initialStartDate": value.initialStartDate === void 0 ? void 0 : value.initialStartDate.toISOString(),
    "signatureDate": value.signatureDate === void 0 ? void 0 : value.signatureDate.toISOString(),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ContractIntegrationEntitiesInnerToJSON),
    "currencyOverride": CurrencyToJSON(value.currencyOverride),
    "customFieldValues": value.customFieldValues === void 0 ? void 0 : value.customFieldValues.map(CustomFieldValueToJSON),
    "notes": value.notes,
    "credits": value.credits === void 0 ? void 0 : value.credits.map(CreditPurchaseConfigToJSON),
    "isTrial": value.isTrial
  };
}

// src/generated/models/NewContractWithoutPlan.ts
function instanceOfNewContractWithoutPlan(value) {
  let isInstance = true;
  isInstance = isInstance && "creationType" in value;
  isInstance = isInstance && "contracts" in value;
  return isInstance;
}
function NewContractWithoutPlanToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "creationType": value.creationType,
    "contracts": value.contracts.map(NewContractWithoutPlanContractsInnerToJSON)
  };
}

// src/generated/models/CreateContractsRequest.ts
function CreateContractsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfCreateContractsRequestOneOf(value)) {
    return CreateContractsRequestOneOfToJSON(value);
  }
  if (instanceOfNewContractWithoutPlan(value)) {
    return NewContractWithoutPlanToJSON(value);
  }
  return {};
}

// src/generated/models/CreateContractsResponse.ts
function CreateContractsResponseFromJSON(json) {
  return CreateContractsResponseFromJSONTyped(json, false);
}
function CreateContractsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contracts": json["contracts"].map(ContractFromJSON)
  };
}

// src/generated/models/CreateCreditTypeRequest.ts
function CreateCreditTypeRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "units": value.units,
    "isTaxable": value.isTaxable
  };
}

// src/generated/models/CreditType.ts
function CreditTypeFromJSON(json) {
  return CreditTypeFromJSONTyped(json, false);
}
function CreditTypeFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "name": json["name"],
    "units": !exists(json, "units") ? void 0 : json["units"],
    "isTaxable": json["isTaxable"],
    "isDeletable": json["isDeletable"]
  };
}

// src/generated/models/CreateCreditTypeResponse.ts
function CreateCreditTypeResponseFromJSON(json) {
  return CreateCreditTypeResponseFromJSONTyped(json, false);
}
function CreateCreditTypeResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditType": CreditTypeFromJSON(json["creditType"])
  };
}

// src/generated/models/CreateCustomerNoteRequest.ts
function CreateCustomerNoteRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "content": value.content
  };
}

// src/generated/models/CreateCustomerNoteResponse.ts
function CreateCustomerNoteResponseFromJSON(json) {
  return CreateCustomerNoteResponseFromJSONTyped(json, false);
}
function CreateCustomerNoteResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "content": json["content"],
    "customerId": json["customerId"],
    "userEmail": json["userEmail"],
    "authorFirstName": !exists(json, "authorFirstName") ? void 0 : json["authorFirstName"],
    "authorLastName": !exists(json, "authorLastName") ? void 0 : json["authorLastName"],
    "createdAt": json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"]
  };
}

// src/generated/models/CreateCustomerRequest.ts
function CreateCustomerRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "legalName": value.legalName,
    "externalId": value.externalId,
    "aliases": value.aliases,
    "taxIds": value.taxIds,
    "crmId": value.crmId,
    "crmMetadata": CrmMetadataToJSON(value.crmMetadata),
    "erpMetadata": ErpMetadataToJSON(value.erpMetadata),
    "address": AddressToJSON(value.address),
    "contacts": value.contacts === void 0 ? void 0 : value.contacts === null ? null : value.contacts.map(ContactToJSON),
    "settings": CustomerSettingsToJSON(value.settings),
    "revenueBreakdown": CustomerRevenueBreakdownToJSON(value.revenueBreakdown),
    "status": CustomerStatusToJSON(value.status),
    "source": CustomerSourceToJSON(value.source),
    "subsidiaryId": value.subsidiaryId,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(CustomerIntegrationEntityToJSON),
    "externalIntegration": value.externalIntegration === void 0 ? void 0 : value.externalIntegration === null ? null : value.externalIntegration.map(CustomerExternalIntegrationInnerToJSON),
    "accountOwnerId": value.accountOwnerId,
    "customFieldValues": value.customFieldValues === void 0 ? void 0 : value.customFieldValues.map(CustomFieldValueToJSON)
  };
}

// src/generated/models/CreateCustomerResponse.ts
function CreateCustomerResponseFromJSON(json) {
  return CreateCustomerResponseFromJSONTyped(json, false);
}
function CreateCustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": CustomerFromJSON(json["customer"])
  };
}

// src/generated/models/FixedPricing.ts
function FixedPricingFromJSON(json) {
  return FixedPricingFromJSONTyped(json, false);
}
function FixedPricingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["pricingModel"]) {
    case "CommercialTerms":
      return { ...CommercialTermsPricingFromJSONTyped(json, true), pricingModel: "CommercialTerms" };
    case "Commission":
      return { ...CommissionPricingFromJSONTyped(json, true), pricingModel: "Commission" };
    case "FixedDeduction":
      return { ...FixedDeductionPricingFromJSONTyped(json, true), pricingModel: "FixedDeduction" };
    case "FixedOneTime":
      return { ...OneTimePricingFromJSONTyped(json, true), pricingModel: "FixedOneTime" };
    case "PercentageDeduction":
      return { ...PercentageDeductionPricingFromJSONTyped(json, true), pricingModel: "PercentageDeduction" };
    case "Refund":
      return { ...RefundPricingFromJSONTyped(json, true), pricingModel: "Refund" };
    case "Subscription":
      return { ...RecurringPricingFromJSONTyped(json, true), pricingModel: "Subscription" };
    default:
      throw new Error(`No variant of FixedPricing exists with 'pricingModel=${json["pricingModel"]}'`);
  }
}
function FixedPricingToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["pricingModel"]) {
    case "CommercialTerms":
      return CommercialTermsPricingToJSON(value);
    case "Commission":
      return CommissionPricingToJSON(value);
    case "FixedDeduction":
      return FixedDeductionPricingToJSON(value);
    case "FixedOneTime":
      return OneTimePricingToJSON(value);
    case "PercentageDeduction":
      return PercentageDeductionPricingToJSON(value);
    case "Refund":
      return RefundPricingToJSON(value);
    case "Subscription":
      return RecurringPricingToJSON(value);
    default:
      throw new Error(`No variant of FixedPricing exists with 'pricingModel=${value["pricingModel"]}'`);
  }
}

// src/generated/models/NewFixedProductVariant.ts
function NewFixedProductVariantToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "meterId": value.meterId,
    "pricing": FixedPricingToJSON(value.pricing),
    "settings": ProductSettingsToJSON(value.settings),
    "description": value.description,
    "name": value.name
  };
}

// src/generated/models/CreateInvoiceRequestFixedProductsInner.ts
function CreateInvoiceRequestFixedProductsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "variants": value.variants.map(NewFixedProductVariantToJSON),
    "basePrice": value.basePrice,
    "additionalCharge": value.additionalCharge,
    "commitment": ProductConfigCommitmentToJSON(value.commitment),
    "advancePayment": AdvancePaymentToJSON(value.advancePayment),
    "chargingCadence": value.chargingCadence,
    "currencyCommitment": value.currencyCommitment,
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "accumulationInterval": value.accumulationInterval,
    "proRata": value.proRata,
    "erpMetadata": ErpMetadataToJSON(value.erpMetadata),
    "rateMultiplier": value.rateMultiplier,
    "isPeriodicVariants": value.isPeriodicVariants,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "startDate": value.startDate === void 0 ? void 0 : value.startDate === null ? null : value.startDate.toISOString(),
    "endDate": value.endDate === void 0 ? void 0 : value.endDate === null ? null : value.endDate.toISOString(),
    "catalogProductId": value.catalogProductId,
    "productConfigs": value.productConfigs === void 0 ? void 0 : value.productConfigs === null ? null : value.productConfigs.map(ProductConfigToJSON),
    "externalIntegration": ProductExternalIntegrationToJSON(value.externalIntegration),
    "revisionId": value.revisionId,
    "cloudProviderSettings": ProductCloudProviderSettingsToJSON(value.cloudProviderSettings),
    "isCalendarAligned": value.isCalendarAligned,
    "upliftConfiguration": ProductUpliftConfigurationToJSON(value.upliftConfiguration),
    "creditTypeIds": value.creditTypeIds,
    "creditPurchaseConfig": CreditPurchaseConfigToJSON(value.creditPurchaseConfig)
  };
}

// src/generated/models/CreateInvoiceSettings.ts
function CreateInvoiceSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "customerId": value.customerId,
    "contractId": value.contractId,
    "currency": CurrencyToJSON(value.currency),
    "startDate": value.startDate,
    "endDate": value.endDate,
    "issueDate": value.issueDate,
    "paymentDueDays": value.paymentDueDays,
    "purchaseOrder": value.purchaseOrder,
    "refundsInvoiceId": value.refundsInvoiceId
  };
}

// src/generated/models/CreateInvoiceRequest.ts
function CreateInvoiceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "fixedProducts": value.fixedProducts.map(CreateInvoiceRequestFixedProductsInnerToJSON),
    "settings": CreateInvoiceSettingsToJSON(value.settings),
    "contractId": value.contractId,
    "credits": value.credits === void 0 ? void 0 : value.credits.map(CreditPurchaseConfigToJSON)
  };
}

// src/generated/models/CreateInvoiceResponse.ts
function CreateInvoiceResponseFromJSON(json) {
  return CreateInvoiceResponseFromJSONTyped(json, false);
}
function CreateInvoiceResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "customerId": json["customerId"]
  };
}

// src/generated/models/CreateLabelRequest.ts
function CreateLabelRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "color": value.color,
    "backgroundColor": value.backgroundColor
  };
}

// src/generated/models/Label.ts
function LabelFromJSON(json) {
  return LabelFromJSONTyped(json, false);
}
function LabelFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "name": json["name"],
    "color": json["color"],
    "backgroundColor": json["backgroundColor"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/CreateLabelResponse.ts
function CreateLabelResponseFromJSON(json) {
  return CreateLabelResponseFromJSONTyped(json, false);
}
function CreateLabelResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "label": LabelFromJSON(json["label"])
  };
}

// src/generated/models/NewCommitmentLineItem.ts
function NewCommitmentLineItemToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceId": value.invoiceId,
    "revenueBreakdown": CustomerRevenueBreakdownToJSON(value.revenueBreakdown),
    "isRevised": value.isRevised,
    "disabled": value.disabled,
    "modifiedName": value.modifiedName,
    "modifiedDescription": value.modifiedDescription,
    "modifiedPrice": value.modifiedPrice,
    "percentage": value.percentage,
    "lineItemPeriod": PeriodToJSON(value.lineItemPeriod),
    "originalInvoiceData": OriginalInvoiceDataToJSON(value.originalInvoiceData),
    "saleTax": SaleTaxToJSON(value.saleTax),
    "lineItemProduct": NewLineItemProductToJSON(value.lineItemProduct),
    "type": value.type,
    "units": value.units,
    "commitmentTiersUsageMap": value.commitmentTiersUsageMap
  };
}

// src/generated/models/NewFixedLineItem.ts
function NewFixedLineItemToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceId": value.invoiceId,
    "revenueBreakdown": CustomerRevenueBreakdownToJSON(value.revenueBreakdown),
    "isRevised": value.isRevised,
    "disabled": value.disabled,
    "modifiedName": value.modifiedName,
    "modifiedDescription": value.modifiedDescription,
    "modifiedPrice": value.modifiedPrice,
    "percentage": value.percentage,
    "lineItemPeriod": PeriodToJSON(value.lineItemPeriod),
    "originalInvoiceData": OriginalInvoiceDataToJSON(value.originalInvoiceData),
    "saleTax": SaleTaxToJSON(value.saleTax),
    "lineItemProduct": LineItemProductToJSON(value.lineItemProduct),
    "type": value.type,
    "tiersUsageMap": value.tiersUsageMap
  };
}

// src/generated/models/NewNonProductFixedLineItemAllOfLineItemProductExternalIntegration.ts
function NewNonProductFixedLineItemAllOfLineItemProductExternalIntegrationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": IntegrationProvidersToJSON(value.type),
    "id": value.id,
    "code": value.code
  };
}

// src/generated/models/NewNonProductFixedLineItemAllOfLineItemProduct.ts
function NewNonProductFixedLineItemAllOfLineItemProductToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "basePrice": value.basePrice,
    "additionalCharge": value.additionalCharge,
    "proRata": value.proRata,
    "rateMultiplier": value.rateMultiplier,
    "variants": value.variants.map(LineItemProductVariantToJSON),
    "commitment": LineItemProductCommitmentToJSON(value.commitment),
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "accumulationInterval": value.accumulationInterval,
    "currencyCommitment": value.currencyCommitment,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "externalIntegration": NewNonProductFixedLineItemAllOfLineItemProductExternalIntegrationToJSON(value.externalIntegration),
    "cloudProviderSettings": ProductCloudProviderSettingsToJSON(value.cloudProviderSettings),
    "creditTypeIds": value.creditTypeIds,
    "creditPurchaseConfig": CreditPurchaseConfigToJSON(value.creditPurchaseConfig)
  };
}

// src/generated/models/NewNonProductFixedLineItem.ts
function NewNonProductFixedLineItemToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceId": value.invoiceId,
    "revenueBreakdown": CustomerRevenueBreakdownToJSON(value.revenueBreakdown),
    "isRevised": value.isRevised,
    "disabled": value.disabled,
    "modifiedName": value.modifiedName,
    "modifiedDescription": value.modifiedDescription,
    "modifiedPrice": value.modifiedPrice,
    "percentage": value.percentage,
    "lineItemPeriod": PeriodToJSON(value.lineItemPeriod),
    "originalInvoiceData": OriginalInvoiceDataToJSON(value.originalInvoiceData),
    "saleTax": SaleTaxToJSON(value.saleTax),
    "type": value.type,
    "lineItemProduct": NewNonProductFixedLineItemAllOfLineItemProductToJSON(value.lineItemProduct)
  };
}

// src/generated/models/NewUsageLineItem.ts
function NewUsageLineItemToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceId": value.invoiceId,
    "revenueBreakdown": CustomerRevenueBreakdownToJSON(value.revenueBreakdown),
    "isRevised": value.isRevised,
    "disabled": value.disabled,
    "modifiedName": value.modifiedName,
    "modifiedDescription": value.modifiedDescription,
    "modifiedPrice": value.modifiedPrice,
    "percentage": value.percentage,
    "lineItemPeriod": PeriodToJSON(value.lineItemPeriod),
    "originalInvoiceData": OriginalInvoiceDataToJSON(value.originalInvoiceData),
    "saleTax": SaleTaxToJSON(value.saleTax),
    "lineItemProduct": LineItemProductToJSON(value.lineItemProduct),
    "type": value.type,
    "units": value.units,
    "tiersUsageMap": value.tiersUsageMap,
    "instanceUsageMap": value.instanceUsageMap
  };
}

// src/generated/models/CreateLineItemRequest.ts
function CreateLineItemRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["type"]) {
    case "Commitment":
      return NewCommitmentLineItemToJSON(value);
    case "Fixed":
      return NewFixedLineItemToJSON(value);
    case "NonProductFixed":
      return NewNonProductFixedLineItemToJSON(value);
    case "Usage":
      return NewUsageLineItemToJSON(value);
    default:
      throw new Error(`No variant of CreateLineItemRequest exists with 'type=${value["type"]}'`);
  }
}

// src/generated/models/FixedLineItem.ts
function FixedLineItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "isRevised": json["isRevised"],
    "disabled": !exists(json, "disabled") ? void 0 : json["disabled"],
    "modifiedName": json["modifiedName"],
    "modifiedDescription": json["modifiedDescription"],
    "modifiedPrice": !exists(json, "modifiedPrice") ? void 0 : json["modifiedPrice"],
    "percentage": !exists(json, "percentage") ? void 0 : json["percentage"],
    "lineItemPeriod": !exists(json, "lineItemPeriod") ? void 0 : PeriodFromJSON(json["lineItemPeriod"]),
    "originalInvoiceData": !exists(json, "originalInvoiceData") ? void 0 : OriginalInvoiceDataFromJSON(json["originalInvoiceData"]),
    "saleTax": !exists(json, "saleTax") ? void 0 : SaleTaxFromJSON(json["saleTax"]),
    "lineItemProduct": LineItemProductFromJSON(json["lineItemProduct"]),
    "type": json["type"],
    "tiersUsageMap": !exists(json, "tiersUsageMap") ? void 0 : json["tiersUsageMap"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/NonProductFixedLineItemLineItemProduct.ts
function NonProductFixedLineItemLineItemProductFromJSON(json) {
  return NonProductFixedLineItemLineItemProductFromJSONTyped(json, false);
}
function NonProductFixedLineItemLineItemProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": !exists(json, "name") ? void 0 : json["name"],
    "basePrice": !exists(json, "basePrice") ? void 0 : json["basePrice"],
    "additionalCharge": !exists(json, "additionalCharge") ? void 0 : json["additionalCharge"],
    "proRata": json["proRata"],
    "rateMultiplier": !exists(json, "rateMultiplier") ? void 0 : json["rateMultiplier"],
    "variants": json["variants"].map(LineItemProductVariantFromJSON),
    "commitment": !exists(json, "commitment") ? void 0 : LineItemProductCommitmentFromJSON(json["commitment"]),
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "accumulationInterval": !exists(json, "accumulationInterval") ? void 0 : json["accumulationInterval"],
    "currencyCommitment": !exists(json, "currencyCommitment") ? void 0 : json["currencyCommitment"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : ProductExternalIntegrationFromJSON(json["externalIntegration"]),
    "cloudProviderSettings": !exists(json, "cloudProviderSettings") ? void 0 : ProductCloudProviderSettingsFromJSON(json["cloudProviderSettings"]),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "creditPurchaseConfig": !exists(json, "creditPurchaseConfig") ? void 0 : CreditPurchaseConfigFromJSON(json["creditPurchaseConfig"])
  };
}

// src/generated/models/NonProductFixedLineItem.ts
function NonProductFixedLineItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "isRevised": json["isRevised"],
    "disabled": !exists(json, "disabled") ? void 0 : json["disabled"],
    "modifiedName": json["modifiedName"],
    "modifiedDescription": json["modifiedDescription"],
    "modifiedPrice": !exists(json, "modifiedPrice") ? void 0 : json["modifiedPrice"],
    "percentage": !exists(json, "percentage") ? void 0 : json["percentage"],
    "lineItemPeriod": !exists(json, "lineItemPeriod") ? void 0 : PeriodFromJSON(json["lineItemPeriod"]),
    "originalInvoiceData": !exists(json, "originalInvoiceData") ? void 0 : OriginalInvoiceDataFromJSON(json["originalInvoiceData"]),
    "saleTax": !exists(json, "saleTax") ? void 0 : SaleTaxFromJSON(json["saleTax"]),
    "type": json["type"],
    "lineItemProduct": NonProductFixedLineItemLineItemProductFromJSON(json["lineItemProduct"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/UsageLineItem.ts
function UsageLineItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "isRevised": json["isRevised"],
    "disabled": !exists(json, "disabled") ? void 0 : json["disabled"],
    "modifiedName": json["modifiedName"],
    "modifiedDescription": json["modifiedDescription"],
    "modifiedPrice": !exists(json, "modifiedPrice") ? void 0 : json["modifiedPrice"],
    "percentage": !exists(json, "percentage") ? void 0 : json["percentage"],
    "lineItemPeriod": !exists(json, "lineItemPeriod") ? void 0 : PeriodFromJSON(json["lineItemPeriod"]),
    "originalInvoiceData": !exists(json, "originalInvoiceData") ? void 0 : OriginalInvoiceDataFromJSON(json["originalInvoiceData"]),
    "saleTax": !exists(json, "saleTax") ? void 0 : SaleTaxFromJSON(json["saleTax"]),
    "lineItemProduct": LineItemProductFromJSON(json["lineItemProduct"]),
    "type": json["type"],
    "units": json["units"],
    "tiersUsageMap": json["tiersUsageMap"],
    "instanceUsageMap": !exists(json, "instanceUsageMap") ? void 0 : json["instanceUsageMap"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/LineItem.ts
function LineItemFromJSON(json) {
  return LineItemFromJSONTyped(json, false);
}
function LineItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "Commitment":
      return { ...CommitmentLineItemFromJSONTyped(json, true), type: "Commitment" };
    case "Fixed":
      return { ...FixedLineItemFromJSONTyped(json, true), type: "Fixed" };
    case "NonProductFixed":
      return { ...NonProductFixedLineItemFromJSONTyped(json, true), type: "NonProductFixed" };
    case "Usage":
      return { ...UsageLineItemFromJSONTyped(json, true), type: "Usage" };
    default:
      throw new Error(`No variant of LineItem exists with 'type=${json["type"]}'`);
  }
}

// src/generated/models/CreateLineItemResponse.ts
function CreateLineItemResponseFromJSON(json) {
  return CreateLineItemResponseFromJSONTyped(json, false);
}
function CreateLineItemResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "updatedLineItem": LineItemFromJSON(json["updatedLineItem"])
  };
}

// src/generated/models/CreateMeterRequest.ts
function CreateMeterRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "eventName": value.eventName,
    "name": value.name,
    "description": value.description,
    "unitsType": value.unitsType,
    "filter": FilterToJSON(value.filter),
    "aggregationMethod": AggregationMethodToJSON(value.aggregationMethod),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "creditTypeIds": value.creditTypeIds,
    "isTaxable": value.isTaxable
  };
}

// src/generated/models/CreatePlanRequest.ts
function CreatePlanRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "products": value.products.map(NewPlanProductsInnerToJSON),
    "billingData": PlanBillingDataToJSON(value.billingData),
    "status": PlanStatusToJSON(value.status),
    "basedFromPlanId": value.basedFromPlanId,
    "trial": PlanTrialToJSON(value.trial),
    "purchaseOrder": value.purchaseOrder,
    "rawSyncData": PlanRawSyncDataToJSON(value.rawSyncData),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(IntegrationEntityToJSON)
  };
}

// src/generated/models/CreatePlanResponse.ts
function CreatePlanResponseFromJSON(json) {
  return CreatePlanResponseFromJSONTyped(json, false);
}
function CreatePlanResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "plan": PlanFromJSON(json["plan"])
  };
}

// src/generated/models/CreatePublicApiKeyRequest.ts
function CreatePublicApiKeyRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name
  };
}

// src/generated/models/CreatePublicApiKeyResponse.ts
function CreatePublicApiKeyResponseFromJSON(json) {
  return CreatePublicApiKeyResponseFromJSONTyped(json, false);
}
function CreatePublicApiKeyResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "keyValue": json["keyValue"],
    "prefix": json["prefix"],
    "createdAt": json["createdAt"]
  };
}

// src/generated/models/NewAccountSettingsInvoicingSettings.ts
function NewAccountSettingsInvoicingSettingsFromJSON(json) {
  return NewAccountSettingsInvoicingSettingsFromJSONTyped(json, false);
}
function NewAccountSettingsInvoicingSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "hideZeroAmountLineItems": json["hideZeroAmountLineItems"],
    "showConsumptionBreakdown": json["showConsumptionBreakdown"],
    "forceCommitmentBreakdown": json["forceCommitmentBreakdown"],
    "hidePriceBreakdownInInvoicePdf": !exists(json, "hidePriceBreakdownInInvoicePdf") ? void 0 : json["hidePriceBreakdownInInvoicePdf"],
    "showPaymentWalletInfo": json["showPaymentWalletInfo"],
    "issueOnApproval": json["issueOnApproval"],
    "excludeUsdtWallet": !exists(json, "excludeUsdtWallet") ? void 0 : json["excludeUsdtWallet"],
    "sendInvoiceOnApproval": json["sendInvoiceOnApproval"],
    "defaultPaymentDueDays": !exists(json, "defaultPaymentDueDays") ? void 0 : json["defaultPaymentDueDays"],
    "issueOnEndOfMonth": json["issueOnEndOfMonth"],
    "deductCredits": !exists(json, "deductCredits") ? void 0 : json["deductCredits"],
    "showCustomerPortalLink": !exists(json, "showCustomerPortalLink") ? void 0 : json["showCustomerPortalLink"],
    "showProductVariantOnInvoice": !exists(json, "showProductVariantOnInvoice") ? void 0 : json["showProductVariantOnInvoice"],
    "creditOnPrepaidRevision": !exists(json, "creditOnPrepaidRevision") ? void 0 : json["creditOnPrepaidRevision"],
    "restrictPaymentsToCreditPoolBalance": !exists(json, "restrictPaymentsToCreditPoolBalance") ? void 0 : json["restrictPaymentsToCreditPoolBalance"]
  };
}
function NewAccountSettingsInvoicingSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "hideZeroAmountLineItems": value.hideZeroAmountLineItems,
    "showConsumptionBreakdown": value.showConsumptionBreakdown,
    "forceCommitmentBreakdown": value.forceCommitmentBreakdown,
    "hidePriceBreakdownInInvoicePdf": value.hidePriceBreakdownInInvoicePdf,
    "showPaymentWalletInfo": value.showPaymentWalletInfo,
    "issueOnApproval": value.issueOnApproval,
    "excludeUsdtWallet": value.excludeUsdtWallet,
    "sendInvoiceOnApproval": value.sendInvoiceOnApproval,
    "defaultPaymentDueDays": value.defaultPaymentDueDays,
    "issueOnEndOfMonth": value.issueOnEndOfMonth,
    "deductCredits": value.deductCredits,
    "showCustomerPortalLink": value.showCustomerPortalLink,
    "showProductVariantOnInvoice": value.showProductVariantOnInvoice,
    "creditOnPrepaidRevision": value.creditOnPrepaidRevision,
    "restrictPaymentsToCreditPoolBalance": value.restrictPaymentsToCreditPoolBalance
  };
}

// src/generated/models/NewBankDetails.ts
function NewBankDetailsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "bankName": value.bankName,
    "routingNumber": value.routingNumber,
    "companyName": value.companyName,
    "accountNumber": value.accountNumber,
    "address": AddressToJSON(value.address),
    "swiftCode": value.swiftCode,
    "abaNumber": value.abaNumber,
    "sortCode": value.sortCode
  };
}

// src/generated/models/NewBillingSettings.ts
function NewBillingSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "billingCycle": PeriodToJSON(value.billingCycle),
    "decimalPrecision": value.decimalPrecision
  };
}

// src/generated/models/NewAccountSettings.ts
function NewAccountSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "address": AddressToJSON(value.address),
    "billingSettings": NewBillingSettingsToJSON(value.billingSettings),
    "bankDetails": NewBankDetailsToJSON(value.bankDetails),
    "invoicingSettings": NewAccountSettingsInvoicingSettingsToJSON(value.invoicingSettings),
    "emailSettings": EmailSettingsToJSON(value.emailSettings),
    "securitySettings": AccountSecuritySettingsToJSON(value.securitySettings),
    "taxId": value.taxId,
    "enabledFeatures": value.enabledFeatures,
    "inboundEmailLocalPart": value.inboundEmailLocalPart,
    "inboundEmailAllowedSenders": value.inboundEmailAllowedSenders
  };
}

// src/generated/models/NewSubsidiaryErpSettingsOneOf.ts
function instanceOfNewSubsidiaryErpSettingsOneOf(value) {
  let isInstance = true;
  isInstance = isInstance && "integration" in value;
  return isInstance;
}
function NewSubsidiaryErpSettingsOneOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integration": json["integration"],
    "salesOrderDefaultFormId": !exists(json, "salesOrderDefaultFormId") ? void 0 : json["salesOrderDefaultFormId"]
  };
}
function NewSubsidiaryErpSettingsOneOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integration": value.integration,
    "salesOrderDefaultFormId": value.salesOrderDefaultFormId
  };
}

// src/generated/models/NewSubsidiaryErpSettingsOneOf1.ts
function instanceOfNewSubsidiaryErpSettingsOneOf1(value) {
  let isInstance = true;
  isInstance = isInstance && "integration" in value;
  return isInstance;
}
function NewSubsidiaryErpSettingsOneOf1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integration": json["integration"]
  };
}
function NewSubsidiaryErpSettingsOneOf1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integration": value.integration
  };
}

// src/generated/models/NewSubsidiaryErpSettingsOneOf2.ts
function instanceOfNewSubsidiaryErpSettingsOneOf2(value) {
  let isInstance = true;
  isInstance = isInstance && "integration" in value;
  return isInstance;
}
function NewSubsidiaryErpSettingsOneOf2FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integration": json["integration"]
  };
}
function NewSubsidiaryErpSettingsOneOf2ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integration": value.integration
  };
}

// src/generated/models/NewSubsidiaryErpSettings.ts
function NewSubsidiaryErpSettingsFromJSON(json) {
  return NewSubsidiaryErpSettingsFromJSONTyped(json, false);
}
function NewSubsidiaryErpSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...NewSubsidiaryErpSettingsOneOfFromJSONTyped(json, true), ...NewSubsidiaryErpSettingsOneOf1FromJSONTyped(json, true), ...NewSubsidiaryErpSettingsOneOf2FromJSONTyped(json, true) };
}
function NewSubsidiaryErpSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfNewSubsidiaryErpSettingsOneOf(value)) {
    return NewSubsidiaryErpSettingsOneOfToJSON(value);
  }
  if (instanceOfNewSubsidiaryErpSettingsOneOf1(value)) {
    return NewSubsidiaryErpSettingsOneOf1ToJSON(value);
  }
  if (instanceOfNewSubsidiaryErpSettingsOneOf2(value)) {
    return NewSubsidiaryErpSettingsOneOf2ToJSON(value);
  }
  return {};
}

// src/generated/models/NewSubsidiaryErp.ts
function NewSubsidiaryErpFromJSON(json) {
  return NewSubsidiaryErpFromJSONTyped(json, false);
}
function NewSubsidiaryErpFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationId": json["integrationId"],
    "integration": json["integration"],
    "settings": !exists(json, "settings") ? void 0 : NewSubsidiaryErpSettingsFromJSON(json["settings"])
  };
}
function NewSubsidiaryErpToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integrationId": value.integrationId,
    "integration": value.integration,
    "settings": NewSubsidiaryErpSettingsToJSON(value.settings)
  };
}

// src/generated/models/NewSubsidiary.ts
function NewSubsidiaryToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "isPrimary": value.isPrimary,
    "taxId": value.taxId,
    "erp": NewSubsidiaryErpToJSON(value.erp),
    "settings": NewAccountSettingsToJSON(value.settings)
  };
}

// src/generated/models/CreateSubsidiaryRequest.ts
function CreateSubsidiaryRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "subsidiary": NewSubsidiaryToJSON(value.subsidiary)
  };
}

// src/generated/models/Subsidiary.ts
function SubsidiaryFromJSON(json) {
  return SubsidiaryFromJSONTyped(json, false);
}
function SubsidiaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "isPrimary": !exists(json, "isPrimary") ? void 0 : json["isPrimary"],
    "taxId": !exists(json, "taxId") ? void 0 : json["taxId"],
    "erp": !exists(json, "erp") ? void 0 : NewSubsidiaryErpFromJSON(json["erp"]),
    "settings": AccountSettingsFromJSON(json["settings"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/CreateSubsidiaryResponse.ts
function CreateSubsidiaryResponseFromJSON(json) {
  return CreateSubsidiaryResponseFromJSONTyped(json, false);
}
function CreateSubsidiaryResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "subsidiary": SubsidiaryFromJSON(json["subsidiary"])
  };
}

// src/generated/models/NotificationEventType.ts
function NotificationEventTypeFromJSON(json) {
  return NotificationEventTypeFromJSONTyped(json, false);
}
function NotificationEventTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function NotificationEventTypeToJSON(value) {
  return value;
}

// src/generated/models/CreateWebhookSubscriptionRequest.ts
function CreateWebhookSubscriptionRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "callbackUrl": value.callbackUrl,
    "eventType": NotificationEventTypeToJSON(value.eventType),
    "threshold": value.threshold
  };
}

// src/generated/models/CreateWebhookSubscriptionResponse.ts
function CreateWebhookSubscriptionResponseFromJSON(json) {
  return CreateWebhookSubscriptionResponseFromJSONTyped(json, false);
}
function CreateWebhookSubscriptionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "eventType": NotificationEventTypeFromJSON(json["eventType"]),
    "callbackUrl": json["callbackUrl"],
    "threshold": !exists(json, "threshold") ? void 0 : json["threshold"],
    "createdAt": json["createdAt"]
  };
}

// src/generated/models/CreateWorkflowRequestGraph.ts
function CreateWorkflowRequestGraphToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "startStepId": value.startStepId,
    "steps": value.steps
  };
}

// src/generated/models/WorkflowStarterSummaryTriggerOneOf1.ts
function instanceOfWorkflowStarterSummaryTriggerOneOf1(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "topic" in value;
  return isInstance;
}
function WorkflowStarterSummaryTriggerOneOf1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "topic": json["topic"],
    "filterPolicy": !exists(json, "filterPolicy") ? void 0 : json["filterPolicy"]
  };
}
function WorkflowStarterSummaryTriggerOneOf1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "topic": value.topic,
    "filterPolicy": value.filterPolicy
  };
}

// src/generated/models/WorkflowStarterSummaryTriggerOneOf2.ts
function instanceOfWorkflowStarterSummaryTriggerOneOf2(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  return isInstance;
}
function WorkflowStarterSummaryTriggerOneOf2FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"]
  };
}
function WorkflowStarterSummaryTriggerOneOf2ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type
  };
}

// src/generated/models/WorkflowSummaryTriggerOneOf.ts
function instanceOfWorkflowSummaryTriggerOneOf(value) {
  let isInstance = true;
  isInstance = isInstance && "type" in value;
  isInstance = isInstance && "schedule" in value;
  return isInstance;
}
function WorkflowSummaryTriggerOneOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "schedule": json["schedule"],
    "configurableSchedule": !exists(json, "configurableSchedule") ? void 0 : json["configurableSchedule"]
  };
}
function WorkflowSummaryTriggerOneOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": value.type,
    "schedule": value.schedule,
    "configurableSchedule": value.configurableSchedule
  };
}

// src/generated/models/WorkflowSummaryTrigger.ts
function WorkflowSummaryTriggerFromJSON(json) {
  return WorkflowSummaryTriggerFromJSONTyped(json, false);
}
function WorkflowSummaryTriggerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...WorkflowStarterSummaryTriggerOneOf1FromJSONTyped(json, true), ...WorkflowStarterSummaryTriggerOneOf2FromJSONTyped(json, true), ...WorkflowSummaryTriggerOneOfFromJSONTyped(json, true) };
}
function WorkflowSummaryTriggerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfWorkflowStarterSummaryTriggerOneOf1(value)) {
    return WorkflowStarterSummaryTriggerOneOf1ToJSON(value);
  }
  if (instanceOfWorkflowStarterSummaryTriggerOneOf2(value)) {
    return WorkflowStarterSummaryTriggerOneOf2ToJSON(value);
  }
  if (instanceOfWorkflowSummaryTriggerOneOf(value)) {
    return WorkflowSummaryTriggerOneOfToJSON(value);
  }
  return {};
}

// src/generated/models/CreateWorkflowRequest.ts
function CreateWorkflowRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "starterTemplateId": value.starterTemplateId,
    "trigger": WorkflowSummaryTriggerToJSON(value.trigger),
    "graph": CreateWorkflowRequestGraphToJSON(value.graph)
  };
}

// src/generated/models/WorkflowStarterAllOfGraph.ts
function WorkflowStarterAllOfGraphFromJSON(json) {
  return WorkflowStarterAllOfGraphFromJSONTyped(json, false);
}
function WorkflowStarterAllOfGraphFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startStepId": json["startStepId"],
    "steps": json["steps"]
  };
}

// src/generated/models/Workflow.ts
function WorkflowFromJSON(json) {
  return WorkflowFromJSONTyped(json, false);
}
function WorkflowFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "definitionId": json["definitionId"],
    "version": json["version"],
    "status": json["status"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "starterTemplateId": !exists(json, "starterTemplateId") ? void 0 : json["starterTemplateId"],
    "trigger": WorkflowSummaryTriggerFromJSON(json["trigger"]),
    "createdAt": json["createdAt"],
    "updatedAt": json["updatedAt"],
    "lastExecutionAt": !exists(json, "lastExecutionAt") ? void 0 : json["lastExecutionAt"],
    "lastExecutionStatus": !exists(json, "lastExecutionStatus") ? void 0 : json["lastExecutionStatus"],
    "previousVersionId": !exists(json, "previousVersionId") ? void 0 : json["previousVersionId"],
    "graph": WorkflowStarterAllOfGraphFromJSON(json["graph"]),
    "createdBy": json["createdBy"],
    "publishedAt": !exists(json, "publishedAt") ? void 0 : json["publishedAt"],
    "publishedBy": !exists(json, "publishedBy") ? void 0 : json["publishedBy"],
    "obsoletedAt": !exists(json, "obsoletedAt") ? void 0 : json["obsoletedAt"]
  };
}

// src/generated/models/CreateWorkflowResponse.ts
function CreateWorkflowResponseFromJSON(json) {
  return CreateWorkflowResponseFromJSONTyped(json, false);
}
function CreateWorkflowResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workflow": WorkflowFromJSON(json["workflow"])
  };
}

// src/generated/models/CreateWorkflowVersionRequest.ts
function CreateWorkflowVersionRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "trigger": WorkflowSummaryTriggerToJSON(value.trigger),
    "graph": CreateWorkflowRequestGraphToJSON(value.graph)
  };
}

// src/generated/models/CreateWorkflowVersionResponse.ts
function CreateWorkflowVersionResponseFromJSON(json) {
  return CreateWorkflowVersionResponseFromJSONTyped(json, false);
}
function CreateWorkflowVersionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workflow": WorkflowFromJSON(json["workflow"])
  };
}

// src/generated/models/CreditLedgerEntryOverview.ts
function CreditLedgerEntryOverviewFromJSON(json) {
  return CreditLedgerEntryOverviewFromJSONTyped(json, false);
}
function CreditLedgerEntryOverviewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "date": new Date(json["date"]),
    "invoiceId": !exists(json, "invoiceId") ? void 0 : json["invoiceId"],
    "invoiceNumber": json["invoiceNumber"],
    "debitAmount": !exists(json, "debitAmount") ? void 0 : json["debitAmount"],
    "creditAmount": !exists(json, "creditAmount") ? void 0 : json["creditAmount"],
    "balance": json["balance"],
    "isInvoiceExportedToNetSuite": !exists(json, "isInvoiceExportedToNetSuite") ? void 0 : json["isInvoiceExportedToNetSuite"]
  };
}

// src/generated/models/CreditPoolEntry.ts
function CreditPoolEntryFromJSON(json) {
  return CreditPoolEntryFromJSONTyped(json, false);
}
function CreditPoolEntryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "creditPoolId": json["creditPoolId"],
    "lineItemId": json["lineItemId"],
    "type": json["type"],
    "amount": json["amount"],
    "balanceAfter": json["balanceAfter"],
    "expiryDate": !exists(json, "expiryDate") ? void 0 : new Date(json["expiryDate"]),
    "createdAt": new Date(json["createdAt"])
  };
}

// src/generated/models/CreditPool.ts
function CreditPoolFromJSON(json) {
  return CreditPoolFromJSONTyped(json, false);
}
function CreditPoolFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "customerId": json["customerId"],
    "creditTypeId": json["creditTypeId"],
    "creditKind": json["creditKind"],
    "accountId": json["accountId"],
    "balance": json["balance"],
    "projectedBalance": json["projectedBalance"],
    "initialGrantSchedule": json["initialGrantSchedule"],
    "closestEntryExpiryDate": !exists(json, "closestEntryExpiryDate") ? void 0 : new Date(json["closestEntryExpiryDate"]),
    "entries": json["entries"].map(CreditPoolEntryFromJSON)
  };
}

// src/generated/models/CreditPoolDepletedNotificationMetadata.ts
function CreditPoolDepletedNotificationMetadataFromJSON(json) {
  return CreditPoolDepletedNotificationMetadataFromJSONTyped(json, false);
}
function CreditPoolDepletedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customerId": json["customerId"],
    "creditPoolId": json["creditPoolId"],
    "creditTypeId": json["creditTypeId"],
    "creditKind": json["creditKind"],
    "balance": json["balance"]
  };
}

// src/generated/models/CreditPoolDepletedNotification.ts
function CreditPoolDepletedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": CreditPoolDepletedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/CreditPoolIncreasedNotificationMetadata.ts
function CreditPoolIncreasedNotificationMetadataFromJSON(json) {
  return CreditPoolIncreasedNotificationMetadataFromJSONTyped(json, false);
}
function CreditPoolIncreasedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customerId": json["customerId"],
    "creditPoolId": json["creditPoolId"],
    "creditTypeId": json["creditTypeId"],
    "creditKind": json["creditKind"],
    "grantedAmount": json["grantedAmount"],
    "previousBalance": json["previousBalance"],
    "balance": json["balance"]
  };
}

// src/generated/models/CreditPoolIncreasedNotification.ts
function CreditPoolIncreasedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": CreditPoolIncreasedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/CreditPoolThresholdCrossedNotificationMetadata.ts
function CreditPoolThresholdCrossedNotificationMetadataFromJSON(json) {
  return CreditPoolThresholdCrossedNotificationMetadataFromJSONTyped(json, false);
}
function CreditPoolThresholdCrossedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customerId": json["customerId"],
    "creditPoolId": json["creditPoolId"],
    "creditTypeId": json["creditTypeId"],
    "creditKind": json["creditKind"],
    "threshold": json["threshold"],
    "pctUsage": json["pctUsage"],
    "balance": json["balance"]
  };
}

// src/generated/models/CreditPoolThresholdCrossedNotification.ts
function CreditPoolThresholdCrossedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": CreditPoolThresholdCrossedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/CreditPoolWithUnits.ts
function CreditPoolWithUnitsFromJSON(json) {
  return CreditPoolWithUnitsFromJSONTyped(json, false);
}
function CreditPoolWithUnitsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "customerId": json["customerId"],
    "creditTypeId": json["creditTypeId"],
    "creditKind": json["creditKind"],
    "accountId": json["accountId"],
    "balance": json["balance"],
    "projectedBalance": json["projectedBalance"],
    "initialGrantSchedule": json["initialGrantSchedule"],
    "closestEntryExpiryDate": !exists(json, "closestEntryExpiryDate") ? void 0 : new Date(json["closestEntryExpiryDate"]),
    "entries": json["entries"].map(CreditPoolEntryFromJSON),
    "units": !exists(json, "units") ? void 0 : json["units"]
  };
}

// src/generated/models/CurrencyCommitmentUsageCrossedNotificationMetadata.ts
function CurrencyCommitmentUsageCrossedNotificationMetadataFromJSON(json) {
  return CurrencyCommitmentUsageCrossedNotificationMetadataFromJSONTyped(json, false);
}
function CurrencyCommitmentUsageCrossedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "productId": json["productId"],
    "productName": json["productName"],
    "customerId": json["customerId"],
    "threshold": json["threshold"],
    "pctUsage": json["pctUsage"],
    "currency": CurrencyFromJSON(json["currency"]),
    "committedAmount": json["committedAmount"],
    "consumedAmount": json["consumedAmount"],
    "cycleStart": new Date(json["cycleStart"])
  };
}

// src/generated/models/CurrencyCommitmentUsageCrossedNotification.ts
function CurrencyCommitmentUsageCrossedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": CurrencyCommitmentUsageCrossedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/ScalarValue.ts
function ScalarValueFromJSON(json) {
  return ScalarValueFromJSONTyped(json, false);
}
function ScalarValueFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/CustomField.ts
function CustomFieldFromJSON(json) {
  return CustomFieldFromJSONTyped(json, false);
}
function CustomFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "internalKey": json["internalKey"],
    "externalKey": !exists(json, "externalKey") ? void 0 : json["externalKey"],
    "value": ScalarValueFromJSON(json["value"])
  };
}

// src/generated/models/CustomFieldEntities.ts
function CustomFieldEntitiesFromJSON(json) {
  return CustomFieldEntitiesFromJSONTyped(json, false);
}
function CustomFieldEntitiesFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/CustomFieldValueTypes.ts
function CustomFieldValueTypesFromJSON(json) {
  return CustomFieldValueTypesFromJSONTyped(json, false);
}
function CustomFieldValueTypesFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/IntegrationEntityTypes.ts
function IntegrationEntityTypesFromJSON(json) {
  return IntegrationEntityTypesFromJSONTyped(json, false);
}
function IntegrationEntityTypesFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/CustomFieldDefinition.ts
function CustomFieldDefinitionFromJSON(json) {
  return CustomFieldDefinitionFromJSONTyped(json, false);
}
function CustomFieldDefinitionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "accountId": json["accountId"],
    "integrationId": !exists(json, "integrationId") ? void 0 : json["integrationId"],
    "integrationSource": !exists(json, "integrationSource") ? void 0 : json["integrationSource"],
    "integrationEntityType": !exists(json, "integrationEntityType") ? void 0 : IntegrationEntityTypesFromJSON(json["integrationEntityType"]),
    "fieldPath": !exists(json, "fieldPath") ? void 0 : json["fieldPath"],
    "vayuEntity": CustomFieldEntitiesFromJSON(json["vayuEntity"]),
    "vayuCustomFieldName": json["vayuCustomFieldName"],
    "valueType": CustomFieldValueTypesFromJSON(json["valueType"]),
    "allowedValues": !exists(json, "allowedValues") ? void 0 : json["allowedValues"],
    "defaultValue": !exists(json, "defaultValue") ? void 0 : json["defaultValue"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/CustomFieldValueWithDefinition.ts
function CustomFieldValueWithDefinitionFromJSON(json) {
  return CustomFieldValueWithDefinitionFromJSONTyped(json, false);
}
function CustomFieldValueWithDefinitionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customFieldDefinitionId": json["customFieldDefinitionId"],
    "value": !exists(json, "value") ? void 0 : CustomFieldValueValueFromJSON(json["value"]),
    "fieldName": !exists(json, "fieldName") ? void 0 : json["fieldName"],
    "definition": !exists(json, "definition") ? void 0 : CustomFieldDefinitionFromJSON(json["definition"])
  };
}

// src/generated/models/CustomerRelationType.ts
function CustomerRelationTypeFromJSON(json) {
  return CustomerRelationTypeFromJSONTyped(json, false);
}
function CustomerRelationTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function CustomerRelationTypeToJSON(value) {
  return value;
}

// src/generated/models/CustomerChildrenRelationsInner.ts
function CustomerChildrenRelationsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "relationType": CustomerRelationTypeToJSON(value.relationType)
  };
}

// src/generated/models/CustomerCreatedNotification.ts
function CustomerCreatedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": CustomerCreatedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/CustomerOverview.ts
function CustomerOverviewFromJSON(json) {
  return CustomerOverviewFromJSONTyped(json, false);
}
function CustomerOverviewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "name": json["name"],
    "revenue": json["revenue"],
    "status": CustomerStatusFromJSON(json["status"]),
    "currency": !exists(json, "currency") ? void 0 : CurrencyFromJSON(json["currency"]),
    "contractsCount": json["contractsCount"],
    "activeContractsCount": json["activeContractsCount"],
    "isChildCustomer": json["isChildCustomer"],
    "parentCustomer": !exists(json, "parentCustomer") ? void 0 : json["parentCustomer"],
    "subsidiary": !exists(json, "subsidiary") ? void 0 : json["subsidiary"],
    "address": !exists(json, "address") ? void 0 : json["address"],
    "country": !exists(json, "country") ? void 0 : json["country"],
    "state": !exists(json, "state") ? void 0 : json["state"],
    "city": !exists(json, "city") ? void 0 : json["city"],
    "postalCode": !exists(json, "postalCode") ? void 0 : json["postalCode"],
    "paymentDueDays": !exists(json, "paymentDueDays") ? void 0 : json["paymentDueDays"],
    "manualReview": !exists(json, "manualReview") ? void 0 : json["manualReview"],
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "erpId": !exists(json, "erpId") ? void 0 : json["erpId"],
    "taxIds": !exists(json, "taxIds") ? void 0 : json["taxIds"],
    "aliases": !exists(json, "aliases") ? void 0 : json["aliases"],
    "wallet": !exists(json, "wallet") ? void 0 : json["wallet"],
    "taxRate": !exists(json, "taxRate") ? void 0 : json["taxRate"],
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON)
  };
}

// src/generated/models/CustomerPortalLinkSentNotificationMetadata.ts
function CustomerPortalLinkSentNotificationMetadataFromJSON(json) {
  return CustomerPortalLinkSentNotificationMetadataFromJSONTyped(json, false);
}
function CustomerPortalLinkSentNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerId": json["customerId"],
    "isSuccessful": json["isSuccessful"],
    "email": json["email"],
    "errorMessage": !exists(json, "errorMessage") ? void 0 : json["errorMessage"],
    "date": new Date(json["date"])
  };
}

// src/generated/models/CustomerPortalLinkSentNotification.ts
function CustomerPortalLinkSentNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": CustomerPortalLinkSentNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/CustomerPortalTokenParams.ts
function CustomerPortalTokenParamsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "customerId": value.customerId
  };
}

// src/generated/models/CustomerRelation.ts
function CustomerRelationFromJSON(json) {
  return CustomerRelationFromJSONTyped(json, false);
}
function CustomerRelationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "parentId": json["parentId"],
    "childId": json["childId"],
    "relationType": CustomerRelationTypeFromJSON(json["relationType"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/CustomerType.ts
function CustomerTypeFromJSON(json) {
  return CustomerTypeFromJSONTyped(json, false);
}
function CustomerTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/DeleteCatalogProductsResponse.ts
function DeleteCatalogProductsResponseFromJSON(json) {
  return DeleteCatalogProductsResponseFromJSONTyped(json, false);
}
function DeleteCatalogProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "catalogProductId": json["catalogProductId"]
  };
}

// src/generated/models/DeleteContractResponse.ts
function DeleteContractResponseFromJSON(json) {
  return DeleteContractResponseFromJSONTyped(json, false);
}
function DeleteContractResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"]
  };
}

// src/generated/models/DeleteCustomerResponse.ts
function DeleteCustomerResponseFromJSON(json) {
  return DeleteCustomerResponseFromJSONTyped(json, false);
}
function DeleteCustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerId": json["customerId"]
  };
}

// src/generated/models/DeleteInvoiceResponse.ts
function DeleteInvoiceResponseFromJSON(json) {
  return DeleteInvoiceResponseFromJSONTyped(json, false);
}
function DeleteInvoiceResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"]
  };
}

// src/generated/models/DeleteLineItemResponse.ts
function DeleteLineItemResponseFromJSON(json) {
  return DeleteLineItemResponseFromJSONTyped(json, false);
}
function DeleteLineItemResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "lineItemId": json["lineItemId"]
  };
}

// src/generated/models/DeleteMeasurementsRequest.ts
function DeleteMeasurementsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "measurementIds": value.measurementIds
  };
}

// src/generated/models/DeletePublicApiKeyResponse.ts
function DeletePublicApiKeyResponseFromJSON(json) {
  return DeletePublicApiKeyResponseFromJSONTyped(json, false);
}
function DeletePublicApiKeyResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "publicApiKeyId": json["publicApiKeyId"]
  };
}

// src/generated/models/DeleteReportResponse.ts
function DeleteReportResponseFromJSON(json) {
  return DeleteReportResponseFromJSONTyped(json, false);
}
function DeleteReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "status": json["status"],
    "reportName": !exists(json, "reportName") ? void 0 : json["reportName"],
    "type": json["type"],
    "invocationType": json["invocationType"],
    "createdAt": new Date(json["createdAt"])
  };
}

// src/generated/models/DeleteRevenueRecognitionOverrideResponse.ts
function DeleteRevenueRecognitionOverrideResponseFromJSON(json) {
  return DeleteRevenueRecognitionOverrideResponseFromJSONTyped(json, false);
}
function DeleteRevenueRecognitionOverrideResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"]
  };
}

// src/generated/models/DeleteRevisionResponse.ts
function DeleteRevisionResponseFromJSON(json) {
  return DeleteRevisionResponseFromJSONTyped(json, false);
}
function DeleteRevisionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"],
    "revisionId": json["revisionId"]
  };
}

// src/generated/models/DeleteWebhookSubscriptionResponse.ts
function DeleteWebhookSubscriptionResponseFromJSON(json) {
  return DeleteWebhookSubscriptionResponseFromJSONTyped(json, false);
}
function DeleteWebhookSubscriptionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "webhookSubscriptionId": json["webhookSubscriptionId"]
  };
}

// src/generated/models/DepositTo.ts
function DepositToFromJSON(json) {
  return DepositToFromJSONTyped(json, false);
}
function DepositToFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "name": json["name"]
  };
}

// src/generated/models/DisablePlanResponse.ts
function DisablePlanResponseFromJSON(json) {
  return DisablePlanResponseFromJSONTyped(json, false);
}
function DisablePlanResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "plan": PlanFromJSON(json["plan"])
  };
}

// src/generated/models/DisableWorkflowResponse.ts
function DisableWorkflowResponseFromJSON(json) {
  return DisableWorkflowResponseFromJSONTyped(json, false);
}
function DisableWorkflowResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workflow": WorkflowFromJSON(json["workflow"])
  };
}

// src/generated/models/DismissJobNotificationResponse.ts
function DismissJobNotificationResponseFromJSON(json) {
  return DismissJobNotificationResponseFromJSONTyped(json, false);
}
function DismissJobNotificationResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"],
    "userId": !exists(json, "userId") ? void 0 : json["userId"],
    "jobId": json["jobId"],
    "title": json["title"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "readAt": !exists(json, "readAt") ? void 0 : new Date(json["readAt"]),
    "metadata": json["metadata"],
    "dismissedAt": !exists(json, "dismissedAt") ? void 0 : new Date(json["dismissedAt"])
  };
}

// src/generated/models/DynamicInvoiceDataContract.ts
function DynamicInvoiceDataContractFromJSON(json) {
  return DynamicInvoiceDataContractFromJSONTyped(json, false);
}
function DynamicInvoiceDataContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "contractType": ContractTypeFromJSON(json["contractType"]),
    "currencyOverride": !exists(json, "currencyOverride") ? void 0 : CurrencyFromJSON(json["currencyOverride"]),
    "isTrial": !exists(json, "isTrial") ? void 0 : json["isTrial"]
  };
}

// src/generated/models/DynamicInvoiceDataCreditPoolsProjectionMapValue.ts
function DynamicInvoiceDataCreditPoolsProjectionMapValueFromJSON(json) {
  return DynamicInvoiceDataCreditPoolsProjectionMapValueFromJSONTyped(json, false);
}
function DynamicInvoiceDataCreditPoolsProjectionMapValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "projectedDeduction": json["projectedDeduction"],
    "projectedBalance": json["projectedBalance"]
  };
}

// src/generated/models/DynamicInvoiceDataCustomerParentCustomer.ts
function DynamicInvoiceDataCustomerParentCustomerFromJSON(json) {
  return DynamicInvoiceDataCustomerParentCustomerFromJSONTyped(json, false);
}
function DynamicInvoiceDataCustomerParentCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "relationType": CustomerRelationTypeFromJSON(json["relationType"])
  };
}

// src/generated/models/DynamicInvoiceDataCustomer.ts
function DynamicInvoiceDataCustomerFromJSON(json) {
  return DynamicInvoiceDataCustomerFromJSONTyped(json, false);
}
function DynamicInvoiceDataCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "settings": !exists(json, "settings") ? void 0 : CustomerSettingsFromJSON(json["settings"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"] === null ? null : json["contacts"].map(ContactFromJSON),
    "createdAt": new Date(json["createdAt"]),
    "parentCustomer": !exists(json, "parentCustomer") ? void 0 : DynamicInvoiceDataCustomerParentCustomerFromJSON(json["parentCustomer"])
  };
}

// src/generated/models/InvoicePayment.ts
function InvoicePaymentFromJSON(json) {
  return InvoicePaymentFromJSONTyped(json, false);
}
function InvoicePaymentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "amount": json["amount"],
    "currency": CurrencyFromJSON(json["currency"]),
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "paymentMethod": !exists(json, "paymentMethod") ? void 0 : json["paymentMethod"],
    "status": !exists(json, "status") ? void 0 : json["status"]
  };
}

// src/generated/models/InvoiceType.ts
function InvoiceTypeFromJSON(json) {
  return InvoiceTypeFromJSONTyped(json, false);
}
function InvoiceTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/DynamicInvoiceDataInvoice.ts
function DynamicInvoiceDataInvoiceFromJSON(json) {
  return DynamicInvoiceDataInvoiceFromJSONTyped(json, false);
}
function DynamicInvoiceDataInvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "issuedAt": json["issuedAt"] === null ? null : new Date(json["issuedAt"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "billingCycle": FullDayPeriodFromJSON(json["billingCycle"]),
    "lineItems": json["lineItems"].map(LineItemFromJSON),
    "purchaseOrder": !exists(json, "purchaseOrder") ? void 0 : json["purchaseOrder"],
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "approvedAt": !exists(json, "approvedAt") ? void 0 : new Date(json["approvedAt"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "taxRate": json["taxRate"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "invoicingDate": !exists(json, "invoicingDate") ? void 0 : new Date(json["invoicingDate"]),
    "invoiceNumber": json["invoiceNumber"],
    "ref": json["ref"],
    "exchangeRateSnapshotTimestamp": !exists(json, "exchangeRateSnapshotTimestamp") ? void 0 : json["exchangeRateSnapshotTimestamp"] === null ? null : new Date(json["exchangeRateSnapshotTimestamp"]),
    "refundsInvoiceId": !exists(json, "refundsInvoiceId") ? void 0 : json["refundsInvoiceId"],
    "invoiceType": !exists(json, "invoiceType") ? void 0 : InvoiceTypeFromJSON(json["invoiceType"]),
    "dynamicLineItems": json["dynamicLineItems"],
    "contractId": !exists(json, "contractId") ? void 0 : json["contractId"],
    "contractName": !exists(json, "contractName") ? void 0 : json["contractName"],
    "currency": CurrencyFromJSON(json["currency"]),
    "modifiedCurrency": !exists(json, "modifiedCurrency") ? void 0 : CurrencyFromJSON(json["modifiedCurrency"]),
    "baseCurrency": !exists(json, "baseCurrency") ? void 0 : CurrencyFromJSON(json["baseCurrency"]),
    "exchangeRateSnapshot": !exists(json, "exchangeRateSnapshot") ? void 0 : json["exchangeRateSnapshot"],
    "modifiedExchangeRate": !exists(json, "modifiedExchangeRate") ? void 0 : json["modifiedExchangeRate"],
    "payments": !exists(json, "payments") ? void 0 : json["payments"].map(InvoicePaymentFromJSON)
  };
}

// src/generated/models/DynamicInvoiceData.ts
function DynamicInvoiceDataFromJSON(json) {
  return DynamicInvoiceDataFromJSONTyped(json, false);
}
function DynamicInvoiceDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoice": DynamicInvoiceDataInvoiceFromJSON(json["invoice"]),
    "customer": DynamicInvoiceDataCustomerFromJSON(json["customer"]),
    "contract": !exists(json, "contract") ? void 0 : DynamicInvoiceDataContractFromJSON(json["contract"]),
    "measurementChartData": json["measurementChartData"],
    "measuredPriceBreakdownMap": !exists(json, "measuredPriceBreakdownMap") ? void 0 : json["measuredPriceBreakdownMap"],
    "creditPoolsProjectionMap": !exists(json, "creditPoolsProjectionMap") ? void 0 : mapValues(json["creditPoolsProjectionMap"], DynamicInvoiceDataCreditPoolsProjectionMapValueFromJSON)
  };
}

// src/generated/models/EmailStatus.ts
function EmailStatusFromJSON(json) {
  return EmailStatusFromJSONTyped(json, false);
}
function EmailStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/EmailType.ts
function EmailTypeFromJSON(json) {
  return EmailTypeFromJSONTyped(json, false);
}
function EmailTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/EmailMessage.ts
function EmailMessageFromJSON(json) {
  return EmailMessageFromJSONTyped(json, false);
}
function EmailMessageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "messageId": json["messageId"],
    "invoiceId": !exists(json, "invoiceId") ? void 0 : json["invoiceId"],
    "accountId": json["accountId"],
    "type": EmailTypeFromJSON(json["type"]),
    "status": EmailStatusFromJSON(json["status"]),
    "isManual": json["isManual"],
    "subject": !exists(json, "subject") ? void 0 : json["subject"],
    "content": json["content"],
    "templateId": json["templateId"],
    "recipient": json["recipient"],
    "bcc": !exists(json, "bcc") ? void 0 : json["bcc"],
    "date": new Date(json["date"])
  };
}

// src/generated/models/EmailVerificationEvent.ts
function EmailVerificationEventFromJSON(json) {
  return EmailVerificationEventFromJSONTyped(json, false);
}
function EmailVerificationEventFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/FieldMapping.ts
function FieldMappingFromJSON(json) {
  return FieldMappingFromJSONTyped(json, false);
}
function FieldMappingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accessor": json["accessor"],
    "name": json["name"]
  };
}

// src/generated/models/EntityMapping.ts
function EntityMappingFromJSON(json) {
  return EntityMappingFromJSONTyped(json, false);
}
function EntityMappingFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "entity": json["entity"],
    "fields": json["fields"].map(FieldMappingFromJSON)
  };
}

// src/generated/models/EnumDataField.ts
function EnumDataFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "eventName": json["eventName"],
    "accountId": json["accountId"],
    "type": json["type"],
    "values": json["values"]
  };
}

// src/generated/models/NumberEventField.ts
function NumberEventFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "eventName": json["eventName"],
    "accountId": json["accountId"],
    "type": json["type"]
  };
}

// src/generated/models/StringDataField.ts
function StringDataFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "eventName": json["eventName"],
    "accountId": json["accountId"],
    "type": json["type"]
  };
}

// src/generated/models/EventField.ts
function EventFieldFromJSON(json) {
  return EventFieldFromJSONTyped(json, false);
}
function EventFieldFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["type"]) {
    case "Enum":
      return { ...EnumDataFieldFromJSONTyped(json, true), type: "Enum" };
    case "Number":
      return { ...NumberEventFieldFromJSONTyped(json, true), type: "Number" };
    case "String":
      return { ...StringDataFieldFromJSONTyped(json, true), type: "String" };
    default:
      throw new Error(`No variant of EventField exists with 'type=${json["type"]}'`);
  }
}

// src/generated/models/WorkflowExecutionAllOfError.ts
function WorkflowExecutionAllOfErrorFromJSON(json) {
  return WorkflowExecutionAllOfErrorFromJSONTyped(json, false);
}
function WorkflowExecutionAllOfErrorFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"]
  };
}

// src/generated/models/WorkflowExecutionAllOfSteps.ts
function WorkflowExecutionAllOfStepsFromJSON(json) {
  return WorkflowExecutionAllOfStepsFromJSONTyped(json, false);
}
function WorkflowExecutionAllOfStepsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "stepId": json["stepId"],
    "type": json["type"],
    "status": json["status"],
    "userMessage": !exists(json, "userMessage") ? void 0 : json["userMessage"],
    "input": !exists(json, "input") ? void 0 : json["input"],
    "output": !exists(json, "output") ? void 0 : json["output"],
    "decision": !exists(json, "decision") ? void 0 : json["decision"],
    "error": !exists(json, "error") ? void 0 : WorkflowExecutionAllOfErrorFromJSON(json["error"]),
    "startedAt": json["startedAt"],
    "completedAt": !exists(json, "completedAt") ? void 0 : json["completedAt"]
  };
}

// src/generated/models/WorkflowExecutionAllOfSummary.ts
function WorkflowExecutionAllOfSummaryFromJSON(json) {
  return WorkflowExecutionAllOfSummaryFromJSONTyped(json, false);
}
function WorkflowExecutionAllOfSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "matched": json["matched"],
    "actioned": json["actioned"],
    "errors": json["errors"]
  };
}

// src/generated/models/WorkflowExecutionSummaryTrigger.ts
function WorkflowExecutionSummaryTriggerFromJSON(json) {
  return WorkflowExecutionSummaryTriggerFromJSONTyped(json, false);
}
function WorkflowExecutionSummaryTriggerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "payload": !exists(json, "payload") ? void 0 : json["payload"]
  };
}

// src/generated/models/WorkflowExecution.ts
function WorkflowExecutionFromJSON(json) {
  return WorkflowExecutionFromJSONTyped(json, false);
}
function WorkflowExecutionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "workflowId": json["workflowId"],
    "definitionId": json["definitionId"],
    "status": json["status"],
    "trigger": WorkflowExecutionSummaryTriggerFromJSON(json["trigger"]),
    "userMessage": !exists(json, "userMessage") ? void 0 : json["userMessage"],
    "startedAt": !exists(json, "startedAt") ? void 0 : json["startedAt"],
    "completedAt": !exists(json, "completedAt") ? void 0 : json["completedAt"],
    "attempts": json["attempts"],
    "createdAt": json["createdAt"],
    "input": json["input"],
    "output": !exists(json, "output") ? void 0 : json["output"],
    "steps": json["steps"].map(WorkflowExecutionAllOfStepsFromJSON),
    "executionPath": json["executionPath"],
    "graphSnapshot": json["graphSnapshot"],
    "summary": !exists(json, "summary") ? void 0 : WorkflowExecutionAllOfSummaryFromJSON(json["summary"]),
    "error": !exists(json, "error") ? void 0 : WorkflowExecutionAllOfErrorFromJSON(json["error"])
  };
}

// src/generated/models/ExecuteWorkflowResponse.ts
function ExecuteWorkflowResponseFromJSON(json) {
  return ExecuteWorkflowResponseFromJSONTyped(json, false);
}
function ExecuteWorkflowResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "execution": WorkflowExecutionFromJSON(json["execution"])
  };
}

// src/generated/models/ExportUsageToMarketplaceRequest.ts
function ExportUsageToMarketplaceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoicesIds": value.invoicesIds
  };
}

// src/generated/models/ExternalPayment.ts
function ExternalPaymentFromJSON(json) {
  return ExternalPaymentFromJSONTyped(json, false);
}
function ExternalPaymentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "chargeTime": !exists(json, "chargeTime") ? void 0 : new Date(json["chargeTime"]),
    "receiptUrl": !exists(json, "receiptUrl") ? void 0 : json["receiptUrl"]
  };
}

// src/generated/models/ExtractContractResponse.ts
function ExtractContractResponseFromJSON(json) {
  return ExtractContractResponseFromJSONTyped(json, false);
}
function ExtractContractResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "jobId": json["jobId"]
  };
}

// src/generated/models/ExtractPlanResponseProductsInnerAllOfVariantsInner.ts
function ExtractPlanResponseProductsInnerAllOfVariantsInnerFromJSON(json) {
  return ExtractPlanResponseProductsInnerAllOfVariantsInnerFromJSONTyped(json, false);
}
function ExtractPlanResponseProductsInnerAllOfVariantsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "pricing": PricingFromJSON(json["pricing"]),
    "settings": !exists(json, "settings") ? void 0 : ProductSettingsFromJSON(json["settings"]),
    "description": !exists(json, "description") ? void 0 : json["description"],
    "name": json["name"]
  };
}

// src/generated/models/ExtractPlanResponseProductsInner.ts
function ExtractPlanResponseProductsInnerFromJSON(json) {
  return ExtractPlanResponseProductsInnerFromJSONTyped(json, false);
}
function ExtractPlanResponseProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "variants": json["variants"].map(ExtractPlanResponseProductsInnerAllOfVariantsInnerFromJSON),
    "basePrice": !exists(json, "basePrice") ? void 0 : json["basePrice"],
    "additionalCharge": !exists(json, "additionalCharge") ? void 0 : json["additionalCharge"],
    "commitment": !exists(json, "commitment") ? void 0 : ProductConfigCommitmentFromJSON(json["commitment"]),
    "advancePayment": !exists(json, "advancePayment") ? void 0 : AdvancePaymentFromJSON(json["advancePayment"]),
    "chargingCadence": !exists(json, "chargingCadence") ? void 0 : json["chargingCadence"],
    "currencyCommitment": !exists(json, "currencyCommitment") ? void 0 : json["currencyCommitment"],
    "paymentTerm": json["paymentTerm"],
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "accumulationInterval": !exists(json, "accumulationInterval") ? void 0 : json["accumulationInterval"],
    "proRata": !exists(json, "proRata") ? void 0 : json["proRata"],
    "erpMetadata": !exists(json, "erpMetadata") ? void 0 : ErpMetadataFromJSON(json["erpMetadata"]),
    "rateMultiplier": !exists(json, "rateMultiplier") ? void 0 : json["rateMultiplier"],
    "isPeriodicVariants": !exists(json, "isPeriodicVariants") ? void 0 : json["isPeriodicVariants"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "startDate": !exists(json, "startDate") ? void 0 : json["startDate"] === null ? null : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : json["endDate"] === null ? null : new Date(json["endDate"]),
    "catalogProductId": !exists(json, "catalogProductId") ? void 0 : json["catalogProductId"],
    "productConfigs": !exists(json, "productConfigs") ? void 0 : json["productConfigs"] === null ? null : json["productConfigs"].map(ProductConfigFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : ProductExternalIntegrationFromJSON(json["externalIntegration"]),
    "revisionId": !exists(json, "revisionId") ? void 0 : json["revisionId"],
    "cloudProviderSettings": !exists(json, "cloudProviderSettings") ? void 0 : ProductCloudProviderSettingsFromJSON(json["cloudProviderSettings"]),
    "isCalendarAligned": json["isCalendarAligned"],
    "upliftConfiguration": !exists(json, "upliftConfiguration") ? void 0 : ProductUpliftConfigurationFromJSON(json["upliftConfiguration"]),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "creditPurchaseConfig": !exists(json, "creditPurchaseConfig") ? void 0 : CreditPurchaseConfigFromJSON(json["creditPurchaseConfig"])
  };
}

// src/generated/models/ExtractPlanResponse.ts
function ExtractPlanResponseFromJSON(json) {
  return ExtractPlanResponseFromJSONTyped(json, false);
}
function ExtractPlanResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "products": json["products"].map(ExtractPlanResponseProductsInnerFromJSON),
    "billingData": PlanBillingDataFromJSON(json["billingData"]),
    "status": json["status"],
    "trial": !exists(json, "trial") ? void 0 : PlanTrialFromJSON(json["trial"]),
    "purchaseOrder": !exists(json, "purchaseOrder") ? void 0 : json["purchaseOrder"],
    "rawSyncData": !exists(json, "rawSyncData") ? void 0 : PlanRawSyncDataFromJSON(json["rawSyncData"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(IntegrationEntityFromJSON)
  };
}

// src/generated/models/FilterSampleEventsRequest.ts
function FilterSampleEventsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "filter": FilterToJSON(value.filter)
  };
}

// src/generated/models/IngestedEventSample.ts
function IngestedEventSampleFromJSON(json) {
  return IngestedEventSampleFromJSONTyped(json, false);
}
function IngestedEventSampleFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "timestamp": new Date(json["timestamp"]),
    "customerAlias": json["customerAlias"],
    "data": !exists(json, "data") ? void 0 : json["data"],
    "ref": json["ref"],
    "name": json["name"],
    "customerId": !exists(json, "customerId") ? void 0 : json["customerId"],
    "affectedMeters": !exists(json, "affectedMeters") ? void 0 : json["affectedMeters"],
    "customerName": !exists(json, "customerName") ? void 0 : json["customerName"],
    "matchedAt": !exists(json, "matchedAt") ? void 0 : new Date(json["matchedAt"])
  };
}

// src/generated/models/FilterSampleEventsResponse.ts
function FilterSampleEventsResponseFromJSON(json) {
  return FilterSampleEventsResponseFromJSONTyped(json, false);
}
function FilterSampleEventsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "events": json["events"].map(IngestedEventSampleFromJSON)
  };
}

// src/generated/models/FinalTierExceededNotificationMetadata.ts
function FinalTierExceededNotificationMetadataFromJSON(json) {
  return FinalTierExceededNotificationMetadataFromJSONTyped(json, false);
}
function FinalTierExceededNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customerId": json["customerId"],
    "contractId": json["contractId"],
    "customerName": json["customerName"],
    "contractName": json["contractName"],
    "productId": json["productId"],
    "productName": json["productName"],
    "accumulatedUnitsValue": json["accumulatedUnitsValue"]
  };
}

// src/generated/models/FinalTierExceededNotification.ts
function FinalTierExceededNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": FinalTierExceededNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/FixedDeductionPricingInput.ts
function FixedDeductionPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": FixedDeductionPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/GenerateMeasurementsRequestData.ts
function GenerateMeasurementsRequestDataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "period": PeriodToJSON(value.period),
    "customersIds": value.customersIds,
    "metersIds": value.metersIds,
    "minimumQuantity": value.minimumQuantity,
    "maximumQuantity": value.maximumQuantity
  };
}

// src/generated/models/GenerateMeasurementsRequest.ts
function GenerateMeasurementsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "data": GenerateMeasurementsRequestDataToJSON(value.data)
  };
}

// src/generated/models/GenerateMeasurementsResponse.ts
function GenerateMeasurementsResponseFromJSON(json) {
  return GenerateMeasurementsResponseFromJSONTyped(json, false);
}
function GenerateMeasurementsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "count": json["count"]
  };
}

// src/generated/models/GenerateTokenRequest.ts
function GenerateTokenRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "params": CustomerPortalTokenParamsToJSON(value.params),
    "expiresAt": value.expiresAt === void 0 ? void 0 : value.expiresAt.toISOString()
  };
}

// src/generated/models/GenerateTokenResponse.ts
function GenerateTokenResponseFromJSON(json) {
  return GenerateTokenResponseFromJSONTyped(json, false);
}
function GenerateTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"]
  };
}

// src/generated/models/GetAccountResponse.ts
function GetAccountResponseFromJSON(json) {
  return GetAccountResponseFromJSONTyped(json, false);
}
function GetAccountResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "account": AccountFromJSON(json["account"])
  };
}

// src/generated/models/GetAffectedMeteredEventsResponseAffectedMeteredEventsInner.ts
function GetAffectedMeteredEventsResponseAffectedMeteredEventsInnerFromJSON(json) {
  return GetAffectedMeteredEventsResponseAffectedMeteredEventsInnerFromJSONTyped(json, false);
}
function GetAffectedMeteredEventsResponseAffectedMeteredEventsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "meterId": json["meterId"],
    "value": json["value"],
    "assignedAt": new Date(json["assignedAt"])
  };
}

// src/generated/models/GetAffectedMeteredEventsResponse.ts
function GetAffectedMeteredEventsResponseFromJSON(json) {
  return GetAffectedMeteredEventsResponseFromJSONTyped(json, false);
}
function GetAffectedMeteredEventsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "affectedMeteredEvents": json["affectedMeteredEvents"].map(GetAffectedMeteredEventsResponseAffectedMeteredEventsInnerFromJSON)
  };
}

// src/generated/models/GetAnonymousCustomersReportResponseReport.ts
function GetAnonymousCustomersReportResponseReportFromJSON(json) {
  return GetAnonymousCustomersReportResponseReportFromJSONTyped(json, false);
}
function GetAnonymousCustomersReportResponseReportFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(CustomerFromJSON),
    "count": json["count"]
  };
}

// src/generated/models/GetAnonymousCustomersReportResponse.ts
function GetAnonymousCustomersReportResponseFromJSON(json) {
  return GetAnonymousCustomersReportResponseFromJSONTyped(json, false);
}
function GetAnonymousCustomersReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": GetAnonymousCustomersReportResponseReportFromJSON(json["report"]),
    "creationDate": new Date(json["creationDate"]),
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"])
  };
}

// src/generated/models/GetApprovalFlowInvoicesListResponseInner.ts
function GetApprovalFlowInvoicesListResponseInnerFromJSON(json) {
  return GetApprovalFlowInvoicesListResponseInnerFromJSONTyped(json, false);
}
function GetApprovalFlowInvoicesListResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "invoiceName": json["invoiceName"],
    "invoicePeriod": PeriodFromJSON(json["invoicePeriod"]),
    "invoiceTags": json["invoiceTags"],
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "customerName": json["customerName"],
    "currency": CurrencyFromJSON(json["currency"]),
    "contractName": !exists(json, "contractName") ? void 0 : json["contractName"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"])
  };
}

// src/generated/models/GetArAgingReportResponseSettings.ts
function GetArAgingReportResponseSettingsFromJSON(json) {
  return GetArAgingReportResponseSettingsFromJSONTyped(json, false);
}
function GetArAgingReportResponseSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "currency": CurrencyFromJSON(json["currency"])
  };
}

// src/generated/models/GetArAgingReportResponseSummaryBreakdownInnerCustomer.ts
function GetArAgingReportResponseSummaryBreakdownInnerCustomerFromJSON(json) {
  return GetArAgingReportResponseSummaryBreakdownInnerCustomerFromJSONTyped(json, false);
}
function GetArAgingReportResponseSummaryBreakdownInnerCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/GetArAgingReportResponseSummaryBreakdownInnerInvoice.ts
function GetArAgingReportResponseSummaryBreakdownInnerInvoiceFromJSON(json) {
  return GetArAgingReportResponseSummaryBreakdownInnerInvoiceFromJSONTyped(json, false);
}
function GetArAgingReportResponseSummaryBreakdownInnerInvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "invoiceNumber": json["invoiceNumber"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "paymentDueDays": json["paymentDueDays"],
    "issuedAt": json["issuedAt"] === null ? null : new Date(json["issuedAt"]),
    "dueDate": json["dueDate"] === null ? null : new Date(json["dueDate"]),
    "billingCycle": FullDayPeriodFromJSON(json["billingCycle"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"])
  };
}

// src/generated/models/GetArAgingReportResponseSummaryBreakdownInner.ts
function GetArAgingReportResponseSummaryBreakdownInnerFromJSON(json) {
  return GetArAgingReportResponseSummaryBreakdownInnerFromJSONTyped(json, false);
}
function GetArAgingReportResponseSummaryBreakdownInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoice": GetArAgingReportResponseSummaryBreakdownInnerInvoiceFromJSON(json["invoice"]),
    "customer": GetArAgingReportResponseSummaryBreakdownInnerCustomerFromJSON(json["customer"]),
    "daysOutstanding": json["daysOutstanding"],
    "remainingAmount": json["remainingAmount"],
    "contractStatus": !exists(json, "contractStatus") ? void 0 : ContractStatusFromJSON(json["contractStatus"]),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON),
    "subsidiaryName": !exists(json, "subsidiaryName") ? void 0 : json["subsidiaryName"]
  };
}

// src/generated/models/GetArAgingReportResponseSummaryInnerOutstandingBreakdownValue.ts
function GetArAgingReportResponseSummaryInnerOutstandingBreakdownValueFromJSON(json) {
  return GetArAgingReportResponseSummaryInnerOutstandingBreakdownValueFromJSONTyped(json, false);
}
function GetArAgingReportResponseSummaryInnerOutstandingBreakdownValueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "grossAmount": json["grossAmount"],
    "invoicesCount": json["invoicesCount"]
  };
}

// src/generated/models/GetArAgingReportResponseSummaryInner.ts
function GetArAgingReportResponseSummaryInnerFromJSON(json) {
  return GetArAgingReportResponseSummaryInnerFromJSONTyped(json, false);
}
function GetArAgingReportResponseSummaryInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": BillingCycleCustomersInnerFromJSON(json["customer"]),
    "outstandingBreakdown": mapValues(json["outstandingBreakdown"], GetArAgingReportResponseSummaryInnerOutstandingBreakdownValueFromJSON)
  };
}

// src/generated/models/GetArAgingReportResponse.ts
function GetArAgingReportResponseFromJSON(json) {
  return GetArAgingReportResponseFromJSONTyped(json, false);
}
function GetArAgingReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "settings": GetArAgingReportResponseSettingsFromJSON(json["settings"]),
    "summary": json["summary"].map(GetArAgingReportResponseSummaryInnerFromJSON),
    "summaryBreakdown": json["summaryBreakdown"].map(GetArAgingReportResponseSummaryBreakdownInnerFromJSON)
  };
}

// src/generated/models/GetBillingCycleInvoicesResponse.ts
function GetBillingCycleInvoicesResponseFromJSON(json) {
  return GetBillingCycleInvoicesResponseFromJSONTyped(json, false);
}
function GetBillingCycleInvoicesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoices": json["invoices"].map(BillingCycleInvoiceFromJSON)
  };
}

// src/generated/models/GetBillingCyclePageResponse.ts
function GetBillingCyclePageResponseFromJSON(json) {
  return GetBillingCyclePageResponseFromJSONTyped(json, false);
}
function GetBillingCyclePageResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "regularBillingCycleInvoicesCount": json["regularBillingCycleInvoicesCount"],
    "inspectionBillingCycleInvoicesCount": json["inspectionBillingCycleInvoicesCount"],
    "oldBillingCycleInvoicesCount": json["oldBillingCycleInvoicesCount"],
    "overcharges": json["overcharges"]
  };
}

// src/generated/models/GetBillingCyclesResponse.ts
function GetBillingCyclesResponseFromJSON(json) {
  return GetBillingCyclesResponseFromJSONTyped(json, false);
}
function GetBillingCyclesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "billingCycles": json["billingCycles"].map(BillingCycleFromJSON)
  };
}

// src/generated/models/GetCatalogProductsListResponse.ts
function GetCatalogProductsListResponseFromJSON(json) {
  return GetCatalogProductsListResponseFromJSONTyped(json, false);
}
function GetCatalogProductsListResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "catalogProducts": json["catalogProducts"].map(CatalogProductsFromJSON)
  };
}

// src/generated/models/GetCatalogProductsResponse.ts
function GetCatalogProductsResponseFromJSON(json) {
  return GetCatalogProductsResponseFromJSONTyped(json, false);
}
function GetCatalogProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "catalogProduct": CatalogProductsFromJSON(json["catalogProduct"])
  };
}

// src/generated/models/GetCommitmentUsageReportItemResponseSchema.ts
function GetCommitmentUsageReportItemResponseSchemaFromJSON(json) {
  return GetCommitmentUsageReportItemResponseSchemaFromJSONTyped(json, false);
}
function GetCommitmentUsageReportItemResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractStatus": ContractStatusFromJSON(json["contractStatus"]),
    "customerName": json["customerName"],
    "startDate": new Date(json["startDate"]),
    "endDate": new Date(json["endDate"]),
    "contractName": !exists(json, "contractName") ? void 0 : json["contractName"],
    "contractStartDate": new Date(json["contractStartDate"]),
    "contractEndDate": !exists(json, "contractEndDate") ? void 0 : new Date(json["contractEndDate"]),
    "daysToContractEnd": !exists(json, "daysToContractEnd") ? void 0 : json["daysToContractEnd"],
    "productVariantName": json["productVariantName"],
    "commitmentConsumptionCurrencyAmount": json["commitmentConsumptionCurrencyAmount"],
    "commitmentConsumptionUnitsAmount": json["commitmentConsumptionUnitsAmount"],
    "commitmentConsumptionPercentage": json["commitmentConsumptionPercentage"],
    "totalCommitmentCurrencyAmount": json["totalCommitmentCurrencyAmount"],
    "totalCommitmentUnitsAmount": json["totalCommitmentUnitsAmount"],
    "commercialTermsAmount": !exists(json, "commercialTermsAmount") ? void 0 : json["commercialTermsAmount"],
    "erpId": !exists(json, "erpId") ? void 0 : json["erpId"],
    "currency": CurrencyFromJSON(json["currency"])
  };
}

// src/generated/models/GetCommitmentReportResponse.ts
function GetCommitmentReportResponseFromJSON(json) {
  return GetCommitmentReportResponseFromJSONTyped(json, false);
}
function GetCommitmentReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": json["report"].map(GetCommitmentUsageReportItemResponseSchemaFromJSON),
    "creationDate": new Date(json["creationDate"]),
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"])
  };
}

// src/generated/models/GetCommitmentVsUsageResponseMonthsInner.ts
function GetCommitmentVsUsageResponseMonthsInnerFromJSON(json) {
  return GetCommitmentVsUsageResponseMonthsInnerFromJSONTyped(json, false);
}
function GetCommitmentVsUsageResponseMonthsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startTime": json["startTime"]
  };
}

// src/generated/models/GetCommitmentVsUsageResponseReportItemsInnerCommitment.ts
function GetCommitmentVsUsageResponseReportItemsInnerCommitmentFromJSON(json) {
  return GetCommitmentVsUsageResponseReportItemsInnerCommitmentFromJSONTyped(json, false);
}
function GetCommitmentVsUsageResponseReportItemsInnerCommitmentFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "units": !exists(json, "units") ? void 0 : json["units"],
    "resetIntervalMonths": !exists(json, "resetIntervalMonths") ? void 0 : json["resetIntervalMonths"]
  };
}

// src/generated/models/GetCommitmentVsUsageResponseReportItemsInnerContract.ts
function GetCommitmentVsUsageResponseReportItemsInnerContractFromJSON(json) {
  return GetCommitmentVsUsageResponseReportItemsInnerContractFromJSONTyped(json, false);
}
function GetCommitmentVsUsageResponseReportItemsInnerContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "status": json["status"],
    "startDate": json["startDate"],
    "endDate": !exists(json, "endDate") ? void 0 : json["endDate"],
    "daysToEnd": !exists(json, "daysToEnd") ? void 0 : json["daysToEnd"]
  };
}

// src/generated/models/GetCommitmentVsUsageResponseReportItemsInnerCurrentCycle.ts
function GetCommitmentVsUsageResponseReportItemsInnerCurrentCycleFromJSON(json) {
  return GetCommitmentVsUsageResponseReportItemsInnerCurrentCycleFromJSONTyped(json, false);
}
function GetCommitmentVsUsageResponseReportItemsInnerCurrentCycleFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startDate": !exists(json, "startDate") ? void 0 : json["startDate"],
    "endDate": !exists(json, "endDate") ? void 0 : json["endDate"],
    "consumed": !exists(json, "consumed") ? void 0 : json["consumed"],
    "pctUsage": !exists(json, "pctUsage") ? void 0 : json["pctUsage"],
    "pacing": !exists(json, "pacing") ? void 0 : json["pacing"],
    "projectedEoP": !exists(json, "projectedEoP") ? void 0 : json["projectedEoP"],
    "shortfall": !exists(json, "shortfall") ? void 0 : json["shortfall"],
    "overage": !exists(json, "overage") ? void 0 : json["overage"]
  };
}

// src/generated/models/GetCommitmentVsUsageResponseReportItemsInnerMonthlyEntriesInner.ts
function GetCommitmentVsUsageResponseReportItemsInnerMonthlyEntriesInnerFromJSON(json) {
  return GetCommitmentVsUsageResponseReportItemsInnerMonthlyEntriesInnerFromJSONTyped(json, false);
}
function GetCommitmentVsUsageResponseReportItemsInnerMonthlyEntriesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startTime": json["startTime"],
    "qtyUsed": !exists(json, "qtyUsed") ? void 0 : json["qtyUsed"],
    "cumulativeQty": !exists(json, "cumulativeQty") ? void 0 : json["cumulativeQty"],
    "cumulativePct": !exists(json, "cumulativePct") ? void 0 : json["cumulativePct"],
    "isResetMonth": !exists(json, "isResetMonth") ? void 0 : json["isResetMonth"]
  };
}

// src/generated/models/GetCommitmentVsUsageResponseReportItemsInnerProduct.ts
function GetCommitmentVsUsageResponseReportItemsInnerProductFromJSON(json) {
  return GetCommitmentVsUsageResponseReportItemsInnerProductFromJSONTyped(json, false);
}
function GetCommitmentVsUsageResponseReportItemsInnerProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "variantId": json["variantId"],
    "variantName": json["variantName"]
  };
}

// src/generated/models/GetUsageReportV2ResponseReportItemsInnerCustomer.ts
function GetUsageReportV2ResponseReportItemsInnerCustomerFromJSON(json) {
  return GetUsageReportV2ResponseReportItemsInnerCustomerFromJSONTyped(json, false);
}
function GetUsageReportV2ResponseReportItemsInnerCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"]
  };
}

// src/generated/models/GetCommitmentVsUsageResponseReportItemsInner.ts
function GetCommitmentVsUsageResponseReportItemsInnerFromJSON(json) {
  return GetCommitmentVsUsageResponseReportItemsInnerFromJSONTyped(json, false);
}
function GetCommitmentVsUsageResponseReportItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": GetUsageReportV2ResponseReportItemsInnerCustomerFromJSON(json["customer"]),
    "contract": GetCommitmentVsUsageResponseReportItemsInnerContractFromJSON(json["contract"]),
    "product": GetCommitmentVsUsageResponseReportItemsInnerProductFromJSON(json["product"]),
    "commitment": GetCommitmentVsUsageResponseReportItemsInnerCommitmentFromJSON(json["commitment"]),
    "currentCycle": GetCommitmentVsUsageResponseReportItemsInnerCurrentCycleFromJSON(json["currentCycle"]),
    "monthlyEntries": json["monthlyEntries"].map(GetCommitmentVsUsageResponseReportItemsInnerMonthlyEntriesInnerFromJSON)
  };
}

// src/generated/models/GetCommitmentVsUsageResponse.ts
function GetCommitmentVsUsageResponseFromJSON(json) {
  return GetCommitmentVsUsageResponseFromJSONTyped(json, false);
}
function GetCommitmentVsUsageResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "reportItems": json["reportItems"].map(GetCommitmentVsUsageResponseReportItemsInnerFromJSON),
    "months": json["months"].map(GetCommitmentVsUsageResponseMonthsInnerFromJSON),
    "reportGeneratedAt": json["reportGeneratedAt"]
  };
}

// src/generated/models/GetContractBillingScheduleResponseInvoicesInnerProductsInner.ts
function GetContractBillingScheduleResponseInvoicesInnerProductsInnerFromJSON(json) {
  return GetContractBillingScheduleResponseInvoicesInnerProductsInnerFromJSONTyped(json, false);
}
function GetContractBillingScheduleResponseInvoicesInnerProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["productId"],
    "name": json["name"],
    "period": PeriodFromJSON(json["period"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"])
  };
}

// src/generated/models/GetContractBillingScheduleResponseInvoicesInner.ts
function GetContractBillingScheduleResponseInvoicesInnerFromJSON(json) {
  return GetContractBillingScheduleResponseInvoicesInnerFromJSONTyped(json, false);
}
function GetContractBillingScheduleResponseInvoicesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "name": json["name"],
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "lineItemsGroupingKey": json["lineItemsGroupingKey"],
    "invoicingDate": new Date(json["invoicingDate"]),
    "period": PeriodFromJSON(json["period"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "products": json["products"].map(GetContractBillingScheduleResponseInvoicesInnerProductsInnerFromJSON)
  };
}

// src/generated/models/GetContractBillingScheduleResponse.ts
function GetContractBillingScheduleResponseFromJSON(json) {
  return GetContractBillingScheduleResponseFromJSONTyped(json, false);
}
function GetContractBillingScheduleResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoices": json["invoices"].map(GetContractBillingScheduleResponseInvoicesInnerFromJSON)
  };
}

// src/generated/models/GetContractCustomFieldsResponse.ts
function GetContractCustomFieldsResponseFromJSON(json) {
  return GetContractCustomFieldsResponseFromJSONTyped(json, false);
}
function GetContractCustomFieldsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customFields": json["customFields"].map(CustomFieldValueWithDefinitionFromJSON)
  };
}

// src/generated/models/GetContractPageDataResponse.ts
function GetContractPageDataResponseFromJSON(json) {
  return GetContractPageDataResponseFromJSONTyped(json, false);
}
function GetContractPageDataResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractPageData": ContractPageDataFromJSON(json["contractPageData"]),
    "customFieldsWithDefinitions": !exists(json, "customFieldsWithDefinitions") ? void 0 : json["customFieldsWithDefinitions"].map(CustomFieldValueWithDefinitionFromJSON),
    "customFieldDefinitions": !exists(json, "customFieldDefinitions") ? void 0 : json["customFieldDefinitions"].map(CustomFieldDefinitionFromJSON)
  };
}

// src/generated/models/GetContractPdfResponse.ts
function GetContractPdfResponseFromJSON(json) {
  return GetContractPdfResponseFromJSONTyped(json, false);
}
function GetContractPdfResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"],
    "encodedPdf": json["encodedPdf"],
    "fileName": !exists(json, "fileName") ? void 0 : json["fileName"]
  };
}

// src/generated/models/GetContractProductsConsumptionResponseProductsInner.ts
function GetContractProductsConsumptionResponseProductsInnerFromJSON(json) {
  return GetContractProductsConsumptionResponseProductsInnerFromJSONTyped(json, false);
}
function GetContractProductsConsumptionResponseProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["productId"],
    "productName": !exists(json, "productName") ? void 0 : json["productName"],
    "currentConsumption": json["currentConsumption"],
    "totalConsumption": json["totalConsumption"]
  };
}

// src/generated/models/GetContractProductsConsumptionResponse.ts
function GetContractProductsConsumptionResponseFromJSON(json) {
  return GetContractProductsConsumptionResponseFromJSONTyped(json, false);
}
function GetContractProductsConsumptionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "products": json["products"].map(GetContractProductsConsumptionResponseProductsInnerFromJSON)
  };
}

// src/generated/models/GetContractProductsOverviewsResponse.ts
function GetContractProductsOverviewsResponseFromJSON(json) {
  return GetContractProductsOverviewsResponseFromJSONTyped(json, false);
}
function GetContractProductsOverviewsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productsOverviews": json["productsOverviews"].map(ContractProductOverviewFromJSON)
  };
}

// src/generated/models/GetContractResponse.ts
function GetContractResponseFromJSON(json) {
  return GetContractResponseFromJSONTyped(json, false);
}
function GetContractResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract": ContractFromJSON(json["contract"])
  };
}

// src/generated/models/GetCustomerRevenueReportResponseReportItemsInnerContract.ts
function GetCustomerRevenueReportResponseReportItemsInnerContractFromJSON(json) {
  return GetCustomerRevenueReportResponseReportItemsInnerContractFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseReportItemsInnerContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "status": !exists(json, "status") ? void 0 : ContractStatusFromJSON(json["status"]),
    "renewedContractId": !exists(json, "renewedContractId") ? void 0 : json["renewedContractId"]
  };
}

// src/generated/models/GetCustomerRevenueReportResponseReportItemsInnerCustomer.ts
function GetCustomerRevenueReportResponseReportItemsInnerCustomerFromJSON(json) {
  return GetCustomerRevenueReportResponseReportItemsInnerCustomerFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseReportItemsInnerCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "currency": CurrencyFromJSON(json["currency"]),
    "source": !exists(json, "source") ? void 0 : CustomerSourceFromJSON(json["source"]),
    "country": !exists(json, "country") ? void 0 : json["country"],
    "state": !exists(json, "state") ? void 0 : json["state"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON)
  };
}

// src/generated/models/GetCustomerRevenueReportResponseReportItemsInnerInvoicesInner.ts
function GetCustomerRevenueReportResponseReportItemsInnerInvoicesInnerFromJSON(json) {
  return GetCustomerRevenueReportResponseReportItemsInnerInvoicesInnerFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseReportItemsInnerInvoicesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "period": PeriodFromJSON(json["period"]),
    "amount": !exists(json, "amount") ? void 0 : json["amount"],
    "currency": !exists(json, "currency") ? void 0 : CurrencyFromJSON(json["currency"])
  };
}

// src/generated/models/GetCustomerRevenueReportResponseReportItemsInnerProduct.ts
function GetCustomerRevenueReportResponseReportItemsInnerProductFromJSON(json) {
  return GetCustomerRevenueReportResponseReportItemsInnerProductFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseReportItemsInnerProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"]
  };
}

// src/generated/models/GetCustomerRevenueReportResponseReportItemsInnerProductVariant.ts
function GetCustomerRevenueReportResponseReportItemsInnerProductVariantFromJSON(json) {
  return GetCustomerRevenueReportResponseReportItemsInnerProductVariantFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseReportItemsInnerProductVariantFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "pricing": PricingFromJSON(json["pricing"])
  };
}

// src/generated/models/RevisionedLineItemType.ts
function RevisionedLineItemTypeFromJSON(json) {
  return RevisionedLineItemTypeFromJSONTyped(json, false);
}
function RevisionedLineItemTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/GetCustomerRevenueReportResponseReportItemsInnerRevisionedLineItem.ts
function GetCustomerRevenueReportResponseReportItemsInnerRevisionedLineItemFromJSON(json) {
  return GetCustomerRevenueReportResponseReportItemsInnerRevisionedLineItemFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseReportItemsInnerRevisionedLineItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "price": json["price"],
    "type": RevisionedLineItemTypeFromJSON(json["type"]),
    "name": json["name"]
  };
}

// src/generated/models/GetCustomerRevenueReportResponseReportItemsInnerVariant.ts
function GetCustomerRevenueReportResponseReportItemsInnerVariantFromJSON(json) {
  return GetCustomerRevenueReportResponseReportItemsInnerVariantFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseReportItemsInnerVariantFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "pricingModel": !exists(json, "pricingModel") ? void 0 : json["pricingModel"],
    "productType": !exists(json, "productType") ? void 0 : json["productType"]
  };
}

// src/generated/models/UpsertRevenueRecognitionOverrideRequestBilledOverrideInner.ts
function UpsertRevenueRecognitionOverrideRequestBilledOverrideInnerFromJSON(json) {
  return UpsertRevenueRecognitionOverrideRequestBilledOverrideInnerFromJSONTyped(json, false);
}
function UpsertRevenueRecognitionOverrideRequestBilledOverrideInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": json["date"],
    "value": json["value"]
  };
}
function UpsertRevenueRecognitionOverrideRequestBilledOverrideInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "date": value.date,
    "value": value.value
  };
}

// src/generated/models/GetCustomerRevenueReportResponseReportItemsInner.ts
function GetCustomerRevenueReportResponseReportItemsInnerFromJSON(json) {
  return GetCustomerRevenueReportResponseReportItemsInnerFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseReportItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": !exists(json, "productId") ? void 0 : json["productId"],
    "variantId": !exists(json, "variantId") ? void 0 : json["variantId"],
    "customer": GetCustomerRevenueReportResponseReportItemsInnerCustomerFromJSON(json["customer"]),
    "contract": !exists(json, "contract") ? void 0 : GetCustomerRevenueReportResponseReportItemsInnerContractFromJSON(json["contract"]),
    "product": !exists(json, "product") ? void 0 : GetCustomerRevenueReportResponseReportItemsInnerProductFromJSON(json["product"]),
    "variant": !exists(json, "variant") ? void 0 : GetCustomerRevenueReportResponseReportItemsInnerVariantFromJSON(json["variant"]),
    "productVariant": !exists(json, "productVariant") ? void 0 : GetCustomerRevenueReportResponseReportItemsInnerProductVariantFromJSON(json["productVariant"]),
    "revisionedLineItem": !exists(json, "revisionedLineItem") ? void 0 : GetCustomerRevenueReportResponseReportItemsInnerRevisionedLineItemFromJSON(json["revisionedLineItem"]),
    "invoices": !exists(json, "invoices") ? void 0 : json["invoices"].map(GetCustomerRevenueReportResponseReportItemsInnerInvoicesInnerFromJSON),
    "invoiceId": !exists(json, "invoiceId") ? void 0 : json["invoiceId"],
    "planName": !exists(json, "planName") ? void 0 : json["planName"],
    "catalogProducts": !exists(json, "catalogProducts") ? void 0 : json["catalogProducts"].map(BillingCycleCustomersInnerFromJSON),
    "meterIds": !exists(json, "meterIds") ? void 0 : json["meterIds"],
    "yearlyRevenue": json["yearlyRevenue"],
    "billed": !exists(json, "billed") ? void 0 : json["billed"].map(UpsertRevenueRecognitionOverrideRequestBilledOverrideInnerFromJSON),
    "revenue": !exists(json, "revenue") ? void 0 : json["revenue"].map(UpsertRevenueRecognitionOverrideRequestBilledOverrideInnerFromJSON),
    "recognitionTypeOverride": !exists(json, "recognitionTypeOverride") ? void 0 : json["recognitionTypeOverride"],
    "totalRevenue": !exists(json, "totalRevenue") ? void 0 : json["totalRevenue"],
    "totalBilled": !exists(json, "totalBilled") ? void 0 : json["totalBilled"],
    "totalDeferred": !exists(json, "totalDeferred") ? void 0 : json["totalDeferred"],
    "totalUnbilled": !exists(json, "totalUnbilled") ? void 0 : json["totalUnbilled"],
    "totalRecognized": !exists(json, "totalRecognized") ? void 0 : json["totalRecognized"],
    "totalRemaining": !exists(json, "totalRemaining") ? void 0 : json["totalRemaining"],
    "invoiceCount": !exists(json, "invoiceCount") ? void 0 : json["invoiceCount"],
    "contractDurationMonths": !exists(json, "contractDurationMonths") ? void 0 : json["contractDurationMonths"],
    "isOverridden": !exists(json, "isOverridden") ? void 0 : json["isOverridden"]
  };
}

// src/generated/models/GetContractRevenueScheduleReportResponse.ts
function GetContractRevenueScheduleReportResponseFromJSON(json) {
  return GetContractRevenueScheduleReportResponseFromJSONTyped(json, false);
}
function GetContractRevenueScheduleReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"],
    "reportItems": json["reportItems"].map(GetCustomerRevenueReportResponseReportItemsInnerFromJSON)
  };
}

// src/generated/models/GetContractUsageBreakdownResponseUsageByDateBreakdownInnerProductUsageInner.ts
function GetContractUsageBreakdownResponseUsageByDateBreakdownInnerProductUsageInnerFromJSON(json) {
  return GetContractUsageBreakdownResponseUsageByDateBreakdownInnerProductUsageInnerFromJSONTyped(json, false);
}
function GetContractUsageBreakdownResponseUsageByDateBreakdownInnerProductUsageInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["productId"],
    "productName": json["productName"],
    "units": json["units"]
  };
}

// src/generated/models/GetContractUsageBreakdownResponseUsageByDateBreakdownInner.ts
function GetContractUsageBreakdownResponseUsageByDateBreakdownInnerFromJSON(json) {
  return GetContractUsageBreakdownResponseUsageByDateBreakdownInnerFromJSONTyped(json, false);
}
function GetContractUsageBreakdownResponseUsageByDateBreakdownInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "units": json["units"],
    "productUsage": json["productUsage"].map(GetContractUsageBreakdownResponseUsageByDateBreakdownInnerProductUsageInnerFromJSON)
  };
}

// src/generated/models/GetContractUsageBreakdownResponse.ts
function GetContractUsageBreakdownResponseFromJSON(json) {
  return GetContractUsageBreakdownResponseFromJSONTyped(json, false);
}
function GetContractUsageBreakdownResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "usageByDateBreakdown": json["usageByDateBreakdown"].map(GetContractUsageBreakdownResponseUsageByDateBreakdownInnerFromJSON)
  };
}

// src/generated/models/GetContractVersionResponse.ts
function GetContractVersionResponseFromJSON(json) {
  return GetContractVersionResponseFromJSONTyped(json, false);
}
function GetContractVersionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "products": json["products"].map(ProductFromJSON)
  };
}

// src/generated/models/GetContractsResponseContractsInnerCustomer.ts
function GetContractsResponseContractsInnerCustomerFromJSON(json) {
  return GetContractsResponseContractsInnerCustomerFromJSONTyped(json, false);
}
function GetContractsResponseContractsInnerCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "settings": !exists(json, "settings") ? void 0 : CustomerSettingsFromJSON(json["settings"])
  };
}

// src/generated/models/GetContractsResponseContractsInnerPlan.ts
function GetContractsResponseContractsInnerPlanFromJSON(json) {
  return GetContractsResponseContractsInnerPlanFromJSONTyped(json, false);
}
function GetContractsResponseContractsInnerPlanFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "billingData": PlanBillingDataFromJSON(json["billingData"]),
    "products": json["products"].map(ContractOverviewProductFromJSON)
  };
}

// src/generated/models/GetContractsResponseContractsInner.ts
function GetContractsResponseContractsInnerFromJSON(json) {
  return GetContractsResponseContractsInnerFromJSONTyped(json, false);
}
function GetContractsResponseContractsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "status": ContractStatusFromJSON(json["status"]),
    "startDate": new Date(json["startDate"]),
    "initialStartDate": !exists(json, "initialStartDate") ? void 0 : new Date(json["initialStartDate"]),
    "revisedAt": !exists(json, "revisedAt") ? void 0 : new Date(json["revisedAt"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ContractIntegrationEntitiesInnerFromJSON),
    "signatureDate": !exists(json, "signatureDate") ? void 0 : new Date(json["signatureDate"]),
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "isEditable": json["isEditable"],
    "revenue": json["revenue"],
    "customer": GetContractsResponseContractsInnerCustomerFromJSON(json["customer"]),
    "plan": GetContractsResponseContractsInnerPlanFromJSON(json["plan"]),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON)
  };
}

// src/generated/models/GetContractsOverviewsResponse.ts
function GetContractsOverviewsResponseFromJSON(json) {
  return GetContractsOverviewsResponseFromJSONTyped(json, false);
}
function GetContractsOverviewsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "countedTotalActiveContractsOverviews": json["countedTotalActiveContractsOverviews"],
    "countedTotalContractsOverviews": json["countedTotalContractsOverviews"],
    "countedFilteredContractsOverviews": json["countedFilteredContractsOverviews"],
    "contracts": json["contracts"].map(GetContractsResponseContractsInnerFromJSON)
  };
}

// src/generated/models/GetContractsReportResponseReportInner.ts
function GetContractsReportResponseReportInnerFromJSON(json) {
  return GetContractsReportResponseReportInnerFromJSONTyped(json, false);
}
function GetContractsReportResponseReportInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractName": json["contractName"],
    "customerName": json["customerName"],
    "status": ContractStatusFromJSON(json["status"]),
    "startDate": new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "currency": CurrencyFromJSON(json["currency"]),
    "discountAmount": json["discountAmount"],
    "daysToEnd": !exists(json, "daysToEnd") ? void 0 : json["daysToEnd"],
    "trialPeriod": !exists(json, "trialPeriod") ? void 0 : json["trialPeriod"],
    "overageAmount": json["overageAmount"],
    "autoRenewal": json["autoRenewal"],
    "estimatedAmount": json["estimatedAmount"],
    "syncStatusUpdatedAt": !exists(json, "syncStatusUpdatedAt") ? void 0 : new Date(json["syncStatusUpdatedAt"]),
    "contractId": !exists(json, "contractId") ? void 0 : json["contractId"]
  };
}

// src/generated/models/GetContractsReportResponse.ts
function GetContractsReportResponseFromJSON(json) {
  return GetContractsReportResponseFromJSONTyped(json, false);
}
function GetContractsReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": json["report"].map(GetContractsReportResponseReportInnerFromJSON),
    "creationDate": new Date(json["creationDate"]),
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"])
  };
}

// src/generated/models/GetContractsResponse.ts
function GetContractsResponseFromJSON(json) {
  return GetContractsResponseFromJSONTyped(json, false);
}
function GetContractsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "countedActiveContracts": json["countedActiveContracts"],
    "countedInReviewContracts": json["countedInReviewContracts"],
    "countedInactiveContracts": json["countedInactiveContracts"],
    "countedExpiredContracts": json["countedExpiredContracts"],
    "countedInactiveImportedContracts": json["countedInactiveImportedContracts"],
    "countedUpcomingRenewalContracts": json["countedUpcomingRenewalContracts"],
    "countedTotalContracts": json["countedTotalContracts"],
    "countedFilteredContracts": json["countedFilteredContracts"],
    "contracts": json["contracts"].map(GetContractsResponseContractsInnerFromJSON)
  };
}

// src/generated/models/GetCreditLedgerOverviewResponseCreditLedger.ts
function GetCreditLedgerOverviewResponseCreditLedgerFromJSON(json) {
  return GetCreditLedgerOverviewResponseCreditLedgerFromJSONTyped(json, false);
}
function GetCreditLedgerOverviewResponseCreditLedgerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "balance": json["balance"],
    "entriesOverviews": json["entriesOverviews"].map(CreditLedgerEntryOverviewFromJSON)
  };
}

// src/generated/models/GetCreditLedgerOverviewResponse.ts
function GetCreditLedgerOverviewResponseFromJSON(json) {
  return GetCreditLedgerOverviewResponseFromJSONTyped(json, false);
}
function GetCreditLedgerOverviewResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditLedger": !exists(json, "creditLedger") ? void 0 : GetCreditLedgerOverviewResponseCreditLedgerFromJSON(json["creditLedger"])
  };
}

// src/generated/models/GetCreditLedgerPdfResponse.ts
function GetCreditLedgerPdfResponseFromJSON(json) {
  return GetCreditLedgerPdfResponseFromJSONTyped(json, false);
}
function GetCreditLedgerPdfResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditLedgerId": json["creditLedgerId"],
    "encodedPdf": json["encodedPdf"]
  };
}

// src/generated/models/GetCreditNotesResponseCreditNotesInner.ts
function GetCreditNotesResponseCreditNotesInnerFromJSON(json) {
  return GetCreditNotesResponseCreditNotesInnerFromJSONTyped(json, false);
}
function GetCreditNotesResponseCreditNotesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "date": new Date(json["date"]),
    "amount": json["amount"],
    "customerId": json["customerId"],
    "customerName": json["customerName"],
    "invoiceId": !exists(json, "invoiceId") ? void 0 : json["invoiceId"],
    "invoiceNumber": !exists(json, "invoiceNumber") ? void 0 : json["invoiceNumber"],
    "contractId": !exists(json, "contractId") ? void 0 : json["contractId"],
    "erpId": !exists(json, "erpId") ? void 0 : json["erpId"],
    "syncedIntegrations": !exists(json, "syncedIntegrations") ? void 0 : json["syncedIntegrations"]
  };
}

// src/generated/models/GetCreditNotesResponse.ts
function GetCreditNotesResponseFromJSON(json) {
  return GetCreditNotesResponseFromJSONTyped(json, false);
}
function GetCreditNotesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditNotes": json["creditNotes"].map(GetCreditNotesResponseCreditNotesInnerFromJSON)
  };
}

// src/generated/models/GetCreditTypeResponse.ts
function GetCreditTypeResponseFromJSON(json) {
  return GetCreditTypeResponseFromJSONTyped(json, false);
}
function GetCreditTypeResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditType": CreditTypeFromJSON(json["creditType"])
  };
}

// src/generated/models/GetCustomFieldDefinitionsResponse.ts
function GetCustomFieldDefinitionsResponseFromJSON(json) {
  return GetCustomFieldDefinitionsResponseFromJSONTyped(json, false);
}
function GetCustomFieldDefinitionsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customFieldDefinitions": json["customFieldDefinitions"].map(CustomFieldDefinitionFromJSON)
  };
}

// src/generated/models/GetCustomerCommitmentUsageResponseCustomerCommitmentUsageInner.ts
function GetCustomerCommitmentUsageResponseCustomerCommitmentUsageInnerFromJSON(json) {
  return GetCustomerCommitmentUsageResponseCustomerCommitmentUsageInnerFromJSONTyped(json, false);
}
function GetCustomerCommitmentUsageResponseCustomerCommitmentUsageInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerName": json["customerName"],
    "customerId": json["customerId"],
    "commitmentUnits": json["commitmentUnits"],
    "usageUnits": json["usageUnits"]
  };
}

// src/generated/models/GetCustomerCommitmentUsageResponse.ts
function GetCustomerCommitmentUsageResponseFromJSON(json) {
  return GetCustomerCommitmentUsageResponseFromJSONTyped(json, false);
}
function GetCustomerCommitmentUsageResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerCommitmentUsage": json["customerCommitmentUsage"].map(GetCustomerCommitmentUsageResponseCustomerCommitmentUsageInnerFromJSON)
  };
}

// src/generated/models/GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerAllOfConsumption.ts
function GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerAllOfConsumptionFromJSON(json) {
  return GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerAllOfConsumptionFromJSONTyped(json, false);
}
function GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerAllOfConsumptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "total": json["total"],
    "current": json["current"]
  };
}

// src/generated/models/GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInner.ts
function GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerFromJSON(json) {
  return GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerFromJSONTyped(json, false);
}
function GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": !exists(json, "name") ? void 0 : json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "variants": json["variants"].map(ProductVariantFromJSON),
    "basePrice": !exists(json, "basePrice") ? void 0 : json["basePrice"],
    "additionalCharge": !exists(json, "additionalCharge") ? void 0 : json["additionalCharge"],
    "commitment": !exists(json, "commitment") ? void 0 : ProductConfigCommitmentFromJSON(json["commitment"]),
    "advancePayment": !exists(json, "advancePayment") ? void 0 : AdvancePaymentFromJSON(json["advancePayment"]),
    "chargingCadence": !exists(json, "chargingCadence") ? void 0 : json["chargingCadence"],
    "currencyCommitment": !exists(json, "currencyCommitment") ? void 0 : json["currencyCommitment"],
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "accumulationInterval": !exists(json, "accumulationInterval") ? void 0 : json["accumulationInterval"],
    "proRata": json["proRata"],
    "erpMetadata": !exists(json, "erpMetadata") ? void 0 : ErpMetadataFromJSON(json["erpMetadata"]),
    "rateMultiplier": !exists(json, "rateMultiplier") ? void 0 : json["rateMultiplier"],
    "isPeriodicVariants": !exists(json, "isPeriodicVariants") ? void 0 : json["isPeriodicVariants"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "startDate": !exists(json, "startDate") ? void 0 : json["startDate"] === null ? null : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : json["endDate"] === null ? null : new Date(json["endDate"]),
    "catalogProductId": !exists(json, "catalogProductId") ? void 0 : json["catalogProductId"],
    "productConfigs": !exists(json, "productConfigs") ? void 0 : json["productConfigs"] === null ? null : json["productConfigs"].map(ProductConfigFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : ProductExternalIntegrationFromJSON(json["externalIntegration"]),
    "revisionId": !exists(json, "revisionId") ? void 0 : json["revisionId"],
    "cloudProviderSettings": !exists(json, "cloudProviderSettings") ? void 0 : ProductCloudProviderSettingsFromJSON(json["cloudProviderSettings"]),
    "isCalendarAligned": json["isCalendarAligned"],
    "upliftConfiguration": !exists(json, "upliftConfiguration") ? void 0 : ProductUpliftConfigurationFromJSON(json["upliftConfiguration"]),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "creditPurchaseConfig": !exists(json, "creditPurchaseConfig") ? void 0 : CreditPurchaseConfigFromJSON(json["creditPurchaseConfig"]),
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "timeline": !exists(json, "timeline") ? void 0 : ProductTimelineFromJSON(json["timeline"]),
    "consumption": !exists(json, "consumption") ? void 0 : GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerAllOfConsumptionFromJSON(json["consumption"]),
    "totalUnits": !exists(json, "totalUnits") ? void 0 : json["totalUnits"]
  };
}

// src/generated/models/GetCustomerContractsOverviewPageResponseInnerContractAllOfPlan.ts
function GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanFromJSON(json) {
  return GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanFromJSONTyped(json, false);
}
function GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "products": json["products"].map(GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanAllOfProductsInnerFromJSON),
    "billingData": PlanBillingDataFromJSON(json["billingData"]),
    "status": PlanStatusFromJSON(json["status"]),
    "basedFromPlanId": !exists(json, "basedFromPlanId") ? void 0 : json["basedFromPlanId"],
    "trial": !exists(json, "trial") ? void 0 : PlanTrialFromJSON(json["trial"]),
    "purchaseOrder": !exists(json, "purchaseOrder") ? void 0 : json["purchaseOrder"],
    "rawSyncData": !exists(json, "rawSyncData") ? void 0 : PlanRawSyncDataFromJSON(json["rawSyncData"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(IntegrationEntityFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"],
    "revision": json["revision"]
  };
}

// src/generated/models/GetCustomerContractsOverviewPageResponseInnerContract.ts
function GetCustomerContractsOverviewPageResponseInnerContractFromJSON(json) {
  return GetCustomerContractsOverviewPageResponseInnerContractFromJSONTyped(json, false);
}
function GetCustomerContractsOverviewPageResponseInnerContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startDate": new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "status": ContractStatusFromJSON(json["status"]),
    "contractType": ContractTypeFromJSON(json["contractType"]),
    "parentAgreementSettings": !exists(json, "parentAgreementSettings") ? void 0 : ParentAgreementSettingsFromJSON(json["parentAgreementSettings"]),
    "trialEndDate": !exists(json, "trialEndDate") ? void 0 : new Date(json["trialEndDate"]),
    "cancelledAt": !exists(json, "cancelledAt") ? void 0 : new Date(json["cancelledAt"]),
    "terminatedAt": !exists(json, "terminatedAt") ? void 0 : new Date(json["terminatedAt"]),
    "revisedAt": !exists(json, "revisedAt") ? void 0 : new Date(json["revisedAt"]),
    "initialStartDate": !exists(json, "initialStartDate") ? void 0 : new Date(json["initialStartDate"]),
    "signatureDate": !exists(json, "signatureDate") ? void 0 : new Date(json["signatureDate"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ContractIntegrationEntitiesInnerFromJSON),
    "currencyOverride": !exists(json, "currencyOverride") ? void 0 : CurrencyFromJSON(json["currencyOverride"]),
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "credits": !exists(json, "credits") ? void 0 : json["credits"].map(CreditPurchaseConfigFromJSON),
    "isTrial": !exists(json, "isTrial") ? void 0 : json["isTrial"],
    "accountId": json["accountId"],
    "customer": CustomerFromJSON(json["customer"]),
    "plan": GetCustomerContractsOverviewPageResponseInnerContractAllOfPlanFromJSON(json["plan"]),
    "invoices": !exists(json, "invoices") ? void 0 : json["invoices"].map(ContractInvoicesInnerFromJSON),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "isEditable": json["isEditable"],
    "revenue": json["revenue"]
  };
}

// src/generated/models/GetCustomerContractsOverviewPageResponseInnerLastInvoice.ts
function GetCustomerContractsOverviewPageResponseInnerLastInvoiceFromJSON(json) {
  return GetCustomerContractsOverviewPageResponseInnerLastInvoiceFromJSONTyped(json, false);
}
function GetCustomerContractsOverviewPageResponseInnerLastInvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "billingCycle": FullDayPeriodFromJSON(json["billingCycle"])
  };
}

// src/generated/models/GetCustomerContractsOverviewPageResponseInner.ts
function GetCustomerContractsOverviewPageResponseInnerFromJSON(json) {
  return GetCustomerContractsOverviewPageResponseInnerFromJSONTyped(json, false);
}
function GetCustomerContractsOverviewPageResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract": GetCustomerContractsOverviewPageResponseInnerContractFromJSON(json["contract"]),
    "lastInvoice": !exists(json, "lastInvoice") ? void 0 : GetCustomerContractsOverviewPageResponseInnerLastInvoiceFromJSON(json["lastInvoice"])
  };
}

// src/generated/models/GetCustomerInvoicePageDataResponseCustomer.ts
function GetCustomerInvoicePageDataResponseCustomerFromJSON(json) {
  return GetCustomerInvoicePageDataResponseCustomerFromJSONTyped(json, false);
}
function GetCustomerInvoicePageDataResponseCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"]
  };
}

// src/generated/models/GetCustomerInvoicePageDataResponseInvoice.ts
function GetCustomerInvoicePageDataResponseInvoiceFromJSON(json) {
  return GetCustomerInvoicePageDataResponseInvoiceFromJSONTyped(json, false);
}
function GetCustomerInvoicePageDataResponseInvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"])
  };
}

// src/generated/models/GetCustomerInvoicePageDataResponse.ts
function GetCustomerInvoicePageDataResponseFromJSON(json) {
  return GetCustomerInvoicePageDataResponseFromJSONTyped(json, false);
}
function GetCustomerInvoicePageDataResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": GetCustomerInvoicePageDataResponseCustomerFromJSON(json["customer"]),
    "invoice": GetCustomerInvoicePageDataResponseInvoiceFromJSON(json["invoice"])
  };
}

// src/generated/models/GetCustomerMasterReportResponseReportInnerContractsInner.ts
function GetCustomerMasterReportResponseReportInnerContractsInnerFromJSON(json) {
  return GetCustomerMasterReportResponseReportInnerContractsInnerFromJSONTyped(json, false);
}
function GetCustomerMasterReportResponseReportInnerContractsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"],
    "contractName": json["contractName"],
    "status": ContractStatusFromJSON(json["status"]),
    "startDate": new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "daysToEnd": !exists(json, "daysToEnd") ? void 0 : json["daysToEnd"],
    "durationMonths": !exists(json, "durationMonths") ? void 0 : json["durationMonths"],
    "currency": CurrencyFromJSON(json["currency"]),
    "estimatedAmount": json["estimatedAmount"],
    "mrr": !exists(json, "mrr") ? void 0 : json["mrr"],
    "autoRenewal": json["autoRenewal"],
    "trialPeriod": !exists(json, "trialPeriod") ? void 0 : json["trialPeriod"],
    "purchaseOrder": !exists(json, "purchaseOrder") ? void 0 : json["purchaseOrder"],
    "accountManager": !exists(json, "accountManager") ? void 0 : json["accountManager"],
    "salesforceOpportunityId": !exists(json, "salesforceOpportunityId") ? void 0 : json["salesforceOpportunityId"],
    "netSuiteSalesOrderId": !exists(json, "netSuiteSalesOrderId") ? void 0 : json["netSuiteSalesOrderId"],
    "syncStatusUpdatedAt": !exists(json, "syncStatusUpdatedAt") ? void 0 : new Date(json["syncStatusUpdatedAt"]),
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON)
  };
}

// src/generated/models/PaymentProvider.ts
function PaymentProviderFromJSON(json) {
  return PaymentProviderFromJSONTyped(json, false);
}
function PaymentProviderFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/GetCustomerMasterReportResponseReportInner.ts
function GetCustomerMasterReportResponseReportInnerFromJSON(json) {
  return GetCustomerMasterReportResponseReportInnerFromJSONTyped(json, false);
}
function GetCustomerMasterReportResponseReportInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerId": !exists(json, "customerId") ? void 0 : json["customerId"],
    "customerName": json["customerName"],
    "customerAlias": !exists(json, "customerAlias") ? void 0 : json["customerAlias"],
    "status": !exists(json, "status") ? void 0 : CustomerStatusFromJSON(json["status"]),
    "customerType": !exists(json, "customerType") ? void 0 : CustomerTypeFromJSON(json["customerType"]),
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "parentCustomer": !exists(json, "parentCustomer") ? void 0 : json["parentCustomer"],
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "nsErpId": !exists(json, "nsErpId") ? void 0 : json["nsErpId"],
    "qbErpId": !exists(json, "qbErpId") ? void 0 : json["qbErpId"],
    "xeroErpId": !exists(json, "xeroErpId") ? void 0 : json["xeroErpId"],
    "stripeId": !exists(json, "stripeId") ? void 0 : json["stripeId"],
    "subsidiary": !exists(json, "subsidiary") ? void 0 : json["subsidiary"],
    "taxId": !exists(json, "taxId") ? void 0 : json["taxId"],
    "customerCurrency": !exists(json, "customerCurrency") ? void 0 : CurrencyFromJSON(json["customerCurrency"]),
    "taxMethod": !exists(json, "taxMethod") ? void 0 : json["taxMethod"],
    "taxRate": !exists(json, "taxRate") ? void 0 : json["taxRate"],
    "manualReview": !exists(json, "manualReview") ? void 0 : json["manualReview"],
    "paymentProvider": !exists(json, "paymentProvider") ? void 0 : PaymentProviderFromJSON(json["paymentProvider"]),
    "autoPay": !exists(json, "autoPay") ? void 0 : json["autoPay"],
    "customerNotes": !exists(json, "customerNotes") ? void 0 : json["customerNotes"],
    "wallet": !exists(json, "wallet") ? void 0 : json["wallet"],
    "createdAt": new Date(json["createdAt"]),
    "dueDate": !exists(json, "dueDate") ? void 0 : json["dueDate"],
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"].map(ContactFromJSON),
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "contracts": json["contracts"].map(GetCustomerMasterReportResponseReportInnerContractsInnerFromJSON)
  };
}

// src/generated/models/GetCustomerMasterReportResponse.ts
function GetCustomerMasterReportResponseFromJSON(json) {
  return GetCustomerMasterReportResponseFromJSONTyped(json, false);
}
function GetCustomerMasterReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": json["report"].map(GetCustomerMasterReportResponseReportInnerFromJSON),
    "creationDate": new Date(json["creationDate"])
  };
}

// src/generated/models/GetCustomerPortalCreditPoolsResponse.ts
function GetCustomerPortalCreditPoolsResponseFromJSON(json) {
  return GetCustomerPortalCreditPoolsResponseFromJSONTyped(json, false);
}
function GetCustomerPortalCreditPoolsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditPools": json["creditPools"].map(CreditPoolWithUnitsFromJSON)
  };
}

// src/generated/models/GetCustomerPortalDailyUsageDataResponseInner.ts
function GetCustomerPortalDailyUsageDataResponseInnerFromJSON(json) {
  return GetCustomerPortalDailyUsageDataResponseInnerFromJSONTyped(json, false);
}
function GetCustomerPortalDailyUsageDataResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "totalValue": json["totalValue"],
    "date": new Date(json["date"]),
    "productName": json["productName"]
  };
}

// src/generated/models/GetCustomerPortalDataResponseAccount.ts
function GetCustomerPortalDataResponseAccountFromJSON(json) {
  return GetCustomerPortalDataResponseAccountFromJSONTyped(json, false);
}
function GetCustomerPortalDataResponseAccountFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "logoUrl": !exists(json, "logoUrl") ? void 0 : json["logoUrl"]
  };
}

// src/generated/models/GetCustomerPortalDataResponseCommitmentSummariesInner.ts
function GetCustomerPortalDataResponseCommitmentSummariesInnerFromJSON(json) {
  return GetCustomerPortalDataResponseCommitmentSummariesInnerFromJSONTyped(json, false);
}
function GetCustomerPortalDataResponseCommitmentSummariesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "amount": json["amount"],
    "type": CommitmentTypeFromJSON(json["type"])
  };
}

// src/generated/models/GetCustomerPortalDataResponseCustomer.ts
function GetCustomerPortalDataResponseCustomerFromJSON(json) {
  return GetCustomerPortalDataResponseCustomerFromJSONTyped(json, false);
}
function GetCustomerPortalDataResponseCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "name": json["name"],
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"] === null ? null : json["contacts"].map(ContactFromJSON)
  };
}

// src/generated/models/GetCustomerPortalDataResponseInvoicesInner.ts
function GetCustomerPortalDataResponseInvoicesInnerFromJSON(json) {
  return GetCustomerPortalDataResponseInvoicesInnerFromJSONTyped(json, false);
}
function GetCustomerPortalDataResponseInvoicesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "issuedAt": json["issuedAt"] === null ? null : new Date(json["issuedAt"]),
    "dueDate": json["dueDate"] === null ? null : new Date(json["dueDate"]),
    "invoicingDate": !exists(json, "invoicingDate") ? void 0 : new Date(json["invoicingDate"]),
    "invoiceNumber": json["invoiceNumber"],
    "ref": json["ref"],
    "customerName": json["customerName"],
    "currency": CurrencyFromJSON(json["currency"]),
    "productsConsumption": json["productsConsumption"].map(ProductConsumptionFromJSON),
    "isTrial": json["isTrial"]
  };
}

// src/generated/models/GetCustomerPortalDataResponse.ts
function GetCustomerPortalDataResponseFromJSON(json) {
  return GetCustomerPortalDataResponseFromJSONTyped(json, false);
}
function GetCustomerPortalDataResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "account": GetCustomerPortalDataResponseAccountFromJSON(json["account"]),
    "customer": GetCustomerPortalDataResponseCustomerFromJSON(json["customer"]),
    "invoices": json["invoices"].map(GetCustomerPortalDataResponseInvoicesInnerFromJSON),
    "totalInvoicesCount": json["totalInvoicesCount"],
    "invoicesSummary": !exists(json, "invoicesSummary") ? void 0 : json["invoicesSummary"],
    "commitmentSummaries": !exists(json, "commitmentSummaries") ? void 0 : json["commitmentSummaries"].map(GetCustomerPortalDataResponseCommitmentSummariesInnerFromJSON),
    "currency": !exists(json, "currency") ? void 0 : CurrencyFromJSON(json["currency"]),
    "productsConsumption": !exists(json, "productsConsumption") ? void 0 : json["productsConsumption"].map(ProductConsumptionFromJSON)
  };
}

// src/generated/models/GetCustomerPortalInvoicePdfResponse.ts
function GetCustomerPortalInvoicePdfResponseFromJSON(json) {
  return GetCustomerPortalInvoicePdfResponseFromJSONTyped(json, false);
}
function GetCustomerPortalInvoicePdfResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "encodedPdf": json["encodedPdf"]
  };
}

// src/generated/models/GetCustomerResponseChildrenRelationsInner.ts
function GetCustomerResponseChildrenRelationsInnerFromJSON(json) {
  return GetCustomerResponseChildrenRelationsInnerFromJSONTyped(json, false);
}
function GetCustomerResponseChildrenRelationsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "childId": json["childId"],
    "relationType": CustomerRelationTypeFromJSON(json["relationType"])
  };
}

// src/generated/models/GetCustomerResponse.ts
function GetCustomerResponseFromJSON(json) {
  return GetCustomerResponseFromJSONTyped(json, false);
}
function GetCustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": CustomerFromJSON(json["customer"]),
    "children": json["children"].map(CustomerFromJSON),
    "childrenRelations": !exists(json, "childrenRelations") ? void 0 : json["childrenRelations"].map(GetCustomerResponseChildrenRelationsInnerFromJSON),
    "customFieldsWithDefinitions": !exists(json, "customFieldsWithDefinitions") ? void 0 : json["customFieldsWithDefinitions"].map(CustomFieldValueWithDefinitionFromJSON),
    "customFieldDefinitions": !exists(json, "customFieldDefinitions") ? void 0 : json["customFieldDefinitions"].map(CustomFieldDefinitionFromJSON)
  };
}

// src/generated/models/GetCustomerRevenueReportResponse.ts
function GetCustomerRevenueReportResponseFromJSON(json) {
  return GetCustomerRevenueReportResponseFromJSONTyped(json, false);
}
function GetCustomerRevenueReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "reportItems": json["reportItems"].map(GetCustomerRevenueReportResponseReportItemsInnerFromJSON),
    "reportPeriod": !exists(json, "reportPeriod") ? void 0 : PeriodFromJSON(json["reportPeriod"]),
    "totalRevenue": !exists(json, "totalRevenue") ? void 0 : json["totalRevenue"],
    "totalBilled": !exists(json, "totalBilled") ? void 0 : json["totalBilled"],
    "totalDeferred": !exists(json, "totalDeferred") ? void 0 : json["totalDeferred"],
    "totalUnbilled": !exists(json, "totalUnbilled") ? void 0 : json["totalUnbilled"],
    "customerCount": !exists(json, "customerCount") ? void 0 : json["customerCount"],
    "reportGeneratedAt": !exists(json, "reportGeneratedAt") ? void 0 : json["reportGeneratedAt"],
    "totals": !exists(json, "totals") ? void 0 : json["totals"]
  };
}

// src/generated/models/GetCustomerStatusCountsResponseInner.ts
function GetCustomerStatusCountsResponseInnerFromJSON(json) {
  return GetCustomerStatusCountsResponseInnerFromJSONTyped(json, false);
}
function GetCustomerStatusCountsResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "status": CustomerStatusFromJSON(json["status"]),
    "count": json["count"]
  };
}

// src/generated/models/GetCustomersNamesResponseCustomersInner.ts
function GetCustomersNamesResponseCustomersInnerFromJSON(json) {
  return GetCustomersNamesResponseCustomersInnerFromJSONTyped(json, false);
}
function GetCustomersNamesResponseCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "id": json["id"],
    "childCustomersIds": !exists(json, "childCustomersIds") ? void 0 : json["childCustomersIds"]
  };
}

// src/generated/models/GetCustomersNamesResponse.ts
function GetCustomersNamesResponseFromJSON(json) {
  return GetCustomersNamesResponseFromJSONTyped(json, false);
}
function GetCustomersNamesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(GetCustomersNamesResponseCustomersInnerFromJSON)
  };
}

// src/generated/models/GetCustomersOverviewsNewResponse.ts
function GetCustomersOverviewsNewResponseFromJSON(json) {
  return GetCustomersOverviewsNewResponseFromJSONTyped(json, false);
}
function GetCustomersOverviewsNewResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "items": json["items"].map(CustomerOverviewFromJSON),
    "count": json["count"]
  };
}

// src/generated/models/GetCustomersOverviewsResponse.ts
function GetCustomersOverviewsResponseFromJSON(json) {
  return GetCustomersOverviewsResponseFromJSONTyped(json, false);
}
function GetCustomersOverviewsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(CustomerOverviewFromJSON),
    "countedFilteredCustomers": json["countedFilteredCustomers"],
    "countedTotalCustomers": json["countedTotalCustomers"],
    "countedActiveCustomers": json["countedActiveCustomers"]
  };
}

// src/generated/models/GetCustomersReportResponseReportInner.ts
function GetCustomersReportResponseReportInnerFromJSON(json) {
  return GetCustomersReportResponseReportInnerFromJSONTyped(json, false);
}
function GetCustomersReportResponseReportInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerId": !exists(json, "customerId") ? void 0 : json["customerId"],
    "customerName": json["customerName"],
    "customerAlias": !exists(json, "customerAlias") ? void 0 : json["customerAlias"],
    "status": !exists(json, "status") ? void 0 : CustomerStatusFromJSON(json["status"]),
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "nsErpId": !exists(json, "nsErpId") ? void 0 : json["nsErpId"],
    "qbErpId": !exists(json, "qbErpId") ? void 0 : json["qbErpId"],
    "stripeConnected": json["stripeConnected"],
    "wallet": !exists(json, "wallet") ? void 0 : json["wallet"],
    "createdAt": new Date(json["createdAt"]),
    "dueDate": !exists(json, "dueDate") ? void 0 : json["dueDate"],
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"].map(ContactFromJSON),
    "parentCustomer": !exists(json, "parentCustomer") ? void 0 : json["parentCustomer"],
    "subsidiary": !exists(json, "subsidiary") ? void 0 : json["subsidiary"],
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"])
  };
}

// src/generated/models/GetCustomersReportResponse.ts
function GetCustomersReportResponseFromJSON(json) {
  return GetCustomersReportResponseFromJSONTyped(json, false);
}
function GetCustomersReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": json["report"].map(GetCustomersReportResponseReportInnerFromJSON),
    "creationDate": new Date(json["creationDate"]),
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"])
  };
}

// src/generated/models/GetCustomersResponseCustomersInner.ts
function GetCustomersResponseCustomersInnerFromJSON(json) {
  return GetCustomersResponseCustomersInnerFromJSONTyped(json, false);
}
function GetCustomersResponseCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "aliases": !exists(json, "aliases") ? void 0 : json["aliases"],
    "taxIds": !exists(json, "taxIds") ? void 0 : json["taxIds"],
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "crmMetadata": !exists(json, "crmMetadata") ? void 0 : CrmMetadataFromJSON(json["crmMetadata"]),
    "erpMetadata": !exists(json, "erpMetadata") ? void 0 : ErpMetadataFromJSON(json["erpMetadata"]),
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"] === null ? null : json["contacts"].map(ContactFromJSON),
    "settings": !exists(json, "settings") ? void 0 : CustomerSettingsFromJSON(json["settings"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "status": !exists(json, "status") ? void 0 : CustomerStatusFromJSON(json["status"]),
    "source": !exists(json, "source") ? void 0 : CustomerSourceFromJSON(json["source"]),
    "subsidiaryId": !exists(json, "subsidiaryId") ? void 0 : json["subsidiaryId"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(CustomerIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : json["externalIntegration"] === null ? null : json["externalIntegration"].map(CustomerExternalIntegrationInnerFromJSON),
    "accountOwnerId": !exists(json, "accountOwnerId") ? void 0 : json["accountOwnerId"],
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"],
    "childCustomersIds": !exists(json, "childCustomersIds") ? void 0 : json["childCustomersIds"]
  };
}

// src/generated/models/GetCustomersResponse.ts
function GetCustomersResponseFromJSON(json) {
  return GetCustomersResponseFromJSONTyped(json, false);
}
function GetCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(GetCustomersResponseCustomersInnerFromJSON)
  };
}

// src/generated/models/GetDailyEventsDigestedResponseDailyEventsDigestedInner.ts
function GetDailyEventsDigestedResponseDailyEventsDigestedInnerFromJSON(json) {
  return GetDailyEventsDigestedResponseDailyEventsDigestedInnerFromJSONTyped(json, false);
}
function GetDailyEventsDigestedResponseDailyEventsDigestedInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "count": json["count"]
  };
}

// src/generated/models/GetDailyEventsDigestedResponse.ts
function GetDailyEventsDigestedResponseFromJSON(json) {
  return GetDailyEventsDigestedResponseFromJSONTyped(json, false);
}
function GetDailyEventsDigestedResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "dailyEventsDigested": json["dailyEventsDigested"].map(GetDailyEventsDigestedResponseDailyEventsDigestedInnerFromJSON)
  };
}

// src/generated/models/GetDepositToResponse.ts
function GetDepositToResponseFromJSON(json) {
  return GetDepositToResponseFromJSONTyped(json, false);
}
function GetDepositToResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "depositToAccounts": json["depositToAccounts"].map(DepositToFromJSON),
    "defaultDepositToAccountId": !exists(json, "defaultDepositToAccountId") ? void 0 : json["defaultDepositToAccountId"]
  };
}

// src/generated/models/GetDynamicInvoiceResponse.ts
function GetDynamicInvoiceResponseFromJSON(json) {
  return GetDynamicInvoiceResponseFromJSONTyped(json, false);
}
function GetDynamicInvoiceResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "dynamicInvoiceData": DynamicInvoiceDataFromJSON(json["dynamicInvoiceData"])
  };
}

// src/generated/models/GetEventFieldValuesResponse.ts
function GetEventFieldValuesResponseFromJSON(json) {
  return GetEventFieldValuesResponseFromJSONTyped(json, false);
}
function GetEventFieldValuesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventFieldValues": json["eventFieldValues"]
  };
}

// src/generated/models/GetEventFieldsResponse.ts
function GetEventFieldsResponseFromJSON(json) {
  return GetEventFieldsResponseFromJSONTyped(json, false);
}
function GetEventFieldsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventFields": json["eventFields"].map(EventFieldFromJSON)
  };
}

// src/generated/models/GetEventNamesResponseEventNamesInner.ts
function GetEventNamesResponseEventNamesInnerFromJSON(json) {
  return GetEventNamesResponseEventNamesInnerFromJSONTyped(json, false);
}
function GetEventNamesResponseEventNamesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventName": json["eventName"]
  };
}

// src/generated/models/GetEventNamesResponse.ts
function GetEventNamesResponseFromJSON(json) {
  return GetEventNamesResponseFromJSONTyped(json, false);
}
function GetEventNamesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventNames": json["eventNames"].map(GetEventNamesResponseEventNamesInnerFromJSON)
  };
}

// src/generated/models/GetExchangeRatesMatrixResponse.ts
function GetExchangeRatesMatrixResponseFromJSON(json) {
  return GetExchangeRatesMatrixResponseFromJSONTyped(json, false);
}
function GetExchangeRatesMatrixResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": json["data"]
  };
}

// src/generated/models/GetExchangeRatesResponseData.ts
function GetExchangeRatesResponseDataFromJSON(json) {
  return GetExchangeRatesResponseDataFromJSONTyped(json, false);
}
function GetExchangeRatesResponseDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "uSD": json["USD"],
    "eUR": json["EUR"],
    "gBP": json["GBP"],
    "iLS": json["ILS"],
    "cAD": !exists(json, "CAD") ? void 0 : json["CAD"],
    "aUD": !exists(json, "AUD") ? void 0 : json["AUD"],
    "cOP": !exists(json, "COP") ? void 0 : json["COP"],
    "bRL": !exists(json, "BRL") ? void 0 : json["BRL"],
    "aRS": !exists(json, "ARS") ? void 0 : json["ARS"],
    "iNR": !exists(json, "INR") ? void 0 : json["INR"],
    "mXN": !exists(json, "MXN") ? void 0 : json["MXN"]
  };
}

// src/generated/models/GetExchangeRatesResponse.ts
function GetExchangeRatesResponseFromJSON(json) {
  return GetExchangeRatesResponseFromJSONTyped(json, false);
}
function GetExchangeRatesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "data": GetExchangeRatesResponseDataFromJSON(json["data"])
  };
}

// src/generated/models/GetExportedIntegrationsResponseInnerAttemptsInner.ts
function GetExportedIntegrationsResponseInnerAttemptsInnerFromJSON(json) {
  return GetExportedIntegrationsResponseInnerAttemptsInnerFromJSONTyped(json, false);
}
function GetExportedIntegrationsResponseInnerAttemptsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "syncJobId": json["syncJobId"],
    "status": json["status"],
    "startedAt": new Date(json["startedAt"]),
    "completedAt": new Date(json["completedAt"]),
    "error": json["error"],
    "errorData": !exists(json, "errorData") ? void 0 : json["errorData"]
  };
}

// src/generated/models/GetExportedIntegrationsResponseInner.ts
function GetExportedIntegrationsResponseInnerFromJSON(json) {
  return GetExportedIntegrationsResponseInnerFromJSONTyped(json, false);
}
function GetExportedIntegrationsResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integration": json["integration"],
    "integrationExternalId": json["integrationExternalId"],
    "entityName": !exists(json, "entityName") ? void 0 : json["entityName"],
    "status": json["status"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "attempts": json["attempts"].map(GetExportedIntegrationsResponseInnerAttemptsInnerFromJSON)
  };
}

// src/generated/models/GetExternalApiTokenResponse.ts
function GetExternalApiTokenResponseFromJSON(json) {
  return GetExternalApiTokenResponseFromJSONTyped(json, false);
}
function GetExternalApiTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "refreshToken": json["refreshToken"]
  };
}

// src/generated/models/GetExternalLinkResponse.ts
function GetExternalLinkResponseFromJSON(json) {
  return GetExternalLinkResponseFromJSONTyped(json, false);
}
function GetExternalLinkResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "url": json["url"]
  };
}

// src/generated/models/GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerCustomer.ts
function GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerCustomerFromJSON(json) {
  return GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerCustomerFromJSONTyped(json, false);
}
function GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "currency": !exists(json, "currency") ? void 0 : CurrencyFromJSON(json["currency"])
  };
}

// src/generated/models/GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerInvoice.ts
function GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerInvoiceFromJSON(json) {
  return GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerInvoiceFromJSONTyped(json, false);
}
function GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerInvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "contractId": !exists(json, "contractId") ? void 0 : json["contractId"],
    "parentLineItemId": !exists(json, "parentLineItemId") ? void 0 : json["parentLineItemId"],
    "invoicingDate": !exists(json, "invoicingDate") ? void 0 : new Date(json["invoicingDate"]),
    "issuedAt": json["issuedAt"] === null ? null : new Date(json["issuedAt"]),
    "name": json["name"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "invoiceNumber": json["invoiceNumber"]
  };
}

// src/generated/models/GetFailedInvoiceDeliveriesReportResponseReportReportItemsInner.ts
function GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerFromJSON(json) {
  return GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerFromJSONTyped(json, false);
}
function GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customer": GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerCustomerFromJSON(json["customer"]),
    "invoice": GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerInvoiceFromJSON(json["invoice"]),
    "reason": !exists(json, "reason") ? void 0 : json["reason"],
    "response": !exists(json, "response") ? void 0 : json["response"],
    "recipient": json["recipient"],
    "emailType": EmailTypeFromJSON(json["emailType"]),
    "source": json["source"],
    "event": EmailVerificationEventFromJSON(json["event"])
  };
}

// src/generated/models/GetFailedInvoiceDeliveriesReportResponseReport.ts
function GetFailedInvoiceDeliveriesReportResponseReportFromJSON(json) {
  return GetFailedInvoiceDeliveriesReportResponseReportFromJSONTyped(json, false);
}
function GetFailedInvoiceDeliveriesReportResponseReportFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "reportDate": new Date(json["reportDate"]),
    "reportItems": json["reportItems"].map(GetFailedInvoiceDeliveriesReportResponseReportReportItemsInnerFromJSON)
  };
}

// src/generated/models/GetFailedInvoiceDeliveriesReportResponse.ts
function GetFailedInvoiceDeliveriesReportResponseFromJSON(json) {
  return GetFailedInvoiceDeliveriesReportResponseFromJSONTyped(json, false);
}
function GetFailedInvoiceDeliveriesReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": GetFailedInvoiceDeliveriesReportResponseReportFromJSON(json["report"]),
    "creationDate": new Date(json["creationDate"])
  };
}

// src/generated/models/GetHomePageAccountSummaryResponseCustomers.ts
function GetHomePageAccountSummaryResponseCustomersFromJSON(json) {
  return GetHomePageAccountSummaryResponseCustomersFromJSONTyped(json, false);
}
function GetHomePageAccountSummaryResponseCustomersFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": json["total"],
    "lastMonth": json["lastMonth"],
    "currentMonth": json["currentMonth"]
  };
}

// src/generated/models/GetHomePageAccountSummaryResponseInvoices.ts
function GetHomePageAccountSummaryResponseInvoicesFromJSON(json) {
  return GetHomePageAccountSummaryResponseInvoicesFromJSONTyped(json, false);
}
function GetHomePageAccountSummaryResponseInvoicesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": json["total"]
  };
}

// src/generated/models/GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallMovements.ts
function GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallMovementsFromJSON(json) {
  return GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallMovementsFromJSONTyped(json, false);
}
function GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallMovementsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "newMrr": json["newMrr"],
    "expansionMrr": json["expansionMrr"],
    "reactivationMrr": json["reactivationMrr"],
    "contractionMrr": json["contractionMrr"],
    "churnMrr": json["churnMrr"]
  };
}

// src/generated/models/GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfall.ts
function GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallFromJSON(json) {
  return GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallFromJSONTyped(json, false);
}
function GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "month": json["month"],
    "beginningMrr": json["beginningMrr"],
    "endingMrr": json["endingMrr"],
    "movements": GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallMovementsFromJSON(json["movements"]),
    "nrr": json["nrr"],
    "grr": json["grr"]
  };
}

// src/generated/models/GetHomePageAccountSummaryResponseKpiMetrics.ts
function GetHomePageAccountSummaryResponseKpiMetricsFromJSON(json) {
  return GetHomePageAccountSummaryResponseKpiMetricsFromJSONTyped(json, false);
}
function GetHomePageAccountSummaryResponseKpiMetricsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "acv": json["acv"],
    "previousAcv": json["previousAcv"],
    "activeCustomers": json["activeCustomers"],
    "previousActiveCustomers": json["previousActiveCustomers"],
    "activeContracts": json["activeContracts"],
    "previousActiveContracts": json["previousActiveContracts"],
    "renewalContracts": json["renewalContracts"],
    "inReviewContracts": json["inReviewContracts"],
    "mrrWaterfall": GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallFromJSON(json["mrrWaterfall"])
  };
}

// src/generated/models/GetHomePageAccountSummaryResponseOverages.ts
function GetHomePageAccountSummaryResponseOveragesFromJSON(json) {
  return GetHomePageAccountSummaryResponseOveragesFromJSONTyped(json, false);
}
function GetHomePageAccountSummaryResponseOveragesFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoices": json["invoices"],
    "amount": json["amount"]
  };
}

// src/generated/models/GetHomePageAccountSummaryResponse.ts
function GetHomePageAccountSummaryResponseFromJSON(json) {
  return GetHomePageAccountSummaryResponseFromJSONTyped(json, false);
}
function GetHomePageAccountSummaryResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": GetHomePageAccountSummaryResponseCustomersFromJSON(json["customers"]),
    "contracts": GetHomePageAccountSummaryResponseCustomersFromJSON(json["contracts"]),
    "overages": GetHomePageAccountSummaryResponseOveragesFromJSON(json["overages"]),
    "invoices": GetHomePageAccountSummaryResponseInvoicesFromJSON(json["invoices"]),
    "kpiMetrics": GetHomePageAccountSummaryResponseKpiMetricsFromJSON(json["kpiMetrics"])
  };
}

// src/generated/models/HubspotIntegrationConfigurationAllOfAuthData.ts
function HubspotIntegrationConfigurationAllOfAuthDataFromJSON(json) {
  return HubspotIntegrationConfigurationAllOfAuthDataFromJSONTyped(json, false);
}
function HubspotIntegrationConfigurationAllOfAuthDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "state": !exists(json, "state") ? void 0 : json["state"],
    "redirectUrl": !exists(json, "redirectUrl") ? void 0 : json["redirectUrl"],
    "accessToken": !exists(json, "accessToken") ? void 0 : json["accessToken"],
    "refreshToken": !exists(json, "refreshToken") ? void 0 : json["refreshToken"],
    "expiresAt": !exists(json, "expiresAt") ? void 0 : new Date(json["expiresAt"]),
    "portalId": !exists(json, "portalId") ? void 0 : json["portalId"]
  };
}

// src/generated/models/HubspotIntegrationConfiguration.ts
function HubspotIntegrationConfigurationFromJSON(json) {
  return HubspotIntegrationConfigurationFromJSONTyped(json, false);
}
function HubspotIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "authData": HubspotIntegrationConfigurationAllOfAuthDataFromJSON(json["authData"]),
    "customFieldMapping": !exists(json, "customFieldMapping") ? void 0 : json["customFieldMapping"].map(EntityMappingFromJSON),
    "autoImportCustomers": !exists(json, "autoImportCustomers") ? void 0 : json["autoImportCustomers"],
    "autoImportContracts": !exists(json, "autoImportContracts") ? void 0 : json["autoImportContracts"]
  };
}

// src/generated/models/HubspotIntegrationSettings.ts
function HubspotIntegrationSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": HubspotIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/InvoiceNumberSyncStrategy.ts
function InvoiceNumberSyncStrategyFromJSON(json) {
  return InvoiceNumberSyncStrategyFromJSONTyped(json, false);
}
function InvoiceNumberSyncStrategyFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/InvoicePaymentStatusSyncStrategy.ts
function InvoicePaymentStatusSyncStrategyFromJSON(json) {
  return InvoicePaymentStatusSyncStrategyFromJSONTyped(json, false);
}
function InvoicePaymentStatusSyncStrategyFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/NetSuiteAuthData.ts
function NetSuiteAuthDataFromJSON(json) {
  return NetSuiteAuthDataFromJSONTyped(json, false);
}
function NetSuiteAuthDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountRealm": json["accountRealm"],
    "certificateId": json["certificateId"],
    "clientId": json["clientId"],
    "clientSecret": !exists(json, "clientSecret") ? void 0 : json["clientSecret"],
    "tokenId": !exists(json, "tokenId") ? void 0 : json["tokenId"],
    "tokenSecret": !exists(json, "tokenSecret") ? void 0 : json["tokenSecret"],
    "integrationProvider": json["integrationProvider"]
  };
}

// src/generated/models/NetSuiteIntegrationConfigurationAllOfAttachmentsConfig.ts
function NetSuiteIntegrationConfigurationAllOfAttachmentsConfigFromJSON(json) {
  return NetSuiteIntegrationConfigurationAllOfAttachmentsConfigFromJSONTyped(json, false);
}
function NetSuiteIntegrationConfigurationAllOfAttachmentsConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "folderId": json["folderId"],
    "exportUsageEventsReport": json["exportUsageEventsReport"]
  };
}

// src/generated/models/NetSuiteIntegrationConfigurationAllOfDefaultProduct.ts
function NetSuiteIntegrationConfigurationAllOfDefaultProductFromJSON(json) {
  return NetSuiteIntegrationConfigurationAllOfDefaultProductFromJSONTyped(json, false);
}
function NetSuiteIntegrationConfigurationAllOfDefaultProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "erpId": json["erpId"],
    "erpName": json["erpName"],
    "displayId": !exists(json, "displayId") ? void 0 : json["displayId"],
    "code": !exists(json, "code") ? void 0 : json["code"]
  };
}

// src/generated/models/TaxExportStrategy.ts
function TaxExportStrategyFromJSON(json) {
  return TaxExportStrategyFromJSONTyped(json, false);
}
function TaxExportStrategyFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/NetSuiteIntegrationConfiguration.ts
function NetSuiteIntegrationConfigurationFromJSON(json) {
  return NetSuiteIntegrationConfigurationFromJSONTyped(json, false);
}
function NetSuiteIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "defaultReceivableAccount": !exists(json, "defaultReceivableAccount") ? void 0 : json["defaultReceivableAccount"],
    "defaultSubsidiaryId": !exists(json, "defaultSubsidiaryId") ? void 0 : json["defaultSubsidiaryId"],
    "defaultProduct": !exists(json, "defaultProduct") ? void 0 : NetSuiteIntegrationConfigurationAllOfDefaultProductFromJSON(json["defaultProduct"]),
    "customersAdditionalFilters": !exists(json, "customersAdditionalFilters") ? void 0 : json["customersAdditionalFilters"].map(AdvancedFilterFromJSON),
    "authData": NetSuiteAuthDataFromJSON(json["authData"]),
    "autoExportInvoices": json["autoExportInvoices"],
    "customFieldMapping": !exists(json, "customFieldMapping") ? void 0 : json["customFieldMapping"].map(EntityMappingFromJSON),
    "autoExportCreditMemos": json["autoExportCreditMemos"],
    "autoExportCustomers": json["autoExportCustomers"],
    "summarizeLineItemsByProductId": json["summarizeLineItemsByProductId"],
    "overrideLineItemQuantity": json["overrideLineItemQuantity"],
    "taxExportStrategy": TaxExportStrategyFromJSON(json["taxExportStrategy"]),
    "accountTaxItem": !exists(json, "accountTaxItem") ? void 0 : NetSuiteIntegrationConfigurationAllOfDefaultProductFromJSON(json["accountTaxItem"]),
    "taxItemBySubsidiaryId": !exists(json, "taxItemBySubsidiaryId") ? void 0 : mapValues(json["taxItemBySubsidiaryId"], NetSuiteIntegrationConfigurationAllOfDefaultProductFromJSON),
    "invoiceNumberSyncStrategy": InvoiceNumberSyncStrategyFromJSON(json["invoiceNumberSyncStrategy"]),
    "invoicePaymentStatusSyncStrategy": InvoicePaymentStatusSyncStrategyFromJSON(json["invoicePaymentStatusSyncStrategy"]),
    "defaultStripeDepositToAccountId": !exists(json, "defaultStripeDepositToAccountId") ? void 0 : json["defaultStripeDepositToAccountId"],
    "attachmentsConfig": !exists(json, "attachmentsConfig") ? void 0 : NetSuiteIntegrationConfigurationAllOfAttachmentsConfigFromJSON(json["attachmentsConfig"]),
    "linkInvoiceToSalesOrder": json["linkInvoiceToSalesOrder"]
  };
}

// src/generated/models/NetSuiteIntegrationSettings.ts
function NetSuiteIntegrationSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": NetSuiteIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/SalesforceAuthData.ts
function SalesforceAuthDataFromJSON(json) {
  return SalesforceAuthDataFromJSONTyped(json, false);
}
function SalesforceAuthDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountUrl": json["accountUrl"],
    "clientId": json["clientId"],
    "clientSecret": json["clientSecret"]
  };
}

// src/generated/models/SalesforceIntegrationConfiguration.ts
function SalesforceIntegrationConfigurationFromJSON(json) {
  return SalesforceIntegrationConfigurationFromJSONTyped(json, false);
}
function SalesforceIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "authData": SalesforceAuthDataFromJSON(json["authData"]),
    "customFieldMapping": !exists(json, "customFieldMapping") ? void 0 : json["customFieldMapping"].map(EntityMappingFromJSON)
  };
}

// src/generated/models/SalesforceIntegrationSettings.ts
function SalesforceIntegrationSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": SalesforceIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/SlackIntegrationConfiguration.ts
function SlackIntegrationConfigurationFromJSON(json) {
  return SlackIntegrationConfigurationFromJSONTyped(json, false);
}
function SlackIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "authData": HubspotIntegrationConfigurationAllOfAuthDataFromJSON(json["authData"]),
    "channelId": !exists(json, "channelId") ? void 0 : json["channelId"]
  };
}

// src/generated/models/SlackIntegrationSettings.ts
function SlackIntegrationSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": SlackIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/StripeAuthData.ts
function StripeAuthDataFromJSON(json) {
  return StripeAuthDataFromJSONTyped(json, false);
}
function StripeAuthDataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "bearerToken": json["bearerToken"],
    "apiId": json["apiId"]
  };
}

// src/generated/models/StripeIntegrationConfiguration.ts
function StripeIntegrationConfigurationFromJSON(json) {
  return StripeIntegrationConfigurationFromJSONTyped(json, false);
}
function StripeIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "autoImportCustomers": json["autoImportCustomers"],
    "autoExportCreatedCustomers": json["autoExportCreatedCustomers"],
    "autoExportInvoices": json["autoExportInvoices"],
    "syncPaymentRefIdToErp": json["syncPaymentRefIdToErp"],
    "authData": StripeAuthDataFromJSON(json["authData"])
  };
}

// src/generated/models/StripeIntegrationSettings.ts
function StripeIntegrationSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": StripeIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/IntegrationSettings.ts
function IntegrationSettingsFromJSON(json) {
  return IntegrationSettingsFromJSONTyped(json, false);
}
function IntegrationSettingsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["integrationProvider"]) {
    case "Hubspot":
      return { ...HubspotIntegrationSettingsFromJSONTyped(json, true), integrationProvider: "Hubspot" };
    case "NetSuite":
      return { ...NetSuiteIntegrationSettingsFromJSONTyped(json, true), integrationProvider: "NetSuite" };
    case "Salesforce":
      return { ...SalesforceIntegrationSettingsFromJSONTyped(json, true), integrationProvider: "Salesforce" };
    case "Slack":
      return { ...SlackIntegrationSettingsFromJSONTyped(json, true), integrationProvider: "Slack" };
    case "Stripe":
      return { ...StripeIntegrationSettingsFromJSONTyped(json, true), integrationProvider: "Stripe" };
    default:
      throw new Error(`No variant of IntegrationSettings exists with 'integrationProvider=${json["integrationProvider"]}'`);
  }
}

// src/generated/models/V2IntegrationSettingsSchema.ts
function V2IntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": json["version"],
    "settings": IntegrationSettingsFromJSON(json["settings"])
  };
}

// src/generated/models/HubspotIntegrationSettingsSchemaIntegrationConfigurationAuthConfig.ts
function HubspotIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json) {
  return HubspotIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, false);
}
function HubspotIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "state": !exists(json, "state") ? void 0 : json["state"],
    "redirectUrl": !exists(json, "redirectUrl") ? void 0 : json["redirectUrl"],
    "accessToken": !exists(json, "accessToken") ? void 0 : json["accessToken"],
    "refreshToken": !exists(json, "refreshToken") ? void 0 : json["refreshToken"],
    "expiresAt": !exists(json, "expiresAt") ? void 0 : json["expiresAt"],
    "portalId": !exists(json, "portalId") ? void 0 : json["portalId"]
  };
}

// src/generated/models/HubspotIntegrationSettingsSchemaIntegrationConfigurationGeneralConfig.ts
function HubspotIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json) {
  return HubspotIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, false);
}
function HubspotIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "autoImportCustomers": !exists(json, "autoImportCustomers") ? void 0 : json["autoImportCustomers"],
    "autoImportContracts": !exists(json, "autoImportContracts") ? void 0 : json["autoImportContracts"],
    "pricingStrategy": !exists(json, "pricingStrategy") ? void 0 : json["pricingStrategy"]
  };
}

// src/generated/models/HubspotIntegrationSettingsSchemaIntegrationConfiguration.ts
function HubspotIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json) {
  return HubspotIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, false);
}
function HubspotIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "authConfig": HubspotIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json["authConfig"]),
    "generalConfig": HubspotIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json["generalConfig"]),
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/HubspotIntegrationSettingsSchema.ts
function HubspotIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": HubspotIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/MorningIntegrationSettingsSchemaIntegrationConfigurationAuthConfig.ts
function MorningIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json) {
  return MorningIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, false);
}
function MorningIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "apiKey": json["apiKey"],
    "secretId": json["secretId"]
  };
}

// src/generated/models/MorningIntegrationSettingsSchemaIntegrationConfigurationGeneralConfig.ts
function MorningIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json) {
  return MorningIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, false);
}
function MorningIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "autoImportCustomers": !exists(json, "autoImportCustomers") ? void 0 : json["autoImportCustomers"],
    "autoExportInvoices": !exists(json, "autoExportInvoices") ? void 0 : json["autoExportInvoices"],
    "invoiceNumberSyncStrategy": InvoiceNumberSyncStrategyFromJSON(json["invoiceNumberSyncStrategy"])
  };
}

// src/generated/models/MorningIntegrationSettingsSchemaIntegrationConfiguration.ts
function MorningIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json) {
  return MorningIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, false);
}
function MorningIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "generalConfig": MorningIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json["generalConfig"]),
    "authConfig": MorningIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json["authConfig"]),
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/MorningIntegrationSettingsSchema.ts
function MorningIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": MorningIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/PaddleIntegrationSettingsSchemaIntegrationConfigurationAuthConfig.ts
function PaddleIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json) {
  return PaddleIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, false);
}
function PaddleIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "apiKey": json["apiKey"],
    "environment": json["environment"]
  };
}

// src/generated/models/PaddleIntegrationSettingsSchemaIntegrationConfigurationGeneralConfig.ts
function PaddleIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json) {
  return PaddleIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, false);
}
function PaddleIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "autoExportInvoices": !exists(json, "autoExportInvoices") ? void 0 : json["autoExportInvoices"]
  };
}

// src/generated/models/PaddleIntegrationSettingsSchemaIntegrationConfiguration.ts
function PaddleIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json) {
  return PaddleIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, false);
}
function PaddleIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "generalConfig": PaddleIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json["generalConfig"]),
    "authConfig": PaddleIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json["authConfig"]),
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/PaddleIntegrationSettingsSchema.ts
function PaddleIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": PaddleIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/QuickBooksIntegrationSettingsSchemaIntegrationConfigurationAuthConfig.ts
function QuickBooksIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json) {
  return QuickBooksIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, false);
}
function QuickBooksIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "realmId": json["realmId"],
    "expiresAt": json["expiresAt"],
    "accessToken": json["accessToken"],
    "refreshToken": json["refreshToken"],
    "refreshTokenExpiresAt": json["refreshTokenExpiresAt"]
  };
}

// src/generated/models/QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigAccountTaxItem.ts
function QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigAccountTaxItemFromJSON(json) {
  return QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigAccountTaxItemFromJSONTyped(json, false);
}
function QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigAccountTaxItemFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "erpId": json["erpId"],
    "erpName": json["erpName"],
    "code": !exists(json, "code") ? void 0 : json["code"]
  };
}

// src/generated/models/QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfig.ts
function QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json) {
  return QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, false);
}
function QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "autoImportCustomers": !exists(json, "autoImportCustomers") ? void 0 : json["autoImportCustomers"],
    "autoExportInvoices": !exists(json, "autoExportInvoices") ? void 0 : json["autoExportInvoices"],
    "autoExportCreditMemos": !exists(json, "autoExportCreditMemos") ? void 0 : json["autoExportCreditMemos"],
    "invoiceNumberSyncStrategy": InvoiceNumberSyncStrategyFromJSON(json["invoiceNumberSyncStrategy"]),
    "invoicePaymentStatusSyncStrategy": InvoicePaymentStatusSyncStrategyFromJSON(json["invoicePaymentStatusSyncStrategy"]),
    "exportBankDetails": !exists(json, "exportBankDetails") ? void 0 : json["exportBankDetails"],
    "defaultStripeDepositToAccountId": !exists(json, "defaultStripeDepositToAccountId") ? void 0 : json["defaultStripeDepositToAccountId"],
    "defaultDepositToAccountId": !exists(json, "defaultDepositToAccountId") ? void 0 : json["defaultDepositToAccountId"],
    "taxExportStrategy": TaxExportStrategyFromJSON(json["taxExportStrategy"]),
    "accountTaxItem": !exists(json, "accountTaxItem") ? void 0 : QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigAccountTaxItemFromJSON(json["accountTaxItem"])
  };
}

// src/generated/models/QuickBooksIntegrationSettingsSchemaIntegrationConfiguration.ts
function QuickBooksIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json) {
  return QuickBooksIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, false);
}
function QuickBooksIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "generalConfig": QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json["generalConfig"]),
    "authConfig": QuickBooksIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json["authConfig"]),
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/QuickBooksIntegrationSettingsSchema.ts
function QuickBooksIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": QuickBooksIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/SnowflakeIntegrationSettingsSchemaIntegrationConfigurationAuthConfig.ts
function SnowflakeIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json) {
  return SnowflakeIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, false);
}
function SnowflakeIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "account": json["account"],
    "username": json["username"],
    "password": json["password"],
    "warehouse": json["warehouse"],
    "database": json["database"],
    "schema": json["schema"],
    "role": !exists(json, "role") ? void 0 : json["role"],
    "region": !exists(json, "region") ? void 0 : json["region"]
  };
}

// src/generated/models/SnowflakeIntegrationSettingsSchemaIntegrationConfigurationGeneralConfig.ts
function SnowflakeIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json) {
  return SnowflakeIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, false);
}
function SnowflakeIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "tablePath": json["tablePath"],
    "timestampField": !exists(json, "timestampField") ? void 0 : json["timestampField"],
    "autoImportEvents": !exists(json, "autoImportEvents") ? void 0 : json["autoImportEvents"]
  };
}

// src/generated/models/SnowflakeIntegrationSettingsSchemaIntegrationConfiguration.ts
function SnowflakeIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json) {
  return SnowflakeIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, false);
}
function SnowflakeIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "generalConfig": SnowflakeIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json["generalConfig"]),
    "authConfig": SnowflakeIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json["authConfig"]),
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/SnowflakeIntegrationSettingsSchema.ts
function SnowflakeIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": SnowflakeIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/XeroIntegrationSettingsSchemaIntegrationConfigurationAuthConfig.ts
function XeroIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json) {
  return XeroIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, false);
}
function XeroIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "tenantId": json["tenantId"],
    "accessToken": json["accessToken"],
    "refreshToken": json["refreshToken"],
    "expiresAt": json["expiresAt"],
    "refreshTokenExpiresAt": json["refreshTokenExpiresAt"],
    "clientId": !exists(json, "clientId") ? void 0 : json["clientId"],
    "clientSecret": !exists(json, "clientSecret") ? void 0 : json["clientSecret"],
    "environment": !exists(json, "environment") ? void 0 : json["environment"]
  };
}

// src/generated/models/XeroIntegrationSettingsSchemaIntegrationConfigurationGeneralConfig.ts
function XeroIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json) {
  return XeroIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, false);
}
function XeroIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "autoImportCustomers": !exists(json, "autoImportCustomers") ? void 0 : json["autoImportCustomers"],
    "autoExportInvoices": !exists(json, "autoExportInvoices") ? void 0 : json["autoExportInvoices"],
    "autoExportCreditMemos": !exists(json, "autoExportCreditMemos") ? void 0 : json["autoExportCreditMemos"],
    "autoExportCustomers": !exists(json, "autoExportCustomers") ? void 0 : json["autoExportCustomers"],
    "invoiceNumberSyncStrategy": InvoiceNumberSyncStrategyFromJSON(json["invoiceNumberSyncStrategy"]),
    "invoicePaymentStatusSyncStrategy": InvoicePaymentStatusSyncStrategyFromJSON(json["invoicePaymentStatusSyncStrategy"]),
    "defaultStripeDepositToAccountId": !exists(json, "defaultStripeDepositToAccountId") ? void 0 : json["defaultStripeDepositToAccountId"],
    "defaultDepositToAccountId": !exists(json, "defaultDepositToAccountId") ? void 0 : json["defaultDepositToAccountId"],
    "taxExportStrategy": TaxExportStrategyFromJSON(json["taxExportStrategy"]),
    "accountTaxItem": !exists(json, "accountTaxItem") ? void 0 : QuickBooksIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigAccountTaxItemFromJSON(json["accountTaxItem"])
  };
}

// src/generated/models/XeroIntegrationSettingsSchemaIntegrationConfiguration.ts
function XeroIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json) {
  return XeroIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, false);
}
function XeroIntegrationSettingsSchemaIntegrationConfigurationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "generalConfig": XeroIntegrationSettingsSchemaIntegrationConfigurationGeneralConfigFromJSON(json["generalConfig"]),
    "authConfig": XeroIntegrationSettingsSchemaIntegrationConfigurationAuthConfigFromJSON(json["authConfig"]),
    "id": json["id"],
    "createdAt": !exists(json, "createdAt") ? void 0 : json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"],
    "deletedAt": !exists(json, "deletedAt") ? void 0 : json["deletedAt"],
    "accountId": json["accountId"]
  };
}

// src/generated/models/XeroIntegrationSettingsSchema.ts
function XeroIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationProvider": json["integrationProvider"],
    "integrationConfiguration": XeroIntegrationSettingsSchemaIntegrationConfigurationFromJSON(json["integrationConfiguration"])
  };
}

// src/generated/models/IntegrationsSettingsSchema.ts
function IntegrationsSettingsSchemaFromJSON(json) {
  return IntegrationsSettingsSchemaFromJSONTyped(json, false);
}
function IntegrationsSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["integrationProvider"]) {
    case "Anrok":
      return { ...AnrokIntegrationSettingsSchemaFromJSONTyped(json, true), integrationProvider: "Anrok" };
    case "Connact":
      return { ...ConnactIntegrationSettingsSchemaFromJSONTyped(json, true), integrationProvider: "Connact" };
    case "Hubspot":
      return { ...HubspotIntegrationSettingsSchemaFromJSONTyped(json, true), integrationProvider: "Hubspot" };
    case "Morning":
      return { ...MorningIntegrationSettingsSchemaFromJSONTyped(json, true), integrationProvider: "Morning" };
    case "Paddle":
      return { ...PaddleIntegrationSettingsSchemaFromJSONTyped(json, true), integrationProvider: "Paddle" };
    case "QuickBooks":
      return { ...QuickBooksIntegrationSettingsSchemaFromJSONTyped(json, true), integrationProvider: "QuickBooks" };
    case "Snowflake":
      return { ...SnowflakeIntegrationSettingsSchemaFromJSONTyped(json, true), integrationProvider: "Snowflake" };
    case "Xero":
      return { ...XeroIntegrationSettingsSchemaFromJSONTyped(json, true), integrationProvider: "Xero" };
    default:
      throw new Error(`No variant of IntegrationsSettingsSchema exists with 'integrationProvider=${json["integrationProvider"]}'`);
  }
}

// src/generated/models/V3IntegrationSettingsSchema.ts
function V3IntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "version": json["version"],
    "settings": IntegrationsSettingsSchemaFromJSON(json["settings"])
  };
}

// src/generated/models/VersionedIntegrationSettingsSchema.ts
function VersionedIntegrationSettingsSchemaFromJSON(json) {
  return VersionedIntegrationSettingsSchemaFromJSONTyped(json, false);
}
function VersionedIntegrationSettingsSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["version"]) {
    case "2":
      return { ...V2IntegrationSettingsSchemaFromJSONTyped(json, true), version: "2" };
    case "3":
      return { ...V3IntegrationSettingsSchemaFromJSONTyped(json, true), version: "3" };
    default:
      throw new Error(`No variant of VersionedIntegrationSettingsSchema exists with 'version=${json["version"]}'`);
  }
}

// src/generated/models/GetIntegrationsSettingsResponse.ts
function GetIntegrationsSettingsResponseFromJSON(json) {
  return GetIntegrationsSettingsResponseFromJSONTyped(json, false);
}
function GetIntegrationsSettingsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationId": json["integrationId"],
    "integrationSettings": VersionedIntegrationSettingsSchemaFromJSON(json["integrationSettings"])
  };
}

// src/generated/models/Role.ts
function RoleFromJSON(json) {
  return RoleFromJSONTyped(json, false);
}
function RoleFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function RoleToJSON(value) {
  return value;
}

// src/generated/models/UserInvitationStatus.ts
function UserInvitationStatusFromJSON(json) {
  return UserInvitationStatusFromJSONTyped(json, false);
}
function UserInvitationStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/UserInvitation.ts
function UserInvitationFromJSON(json) {
  return UserInvitationFromJSONTyped(json, false);
}
function UserInvitationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "email": json["email"],
    "role": RoleFromJSON(json["role"]),
    "invitedBy": json["invitedBy"],
    "status": UserInvitationStatusFromJSON(json["status"]),
    "firstName": !exists(json, "firstName") ? void 0 : json["firstName"],
    "lastName": !exists(json, "lastName") ? void 0 : json["lastName"]
  };
}

// src/generated/models/GetInvitationsResponse.ts
function GetInvitationsResponseFromJSON(json) {
  return GetInvitationsResponseFromJSONTyped(json, false);
}
function GetInvitationsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invitations": json["invitations"].map(UserInvitationFromJSON)
  };
}

// src/generated/models/GetInvoicePdfResponse.ts
function GetInvoicePdfResponseFromJSON(json) {
  return GetInvoicePdfResponseFromJSONTyped(json, false);
}
function GetInvoicePdfResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "encodedPdf": json["encodedPdf"]
  };
}

// src/generated/models/GetInvoiceProductsIntegrationEntitiesResponseProductsInner.ts
function GetInvoiceProductsIntegrationEntitiesResponseProductsInnerFromJSON(json) {
  return GetInvoiceProductsIntegrationEntitiesResponseProductsInnerFromJSONTyped(json, false);
}
function GetInvoiceProductsIntegrationEntitiesResponseProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "lineItemId": json["lineItemId"],
    "name": json["name"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(IntegrationEntityFromJSON)
  };
}

// src/generated/models/GetInvoiceProductsIntegrationEntitiesResponse.ts
function GetInvoiceProductsIntegrationEntitiesResponseFromJSON(json) {
  return GetInvoiceProductsIntegrationEntitiesResponseFromJSONTyped(json, false);
}
function GetInvoiceProductsIntegrationEntitiesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "products": json["products"].map(GetInvoiceProductsIntegrationEntitiesResponseProductsInnerFromJSON)
  };
}

// src/generated/models/GetInvoiceProductsIntegrationsResponseProductsInner.ts
function GetInvoiceProductsIntegrationsResponseProductsInnerFromJSON(json) {
  return GetInvoiceProductsIntegrationsResponseProductsInnerFromJSONTyped(json, false);
}
function GetInvoiceProductsIntegrationsResponseProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "externalName": !exists(json, "externalName") ? void 0 : json["externalName"]
  };
}

// src/generated/models/GetInvoiceProductsIntegrationsResponse.ts
function GetInvoiceProductsIntegrationsResponseFromJSON(json) {
  return GetInvoiceProductsIntegrationsResponseFromJSONTyped(json, false);
}
function GetInvoiceProductsIntegrationsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "products": json["products"].map(GetInvoiceProductsIntegrationsResponseProductsInnerFromJSON)
  };
}

// src/generated/models/InvoiceContract.ts
function InvoiceContractFromJSON(json) {
  return InvoiceContractFromJSONTyped(json, false);
}
function InvoiceContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startDate": new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"]),
    "status": ContractStatusFromJSON(json["status"]),
    "contractType": ContractTypeFromJSON(json["contractType"]),
    "parentAgreementSettings": !exists(json, "parentAgreementSettings") ? void 0 : ParentAgreementSettingsFromJSON(json["parentAgreementSettings"]),
    "trialEndDate": !exists(json, "trialEndDate") ? void 0 : new Date(json["trialEndDate"]),
    "cancelledAt": !exists(json, "cancelledAt") ? void 0 : new Date(json["cancelledAt"]),
    "terminatedAt": !exists(json, "terminatedAt") ? void 0 : new Date(json["terminatedAt"]),
    "revisedAt": !exists(json, "revisedAt") ? void 0 : new Date(json["revisedAt"]),
    "initialStartDate": !exists(json, "initialStartDate") ? void 0 : new Date(json["initialStartDate"]),
    "signatureDate": !exists(json, "signatureDate") ? void 0 : new Date(json["signatureDate"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ContractIntegrationEntitiesInnerFromJSON),
    "currencyOverride": !exists(json, "currencyOverride") ? void 0 : CurrencyFromJSON(json["currencyOverride"]),
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "credits": !exists(json, "credits") ? void 0 : json["credits"].map(CreditPurchaseConfigFromJSON),
    "isTrial": !exists(json, "isTrial") ? void 0 : json["isTrial"],
    "accountId": json["accountId"],
    "customer": CustomerFromJSON(json["customer"]),
    "plan": PlanFromJSON(json["plan"]),
    "invoices": !exists(json, "invoices") ? void 0 : json["invoices"].map(ContractInvoicesInnerFromJSON),
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/InvoiceCustomer.ts
function InvoiceCustomerFromJSON(json) {
  return InvoiceCustomerFromJSONTyped(json, false);
}
function InvoiceCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "aliases": !exists(json, "aliases") ? void 0 : json["aliases"],
    "taxIds": !exists(json, "taxIds") ? void 0 : json["taxIds"],
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "crmMetadata": !exists(json, "crmMetadata") ? void 0 : CrmMetadataFromJSON(json["crmMetadata"]),
    "erpMetadata": !exists(json, "erpMetadata") ? void 0 : ErpMetadataFromJSON(json["erpMetadata"]),
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"] === null ? null : json["contacts"].map(ContactFromJSON),
    "settings": !exists(json, "settings") ? void 0 : CustomerSettingsFromJSON(json["settings"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "status": !exists(json, "status") ? void 0 : CustomerStatusFromJSON(json["status"]),
    "source": !exists(json, "source") ? void 0 : CustomerSourceFromJSON(json["source"]),
    "subsidiaryId": !exists(json, "subsidiaryId") ? void 0 : json["subsidiaryId"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(CustomerIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : json["externalIntegration"] === null ? null : json["externalIntegration"].map(CustomerExternalIntegrationInnerFromJSON),
    "accountOwnerId": !exists(json, "accountOwnerId") ? void 0 : json["accountOwnerId"],
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"]
  };
}

// src/generated/models/InvoicePaymentProviderInformation.ts
function InvoicePaymentProviderInformationFromJSON(json) {
  return InvoicePaymentProviderInformationFromJSONTyped(json, false);
}
function InvoicePaymentProviderInformationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "paymentProviderType": json["paymentProviderType"],
    "externalInvoicePaymentLink": !exists(json, "externalInvoicePaymentLink") ? void 0 : json["externalInvoicePaymentLink"],
    "externalInvoiceId": json["externalInvoiceId"],
    "externalInvoiceStatus": json["externalInvoiceStatus"]
  };
}

// src/generated/models/InvoiceSnapshotCustomer.ts
function InvoiceSnapshotCustomerFromJSON(json) {
  return InvoiceSnapshotCustomerFromJSONTyped(json, false);
}
function InvoiceSnapshotCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"])
  };
}

// src/generated/models/InvoiceSnapshot.ts
function InvoiceSnapshotFromJSON(json) {
  return InvoiceSnapshotFromJSONTyped(json, false);
}
function InvoiceSnapshotFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": !exists(json, "customer") ? void 0 : InvoiceSnapshotCustomerFromJSON(json["customer"])
  };
}

// src/generated/models/PaymentInfoDepositTo.ts
function PaymentInfoDepositToFromJSON(json) {
  return PaymentInfoDepositToFromJSONTyped(json, false);
}
function PaymentInfoDepositToFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": !exists(json, "id") ? void 0 : json["id"],
    "name": json["name"]
  };
}
function PaymentInfoDepositToToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name
  };
}

// src/generated/models/PaymentInfo.ts
function PaymentInfoFromJSON(json) {
  return PaymentInfoFromJSONTyped(json, false);
}
function PaymentInfoFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "transactionId": !exists(json, "transactionId") ? void 0 : json["transactionId"],
    "date": !exists(json, "date") ? void 0 : new Date(json["date"]),
    "paymentMethod": !exists(json, "paymentMethod") ? void 0 : json["paymentMethod"],
    "paymentMethodId": !exists(json, "paymentMethodId") ? void 0 : json["paymentMethodId"],
    "amount": !exists(json, "amount") ? void 0 : json["amount"],
    "currency": !exists(json, "currency") ? void 0 : CurrencyFromJSON(json["currency"]),
    "status": !exists(json, "status") ? void 0 : json["status"],
    "note": !exists(json, "note") ? void 0 : json["note"],
    "customerId": !exists(json, "customerId") ? void 0 : json["customerId"],
    "depositTo": !exists(json, "depositTo") ? void 0 : PaymentInfoDepositToFromJSON(json["depositTo"])
  };
}

// src/generated/models/Invoice.ts
function InvoiceFromJSON(json) {
  return InvoiceFromJSONTyped(json, false);
}
function InvoiceFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "billingCycle": FullDayPeriodFromJSON(json["billingCycle"]),
    "customerId": json["customerId"],
    "taxRate": json["taxRate"],
    "issuedAt": json["issuedAt"] === null ? null : new Date(json["issuedAt"]),
    "dueDate": json["dueDate"] === null ? null : new Date(json["dueDate"]),
    "lineItems": json["lineItems"].map(LineItemFromJSON),
    "contractId": !exists(json, "contractId") ? void 0 : json["contractId"],
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "approvedAt": !exists(json, "approvedAt") ? void 0 : new Date(json["approvedAt"]),
    "paymentDueDays": json["paymentDueDays"],
    "trial": !exists(json, "trial") ? void 0 : PlanTrialFromJSON(json["trial"]),
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "syncStatusUpdatedAt": !exists(json, "syncStatusUpdatedAt") ? void 0 : json["syncStatusUpdatedAt"] === null ? null : new Date(json["syncStatusUpdatedAt"]),
    "stripeSyncStatus": SyncStatusFromJSON(json["stripeSyncStatus"]),
    "stripeSyncStatusUpdatedAt": !exists(json, "stripeSyncStatusUpdatedAt") ? void 0 : json["stripeSyncStatusUpdatedAt"] === null ? null : new Date(json["stripeSyncStatusUpdatedAt"]),
    "stripeIntegrationExternalId": !exists(json, "stripeIntegrationExternalId") ? void 0 : json["stripeIntegrationExternalId"],
    "paymentInfo": !exists(json, "paymentInfo") ? void 0 : PaymentInfoFromJSON(json["paymentInfo"]),
    "lineItemsGroupingKey": !exists(json, "lineItemsGroupingKey") ? void 0 : json["lineItemsGroupingKey"],
    "invoicingDate": !exists(json, "invoicingDate") ? void 0 : new Date(json["invoicingDate"]),
    "invoiceType": InvoiceTypeFromJSON(json["invoiceType"]),
    "parentLineItemId": !exists(json, "parentLineItemId") ? void 0 : json["parentLineItemId"],
    "currency": CurrencyFromJSON(json["currency"]),
    "modifiedCurrency": !exists(json, "modifiedCurrency") ? void 0 : CurrencyFromJSON(json["modifiedCurrency"]),
    "baseCurrency": !exists(json, "baseCurrency") ? void 0 : CurrencyFromJSON(json["baseCurrency"]),
    "exchangeRateSnapshot": !exists(json, "exchangeRateSnapshot") ? void 0 : json["exchangeRateSnapshot"],
    "modifiedExchangeRate": !exists(json, "modifiedExchangeRate") ? void 0 : json["modifiedExchangeRate"],
    "invoiceNumber": json["invoiceNumber"],
    "ref": json["ref"],
    "invoicingSettingsOverride": !exists(json, "invoicingSettingsOverride") ? void 0 : NewAccountSettingsInvoicingSettingsFromJSON(json["invoicingSettingsOverride"]),
    "exchangeRateSnapshotTimestamp": !exists(json, "exchangeRateSnapshotTimestamp") ? void 0 : json["exchangeRateSnapshotTimestamp"] === null ? null : new Date(json["exchangeRateSnapshotTimestamp"]),
    "purchaseOrder": !exists(json, "purchaseOrder") ? void 0 : json["purchaseOrder"],
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "customer": InvoiceCustomerFromJSON(json["customer"]),
    "contract": InvoiceContractFromJSON(json["contract"]),
    "parentLineItem": !exists(json, "parentLineItem") ? void 0 : LineItemFromJSON(json["parentLineItem"]),
    "paymentProviderInformation": !exists(json, "paymentProviderInformation") ? void 0 : InvoicePaymentProviderInformationFromJSON(json["paymentProviderInformation"]),
    "erpId": !exists(json, "erpId") ? void 0 : json["erpId"],
    "refundsInvoiceId": !exists(json, "refundsInvoiceId") ? void 0 : json["refundsInvoiceId"],
    "snapshot": !exists(json, "snapshot") ? void 0 : InvoiceSnapshotFromJSON(json["snapshot"]),
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"]
  };
}

// src/generated/models/GetInvoiceResponse.ts
function GetInvoiceResponseFromJSON(json) {
  return GetInvoiceResponseFromJSONTyped(json, false);
}
function GetInvoiceResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoice": InvoiceFromJSON(json["invoice"])
  };
}

// src/generated/models/OverdueBucketsInner.ts
function OverdueBucketsInnerFromJSON(json) {
  return OverdueBucketsInnerFromJSONTyped(json, false);
}
function OverdueBucketsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "range": json["range"],
    "sum": json["sum"],
    "count": json["count"]
  };
}

// src/generated/models/GetInvoicesArHealthResponse.ts
function GetInvoicesArHealthResponseFromJSON(json) {
  return GetInvoicesArHealthResponseFromJSONTyped(json, false);
}
function GetInvoicesArHealthResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "overdueInvoicesSumThan90Days": json["overdueInvoicesSumThan90Days"],
    "overdueInvoicesPercentage": json["overdueInvoicesPercentage"],
    "overdueBuckets": !exists(json, "overdueBuckets") ? void 0 : json["overdueBuckets"] === null ? null : json["overdueBuckets"].map(OverdueBucketsInnerFromJSON),
    "avgDso": json["avgDso"]
  };
}

// src/generated/models/GetInvoicesBreakdownStatsResponseTotal.ts
function GetInvoicesBreakdownStatsResponseTotalFromJSON(json) {
  return GetInvoicesBreakdownStatsResponseTotalFromJSONTyped(json, false);
}
function GetInvoicesBreakdownStatsResponseTotalFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "sum": json["sum"],
    "count": json["count"]
  };
}

// src/generated/models/GetInvoicesBreakdownStatsResponse.ts
function GetInvoicesBreakdownStatsResponseFromJSON(json) {
  return GetInvoicesBreakdownStatsResponseFromJSONTyped(json, false);
}
function GetInvoicesBreakdownStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": GetInvoicesBreakdownStatsResponseTotalFromJSON(json["total"]),
    "inReview": GetInvoicesBreakdownStatsResponseTotalFromJSON(json["inReview"]),
    "inOverage": GetInvoicesBreakdownStatsResponseTotalFromJSON(json["inOverage"])
  };
}

// src/generated/models/InvoicesHighlightsSummaryInReview.ts
function InvoicesHighlightsSummaryInReviewFromJSON(json) {
  return InvoicesHighlightsSummaryInReviewFromJSONTyped(json, false);
}
function InvoicesHighlightsSummaryInReviewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "count": json["count"],
    "amount": json["amount"]
  };
}

// src/generated/models/InvoicesHighlightsSummary.ts
function InvoicesHighlightsSummaryFromJSON(json) {
  return InvoicesHighlightsSummaryFromJSONTyped(json, false);
}
function InvoicesHighlightsSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "totalCount": json["totalCount"],
    "totalAmount": json["totalAmount"],
    "inReview": InvoicesHighlightsSummaryInReviewFromJSON(json["inReview"]),
    "overdue": InvoicesHighlightsSummaryInReviewFromJSON(json["overdue"]),
    "pendingPayment": InvoicesHighlightsSummaryInReviewFromJSON(json["pendingPayment"])
  };
}

// src/generated/models/GetInvoicesHighlightsStatisticsResponse.ts
function GetInvoicesHighlightsStatisticsResponseFromJSON(json) {
  return GetInvoicesHighlightsStatisticsResponseFromJSONTyped(json, false);
}
function GetInvoicesHighlightsStatisticsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "summary": InvoicesHighlightsSummaryFromJSON(json["summary"])
  };
}

// src/generated/models/InvoiceOverviewCustomer.ts
function InvoiceOverviewCustomerFromJSON(json) {
  return InvoiceOverviewCustomerFromJSONTyped(json, false);
}
function InvoiceOverviewCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "aliases": !exists(json, "aliases") ? void 0 : json["aliases"],
    "taxIds": !exists(json, "taxIds") ? void 0 : json["taxIds"],
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "crmMetadata": !exists(json, "crmMetadata") ? void 0 : CrmMetadataFromJSON(json["crmMetadata"]),
    "erpMetadata": !exists(json, "erpMetadata") ? void 0 : ErpMetadataFromJSON(json["erpMetadata"]),
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"] === null ? null : json["contacts"].map(ContactFromJSON),
    "settings": !exists(json, "settings") ? void 0 : CustomerSettingsFromJSON(json["settings"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "status": !exists(json, "status") ? void 0 : CustomerStatusFromJSON(json["status"]),
    "source": !exists(json, "source") ? void 0 : CustomerSourceFromJSON(json["source"]),
    "subsidiaryId": !exists(json, "subsidiaryId") ? void 0 : json["subsidiaryId"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(CustomerIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : json["externalIntegration"] === null ? null : json["externalIntegration"].map(CustomerExternalIntegrationInnerFromJSON),
    "accountOwnerId": !exists(json, "accountOwnerId") ? void 0 : json["accountOwnerId"],
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"],
    "parentCustomer": !exists(json, "parentCustomer") ? void 0 : DynamicInvoiceDataCustomerParentCustomerFromJSON(json["parentCustomer"])
  };
}

// src/generated/models/InvoiceOverviewIntegrationExportsInner.ts
function InvoiceOverviewIntegrationExportsInnerFromJSON(json) {
  return InvoiceOverviewIntegrationExportsInnerFromJSONTyped(json, false);
}
function InvoiceOverviewIntegrationExportsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "status": json["status"],
    "integration": json["integration"],
    "date": new Date(json["date"]),
    "entityId": !exists(json, "entityId") ? void 0 : json["entityId"]
  };
}

// src/generated/models/InvoiceOverviewMarketplaceSyncStatus.ts
function InvoiceOverviewMarketplaceSyncStatusFromJSON(json) {
  return InvoiceOverviewMarketplaceSyncStatusFromJSONTyped(json, false);
}
function InvoiceOverviewMarketplaceSyncStatusFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "status": json["status"],
    "message": !exists(json, "message") ? void 0 : json["message"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : new Date(json["updatedAt"]),
    "rawResponse": !exists(json, "rawResponse") ? void 0 : json["rawResponse"]
  };
}

// src/generated/models/InvoiceOverviewMarketplaceUnitsDimensionsInner.ts
function InvoiceOverviewMarketplaceUnitsDimensionsInnerFromJSON(json) {
  return InvoiceOverviewMarketplaceUnitsDimensionsInnerFromJSONTyped(json, false);
}
function InvoiceOverviewMarketplaceUnitsDimensionsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "dimension": json["dimension"],
    "quantity": json["quantity"]
  };
}

// src/generated/models/InvoiceOverviewMarketplaceUnits.ts
function InvoiceOverviewMarketplaceUnitsFromJSON(json) {
  return InvoiceOverviewMarketplaceUnitsFromJSONTyped(json, false);
}
function InvoiceOverviewMarketplaceUnitsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": json["total"],
    "dimensions": json["dimensions"].map(InvoiceOverviewMarketplaceUnitsDimensionsInnerFromJSON)
  };
}

// src/generated/models/InvoiceOverview.ts
function InvoiceOverviewFromJSON(json) {
  return InvoiceOverviewFromJSONTyped(json, false);
}
function InvoiceOverviewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "id": json["id"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "billingCycle": FullDayPeriodFromJSON(json["billingCycle"]),
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "invoicingDate": !exists(json, "invoicingDate") ? void 0 : new Date(json["invoicingDate"]),
    "syncStatusUpdatedAt": !exists(json, "syncStatusUpdatedAt") ? void 0 : json["syncStatusUpdatedAt"] === null ? null : new Date(json["syncStatusUpdatedAt"]),
    "stripeSyncStatus": SyncStatusFromJSON(json["stripeSyncStatus"]),
    "stripeSyncStatusUpdatedAt": !exists(json, "stripeSyncStatusUpdatedAt") ? void 0 : json["stripeSyncStatusUpdatedAt"] === null ? null : new Date(json["stripeSyncStatusUpdatedAt"]),
    "stripeIntegrationExternalId": !exists(json, "stripeIntegrationExternalId") ? void 0 : json["stripeIntegrationExternalId"],
    "paymentInfo": !exists(json, "paymentInfo") ? void 0 : PaymentInfoFromJSON(json["paymentInfo"]),
    "dueDate": json["dueDate"] === null ? null : new Date(json["dueDate"]),
    "invoiceType": InvoiceTypeFromJSON(json["invoiceType"]),
    "invoiceNumber": json["invoiceNumber"],
    "ref": json["ref"],
    "refundsInvoiceId": !exists(json, "refundsInvoiceId") ? void 0 : json["refundsInvoiceId"],
    "customer": InvoiceOverviewCustomerFromJSON(json["customer"]),
    "contractId": !exists(json, "contractId") ? void 0 : json["contractId"],
    "contractName": !exists(json, "contractName") ? void 0 : json["contractName"],
    "contractStatus": !exists(json, "contractStatus") ? void 0 : ContractStatusFromJSON(json["contractStatus"]),
    "contractEndDate": !exists(json, "contractEndDate") ? void 0 : new Date(json["contractEndDate"]),
    "isTrial": !exists(json, "isTrial") ? void 0 : json["isTrial"],
    "issuedAt": json["issuedAt"] === null ? null : new Date(json["issuedAt"]),
    "currency": CurrencyFromJSON(json["currency"]),
    "isStripeSyncMissing": json["isStripeSyncMissing"],
    "paymentProvider": !exists(json, "paymentProvider") ? void 0 : PaymentProviderFromJSON(json["paymentProvider"]),
    "wasInvoiceEmailSent": !exists(json, "wasInvoiceEmailSent") ? void 0 : json["wasInvoiceEmailSent"],
    "lastSentAt": !exists(json, "lastSentAt") ? void 0 : json["lastSentAt"] === null ? null : new Date(json["lastSentAt"]),
    "integrationExports": !exists(json, "integrationExports") ? void 0 : json["integrationExports"].map(InvoiceOverviewIntegrationExportsInnerFromJSON),
    "marketplaceSyncStatus": !exists(json, "marketplaceSyncStatus") ? void 0 : InvoiceOverviewMarketplaceSyncStatusFromJSON(json["marketplaceSyncStatus"]),
    "purchaseOrder": !exists(json, "purchaseOrder") ? void 0 : json["purchaseOrder"],
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "payments": !exists(json, "payments") ? void 0 : json["payments"].map(InvoicePaymentFromJSON),
    "marketplaceUnits": !exists(json, "marketplaceUnits") ? void 0 : InvoiceOverviewMarketplaceUnitsFromJSON(json["marketplaceUnits"]),
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON)
  };
}

// src/generated/models/GetInvoicesOverviewsNewResponse.ts
function GetInvoicesOverviewsNewResponseFromJSON(json) {
  return GetInvoicesOverviewsNewResponseFromJSONTyped(json, false);
}
function GetInvoicesOverviewsNewResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoicesOverviews": json["invoicesOverviews"].map(InvoiceOverviewFromJSON),
    "count": json["count"],
    "availableCustomFieldNames": !exists(json, "availableCustomFieldNames") ? void 0 : json["availableCustomFieldNames"]
  };
}

// src/generated/models/GetInvoicesOverviewsResponse.ts
function GetInvoicesOverviewsResponseFromJSON(json) {
  return GetInvoicesOverviewsResponseFromJSONTyped(json, false);
}
function GetInvoicesOverviewsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoicesOverviews": json["invoicesOverviews"].map(InvoiceOverviewFromJSON),
    "count": json["count"]
  };
}

// src/generated/models/InvoicesOverviewsSummary.ts
function InvoicesOverviewsSummaryFromJSON(json) {
  return InvoicesOverviewsSummaryFromJSONTyped(json, false);
}
function InvoicesOverviewsSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "totalAmount": json["totalAmount"],
    "openAmount": json["openAmount"],
    "overdueAmount": json["overdueAmount"],
    "pendingPaymentAmount": json["pendingPaymentAmount"],
    "paidAmount": json["paidAmount"]
  };
}

// src/generated/models/GetInvoicesStatisticsResponse.ts
function GetInvoicesStatisticsResponseFromJSON(json) {
  return GetInvoicesStatisticsResponseFromJSONTyped(json, false);
}
function GetInvoicesStatisticsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "summary": InvoicesOverviewsSummaryFromJSON(json["summary"])
  };
}

// src/generated/models/ReportInvoiceSummaryComparisons.ts
function ReportInvoiceSummaryComparisonsFromJSON(json) {
  return ReportInvoiceSummaryComparisonsFromJSONTyped(json, false);
}
function ReportInvoiceSummaryComparisonsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "totalInvoicesSum": json["totalInvoicesSum"],
    "lastMonthInvoicesSum": json["lastMonthInvoicesSum"],
    "totalActiveCustomers": json["totalActiveCustomers"],
    "lastMonthActiveCustomers": json["lastMonthActiveCustomers"],
    "totalActiveContracts": json["totalActiveContracts"],
    "lastMonthActiveContracts": json["lastMonthActiveContracts"]
  };
}

// src/generated/models/ReportInvoicesSummary.ts
function ReportInvoicesSummaryFromJSON(json) {
  return ReportInvoicesSummaryFromJSONTyped(json, false);
}
function ReportInvoicesSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "revenueByBillingStatus": json["revenueByBillingStatus"],
    "countsByBillingStatus": json["countsByBillingStatus"],
    "comparisons": ReportInvoiceSummaryComparisonsFromJSON(json["comparisons"])
  };
}

// src/generated/models/GetInvoicesSummaryReportResponse.ts
function GetInvoicesSummaryReportResponseFromJSON(json) {
  return GetInvoicesSummaryReportResponseFromJSONTyped(json, false);
}
function GetInvoicesSummaryReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoicesSummary": ReportInvoicesSummaryFromJSON(json["invoicesSummary"])
  };
}

// src/generated/models/GetJournalEntriesReportResponseEntriesInnerLinesInner.ts
function GetJournalEntriesReportResponseEntriesInnerLinesInnerFromJSON(json) {
  return GetJournalEntriesReportResponseEntriesInnerLinesInnerFromJSONTyped(json, false);
}
function GetJournalEntriesReportResponseEntriesInnerLinesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "account": json["account"],
    "customerId": json["customerId"],
    "customerName": json["customerName"],
    "productId": json["productId"],
    "productName": json["productName"],
    "invoiceId": json["invoiceId"],
    "debit": json["debit"],
    "credit": json["credit"]
  };
}

// src/generated/models/GetJournalEntriesReportResponseEntriesInner.ts
function GetJournalEntriesReportResponseEntriesInnerFromJSON(json) {
  return GetJournalEntriesReportResponseEntriesInnerFromJSONTyped(json, false);
}
function GetJournalEntriesReportResponseEntriesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "date": json["date"],
    "status": json["status"],
    "lines": json["lines"].map(GetJournalEntriesReportResponseEntriesInnerLinesInnerFromJSON)
  };
}

// src/generated/models/GetJournalEntriesReportResponse.ts
function GetJournalEntriesReportResponseFromJSON(json) {
  return GetJournalEntriesReportResponseFromJSONTyped(json, false);
}
function GetJournalEntriesReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "entries": json["entries"].map(GetJournalEntriesReportResponseEntriesInnerFromJSON),
    "reportGeneratedAt": json["reportGeneratedAt"]
  };
}

// src/generated/models/GetLabelsResponse.ts
function GetLabelsResponseFromJSON(json) {
  return GetLabelsResponseFromJSONTyped(json, false);
}
function GetLabelsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "labels": json["labels"].map(LabelFromJSON)
  };
}

// src/generated/models/GetLatestContractRenewalResponse.ts
function GetLatestContractRenewalResponseFromJSON(json) {
  return GetLatestContractRenewalResponseFromJSONTyped(json, false);
}
function GetLatestContractRenewalResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractRenewal": !exists(json, "contractRenewal") ? void 0 : ContractRenewalFromJSON(json["contractRenewal"])
  };
}

// src/generated/models/GetLatestEventsResponse.ts
function GetLatestEventsResponseFromJSON(json) {
  return GetLatestEventsResponseFromJSONTyped(json, false);
}
function GetLatestEventsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "events": json["events"].map(IngestedEventSampleFromJSON),
    "countedFilteredEvents": json["countedFilteredEvents"]
  };
}

// src/generated/models/GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerPerUnitProductVariantsInner.ts
function GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerPerUnitProductVariantsInnerFromJSON(json) {
  return GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerPerUnitProductVariantsInnerFromJSONTyped(json, false);
}
function GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerPerUnitProductVariantsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "pricing": PerUnitPricingFromJSON(json["pricing"]),
    "meterName": json["meterName"]
  };
}

// src/generated/models/GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerTiersProductVariantsInner.ts
function GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerTiersProductVariantsInnerFromJSON(json) {
  return GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerTiersProductVariantsInnerFromJSONTyped(json, false);
}
function GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerTiersProductVariantsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "pricing": TiersPricingFromJSON(json["pricing"])
  };
}

// src/generated/models/GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInner.ts
function GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerFromJSON(json) {
  return GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerFromJSONTyped(json, false);
}
function GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "commitmentTiersUsageMap": json["commitmentTiersUsageMap"],
    "productDescription": !exists(json, "productDescription") ? void 0 : json["productDescription"],
    "productTitle": json["productTitle"],
    "tiersProductVariants": json["tiersProductVariants"].map(GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerTiersProductVariantsInnerFromJSON),
    "perUnitProductVariants": json["perUnitProductVariants"].map(GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerPerUnitProductVariantsInnerFromJSON)
  };
}

// src/generated/models/GetLightInvoicesResponseInvoicesInnerContract.ts
function GetLightInvoicesResponseInvoicesInnerContractFromJSON(json) {
  return GetLightInvoicesResponseInvoicesInnerContractFromJSONTyped(json, false);
}
function GetLightInvoicesResponseInvoicesInnerContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractName": json["contractName"],
    "contractStartDate": new Date(json["contractStartDate"]),
    "contractId": json["contractId"]
  };
}

// src/generated/models/GetLightInvoicesResponseInvoicesInnerCustomer.ts
function GetLightInvoicesResponseInvoicesInnerCustomerFromJSON(json) {
  return GetLightInvoicesResponseInvoicesInnerCustomerFromJSONTyped(json, false);
}
function GetLightInvoicesResponseInvoicesInnerCustomerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "name": json["name"],
    "legalName": !exists(json, "legalName") ? void 0 : json["legalName"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "aliases": !exists(json, "aliases") ? void 0 : json["aliases"],
    "taxIds": !exists(json, "taxIds") ? void 0 : json["taxIds"],
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "crmMetadata": !exists(json, "crmMetadata") ? void 0 : CrmMetadataFromJSON(json["crmMetadata"]),
    "erpMetadata": !exists(json, "erpMetadata") ? void 0 : ErpMetadataFromJSON(json["erpMetadata"]),
    "address": !exists(json, "address") ? void 0 : AddressFromJSON(json["address"]),
    "contacts": !exists(json, "contacts") ? void 0 : json["contacts"] === null ? null : json["contacts"].map(ContactFromJSON),
    "settings": !exists(json, "settings") ? void 0 : CustomerSettingsFromJSON(json["settings"]),
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "status": !exists(json, "status") ? void 0 : CustomerStatusFromJSON(json["status"]),
    "source": !exists(json, "source") ? void 0 : CustomerSourceFromJSON(json["source"]),
    "subsidiaryId": !exists(json, "subsidiaryId") ? void 0 : json["subsidiaryId"],
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"] === null ? null : json["integrationEntities"].map(CustomerIntegrationEntityFromJSON),
    "externalIntegration": !exists(json, "externalIntegration") ? void 0 : json["externalIntegration"] === null ? null : json["externalIntegration"].map(CustomerExternalIntegrationInnerFromJSON),
    "accountOwnerId": !exists(json, "accountOwnerId") ? void 0 : json["accountOwnerId"],
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"],
    "parentCustomer": !exists(json, "parentCustomer") ? void 0 : CustomerRelationFromJSON(json["parentCustomer"])
  };
}

// src/generated/models/GetLightInvoicesResponseInvoicesInnerFixedLineItemsInner.ts
function GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerFromJSON(json) {
  return GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerFromJSONTyped(json, false);
}
function GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "modifiedName": json["modifiedName"],
    "pricing": FixedPricingFromJSON(json["pricing"]),
    "productName": json["productName"],
    "productId": !exists(json, "productId") ? void 0 : json["productId"],
    "description": !exists(json, "description") ? void 0 : json["description"]
  };
}

// src/generated/models/GetLightInvoicesResponseInvoicesInnerUsageLineItemsInner.ts
function GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerFromJSON(json) {
  return GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerFromJSONTyped(json, false);
}
function GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "tiersUsageMap": json["tiersUsageMap"],
    "productDescription": !exists(json, "productDescription") ? void 0 : json["productDescription"],
    "productTitle": json["productTitle"],
    "tiersProductVariants": json["tiersProductVariants"].map(GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerTiersProductVariantsInnerFromJSON),
    "perUnitProductVariants": json["perUnitProductVariants"].map(GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerPerUnitProductVariantsInnerFromJSON)
  };
}

// src/generated/models/InvoiceCalculationStatus.ts
function InvoiceCalculationStatusFromJSON(json) {
  return InvoiceCalculationStatusFromJSONTyped(json, false);
}
function InvoiceCalculationStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/GetLightInvoicesResponseInvoicesInner.ts
function GetLightInvoicesResponseInvoicesInnerFromJSON(json) {
  return GetLightInvoicesResponseInvoicesInnerFromJSONTyped(json, false);
}
function GetLightInvoicesResponseInvoicesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "customer": GetLightInvoicesResponseInvoicesInnerCustomerFromJSON(json["customer"]),
    "currency": CurrencyFromJSON(json["currency"]),
    "notes": !exists(json, "notes") ? void 0 : json["notes"],
    "totalCommitment": json["totalCommitment"],
    "taxRate": json["taxRate"],
    "issuedAt": json["issuedAt"] === null ? null : new Date(json["issuedAt"]),
    "emailMessages": !exists(json, "emailMessages") ? void 0 : json["emailMessages"].map(EmailMessageFromJSON),
    "contract": !exists(json, "contract") ? void 0 : GetLightInvoicesResponseInvoicesInnerContractFromJSON(json["contract"]),
    "invoicingDate": !exists(json, "invoicingDate") ? void 0 : new Date(json["invoicingDate"]),
    "dueDate": json["dueDate"] === null ? null : new Date(json["dueDate"]),
    "isStripeSyncMissing": json["isStripeSyncMissing"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "billingCycle": PeriodFromJSON(json["billingCycle"]),
    "purchaseOrder": !exists(json, "purchaseOrder") ? void 0 : json["purchaseOrder"],
    "syncStatus": SyncStatusFromJSON(json["syncStatus"]),
    "fixedLineItems": json["fixedLineItems"].map(GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerFromJSON),
    "usageLineItems": json["usageLineItems"].map(GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerFromJSON),
    "commitmentLineItems": json["commitmentLineItems"].map(GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerFromJSON),
    "promotionLineItems": json["promotionLineItems"].map(GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerFromJSON),
    "paymentInfo": !exists(json, "paymentInfo") ? void 0 : PaymentInfoFromJSON(json["paymentInfo"]),
    "paymentDueDays": json["paymentDueDays"],
    "paymentProviderInformation": !exists(json, "paymentProviderInformation") ? void 0 : InvoicePaymentProviderInformationFromJSON(json["paymentProviderInformation"]),
    "paymentTerm": json["paymentTerm"],
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "calculationStatus": InvoiceCalculationStatusFromJSON(json["calculationStatus"]),
    "integrationEntities": json["integrationEntities"].map(IntegrationEntityFromJSON),
    "invoiceNumber": json["invoiceNumber"],
    "ref": json["ref"],
    "marketplaceSyncStatus": !exists(json, "marketplaceSyncStatus") ? void 0 : InvoiceOverviewMarketplaceSyncStatusFromJSON(json["marketplaceSyncStatus"])
  };
}

// src/generated/models/SystemEventType.ts
function SystemEventTypeFromJSON(json) {
  return SystemEventTypeFromJSONTyped(json, false);
}
function SystemEventTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/SystemType.ts
function SystemTypeFromJSON(json) {
  return SystemTypeFromJSONTyped(json, false);
}
function SystemTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/SystemEvent.ts
function SystemEventFromJSON(json) {
  return SystemEventFromJSONTyped(json, false);
}
function SystemEventFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": SystemEventTypeFromJSON(json["type"]),
    "objectTypeId": json["objectTypeId"],
    "timestamp": !exists(json, "timestamp") ? void 0 : new Date(json["timestamp"]),
    "system": !exists(json, "system") ? void 0 : SystemTypeFromJSON(json["system"]),
    "metadata": !exists(json, "metadata") ? void 0 : json["metadata"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/GetLightInvoicesResponse.ts
function GetLightInvoicesResponseFromJSON(json) {
  return GetLightInvoicesResponseFromJSONTyped(json, false);
}
function GetLightInvoicesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoices": json["invoices"].map(GetLightInvoicesResponseInvoicesInnerFromJSON),
    "invoicesSystemEvents": json["invoicesSystemEvents"].map(SystemEventFromJSON)
  };
}

// src/generated/models/MeasurementMeasurementTimeSlot.ts
function MeasurementMeasurementTimeSlotFromJSON(json) {
  return MeasurementMeasurementTimeSlotFromJSONTyped(json, false);
}
function MeasurementMeasurementTimeSlotFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "year": json["year"],
    "month": json["month"],
    "day": json["day"]
  };
}

// src/generated/models/Measurement.ts
function MeasurementFromJSON(json) {
  return MeasurementFromJSONTyped(json, false);
}
function MeasurementFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "period": FullDayPeriodFromJSON(json["period"]),
    "meterId": json["meterId"],
    "customerId": json["customerId"],
    "value": json["value"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "measurementPriceId": !exists(json, "measurementPriceId") ? void 0 : json["measurementPriceId"],
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "measurementTimeSlot": !exists(json, "measurementTimeSlot") ? void 0 : MeasurementMeasurementTimeSlotFromJSON(json["measurementTimeSlot"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/GetMeasurementsResponse.ts
function GetMeasurementsResponseFromJSON(json) {
  return GetMeasurementsResponseFromJSONTyped(json, false);
}
function GetMeasurementsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "measurements": json["measurements"].map(MeasurementFromJSON)
  };
}

// src/generated/models/MeasurementsStats.ts
function MeasurementsStatsFromJSON(json) {
  return MeasurementsStatsFromJSONTyped(json, false);
}
function MeasurementsStatsFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "day": new Date(json["day"]),
    "customer": json["customer"],
    "customerId": json["customerId"],
    "customerExternalId": !exists(json, "customerExternalId") ? void 0 : json["customerExternalId"],
    "product": json["product"],
    "productVariant": json["productVariant"],
    "meterId": json["meterId"],
    "quantity": json["quantity"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "currency": !exists(json, "currency") ? void 0 : CurrencyFromJSON(json["currency"]),
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"]
  };
}

// src/generated/models/GetMeasurementsStatsExportResponse.ts
function GetMeasurementsStatsExportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "items": json["items"].map(MeasurementsStatsFromJSON),
    "mode": json["mode"]
  };
}

// src/generated/models/GetMeasurementsStatsQueryResponse.ts
function GetMeasurementsStatsQueryResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "items": json["items"].map(MeasurementsStatsFromJSON),
    "totalCount": json["totalCount"],
    "mode": json["mode"],
    "totalValue": json["totalValue"]
  };
}

// src/generated/models/GetMeasurementsStatsResponse.ts
function GetMeasurementsStatsResponseFromJSON(json) {
  return GetMeasurementsStatsResponseFromJSONTyped(json, false);
}
function GetMeasurementsStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["mode"]) {
    case "export":
      return { ...GetMeasurementsStatsExportResponseFromJSONTyped(json, true), mode: "export" };
    case "query":
      return { ...GetMeasurementsStatsQueryResponseFromJSONTyped(json, true), mode: "query" };
    default:
      throw new Error(`No variant of GetMeasurementsStatsResponse exists with 'mode=${json["mode"]}'`);
  }
}

// src/generated/models/GetMeterDescriptionRequestMeterFilterConditionsInner.ts
function GetMeterDescriptionRequestMeterFilterConditionsInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "criterions": value.criterions.map(CriterionToJSON)
  };
}

// src/generated/models/GetMeterDescriptionRequestMeterFilter.ts
function GetMeterDescriptionRequestMeterFilterToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "conditions": value.conditions.map(GetMeterDescriptionRequestMeterFilterConditionsInnerToJSON)
  };
}

// src/generated/models/GetMeterDescriptionRequestMeter.ts
function GetMeterDescriptionRequestMeterToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "eventName": value.eventName,
    "name": value.name,
    "description": value.description,
    "unitsType": value.unitsType,
    "filter": GetMeterDescriptionRequestMeterFilterToJSON(value.filter),
    "aggregationMethod": AggregationMethodToJSON(value.aggregationMethod),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "creditTypeIds": value.creditTypeIds,
    "isTaxable": value.isTaxable
  };
}

// src/generated/models/GetMeterDescriptionRequest.ts
function GetMeterDescriptionRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "meter": GetMeterDescriptionRequestMeterToJSON(value.meter)
  };
}

// src/generated/models/GetMeterDescriptionResponse.ts
function GetMeterDescriptionResponseFromJSON(json) {
  return GetMeterDescriptionResponseFromJSONTyped(json, false);
}
function GetMeterDescriptionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "description": json["description"]
  };
}

// src/generated/models/GetMeterInstanceKeysResponse.ts
function GetMeterInstanceKeysResponseFromJSON(json) {
  return GetMeterInstanceKeysResponseFromJSONTyped(json, false);
}
function GetMeterInstanceKeysResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "instanceKeys": json["instanceKeys"]
  };
}

// src/generated/models/GetMetersResponse.ts
function GetMetersResponseFromJSON(json) {
  return GetMetersResponseFromJSONTyped(json, false);
}
function GetMetersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "meters": json["meters"].map(MeterFromJSON)
  };
}

// src/generated/models/MonthlyClosureReportResponseSchemaInner.ts
function MonthlyClosureReportResponseSchemaInnerFromJSON(json) {
  return MonthlyClosureReportResponseSchemaInnerFromJSONTyped(json, false);
}
function MonthlyClosureReportResponseSchemaInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "revenueBreakdown": CustomerRevenueBreakdownFromJSON(json["revenueBreakdown"]),
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "billingCycle": FullDayPeriodFromJSON(json["billingCycle"]),
    "invoiceNumber": json["invoiceNumber"],
    "customerName": json["customerName"],
    "erpDisplayId": !exists(json, "erpDisplayId") ? void 0 : json["erpDisplayId"],
    "overcharges": json["overcharges"],
    "currency": CurrencyFromJSON(json["currency"]),
    "erpId": !exists(json, "erpId") ? void 0 : json["erpId"],
    "customerExternalId": !exists(json, "customerExternalId") ? void 0 : json["customerExternalId"],
    "paymentTerm": json["paymentTerm"],
    "contractName": !exists(json, "contractName") ? void 0 : json["contractName"]
  };
}

// src/generated/models/GetMonthlyClouserReportResponse.ts
function GetMonthlyClouserReportResponseFromJSON(json) {
  return GetMonthlyClouserReportResponseFromJSONTyped(json, false);
}
function GetMonthlyClouserReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": json["report"].map(MonthlyClosureReportResponseSchemaInnerFromJSON),
    "creationDate": new Date(json["creationDate"]),
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"])
  };
}

// src/generated/models/GetMrrWaterfallResponse.ts
function GetMrrWaterfallResponseFromJSON(json) {
  return GetMrrWaterfallResponseFromJSONTyped(json, false);
}
function GetMrrWaterfallResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "month": json["month"],
    "beginningMrr": json["beginningMrr"],
    "endingMrr": json["endingMrr"],
    "movements": GetHomePageAccountSummaryResponseKpiMetricsMrrWaterfallMovementsFromJSON(json["movements"]),
    "nrr": json["nrr"],
    "grr": json["grr"],
    "netChange": json["netChange"],
    "netChangePercentage": json["netChangePercentage"]
  };
}

// src/generated/models/GetNetSuiteSubsidiariesResponseSubsidiariesInner.ts
function GetNetSuiteSubsidiariesResponseSubsidiariesInnerFromJSON(json) {
  return GetNetSuiteSubsidiariesResponseSubsidiariesInnerFromJSONTyped(json, false);
}
function GetNetSuiteSubsidiariesResponseSubsidiariesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "parent": !exists(json, "parent") ? void 0 : json["parent"]
  };
}

// src/generated/models/GetNetSuiteSubsidiariesResponse.ts
function GetNetSuiteSubsidiariesResponseFromJSON(json) {
  return GetNetSuiteSubsidiariesResponseFromJSONTyped(json, false);
}
function GetNetSuiteSubsidiariesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "subsidiaries": json["subsidiaries"].map(GetNetSuiteSubsidiariesResponseSubsidiariesInnerFromJSON)
  };
}

// src/generated/models/NotificationAlertStatus.ts
function NotificationAlertStatusFromJSON(json) {
  return NotificationAlertStatusFromJSONTyped(json, false);
}
function NotificationAlertStatusFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}
function NotificationAlertStatusToJSON(value) {
  return value;
}

// src/generated/models/GetNotificationAlertsResponseInnerNotificationAlert.ts
function GetNotificationAlertsResponseInnerNotificationAlertFromJSON(json) {
  return GetNotificationAlertsResponseInnerNotificationAlertFromJSONTyped(json, false);
}
function GetNotificationAlertsResponseInnerNotificationAlertFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "status": NotificationAlertStatusFromJSON(json["status"]),
    "channelType": ChannelTypeFromJSON(json["channelType"])
  };
}

// src/generated/models/InvoiceApprovedNotificationMetadata.ts
function InvoiceApprovedNotificationMetadataFromJSON(json) {
  return InvoiceApprovedNotificationMetadataFromJSONTyped(json, false);
}
function InvoiceApprovedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "invoiceId": json["invoiceId"]
  };
}

// src/generated/models/InvoiceApprovedNotification.ts
function InvoiceApprovedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": InvoiceApprovedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/InvoicePaymentStatusChangedMetadata.ts
function InvoicePaymentStatusChangedMetadataFromJSON(json) {
  return InvoicePaymentStatusChangedMetadataFromJSONTyped(json, false);
}
function InvoicePaymentStatusChangedMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "amountDue": json["amountDue"],
    "amountPaid": json["amountPaid"],
    "total": json["total"],
    "dueDate": !exists(json, "dueDate") ? void 0 : new Date(json["dueDate"]),
    "paidAt": !exists(json, "paidAt") ? void 0 : new Date(json["paidAt"]),
    "invoicePdfUrl": !exists(json, "invoicePdfUrl") ? void 0 : json["invoicePdfUrl"]
  };
}

// src/generated/models/InvoicePaymentStatusChangedNotification.ts
function InvoicePaymentStatusChangedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": InvoicePaymentStatusChangedMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/InvoiceSendFailedNotificationMetadata.ts
function InvoiceSendFailedNotificationMetadataFromJSON(json) {
  return InvoiceSendFailedNotificationMetadataFromJSONTyped(json, false);
}
function InvoiceSendFailedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "invoiceNumber": json["invoiceNumber"],
    "date": new Date(json["date"])
  };
}

// src/generated/models/InvoiceSendFailedNotification.ts
function InvoiceSendFailedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": InvoiceSendFailedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/MonthEndReportNotificationMetadata.ts
function MonthEndReportNotificationMetadataFromJSON(json) {
  return MonthEndReportNotificationMetadataFromJSONTyped(json, false);
}
function MonthEndReportNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "reportId": json["reportId"]
  };
}

// src/generated/models/MonthEndReportNotification.ts
function MonthEndReportNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": MonthEndReportNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/NewCustomerWithoutContractNotificationMetadata.ts
function NewCustomerWithoutContractNotificationMetadataFromJSON(json) {
  return NewCustomerWithoutContractNotificationMetadataFromJSONTyped(json, false);
}
function NewCustomerWithoutContractNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customerId": json["customerId"],
    "customerName": json["customerName"]
  };
}

// src/generated/models/NewCustomerWithoutContractNotification.ts
function NewCustomerWithoutContractNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": NewCustomerWithoutContractNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/OverageNotificationEntity.ts
function OverageNotificationEntityFromJSON(json) {
  return OverageNotificationEntityFromJSONTyped(json, false);
}
function OverageNotificationEntityFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "entityId": json["entityId"],
    "type": NotificationEntityFromJSON(json["type"])
  };
}

// src/generated/models/OverageNotificationMetadata.ts
function OverageNotificationMetadataFromJSON(json) {
  return OverageNotificationMetadataFromJSONTyped(json, false);
}
function OverageNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "overageAmount": json["overageAmount"],
    "invoiceId": json["invoiceId"],
    "customerId": json["customerId"],
    "customerName": json["customerName"],
    "currency": CurrencyFromJSON(json["currency"])
  };
}

// src/generated/models/OverageNotification.ts
function OverageNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": OverageNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": OverageNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/PaymentFailedNotificationMetadata.ts
function PaymentFailedNotificationMetadataFromJSON(json) {
  return PaymentFailedNotificationMetadataFromJSONTyped(json, false);
}
function PaymentFailedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customerId": json["customerId"],
    "invoiceId": json["invoiceId"],
    "paymentProvider": IntegrationProvidersFromJSON(json["paymentProvider"]),
    "amount": !exists(json, "amount") ? void 0 : json["amount"],
    "currency": !exists(json, "currency") ? void 0 : CurrencyFromJSON(json["currency"]),
    "failureReason": !exists(json, "failureReason") ? void 0 : json["failureReason"]
  };
}

// src/generated/models/PaymentFailedNotification.ts
function PaymentFailedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": PaymentFailedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/TierCrossedNotificationMetadata.ts
function TierCrossedNotificationMetadataFromJSON(json) {
  return TierCrossedNotificationMetadataFromJSONTyped(json, false);
}
function TierCrossedNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "customerId": json["customerId"],
    "contractId": json["contractId"],
    "customerName": json["customerName"],
    "contractName": json["contractName"],
    "variantId": !exists(json, "variantId") ? void 0 : json["variantId"]
  };
}

// src/generated/models/TierCrossedNotification.ts
function TierCrossedNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": TierCrossedNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/UnchargedEventsNotificationMetadata.ts
function UnchargedEventsNotificationMetadataFromJSON(json) {
  return UnchargedEventsNotificationMetadataFromJSONTyped(json, false);
}
function UnchargedEventsNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "reportId": json["reportId"]
  };
}

// src/generated/models/UnchargedEventsNotification.ts
function UnchargedEventsNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": UnchargedEventsNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/UpcomingRenewalNotificationMetadata.ts
function UpcomingRenewalNotificationMetadataFromJSON(json) {
  return UpcomingRenewalNotificationMetadataFromJSONTyped(json, false);
}
function UpcomingRenewalNotificationMetadataFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "contractEndDate": new Date(json["contractEndDate"]),
    "contractName": json["contractName"],
    "contractId": json["contractId"],
    "customerName": !exists(json, "customerName") ? void 0 : json["customerName"],
    "isTrial": !exists(json, "isTrial") ? void 0 : json["isTrial"]
  };
}

// src/generated/models/UpcomingRenewalNotification.ts
function UpcomingRenewalNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "duplicationId": !exists(json, "duplicationId") ? void 0 : json["duplicationId"],
    "entity": AnonymousCustomerNotificationEntityFromJSON(json["entity"]),
    "eventType": json["eventType"],
    "metadata": UpcomingRenewalNotificationMetadataFromJSON(json["metadata"])
  };
}

// src/generated/models/NewNotification.ts
function NewNotificationFromJSON(json) {
  return NewNotificationFromJSONTyped(json, false);
}
function NewNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  switch (json["eventType"]) {
    case "AnonymousCustomer":
      return { ...AnonymousCustomerNotificationFromJSONTyped(json, true), eventType: "AnonymousCustomer" };
    case "CommitmentCrossed":
      return { ...CommitmentCrossedNotificationFromJSONTyped(json, true), eventType: "CommitmentCrossed" };
    case "CommitmentUsageCrossed":
      return { ...CommitmentUsageCrossedNotificationFromJSONTyped(json, true), eventType: "CommitmentUsageCrossed" };
    case "ContractCreated":
      return { ...ContractCreatedNotificationFromJSONTyped(json, true), eventType: "ContractCreated" };
    case "ContractExpired":
      return { ...ContractExpiredNotificationFromJSONTyped(json, true), eventType: "ContractExpired" };
    case "CreditPoolDepleted":
      return { ...CreditPoolDepletedNotificationFromJSONTyped(json, true), eventType: "CreditPoolDepleted" };
    case "CreditPoolIncreased":
      return { ...CreditPoolIncreasedNotificationFromJSONTyped(json, true), eventType: "CreditPoolIncreased" };
    case "CreditPoolThresholdCrossed":
      return { ...CreditPoolThresholdCrossedNotificationFromJSONTyped(json, true), eventType: "CreditPoolThresholdCrossed" };
    case "CurrencyCommitmentUsageCrossed":
      return { ...CurrencyCommitmentUsageCrossedNotificationFromJSONTyped(json, true), eventType: "CurrencyCommitmentUsageCrossed" };
    case "CustomerCreated":
      return { ...CustomerCreatedNotificationFromJSONTyped(json, true), eventType: "CustomerCreated" };
    case "CustomerPortalLinkSent":
      return { ...CustomerPortalLinkSentNotificationFromJSONTyped(json, true), eventType: "CustomerPortalLinkSent" };
    case "FinalTierExceeded":
      return { ...FinalTierExceededNotificationFromJSONTyped(json, true), eventType: "FinalTierExceeded" };
    case "InvoiceApproved":
      return { ...InvoiceApprovedNotificationFromJSONTyped(json, true), eventType: "InvoiceApproved" };
    case "InvoicePaymentStatusChanged":
      return { ...InvoicePaymentStatusChangedNotificationFromJSONTyped(json, true), eventType: "InvoicePaymentStatusChanged" };
    case "InvoiceSendFailed":
      return { ...InvoiceSendFailedNotificationFromJSONTyped(json, true), eventType: "InvoiceSendFailed" };
    case "MonthEndReport":
      return { ...MonthEndReportNotificationFromJSONTyped(json, true), eventType: "MonthEndReport" };
    case "NewCustomerWithoutContract":
      return { ...NewCustomerWithoutContractNotificationFromJSONTyped(json, true), eventType: "NewCustomerWithoutContract" };
    case "Overage":
      return { ...OverageNotificationFromJSONTyped(json, true), eventType: "Overage" };
    case "PaymentFailed":
      return { ...PaymentFailedNotificationFromJSONTyped(json, true), eventType: "PaymentFailed" };
    case "TierCrossed":
      return { ...TierCrossedNotificationFromJSONTyped(json, true), eventType: "TierCrossed" };
    case "UnchargedEvents":
      return { ...UnchargedEventsNotificationFromJSONTyped(json, true), eventType: "UnchargedEvents" };
    case "UpcomingRenewal":
      return { ...UpcomingRenewalNotificationFromJSONTyped(json, true), eventType: "UpcomingRenewal" };
    default:
      throw new Error(`No variant of NewNotification exists with 'eventType=${json["eventType"]}'`);
  }
}

// src/generated/models/GetNotificationAlertsResponseInner.ts
function GetNotificationAlertsResponseInnerFromJSON(json) {
  return GetNotificationAlertsResponseInnerFromJSONTyped(json, false);
}
function GetNotificationAlertsResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "notification": NewNotificationFromJSON(json["notification"]),
    "notificationAlert": GetNotificationAlertsResponseInnerNotificationAlertFromJSON(json["notificationAlert"])
  };
}

// src/generated/models/PaymentMethod.ts
function PaymentMethodFromJSON(json) {
  return PaymentMethodFromJSONTyped(json, false);
}
function PaymentMethodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"]
  };
}

// src/generated/models/GetPaymentMethodsResponse.ts
function GetPaymentMethodsResponseFromJSON(json) {
  return GetPaymentMethodsResponseFromJSONTyped(json, false);
}
function GetPaymentMethodsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "paymentMethods": json["paymentMethods"].map(PaymentMethodFromJSON)
  };
}

// src/generated/models/PaymentOverview.ts
function PaymentOverviewFromJSON(json) {
  return PaymentOverviewFromJSONTyped(json, false);
}
function PaymentOverviewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "updatedAt": new Date(json["updatedAt"]),
    "amount": json["amount"],
    "currency": CurrencyFromJSON(json["currency"]),
    "paymentMethod": !exists(json, "paymentMethod") ? void 0 : json["paymentMethod"],
    "externalPayment": !exists(json, "externalPayment") ? void 0 : ExternalPaymentFromJSON(json["externalPayment"]),
    "status": json["status"],
    "invoiceId": !exists(json, "invoiceId") ? void 0 : json["invoiceId"],
    "invoiceNumber": !exists(json, "invoiceNumber") ? void 0 : json["invoiceNumber"],
    "customerName": json["customerName"],
    "customerId": json["customerId"],
    "customFieldValues": !exists(json, "customFieldValues") ? void 0 : json["customFieldValues"].map(CustomFieldValueFromJSON)
  };
}

// src/generated/models/GetPaymentOverviewsResponse.ts
function GetPaymentOverviewsResponseFromJSON(json) {
  return GetPaymentOverviewsResponseFromJSONTyped(json, false);
}
function GetPaymentOverviewsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "paymentsOverviews": json["paymentsOverviews"].map(PaymentOverviewFromJSON),
    "count": json["count"]
  };
}

// src/generated/models/GetPaymentsNewResponse.ts
function GetPaymentsNewResponseFromJSON(json) {
  return GetPaymentsNewResponseFromJSONTyped(json, false);
}
function GetPaymentsNewResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "items": json["items"].map(PaymentOverviewFromJSON),
    "count": json["count"]
  };
}

// src/generated/models/PhaseLabel.ts
function PhaseLabelFromJSON(json) {
  return PhaseLabelFromJSONTyped(json, false);
}
function PhaseLabelFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": !exists(json, "accountId") ? void 0 : json["accountId"],
    "type": PhaseTypeFromJSON(json["type"]),
    "textLabel": json["textLabel"],
    "color": json["color"],
    "backgroundColor": json["backgroundColor"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/GetPhaseLabelsResponse.ts
function GetPhaseLabelsResponseFromJSON(json) {
  return GetPhaseLabelsResponseFromJSONTyped(json, false);
}
function GetPhaseLabelsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "phaseLabels": json["phaseLabels"].map(PhaseLabelFromJSON)
  };
}

// src/generated/models/PlanOverview.ts
function PlanOverviewFromJSON(json) {
  return PlanOverviewFromJSONTyped(json, false);
}
function PlanOverviewFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "revenue": json["revenue"],
    "accrued": json["accrued"],
    "paymentTerm": PaymentTermFromJSON(json["paymentTerm"]),
    "status": PlanStatusFromJSON(json["status"]),
    "customersCount": json["customersCount"],
    "basedFromPlanId": !exists(json, "basedFromPlanId") ? void 0 : json["basedFromPlanId"],
    "billingInterval": BillingIntervalFromJSON(json["billingInterval"]),
    "planDuration": PlanDurationFromJSON(json["planDuration"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/GetPlanOverviewResponse.ts
function GetPlanOverviewResponseFromJSON(json) {
  return GetPlanOverviewResponseFromJSONTyped(json, false);
}
function GetPlanOverviewResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "plan": PlanOverviewFromJSON(json["plan"])
  };
}

// src/generated/models/GetPlanOverviewsResponse.ts
function GetPlanOverviewsResponseFromJSON(json) {
  return GetPlanOverviewsResponseFromJSONTyped(json, false);
}
function GetPlanOverviewsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "countedActivePlansOverviews": json["countedActivePlansOverviews"],
    "countedTotalPlansOverviews": json["countedTotalPlansOverviews"],
    "countedFilteredPlansOverviews": json["countedFilteredPlansOverviews"],
    "plansOverviews": json["plansOverviews"].map(PlanOverviewFromJSON)
  };
}

// src/generated/models/GetPlanResponse.ts
function GetPlanResponseFromJSON(json) {
  return GetPlanResponseFromJSONTyped(json, false);
}
function GetPlanResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "plan": PlanFromJSON(json["plan"])
  };
}

// src/generated/models/GetPotentialChildCustomersResponsePotentialChildCustomersInner.ts
function GetPotentialChildCustomersResponsePotentialChildCustomersInnerFromJSON(json) {
  return GetPotentialChildCustomersResponsePotentialChildCustomersInnerFromJSONTyped(json, false);
}
function GetPotentialChildCustomersResponsePotentialChildCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "externalId": !exists(json, "externalId") ? void 0 : json["externalId"],
    "name": json["name"]
  };
}

// src/generated/models/GetPotentialChildCustomersResponse.ts
function GetPotentialChildCustomersResponseFromJSON(json) {
  return GetPotentialChildCustomersResponseFromJSONTyped(json, false);
}
function GetPotentialChildCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "potentialChildCustomers": json["potentialChildCustomers"].map(GetPotentialChildCustomersResponsePotentialChildCustomersInnerFromJSON)
  };
}

// src/generated/models/PricingModel.ts
function PricingModelFromJSON(json) {
  return PricingModelFromJSONTyped(json, false);
}
function PricingModelFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/PricingTemplateType.ts
function PricingTemplateTypeFromJSON(json) {
  return PricingTemplateTypeFromJSONTyped(json, false);
}
function PricingTemplateTypeFromJSONTyped(json, ignoreDiscriminator) {
  return json;
}

// src/generated/models/PricingTemplateOneOf.ts
function PricingTemplateOneOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": !exists(json, "accountId") ? void 0 : json["accountId"],
    "pricingModel": PricingModelFromJSON(json["pricingModel"]),
    "templateType": PricingTemplateTypeFromJSON(json["templateType"]),
    "primitiveType": json["primitiveType"],
    "userConfigurable": json["userConfigurable"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "defaultValue": !exists(json, "defaultValue") ? void 0 : json["defaultValue"],
    "possibleValues": !exists(json, "possibleValues") ? void 0 : json["possibleValues"]
  };
}

// src/generated/models/PricingTemplateOneOf1.ts
function PricingTemplateOneOf1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": !exists(json, "accountId") ? void 0 : json["accountId"],
    "pricingModel": PricingModelFromJSON(json["pricingModel"]),
    "templateType": PricingTemplateTypeFromJSON(json["templateType"]),
    "primitiveType": json["primitiveType"],
    "userConfigurable": json["userConfigurable"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "defaultValue": !exists(json, "defaultValue") ? void 0 : json["defaultValue"],
    "possibleValues": !exists(json, "possibleValues") ? void 0 : json["possibleValues"]
  };
}

// src/generated/models/PricingTemplateOneOf2.ts
function PricingTemplateOneOf2FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": !exists(json, "accountId") ? void 0 : json["accountId"],
    "pricingModel": PricingModelFromJSON(json["pricingModel"]),
    "templateType": PricingTemplateTypeFromJSON(json["templateType"]),
    "primitiveType": json["primitiveType"],
    "userConfigurable": json["userConfigurable"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "defaultValue": !exists(json, "defaultValue") ? void 0 : json["defaultValue"],
    "possibleValues": !exists(json, "possibleValues") ? void 0 : json["possibleValues"]
  };
}

// src/generated/models/PricingTemplate.ts
function PricingTemplateFromJSON(json) {
  return PricingTemplateFromJSONTyped(json, false);
}
function PricingTemplateFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...PricingTemplateOneOfFromJSONTyped(json, true), ...PricingTemplateOneOf1FromJSONTyped(json, true), ...PricingTemplateOneOf2FromJSONTyped(json, true) };
}

// src/generated/models/GetPricingTemplatesResponse.ts
function GetPricingTemplatesResponseFromJSON(json) {
  return GetPricingTemplatesResponseFromJSONTyped(json, false);
}
function GetPricingTemplatesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "pricingTemplates": json["pricingTemplates"].map(PricingTemplateFromJSON)
  };
}

// src/generated/models/GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerCustomerUsageInner.ts
function GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerCustomerUsageInnerFromJSON(json) {
  return GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerCustomerUsageInnerFromJSONTyped(json, false);
}
function GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerCustomerUsageInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerId": json["customerId"],
    "customerName": json["customerName"],
    "units": json["units"],
    "price": !exists(json, "price") ? void 0 : json["price"]
  };
}

// src/generated/models/GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInner.ts
function GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerFromJSON(json) {
  return GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerFromJSONTyped(json, false);
}
function GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "date": new Date(json["date"]),
    "units": json["units"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "customerUsage": json["customerUsage"].map(GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerCustomerUsageInnerFromJSON)
  };
}

// src/generated/models/GetProductUsageByDateBreakdownResponse.ts
function GetProductUsageByDateBreakdownResponseFromJSON(json) {
  return GetProductUsageByDateBreakdownResponseFromJSONTyped(json, false);
}
function GetProductUsageByDateBreakdownResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "usageByDateBreakdown": json["usageByDateBreakdown"].map(GetProductUsageByDateBreakdownResponseUsageByDateBreakdownInnerFromJSON)
  };
}

// src/generated/models/GetProductUsageChartDataResponse.ts
function GetProductUsageChartDataResponseFromJSON(json) {
  return GetProductUsageChartDataResponseFromJSONTyped(json, false);
}
function GetProductUsageChartDataResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "usageData": json["usageData"]
  };
}

// src/generated/models/MeterForProjectPageResponse.ts
function MeterForProjectPageResponseFromJSON(json) {
  return MeterForProjectPageResponseFromJSONTyped(json, false);
}
function MeterForProjectPageResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "eventName": json["eventName"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "unitsType": !exists(json, "unitsType") ? void 0 : json["unitsType"],
    "filter": !exists(json, "filter") ? void 0 : FilterFromJSON(json["filter"]),
    "aggregationMethod": AggregationMethodFromJSON(json["aggregationMethod"]),
    "integrationEntities": !exists(json, "integrationEntities") ? void 0 : json["integrationEntities"].map(ProductIntegrationEntityFromJSON),
    "creditTypeIds": !exists(json, "creditTypeIds") ? void 0 : json["creditTypeIds"],
    "isTaxable": !exists(json, "isTaxable") ? void 0 : json["isTaxable"],
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"]
  };
}

// src/generated/models/GetProductsPageDataResponse.ts
function GetProductsPageDataResponseFromJSON(json) {
  return GetProductsPageDataResponseFromJSONTyped(json, false);
}
function GetProductsPageDataResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "totalRevenue": json["totalRevenue"],
    "meters": json["meters"].map(MeterForProjectPageResponseFromJSON),
    "countedTotalMeters": json["countedTotalMeters"],
    "countedFilteredMeters": json["countedFilteredMeters"]
  };
}

// src/generated/models/GetProductsUsageReportResponseReportInner.ts
function GetProductsUsageReportResponseReportInnerFromJSON(json) {
  return GetProductsUsageReportResponseReportInnerFromJSONTyped(json, false);
}
function GetProductsUsageReportResponseReportInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractStatus": ContractStatusFromJSON(json["contractStatus"]),
    "customerName": json["customerName"],
    "startDate": new Date(json["startDate"]),
    "endDate": new Date(json["endDate"]),
    "contractName": !exists(json, "contractName") ? void 0 : json["contractName"],
    "contractStartDate": new Date(json["contractStartDate"]),
    "contractEndDate": !exists(json, "contractEndDate") ? void 0 : new Date(json["contractEndDate"]),
    "daysToContractEnd": !exists(json, "daysToContractEnd") ? void 0 : json["daysToContractEnd"],
    "productVariantName": json["productVariantName"],
    "commitmentConsumptionPercentage": !exists(json, "commitmentConsumptionPercentage") ? void 0 : json["commitmentConsumptionPercentage"],
    "totalCommitmentCurrencyAmount": !exists(json, "totalCommitmentCurrencyAmount") ? void 0 : json["totalCommitmentCurrencyAmount"],
    "totalCommitmentUnitsAmount": !exists(json, "totalCommitmentUnitsAmount") ? void 0 : json["totalCommitmentUnitsAmount"],
    "commercialTermsAmount": !exists(json, "commercialTermsAmount") ? void 0 : json["commercialTermsAmount"],
    "erpId": !exists(json, "erpId") ? void 0 : json["erpId"],
    "currency": CurrencyFromJSON(json["currency"]),
    "usageConsumptionCurrencyAmount": !exists(json, "usageConsumptionCurrencyAmount") ? void 0 : json["usageConsumptionCurrencyAmount"],
    "usageConsumptionUnitsAmount": !exists(json, "usageConsumptionUnitsAmount") ? void 0 : json["usageConsumptionUnitsAmount"]
  };
}

// src/generated/models/GetProductsUsageReportResponse.ts
function GetProductsUsageReportResponseFromJSON(json) {
  return GetProductsUsageReportResponseFromJSONTyped(json, false);
}
function GetProductsUsageReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": json["report"].map(GetProductsUsageReportResponseReportInnerFromJSON),
    "creationDate": new Date(json["creationDate"]),
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"])
  };
}

// src/generated/models/PublicApiKeySummary.ts
function PublicApiKeySummaryFromJSON(json) {
  return PublicApiKeySummaryFromJSONTyped(json, false);
}
function PublicApiKeySummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "prefix": json["prefix"],
    "createdAt": json["createdAt"]
  };
}

// src/generated/models/GetPublicApiKeysResponse.ts
function GetPublicApiKeysResponseFromJSON(json) {
  return GetPublicApiKeysResponseFromJSONTyped(json, false);
}
function GetPublicApiKeysResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "publicApiKeys": json["publicApiKeys"].map(PublicApiKeySummaryFromJSON)
  };
}

// src/generated/models/GetRecurringRevenueReportResponseReportInnerProductSummariesInner.ts
function GetRecurringRevenueReportResponseReportInnerProductSummariesInnerFromJSON(json) {
  return GetRecurringRevenueReportResponseReportInnerProductSummariesInnerFromJSONTyped(json, false);
}
function GetRecurringRevenueReportResponseReportInnerProductSummariesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "productId": json["productId"],
    "productName": !exists(json, "productName") ? void 0 : json["productName"],
    "currentMrrUsd": json["currentMrrUsd"],
    "totalArrUsd": json["totalArrUsd"]
  };
}

// src/generated/models/GetRecurringRevenueReportResponseReportInner.ts
function GetRecurringRevenueReportResponseReportInnerFromJSON(json) {
  return GetRecurringRevenueReportResponseReportInnerFromJSONTyped(json, false);
}
function GetRecurringRevenueReportResponseReportInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"],
    "customerId": !exists(json, "customerId") ? void 0 : json["customerId"],
    "customerName": json["customerName"],
    "subsidiaryName": !exists(json, "subsidiaryName") ? void 0 : json["subsidiaryName"],
    "parentName": json["parentName"],
    "country": !exists(json, "country") ? void 0 : json["country"],
    "state": !exists(json, "state") ? void 0 : json["state"],
    "labels": !exists(json, "labels") ? void 0 : json["labels"].map(ContractLabelsInnerFromJSON),
    "catalogProductIds": !exists(json, "catalogProductIds") ? void 0 : json["catalogProductIds"],
    "meterIds": !exists(json, "meterIds") ? void 0 : json["meterIds"],
    "contractName": json["contractName"],
    "contractStartDate": json["contractStartDate"],
    "contractEndDate": json["contractEndDate"],
    "contractStatus": ContractStatusFromJSON(json["contractStatus"]),
    "originalCurrency": json["originalCurrency"],
    "currentMrrInOriginalCurrency": json["currentMrrInOriginalCurrency"],
    "exchangeRate": json["exchangeRate"],
    "currentMrrUsd": json["currentMrrUsd"],
    "totalArrUsd": json["totalArrUsd"],
    "productSummaries": !exists(json, "productSummaries") ? void 0 : json["productSummaries"].map(GetRecurringRevenueReportResponseReportInnerProductSummariesInnerFromJSON)
  };
}

// src/generated/models/GetRecurringRevenueReportResponse.ts
function GetRecurringRevenueReportResponseFromJSON(json) {
  return GetRecurringRevenueReportResponseFromJSONTyped(json, false);
}
function GetRecurringRevenueReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": json["report"].map(GetRecurringRevenueReportResponseReportInnerFromJSON),
    "creationDate": new Date(json["creationDate"]),
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"])
  };
}

// src/generated/models/GetRecurringRevenueResponseRecurringRevenueTrendInner.ts
function GetRecurringRevenueResponseRecurringRevenueTrendInnerFromJSON(json) {
  return GetRecurringRevenueResponseRecurringRevenueTrendInnerFromJSONTyped(json, false);
}
function GetRecurringRevenueResponseRecurringRevenueTrendInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "month": new Date(json["month"]),
    "monthlyRecurringRevenue": json["monthlyRecurringRevenue"],
    "annualRecurringRevenue": json["annualRecurringRevenue"]
  };
}

// src/generated/models/GetRecurringRevenueResponse.ts
function GetRecurringRevenueResponseFromJSON(json) {
  return GetRecurringRevenueResponseFromJSONTyped(json, false);
}
function GetRecurringRevenueResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "monthlyRecurringRevenue": json["monthlyRecurringRevenue"],
    "annualRecurringRevenue": json["annualRecurringRevenue"],
    "recurringRevenueTrend": json["recurringRevenueTrend"].map(GetRecurringRevenueResponseRecurringRevenueTrendInnerFromJSON)
  };
}

// src/generated/models/GetReportsResponseInner.ts
function GetReportsResponseInnerFromJSON(json) {
  return GetReportsResponseInnerFromJSONTyped(json, false);
}
function GetReportsResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "status": json["status"],
    "reportName": !exists(json, "reportName") ? void 0 : json["reportName"],
    "type": json["type"],
    "invocationType": json["invocationType"],
    "createdAt": new Date(json["createdAt"])
  };
}

// src/generated/models/GetRevenueByCurrencyResponse.ts
function GetRevenueByCurrencyResponseFromJSON(json) {
  return GetRevenueByCurrencyResponseFromJSONTyped(json, false);
}
function GetRevenueByCurrencyResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "amountByCurrency": json["amountByCurrency"]
  };
}

// src/generated/models/StepTypeSummary.ts
function StepTypeSummaryFromJSON(json) {
  return StepTypeSummaryFromJSONTyped(json, false);
}
function StepTypeSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "description": json["description"],
    "category": json["category"]
  };
}

// src/generated/models/GetStepTypesResponse.ts
function GetStepTypesResponseFromJSON(json) {
  return GetStepTypesResponseFromJSONTyped(json, false);
}
function GetStepTypesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "stepTypes": json["stepTypes"].map(StepTypeSummaryFromJSON)
  };
}

// src/generated/models/GetSubsidiariesResponse.ts
function GetSubsidiariesResponseFromJSON(json) {
  return GetSubsidiariesResponseFromJSONTyped(json, false);
}
function GetSubsidiariesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "subsidiaries": json["subsidiaries"].map(SubsidiaryFromJSON)
  };
}

// src/generated/models/GetTopOverdueCustomersResponseCustomersInner.ts
function GetTopOverdueCustomersResponseCustomersInnerFromJSON(json) {
  return GetTopOverdueCustomersResponseCustomersInnerFromJSONTyped(json, false);
}
function GetTopOverdueCustomersResponseCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "currentRevenue": json["currentRevenue"],
    "previousRevenue": json["previousRevenue"]
  };
}

// src/generated/models/GetTopOverdueCustomersResponse.ts
function GetTopOverdueCustomersResponseFromJSON(json) {
  return GetTopOverdueCustomersResponseFromJSONTyped(json, false);
}
function GetTopOverdueCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(GetTopOverdueCustomersResponseCustomersInnerFromJSON)
  };
}

// src/generated/models/UnchargedUsageReportResponseSchemaInnerPeriod.ts
function UnchargedUsageReportResponseSchemaInnerPeriodFromJSON(json) {
  return UnchargedUsageReportResponseSchemaInnerPeriodFromJSONTyped(json, false);
}
function UnchargedUsageReportResponseSchemaInnerPeriodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startTime": new Date(json["startTime"]),
    "endTime": new Date(json["endTime"])
  };
}

// src/generated/models/UnchargedUsageReportResponseSchemaInner.ts
function UnchargedUsageReportResponseSchemaInnerFromJSON(json) {
  return UnchargedUsageReportResponseSchemaInnerFromJSONTyped(json, false);
}
function UnchargedUsageReportResponseSchemaInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "measurementId": json["measurementId"],
    "customerId": json["customerId"],
    "meterId": json["meterId"],
    "contractId": !exists(json, "contractId") ? void 0 : json["contractId"],
    "meterName": json["meterName"],
    "customerName": json["customerName"],
    "period": UnchargedUsageReportResponseSchemaInnerPeriodFromJSON(json["period"]),
    "value": json["value"],
    "reason": json["reason"]
  };
}

// src/generated/models/GetUnchargedUsageReportResponse.ts
function GetUnchargedUsageReportResponseFromJSON(json) {
  return GetUnchargedUsageReportResponseFromJSONTyped(json, false);
}
function GetUnchargedUsageReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "report": json["report"].map(UnchargedUsageReportResponseSchemaInnerFromJSON),
    "creationDate": new Date(json["creationDate"]),
    "startDate": !exists(json, "startDate") ? void 0 : new Date(json["startDate"]),
    "endDate": !exists(json, "endDate") ? void 0 : new Date(json["endDate"])
  };
}

// src/generated/models/GetUnmeteredEventsReportResponseDisconnectedMetersInner.ts
function GetUnmeteredEventsReportResponseDisconnectedMetersInnerFromJSON(json) {
  return GetUnmeteredEventsReportResponseDisconnectedMetersInnerFromJSONTyped(json, false);
}
function GetUnmeteredEventsReportResponseDisconnectedMetersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "meterName": json["meterName"],
    "eventName": json["eventName"],
    "breakpoint": json["breakpoint"]
  };
}

// src/generated/models/GetUnmeteredEventsReportResponseReportItemsInner.ts
function GetUnmeteredEventsReportResponseReportItemsInnerFromJSON(json) {
  return GetUnmeteredEventsReportResponseReportItemsInnerFromJSONTyped(json, false);
}
function GetUnmeteredEventsReportResponseReportItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customerAlias": json["customerAlias"],
    "eventName": json["eventName"],
    "eventCount": json["eventCount"],
    "filterFields": json["filterFields"],
    "lastRawData": json["lastRawData"],
    "reason": json["reason"]
  };
}

// src/generated/models/GetUnmeteredEventsReportResponse.ts
function GetUnmeteredEventsReportResponseFromJSON(json) {
  return GetUnmeteredEventsReportResponseFromJSONTyped(json, false);
}
function GetUnmeteredEventsReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "reportItems": json["reportItems"].map(GetUnmeteredEventsReportResponseReportItemsInnerFromJSON),
    "filterFieldNames": json["filterFieldNames"],
    "disconnectedMeters": json["disconnectedMeters"].map(GetUnmeteredEventsReportResponseDisconnectedMetersInnerFromJSON)
  };
}

// src/generated/models/GetUpcomingInvoicesReportResponseReportItemsInnerContract.ts
function GetUpcomingInvoicesReportResponseReportItemsInnerContractFromJSON(json) {
  return GetUpcomingInvoicesReportResponseReportItemsInnerContractFromJSONTyped(json, false);
}
function GetUpcomingInvoicesReportResponseReportItemsInnerContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "status": ContractStatusFromJSON(json["status"])
  };
}

// src/generated/models/GetUpcomingInvoicesReportResponseReportItemsInnerInvoicesInner.ts
function GetUpcomingInvoicesReportResponseReportItemsInnerInvoicesInnerFromJSON(json) {
  return GetUpcomingInvoicesReportResponseReportItemsInnerInvoicesInnerFromJSONTyped(json, false);
}
function GetUpcomingInvoicesReportResponseReportItemsInnerInvoicesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "reviewStatus": InvoiceReviewStatusFromJSON(json["reviewStatus"]),
    "billingStatus": InvoiceBillingStatusFromJSON(json["billingStatus"]),
    "total": json["total"],
    "issuedAt": !exists(json, "issuedAt") ? void 0 : new Date(json["issuedAt"]),
    "dueAt": !exists(json, "dueAt") ? void 0 : new Date(json["dueAt"]),
    "invoicingDate": new Date(json["invoicingDate"]),
    "period": PeriodFromJSON(json["period"])
  };
}

// src/generated/models/GetUpcomingInvoicesReportResponseReportItemsInnerRevenue.ts
function GetUpcomingInvoicesReportResponseReportItemsInnerRevenueFromJSON(json) {
  return GetUpcomingInvoicesReportResponseReportItemsInnerRevenueFromJSONTyped(json, false);
}
function GetUpcomingInvoicesReportResponseReportItemsInnerRevenueFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "total": json["total"],
    "monthlyTotals": json["monthlyTotals"],
    "currency": CurrencyFromJSON(json["currency"])
  };
}

// src/generated/models/GetUpcomingInvoicesReportResponseReportItemsInner.ts
function GetUpcomingInvoicesReportResponseReportItemsInnerFromJSON(json) {
  return GetUpcomingInvoicesReportResponseReportItemsInnerFromJSONTyped(json, false);
}
function GetUpcomingInvoicesReportResponseReportItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startDate": new Date(json["startDate"]),
    "invoices": json["invoices"].map(GetUpcomingInvoicesReportResponseReportItemsInnerInvoicesInnerFromJSON),
    "contract": GetUpcomingInvoicesReportResponseReportItemsInnerContractFromJSON(json["contract"]),
    "revenue": GetUpcomingInvoicesReportResponseReportItemsInnerRevenueFromJSON(json["revenue"]),
    "customer": BillingCycleCustomersInnerFromJSON(json["customer"])
  };
}

// src/generated/models/GetUpcomingInvoicesReportResponse.ts
function GetUpcomingInvoicesReportResponseFromJSON(json) {
  return GetUpcomingInvoicesReportResponseFromJSONTyped(json, false);
}
function GetUpcomingInvoicesReportResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "reportDate": new Date(json["reportDate"]),
    "reportItems": json["reportItems"].map(GetUpcomingInvoicesReportResponseReportItemsInnerFromJSON)
  };
}

// src/generated/models/UsageByProductSchema.ts
function UsageByProductSchemaFromJSON(json) {
  return UsageByProductSchemaFromJSONTyped(json, false);
}
function UsageByProductSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "usageAmount": json["usageAmount"],
    "meterName": json["meterName"],
    "meterId": json["meterId"]
  };
}

// src/generated/models/GetUsageByMeterResponse.ts
function GetUsageByMeterResponseFromJSON(json) {
  return GetUsageByMeterResponseFromJSONTyped(json, false);
}
function GetUsageByMeterResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "usageByMeter": json["usageByMeter"].map(UsageByProductSchemaFromJSON)
  };
}

// src/generated/models/GetUsageEventsReportConfigurationResponse.ts
function GetUsageEventsReportConfigurationResponseFromJSON(json) {
  return GetUsageEventsReportConfigurationResponseFromJSONTyped(json, false);
}
function GetUsageEventsReportConfigurationResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "configured": json["configured"]
  };
}

// src/generated/models/GetUsageReportV2ResponseReportItemsInnerContract.ts
function GetUsageReportV2ResponseReportItemsInnerContractFromJSON(json) {
  return GetUsageReportV2ResponseReportItemsInnerContractFromJSONTyped(json, false);
}
function GetUsageReportV2ResponseReportItemsInnerContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "startDate": json["startDate"],
    "endDate": !exists(json, "endDate") ? void 0 : json["endDate"],
    "status": json["status"],
    "durationMonths": !exists(json, "durationMonths") ? void 0 : json["durationMonths"],
    "daysToEnd": !exists(json, "daysToEnd") ? void 0 : json["daysToEnd"]
  };
}

// src/generated/models/GetUsageReportV2ResponseReportItemsInnerPeriod.ts
function GetUsageReportV2ResponseReportItemsInnerPeriodFromJSON(json) {
  return GetUsageReportV2ResponseReportItemsInnerPeriodFromJSONTyped(json, false);
}
function GetUsageReportV2ResponseReportItemsInnerPeriodFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "startTime": json["startTime"],
    "endTime": json["endTime"]
  };
}

// src/generated/models/GetUsageReportV2ResponseReportItemsInnerProduct.ts
function GetUsageReportV2ResponseReportItemsInnerProductFromJSON(json) {
  return GetUsageReportV2ResponseReportItemsInnerProductFromJSONTyped(json, false);
}
function GetUsageReportV2ResponseReportItemsInnerProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "productGroupName": !exists(json, "productGroupName") ? void 0 : json["productGroupName"],
    "pricingModel": json["pricingModel"],
    "chargingCadenceMonths": !exists(json, "chargingCadenceMonths") ? void 0 : json["chargingCadenceMonths"],
    "billingIntervalMonths": !exists(json, "billingIntervalMonths") ? void 0 : json["billingIntervalMonths"],
    "commitmentUnits": !exists(json, "commitmentUnits") ? void 0 : json["commitmentUnits"],
    "accumulationIntervalMonths": !exists(json, "accumulationIntervalMonths") ? void 0 : json["accumulationIntervalMonths"]
  };
}

// src/generated/models/GetUsageReportV2ResponseReportItemsInnerTier.ts
function GetUsageReportV2ResponseReportItemsInnerTierFromJSON(json) {
  return GetUsageReportV2ResponseReportItemsInnerTierFromJSONTyped(json, false);
}
function GetUsageReportV2ResponseReportItemsInnerTierFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "index": json["index"],
    "from": !exists(json, "from") ? void 0 : json["from"],
    "to": !exists(json, "to") ? void 0 : json["to"],
    "isLast": json["isLast"],
    "bulkAmount": !exists(json, "bulkAmount") ? void 0 : json["bulkAmount"]
  };
}

// src/generated/models/GetUsageReportV2ResponseReportItemsInner.ts
function GetUsageReportV2ResponseReportItemsInnerFromJSON(json) {
  return GetUsageReportV2ResponseReportItemsInnerFromJSONTyped(json, false);
}
function GetUsageReportV2ResponseReportItemsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": GetUsageReportV2ResponseReportItemsInnerCustomerFromJSON(json["customer"]),
    "customerCustomFieldValues": !exists(json, "customerCustomFieldValues") ? void 0 : json["customerCustomFieldValues"],
    "contract": GetUsageReportV2ResponseReportItemsInnerContractFromJSON(json["contract"]),
    "contractCustomFieldValues": !exists(json, "contractCustomFieldValues") ? void 0 : json["contractCustomFieldValues"],
    "product": GetUsageReportV2ResponseReportItemsInnerProductFromJSON(json["product"]),
    "tier": GetUsageReportV2ResponseReportItemsInnerTierFromJSON(json["tier"]),
    "period": GetUsageReportV2ResponseReportItemsInnerPeriodFromJSON(json["period"]),
    "totalConsumed": json["totalConsumed"]
  };
}

// src/generated/models/GetUsageReportV2Response.ts
function GetUsageReportV2ResponseFromJSON(json) {
  return GetUsageReportV2ResponseFromJSONTyped(json, false);
}
function GetUsageReportV2ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "reportItems": json["reportItems"].map(GetUsageReportV2ResponseReportItemsInnerFromJSON),
    "customerCustomFieldNames": json["customerCustomFieldNames"].map(BillingCycleCustomersInnerFromJSON),
    "contractCustomFieldNames": json["contractCustomFieldNames"].map(BillingCycleCustomersInnerFromJSON),
    "reportGeneratedAt": json["reportGeneratedAt"]
  };
}

// src/generated/models/User.ts
function UserFromJSON(json) {
  return UserFromJSONTyped(json, false);
}
function UserFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "email": json["email"],
    "firstName": !exists(json, "firstName") ? void 0 : json["firstName"],
    "lastName": !exists(json, "lastName") ? void 0 : json["lastName"],
    "role": RoleFromJSON(json["role"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"]
  };
}

// src/generated/models/GetUsersResponse.ts
function GetUsersResponseFromJSON(json) {
  return GetUsersResponseFromJSONTyped(json, false);
}
function GetUsersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "users": json["users"].map(UserFromJSON)
  };
}

// src/generated/models/WebhookSubscriptionSummary.ts
function WebhookSubscriptionSummaryFromJSON(json) {
  return WebhookSubscriptionSummaryFromJSONTyped(json, false);
}
function WebhookSubscriptionSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "eventType": NotificationEventTypeFromJSON(json["eventType"]),
    "callbackUrl": json["callbackUrl"],
    "threshold": !exists(json, "threshold") ? void 0 : json["threshold"],
    "createdAt": json["createdAt"]
  };
}

// src/generated/models/GetWebhookSubscriptionsResponse.ts
function GetWebhookSubscriptionsResponseFromJSON(json) {
  return GetWebhookSubscriptionsResponseFromJSONTyped(json, false);
}
function GetWebhookSubscriptionsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "webhookSubscriptions": json["webhookSubscriptions"].map(WebhookSubscriptionSummaryFromJSON)
  };
}

// src/generated/models/GetWorkflowExecutionResponse.ts
function GetWorkflowExecutionResponseFromJSON(json) {
  return GetWorkflowExecutionResponseFromJSONTyped(json, false);
}
function GetWorkflowExecutionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "execution": WorkflowExecutionFromJSON(json["execution"])
  };
}

// src/generated/models/WorkflowExecutionSummary.ts
function WorkflowExecutionSummaryFromJSON(json) {
  return WorkflowExecutionSummaryFromJSONTyped(json, false);
}
function WorkflowExecutionSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "workflowId": json["workflowId"],
    "definitionId": json["definitionId"],
    "status": json["status"],
    "trigger": WorkflowExecutionSummaryTriggerFromJSON(json["trigger"]),
    "userMessage": !exists(json, "userMessage") ? void 0 : json["userMessage"],
    "startedAt": !exists(json, "startedAt") ? void 0 : json["startedAt"],
    "completedAt": !exists(json, "completedAt") ? void 0 : json["completedAt"],
    "attempts": json["attempts"],
    "createdAt": json["createdAt"]
  };
}

// src/generated/models/GetWorkflowExecutionsResponse.ts
function GetWorkflowExecutionsResponseFromJSON(json) {
  return GetWorkflowExecutionsResponseFromJSONTyped(json, false);
}
function GetWorkflowExecutionsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "executions": json["executions"].map(WorkflowExecutionSummaryFromJSON)
  };
}

// src/generated/models/GetWorkflowResponse.ts
function GetWorkflowResponseFromJSON(json) {
  return GetWorkflowResponseFromJSONTyped(json, false);
}
function GetWorkflowResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workflow": WorkflowFromJSON(json["workflow"])
  };
}

// src/generated/models/WorkflowStarterAvailableAction.ts
function WorkflowStarterAvailableActionFromJSON(json) {
  return WorkflowStarterAvailableActionFromJSONTyped(json, false);
}
function WorkflowStarterAvailableActionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "description": json["description"],
    "category": json["category"]
  };
}

// src/generated/models/WorkflowStarterParameterOneOf.ts
function WorkflowStarterParameterOneOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "description": json["description"],
    "type": json["type"],
    "defaultValue": json["defaultValue"],
    "min": !exists(json, "min") ? void 0 : json["min"],
    "max": !exists(json, "max") ? void 0 : json["max"]
  };
}

// src/generated/models/WorkflowStarterParameterOneOf1.ts
function WorkflowStarterParameterOneOf1FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "description": json["description"],
    "type": json["type"],
    "defaultValue": json["defaultValue"]
  };
}

// src/generated/models/WorkflowStarterParameterOneOf2.ts
function WorkflowStarterParameterOneOf2FromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "description": json["description"],
    "type": json["type"],
    "defaultValue": json["defaultValue"]
  };
}

// src/generated/models/WorkflowStarterParameter.ts
function WorkflowStarterParameterFromJSON(json) {
  return WorkflowStarterParameterFromJSONTyped(json, false);
}
function WorkflowStarterParameterFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...WorkflowStarterParameterOneOfFromJSONTyped(json, true), ...WorkflowStarterParameterOneOf1FromJSONTyped(json, true), ...WorkflowStarterParameterOneOf2FromJSONTyped(json, true) };
}

// src/generated/models/WorkflowStarterSummaryTriggerOneOf.ts
function WorkflowStarterSummaryTriggerOneOfFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "type": json["type"],
    "defaultSchedule": json["defaultSchedule"],
    "configurableSchedule": !exists(json, "configurableSchedule") ? void 0 : json["configurableSchedule"]
  };
}

// src/generated/models/WorkflowStarterSummaryTrigger.ts
function WorkflowStarterSummaryTriggerFromJSON(json) {
  return WorkflowStarterSummaryTriggerFromJSONTyped(json, false);
}
function WorkflowStarterSummaryTriggerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return { ...WorkflowStarterSummaryTriggerOneOfFromJSONTyped(json, true), ...WorkflowStarterSummaryTriggerOneOf1FromJSONTyped(json, true), ...WorkflowStarterSummaryTriggerOneOf2FromJSONTyped(json, true) };
}

// src/generated/models/WorkflowStarter.ts
function WorkflowStarterFromJSON(json) {
  return WorkflowStarterFromJSONTyped(json, false);
}
function WorkflowStarterFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "description": json["description"],
    "category": json["category"],
    "trigger": WorkflowStarterSummaryTriggerFromJSON(json["trigger"]),
    "availableActions": !exists(json, "availableActions") ? void 0 : json["availableActions"].map(WorkflowStarterAvailableActionFromJSON),
    "parameters": !exists(json, "parameters") ? void 0 : json["parameters"].map(WorkflowStarterParameterFromJSON),
    "graph": WorkflowStarterAllOfGraphFromJSON(json["graph"])
  };
}

// src/generated/models/GetWorkflowStarterResponse.ts
function GetWorkflowStarterResponseFromJSON(json) {
  return GetWorkflowStarterResponseFromJSONTyped(json, false);
}
function GetWorkflowStarterResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "starter": WorkflowStarterFromJSON(json["starter"])
  };
}

// src/generated/models/WorkflowStarterSummary.ts
function WorkflowStarterSummaryFromJSON(json) {
  return WorkflowStarterSummaryFromJSONTyped(json, false);
}
function WorkflowStarterSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "description": json["description"],
    "category": json["category"],
    "trigger": WorkflowStarterSummaryTriggerFromJSON(json["trigger"]),
    "availableActions": !exists(json, "availableActions") ? void 0 : json["availableActions"].map(WorkflowStarterAvailableActionFromJSON),
    "parameters": !exists(json, "parameters") ? void 0 : json["parameters"].map(WorkflowStarterParameterFromJSON)
  };
}

// src/generated/models/GetWorkflowStartersResponse.ts
function GetWorkflowStartersResponseFromJSON(json) {
  return GetWorkflowStartersResponseFromJSONTyped(json, false);
}
function GetWorkflowStartersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "starters": json["starters"].map(WorkflowStarterSummaryFromJSON)
  };
}

// src/generated/models/WorkflowSummary.ts
function WorkflowSummaryFromJSON(json) {
  return WorkflowSummaryFromJSONTyped(json, false);
}
function WorkflowSummaryFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "definitionId": json["definitionId"],
    "version": json["version"],
    "status": json["status"],
    "name": json["name"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "starterTemplateId": !exists(json, "starterTemplateId") ? void 0 : json["starterTemplateId"],
    "trigger": WorkflowSummaryTriggerFromJSON(json["trigger"]),
    "createdAt": json["createdAt"],
    "updatedAt": json["updatedAt"],
    "lastExecutionAt": !exists(json, "lastExecutionAt") ? void 0 : json["lastExecutionAt"],
    "lastExecutionStatus": !exists(json, "lastExecutionStatus") ? void 0 : json["lastExecutionStatus"]
  };
}

// src/generated/models/GetWorkflowVersionsResponse.ts
function GetWorkflowVersionsResponseFromJSON(json) {
  return GetWorkflowVersionsResponseFromJSONTyped(json, false);
}
function GetWorkflowVersionsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "versions": json["versions"].map(WorkflowSummaryFromJSON)
  };
}

// src/generated/models/GetWorkflowsResponse.ts
function GetWorkflowsResponseFromJSON(json) {
  return GetWorkflowsResponseFromJSONTyped(json, false);
}
function GetWorkflowsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workflows": json["workflows"].map(WorkflowSummaryFromJSON)
  };
}

// src/generated/models/GetYtdBilledRevenueResponse.ts
function GetYtdBilledRevenueResponseFromJSON(json) {
  return GetYtdBilledRevenueResponseFromJSONTyped(json, false);
}
function GetYtdBilledRevenueResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "ytdBilledRevenue": json["ytdBilledRevenue"]
  };
}

// src/generated/models/GetYtdRevenueTaxResponse.ts
function GetYtdRevenueTaxResponseFromJSON(json) {
  return GetYtdRevenueTaxResponseFromJSONTyped(json, false);
}
function GetYtdRevenueTaxResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "ytdRevenueTax": json["ytdRevenueTax"]
  };
}

// src/generated/models/HubspotAuthConnectResponse.ts
function HubspotAuthConnectResponseFromJSON(json) {
  return HubspotAuthConnectResponseFromJSONTyped(json, false);
}
function HubspotAuthConnectResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "redirectUrl": json["redirectUrl"]
  };
}

// src/generated/models/InviteUserRequest.ts
function InviteUserRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "username": value.username,
    "role": RoleToJSON(value.role),
    "invitedBy": value.invitedBy,
    "firstName": value.firstName,
    "lastName": value.lastName
  };
}

// src/generated/models/IssueCreditNoteRequest.ts
function IssueCreditNoteRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "date": value.date.toISOString(),
    "amount": value.amount,
    "invoiceId": value.invoiceId,
    "erpId": value.erpId,
    "contractId": value.contractId
  };
}

// src/generated/models/IssueCreditNoteResponse.ts
function IssueCreditNoteResponseFromJSON(json) {
  return IssueCreditNoteResponseFromJSONTyped(json, false);
}
function IssueCreditNoteResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditLedger": !exists(json, "creditLedger") ? void 0 : GetCreditLedgerOverviewResponseCreditLedgerFromJSON(json["creditLedger"])
  };
}

// src/generated/models/LineItemInput.ts
function LineItemInputToJSON(value) {
  return value;
}

// src/generated/models/ListContractCreditPoolsResponse.ts
function ListContractCreditPoolsResponseFromJSON(json) {
  return ListContractCreditPoolsResponseFromJSONTyped(json, false);
}
function ListContractCreditPoolsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditPools": json["creditPools"].map(CreditPoolWithUnitsFromJSON)
  };
}

// src/generated/models/ListCreditPoolsResponse.ts
function ListCreditPoolsResponseFromJSON(json) {
  return ListCreditPoolsResponseFromJSONTyped(json, false);
}
function ListCreditPoolsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditPools": json["creditPools"].map(CreditPoolFromJSON)
  };
}

// src/generated/models/ListCreditTypesResponse.ts
function ListCreditTypesResponseFromJSON(json) {
  return ListCreditTypesResponseFromJSONTyped(json, false);
}
function ListCreditTypesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditTypes": json["creditTypes"].map(CreditTypeFromJSON)
  };
}

// src/generated/models/ListCustomerNotesResponseNotesInner.ts
function ListCustomerNotesResponseNotesInnerFromJSON(json) {
  return ListCustomerNotesResponseNotesInnerFromJSONTyped(json, false);
}
function ListCustomerNotesResponseNotesInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "content": json["content"],
    "authorId": json["authorId"],
    "userEmail": json["userEmail"],
    "authorFirstName": !exists(json, "authorFirstName") ? void 0 : json["authorFirstName"],
    "authorLastName": !exists(json, "authorLastName") ? void 0 : json["authorLastName"],
    "createdAt": json["createdAt"],
    "updatedAt": !exists(json, "updatedAt") ? void 0 : json["updatedAt"]
  };
}

// src/generated/models/ListCustomerNotesResponse.ts
function ListCustomerNotesResponseFromJSON(json) {
  return ListCustomerNotesResponseFromJSONTyped(json, false);
}
function ListCustomerNotesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "notes": json["notes"].map(ListCustomerNotesResponseNotesInnerFromJSON)
  };
}

// src/generated/models/ListJobTasksResponseInner.ts
function ListJobTasksResponseInnerFromJSON(json) {
  return ListJobTasksResponseInnerFromJSONTyped(json, false);
}
function ListJobTasksResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "jobId": json["jobId"],
    "type": json["type"],
    "status": json["status"],
    "metadata": json["metadata"],
    "result": !exists(json, "result") ? void 0 : json["result"],
    "errorMessage": !exists(json, "errorMessage") ? void 0 : json["errorMessage"],
    "startedAt": !exists(json, "startedAt") ? void 0 : new Date(json["startedAt"]),
    "completedAt": !exists(json, "completedAt") ? void 0 : new Date(json["completedAt"])
  };
}

// src/generated/models/ListJobsResponseInnerNotification.ts
function ListJobsResponseInnerNotificationFromJSON(json) {
  return ListJobsResponseInnerNotificationFromJSONTyped(json, false);
}
function ListJobsResponseInnerNotificationFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"],
    "userId": !exists(json, "userId") ? void 0 : json["userId"],
    "jobId": json["jobId"],
    "title": json["title"],
    "description": !exists(json, "description") ? void 0 : json["description"],
    "readAt": !exists(json, "readAt") ? void 0 : new Date(json["readAt"]),
    "metadata": json["metadata"],
    "dismissedAt": !exists(json, "dismissedAt") ? void 0 : new Date(json["dismissedAt"])
  };
}

// src/generated/models/ListJobsResponseInnerTasksInner.ts
function ListJobsResponseInnerTasksInnerFromJSON(json) {
  return ListJobsResponseInnerTasksInnerFromJSONTyped(json, false);
}
function ListJobsResponseInnerTasksInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "jobId": json["jobId"],
    "status": json["status"],
    "metadata": json["metadata"],
    "result": !exists(json, "result") ? void 0 : json["result"],
    "errorMessage": !exists(json, "errorMessage") ? void 0 : json["errorMessage"],
    "startedAt": !exists(json, "startedAt") ? void 0 : new Date(json["startedAt"]),
    "completedAt": !exists(json, "completedAt") ? void 0 : new Date(json["completedAt"])
  };
}

// src/generated/models/ListJobsResponseInner.ts
function ListJobsResponseInnerFromJSON(json) {
  return ListJobsResponseInnerFromJSONTyped(json, false);
}
function ListJobsResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"]),
    "accountId": json["accountId"],
    "userId": !exists(json, "userId") ? void 0 : json["userId"],
    "type": json["type"],
    "tasks": json["tasks"].map(ListJobsResponseInnerTasksInnerFromJSON),
    "status": json["status"],
    "progress": json["progress"],
    "startedAt": !exists(json, "startedAt") ? void 0 : new Date(json["startedAt"]),
    "completedAt": !exists(json, "completedAt") ? void 0 : new Date(json["completedAt"]),
    "hasErrors": json["hasErrors"],
    "errorCount": json["errorCount"],
    "totalTasks": json["totalTasks"],
    "completedTasks": json["completedTasks"],
    "notification": !exists(json, "notification") ? void 0 : ListJobsResponseInnerNotificationFromJSON(json["notification"])
  };
}

// src/generated/models/LoginRequest.ts
function LoginRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "username": value.username,
    "password": value.password
  };
}

// src/generated/models/LoginResponse.ts
function LoginResponseFromJSON(json) {
  return LoginResponseFromJSONTyped(json, false);
}
function LoginResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"],
    "user": UserFromJSON(json["user"])
  };
}

// src/generated/models/MeasurementDeleteResponse.ts
function MeasurementDeleteResponseFromJSON(json) {
  return MeasurementDeleteResponseFromJSONTyped(json, false);
}
function MeasurementDeleteResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "period": FullDayPeriodFromJSON(json["period"]),
    "meterId": json["meterId"],
    "customerId": json["customerId"],
    "value": json["value"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "measurementPriceId": !exists(json, "measurementPriceId") ? void 0 : json["measurementPriceId"],
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "measurementTimeSlot": !exists(json, "measurementTimeSlot") ? void 0 : MeasurementMeasurementTimeSlotFromJSON(json["measurementTimeSlot"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/MeasurementRow.ts
function MeasurementRowToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "date": value.date,
    "customer": value.customer,
    "meter": value.meter,
    "value": value.value
  };
}

// src/generated/models/MergingMeasurement.ts
function MergingMeasurementFromJSON(json) {
  return MergingMeasurementFromJSONTyped(json, false);
}
function MergingMeasurementFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": json["customer"],
    "meter": json["meter"],
    "date": json["date"]
  };
}

// src/generated/models/MeterDeleteResponse.ts
function MeterDeleteResponseFromJSON(json) {
  return MeterDeleteResponseFromJSONTyped(json, false);
}
function MeterDeleteResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "meterId": json["meterId"]
  };
}

// src/generated/models/MigrateToAutomaticTaxRequest.ts
function MigrateToAutomaticTaxRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "scope": value.scope
  };
}

// src/generated/models/MigrateToAutomaticTaxResponse.ts
function MigrateToAutomaticTaxResponseFromJSON(json) {
  return MigrateToAutomaticTaxResponseFromJSONTyped(json, false);
}
function MigrateToAutomaticTaxResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "migratedCount": json["migratedCount"]
  };
}

// src/generated/models/ModifyCustomerNoteRequest.ts
function ModifyCustomerNoteRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "content": value.content
  };
}

// src/generated/models/ModifyCustomerNoteResponse.ts
function ModifyCustomerNoteResponseFromJSON(json) {
  return ModifyCustomerNoteResponseFromJSONTyped(json, false);
}
function ModifyCustomerNoteResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "content": json["content"],
    "updatedAt": json["updatedAt"]
  };
}

// src/generated/models/ModifyWorkflowRequest.ts
function ModifyWorkflowRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "trigger": WorkflowSummaryTriggerToJSON(value.trigger),
    "graph": CreateWorkflowRequestGraphToJSON(value.graph)
  };
}

// src/generated/models/ModifyWorkflowResponse.ts
function ModifyWorkflowResponseFromJSON(json) {
  return ModifyWorkflowResponseFromJSONTyped(json, false);
}
function ModifyWorkflowResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workflow": WorkflowFromJSON(json["workflow"])
  };
}

// src/generated/models/MorningConnectRequest.ts
function MorningConnectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "apiKey": value.apiKey,
    "secretId": value.secretId
  };
}

// src/generated/models/MorningExportInvoicesRequest.ts
function MorningExportInvoicesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceIds": value.invoiceIds
  };
}

// src/generated/models/MorningGetCustomersResponse.ts
function MorningGetCustomersResponseFromJSON(json) {
  return MorningGetCustomersResponseFromJSONTyped(json, false);
}
function MorningGetCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(BillingCycleCustomersInnerFromJSON)
  };
}

// src/generated/models/NetSuiteConnectRequest.ts
function NetSuiteConnectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accountRealm": value.accountRealm,
    "certificateId": value.certificateId,
    "clientId": value.clientId,
    "clientSecret": value.clientSecret,
    "tokenId": value.tokenId,
    "tokenSecret": value.tokenSecret
  };
}

// src/generated/models/NetSuiteExportCreditMemoRequest.ts
function NetSuiteExportCreditMemoRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "creditLedgerEntryId": value.creditLedgerEntryId
  };
}

// src/generated/models/NetSuiteExportSalesOrderRequest.ts
function NetSuiteExportSalesOrderRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contractId": value.contractId,
    "productsIds": value.productsIds,
    "subsidiaryId": value.subsidiaryId,
    "memo": value.memo
  };
}

// src/generated/models/NetSuiteGetClassesResponse.ts
function NetSuiteGetClassesResponseFromJSON(json) {
  return NetSuiteGetClassesResponseFromJSONTyped(json, false);
}
function NetSuiteGetClassesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "classes": json["classes"].map(BillingCycleCustomersInnerFromJSON)
  };
}

// src/generated/models/NetSuiteGetCustomerResponse.ts
function NetSuiteGetCustomerResponseFromJSON(json) {
  return NetSuiteGetCustomerResponseFromJSONTyped(json, false);
}
function NetSuiteGetCustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "entityId": json["entityId"],
    "companyName": json["companyName"],
    "aliasName": json["aliasName"],
    "custentityVayuEntityId": !exists(json, "custentity_vayu_entity_id") ? void 0 : json["custentity_vayu_entity_id"]
  };
}

// src/generated/models/NetSuiteGetCustomersResponseCustomersInner.ts
function NetSuiteGetCustomersResponseCustomersInnerFromJSON(json) {
  return NetSuiteGetCustomersResponseCustomersInnerFromJSONTyped(json, false);
}
function NetSuiteGetCustomersResponseCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "entityId": json["entityId"],
    "companyName": json["companyName"],
    "aliasName": json["aliasName"],
    "custentityVayuEntityId": !exists(json, "custentity_vayu_entity_id") ? void 0 : json["custentity_vayu_entity_id"]
  };
}

// src/generated/models/NetSuiteGetCustomersResponse.ts
function NetSuiteGetCustomersResponseFromJSON(json) {
  return NetSuiteGetCustomersResponseFromJSONTyped(json, false);
}
function NetSuiteGetCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(NetSuiteGetCustomersResponseCustomersInnerFromJSON)
  };
}

// src/generated/models/NetSuiteGetDepositToAccountsResponse.ts
function NetSuiteGetDepositToAccountsResponseFromJSON(json) {
  return NetSuiteGetDepositToAccountsResponseFromJSONTyped(json, false);
}
function NetSuiteGetDepositToAccountsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "depositToAccounts": json["depositToAccounts"].map(BillingCycleCustomersInnerFromJSON)
  };
}

// src/generated/models/NetSuiteGetInvoiceDashboardUrlResponse.ts
function NetSuiteGetInvoiceDashboardUrlResponseFromJSON(json) {
  return NetSuiteGetInvoiceDashboardUrlResponseFromJSONTyped(json, false);
}
function NetSuiteGetInvoiceDashboardUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "url": json["url"]
  };
}

// src/generated/models/NetSuiteGetProductsResponseProductsInner.ts
function NetSuiteGetProductsResponseProductsInnerFromJSON(json) {
  return NetSuiteGetProductsResponseProductsInnerFromJSONTyped(json, false);
}
function NetSuiteGetProductsResponseProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "subsidiary": !exists(json, "subsidiary") ? void 0 : json["subsidiary"]
  };
}

// src/generated/models/NetSuiteGetProductsResponse.ts
function NetSuiteGetProductsResponseFromJSON(json) {
  return NetSuiteGetProductsResponseFromJSONTyped(json, false);
}
function NetSuiteGetProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "products": json["products"].map(NetSuiteGetProductsResponseProductsInnerFromJSON)
  };
}

// src/generated/models/NetSuiteSyncInvoicesRequest.ts
function NetSuiteSyncInvoicesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoicesIds": value.invoicesIds
  };
}

// src/generated/models/NetSuiteSyncInvoicesSalesOrderRequest.ts
function NetSuiteSyncInvoicesSalesOrderRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoicesIds": value.invoicesIds
  };
}

// src/generated/models/NetSuiteUpdateSalesOrderRequest.ts
function NetSuiteUpdateSalesOrderRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "contractId": value.contractId,
    "productsIds": value.productsIds,
    "subsidiaryId": value.subsidiaryId
  };
}

// src/generated/models/NewAccount.ts
function NewAccountToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "logoUrl": value.logoUrl,
    "settings": NewAccountSettingsToJSON(value.settings),
    "contact": ContactToJSON(value.contact)
  };
}

// src/generated/models/OneTimePricingInputPriceConfiguration.ts
function OneTimePricingInputPriceConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "shouldCreateSeparateInvoice": value.shouldCreateSeparateInvoice,
    "discountConfiguration": TieredSubscriptionPricingConfigurationInputDiscountConfigurationToJSON(value.discountConfiguration)
  };
}

// src/generated/models/OneTimePricingInput.ts
function OneTimePricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": OneTimePricingInputPriceConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/PaddleConnectRequest.ts
function PaddleConnectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "apiToken": value.apiToken,
    "environment": value.environment
  };
}

// src/generated/models/PaddleExportInvoicesRequest.ts
function PaddleExportInvoicesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceIds": value.invoiceIds
  };
}

// src/generated/models/PaddleGetCustomersResponseCustomersInner.ts
function PaddleGetCustomersResponseCustomersInnerFromJSON(json) {
  return PaddleGetCustomersResponseCustomersInnerFromJSONTyped(json, false);
}
function PaddleGetCustomersResponseCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "email": !exists(json, "email") ? void 0 : json["email"]
  };
}

// src/generated/models/PaddleGetCustomersResponse.ts
function PaddleGetCustomersResponseFromJSON(json) {
  return PaddleGetCustomersResponseFromJSONTyped(json, false);
}
function PaddleGetCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(PaddleGetCustomersResponseCustomersInnerFromJSON)
  };
}

// src/generated/models/PaddleGetProductsResponse.ts
function PaddleGetProductsResponseFromJSON(json) {
  return PaddleGetProductsResponseFromJSONTyped(json, false);
}
function PaddleGetProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "products": json["products"].map(BillingCycleCustomersInnerFromJSON)
  };
}

// src/generated/models/PaddleGetTransactionUrlResponse.ts
function PaddleGetTransactionUrlResponseFromJSON(json) {
  return PaddleGetTransactionUrlResponseFromJSONTyped(json, false);
}
function PaddleGetTransactionUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "url": json["url"]
  };
}

// src/generated/models/PerUnitPricingInput.ts
function PerUnitPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": PerUnitPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/PercentageDeductionPricingInput.ts
function PercentageDeductionPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": PercentageDeductionPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/PingWebhookSubscriptionResponse.ts
function PingWebhookSubscriptionResponseFromJSON(json) {
  return PingWebhookSubscriptionResponseFromJSONTyped(json, false);
}
function PingWebhookSubscriptionResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "webhookSubscriptionId": json["webhookSubscriptionId"],
    "queuedAt": json["queuedAt"]
  };
}

// src/generated/models/RecurringPricingInputPriceConfiguration.ts
function RecurringPricingInputPriceConfigurationToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "price": value.price,
    "upfrontPay": value.upfrontPay,
    "shouldCreateSeparateInvoice": value.shouldCreateSeparateInvoice,
    "installments": value.installments,
    "seats": value.seats,
    "discountConfiguration": TieredSubscriptionPricingConfigurationInputDiscountConfigurationToJSON(value.discountConfiguration)
  };
}

// src/generated/models/RecurringPricingInput.ts
function RecurringPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": RecurringPricingInputPriceConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/RefundPricingInput.ts
function RefundPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": RefundPricingConfigurationToJSON(value.priceConfiguration)
  };
}

// src/generated/models/TieredSubscriptionPricingConfigurationInput.ts
function TieredSubscriptionPricingConfigurationInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "tiers": value.tiers.map(PriceTierToJSON),
    "maxUnits": value.maxUnits,
    "tierLock": value.tierLock,
    "discountConfiguration": TieredSubscriptionPricingConfigurationInputDiscountConfigurationToJSON(value.discountConfiguration)
  };
}

// src/generated/models/TieredSubscriptionPricingInput.ts
function TieredSubscriptionPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": TieredSubscriptionPricingConfigurationInputToJSON(value.priceConfiguration)
  };
}

// src/generated/models/TiersPricingConfigurationInput.ts
function TiersPricingConfigurationInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "tiers": value.tiers.map(PriceTierToJSON),
    "isVolume": value.isVolume,
    "isFlatRate": value.isFlatRate,
    "isChunked": value.isChunked,
    "isRevShare": value.isRevShare,
    "useInfinity": value.useInfinity,
    "tierLock": value.tierLock
  };
}

// src/generated/models/TiersPricingInput.ts
function TiersPricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "pricingModel": value.pricingModel,
    "priceConfiguration": TiersPricingConfigurationInputToJSON(value.priceConfiguration)
  };
}

// src/generated/models/PricingInput.ts
function PricingInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  switch (value["pricingModel"]) {
    case "CommercialTerms":
      return CommercialTermsPricingInputToJSON(value);
    case "Commission":
      return CommissionPricingInputToJSON(value);
    case "FixedDeduction":
      return FixedDeductionPricingInputToJSON(value);
    case "FixedOneTime":
      return OneTimePricingInputToJSON(value);
    case "PerUnit":
      return PerUnitPricingInputToJSON(value);
    case "PercentageDeduction":
      return PercentageDeductionPricingInputToJSON(value);
    case "Refund":
      return RefundPricingInputToJSON(value);
    case "Subscription":
      return RecurringPricingInputToJSON(value);
    case "TieredSubscription":
      return TieredSubscriptionPricingInputToJSON(value);
    case "Tiers":
      return TiersPricingInputToJSON(value);
    default:
      throw new Error(`No variant of PricingInput exists with 'pricingModel=${value["pricingModel"]}'`);
  }
}

// src/generated/models/ProductVariantInput.ts
function ProductVariantInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "meterId": value.meterId,
    "pricing": PricingInputToJSON(value.pricing),
    "settings": ProductSettingsToJSON(value.settings),
    "description": value.description,
    "name": value.name
  };
}

// src/generated/models/ProductInput.ts
function ProductInputToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "name": value.name,
    "description": value.description,
    "variants": value.variants.map(ProductVariantInputToJSON),
    "basePrice": value.basePrice,
    "additionalCharge": value.additionalCharge,
    "commitment": ProductConfigCommitmentToJSON(value.commitment),
    "advancePayment": AdvancePaymentToJSON(value.advancePayment),
    "chargingCadence": value.chargingCadence,
    "currencyCommitment": value.currencyCommitment,
    "paymentTerm": PaymentTermToJSON(value.paymentTerm),
    "billingInterval": BillingIntervalToJSON(value.billingInterval),
    "accumulationInterval": value.accumulationInterval,
    "proRata": value.proRata,
    "erpMetadata": ErpMetadataToJSON(value.erpMetadata),
    "rateMultiplier": value.rateMultiplier,
    "isPeriodicVariants": value.isPeriodicVariants,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "startDate": value.startDate === void 0 ? void 0 : value.startDate === null ? null : value.startDate.toISOString(),
    "endDate": value.endDate === void 0 ? void 0 : value.endDate === null ? null : value.endDate.toISOString(),
    "catalogProductId": value.catalogProductId,
    "productConfigs": value.productConfigs === void 0 ? void 0 : value.productConfigs === null ? null : value.productConfigs.map(ProductConfigToJSON),
    "externalIntegration": ProductExternalIntegrationToJSON(value.externalIntegration),
    "revisionId": value.revisionId,
    "cloudProviderSettings": ProductCloudProviderSettingsToJSON(value.cloudProviderSettings),
    "isCalendarAligned": value.isCalendarAligned,
    "upliftConfiguration": ProductUpliftConfigurationToJSON(value.upliftConfiguration),
    "creditTypeIds": value.creditTypeIds,
    "creditPurchaseConfig": CreditPurchaseConfigToJSON(value.creditPurchaseConfig)
  };
}

// src/generated/models/PublishWorkflowResponse.ts
function PublishWorkflowResponseFromJSON(json) {
  return PublishWorkflowResponseFromJSONTyped(json, false);
}
function PublishWorkflowResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "workflow": WorkflowFromJSON(json["workflow"])
  };
}

// src/generated/models/QuickBooksConnectResponse.ts
function QuickBooksConnectResponseFromJSON(json) {
  return QuickBooksConnectResponseFromJSONTyped(json, false);
}
function QuickBooksConnectResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "redirectUrl": json["redirectUrl"]
  };
}

// src/generated/models/QuickBooksExportCreditMemoRequest.ts
function QuickBooksExportCreditMemoRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "creditLedgerEntryId": value.creditLedgerEntryId
  };
}

// src/generated/models/QuickBooksExportInvoicesRequest.ts
function QuickBooksExportInvoicesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceIds": value.invoiceIds
  };
}

// src/generated/models/QuickBooksGetCustomersResponseCustomersInner.ts
function QuickBooksGetCustomersResponseCustomersInnerFromJSON(json) {
  return QuickBooksGetCustomersResponseCustomersInnerFromJSONTyped(json, false);
}
function QuickBooksGetCustomersResponseCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "companyName": !exists(json, "companyName") ? void 0 : json["companyName"],
    "displayName": !exists(json, "displayName") ? void 0 : json["displayName"],
    "isActive": !exists(json, "isActive") ? void 0 : json["isActive"]
  };
}

// src/generated/models/QuickBooksGetCustomersResponse.ts
function QuickBooksGetCustomersResponseFromJSON(json) {
  return QuickBooksGetCustomersResponseFromJSONTyped(json, false);
}
function QuickBooksGetCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(QuickBooksGetCustomersResponseCustomersInnerFromJSON)
  };
}

// src/generated/models/QuickBooksGetDepositToAccountsResponse.ts
function QuickBooksGetDepositToAccountsResponseFromJSON(json) {
  return QuickBooksGetDepositToAccountsResponseFromJSONTyped(json, false);
}
function QuickBooksGetDepositToAccountsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "depositToAccounts": json["depositToAccounts"].map(BillingCycleCustomersInnerFromJSON)
  };
}

// src/generated/models/QuickBooksGetProductsResponse.ts
function QuickBooksGetProductsResponseFromJSON(json) {
  return QuickBooksGetProductsResponseFromJSONTyped(json, false);
}
function QuickBooksGetProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "products": json["products"].map(BillingCycleCustomersInnerFromJSON)
  };
}

// src/generated/models/ReceivePaymentRequest.ts
function ReceivePaymentRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "transactionId": value.transactionId,
    "date": value.date === void 0 ? void 0 : value.date.toISOString(),
    "paymentMethod": value.paymentMethod,
    "paymentMethodId": value.paymentMethodId,
    "amount": value.amount,
    "currency": CurrencyToJSON(value.currency),
    "status": value.status,
    "note": value.note,
    "customerId": value.customerId,
    "depositTo": PaymentInfoDepositToToJSON(value.depositTo),
    "invoiceId": value.invoiceId
  };
}

// src/generated/models/RefreshTokenResponse.ts
function RefreshTokenResponseFromJSON(json) {
  return RefreshTokenResponseFromJSONTyped(json, false);
}
function RefreshTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"]
  };
}

// src/generated/models/RefundInvoiceResponse.ts
function RefundInvoiceResponseFromJSON(json) {
  return RefundInvoiceResponseFromJSONTyped(json, false);
}
function RefundInvoiceResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoice": InvoiceFromJSON(json["invoice"])
  };
}

// src/generated/models/RemoveCustomerNoteResponse.ts
function RemoveCustomerNoteResponseFromJSON(json) {
  return RemoveCustomerNoteResponseFromJSONTyped(json, false);
}
function RemoveCustomerNoteResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"]
  };
}

// src/generated/models/RenewContractRequest.ts
function RenewContractRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "startDate": value.startDate.toISOString()
  };
}

// src/generated/models/RenewContractResponse.ts
function RenewContractResponseFromJSON(json) {
  return RenewContractResponseFromJSONTyped(json, false);
}
function RenewContractResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"]
  };
}

// src/generated/models/ResetPasswordRequest.ts
function ResetPasswordRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email
  };
}

// src/generated/models/ResetPasswordResponse.ts
function ResetPasswordResponseFromJSON(json) {
  return ResetPasswordResponseFromJSONTyped(json, false);
}
function ResetPasswordResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"]
  };
}

// src/generated/models/ReviseContractRequestPhaseMetadata.ts
function ReviseContractRequestPhaseMetadataToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "label": PhaseTypeToJSON(value.label),
    "name": value.name
  };
}

// src/generated/models/ReviseContractRequest.ts
function ReviseContractRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "plan": NewPlanToJSON(value.plan),
    "startDate": value.startDate.toISOString(),
    "newContractEndDate": value.newContractEndDate === void 0 ? void 0 : value.newContractEndDate.toISOString(),
    "phaseMetadata": ReviseContractRequestPhaseMetadataToJSON(value.phaseMetadata)
  };
}

// src/generated/models/RevokeTokenRequest.ts
function RevokeTokenRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token
  };
}

// src/generated/models/SalesforceConnectRequest.ts
function SalesforceConnectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accountUrl": value.accountUrl,
    "clientId": value.clientId,
    "clientSecret": value.clientSecret
  };
}

// src/generated/models/SalesforceGetContractContractCustomFieldsResponse.ts
function SalesforceGetContractContractCustomFieldsResponseFromJSON(json) {
  return SalesforceGetContractContractCustomFieldsResponseFromJSONTyped(json, false);
}
function SalesforceGetContractContractCustomFieldsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "fields": json["fields"].map(CustomFieldFromJSON)
  };
}

// src/generated/models/SalesforceImportCustomersResponseInner.ts
function SalesforceImportCustomersResponseInnerFromJSON(json) {
  return SalesforceImportCustomersResponseInnerFromJSONTyped(json, false);
}
function SalesforceImportCustomersResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "crmId": !exists(json, "crmId") ? void 0 : json["crmId"],
    "name": json["name"]
  };
}

// src/generated/models/SandboxUserResponse.ts
function SandboxUserResponseFromJSON(json) {
  return SandboxUserResponseFromJSONTyped(json, false);
}
function SandboxUserResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"],
    "user": UserFromJSON(json["user"])
  };
}

// src/generated/models/SendGridWebhookEvent.ts
function SendGridWebhookEventToJSON(value) {
  return value;
}

// src/generated/models/SendGridEventHandlerRequestSchemaInner.ts
function SendGridEventHandlerRequestSchemaInnerToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "email": value.email,
    "timestamp": value.timestamp,
    "messageId": value.messageId,
    "event": SendGridWebhookEventToJSON(value.event),
    "sg_event_id": value.sgEventId,
    "reason": value.reason,
    "response": value.response,
    "taskId": value.taskId,
    "jobId": value.jobId
  };
}

// src/generated/models/SendGridEventHandlerResponse.ts
function SendGridEventHandlerResponseFromJSON(json) {
  return SendGridEventHandlerResponseFromJSONTyped(json, false);
}
function SendGridEventHandlerResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "response": json["response"]
  };
}

// src/generated/models/SendReminderEmailRequestSchema.ts
function SendReminderEmailRequestSchemaToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "emails": value.emails,
    "subject": value.subject,
    "content": value.content,
    "invoiceId": value.invoiceId,
    "customerId": value.customerId
  };
}

// src/generated/models/SetContractAutoRenewalRequest.ts
function SetContractAutoRenewalRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "autoRenewal": value.autoRenewal
  };
}

// src/generated/models/SetLineItemCalculationStateRequest.ts
function SetLineItemCalculationStateRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "disable": value.disable
  };
}

// src/generated/models/SetLineItemCalculationStateResponse.ts
function SetLineItemCalculationStateResponseFromJSON(json) {
  return SetLineItemCalculationStateResponseFromJSONTyped(json, false);
}
function SetLineItemCalculationStateResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "lineItemId": json["lineItemId"]
  };
}

// src/generated/models/ShareCreditNotesRequest.ts
function ShareCreditNotesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "emailOverride": value.emailOverride,
    "creditLedgerEntryId": value.creditLedgerEntryId
  };
}

// src/generated/models/ShareInvoicesRequest.ts
function ShareInvoicesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "emailOverride": value.emailOverride,
    "invoiceId": value.invoiceId
  };
}

// src/generated/models/SignupRawRequest.ts
function SignupRawRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accountId": value.accountId,
    "username": value.username,
    "password": value.password,
    "userInvitationId": value.userInvitationId
  };
}

// src/generated/models/SignupRawResponse.ts
function SignupRawResponseFromJSON(json) {
  return SignupRawResponseFromJSONTyped(json, false);
}
function SignupRawResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "token": json["token"]
  };
}

// src/generated/models/SignupRequest.ts
function SignupRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "token": value.token,
    "password": value.password
  };
}

// src/generated/models/SignupResponse.ts
function SignupResponseFromJSON(json) {
  return SignupResponseFromJSONTyped(json, false);
}
function SignupResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "requiresConfirmation": json["requiresConfirmation"]
  };
}

// src/generated/models/SlackAuthConnectRedirectResponseSchema.ts
function SlackAuthConnectRedirectResponseSchemaFromJSON(json) {
  return SlackAuthConnectRedirectResponseSchemaFromJSONTyped(json, false);
}
function SlackAuthConnectRedirectResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "redirectUrl": json["redirectUrl"]
  };
}

// src/generated/models/SlackChannelOption.ts
function SlackChannelOptionFromJSON(json) {
  return SlackChannelOptionFromJSONTyped(json, false);
}
function SlackChannelOptionFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"]
  };
}

// src/generated/models/SlackEventHandlerRequestSchema.ts
function SlackEventHandlerRequestSchemaToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "payload": value.payload
  };
}

// src/generated/models/SlackEventHandlerResponseMessage.ts
function SlackEventHandlerResponseMessageFromJSON(json) {
  return SlackEventHandlerResponseMessageFromJSONTyped(json, false);
}
function SlackEventHandlerResponseMessageFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "text": json["text"]
  };
}

// src/generated/models/SlackEventHandlerResponse.ts
function SlackEventHandlerResponseFromJSON(json) {
  return SlackEventHandlerResponseFromJSONTyped(json, false);
}
function SlackEventHandlerResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "responseAction": json["response_action"],
    "message": SlackEventHandlerResponseMessageFromJSON(json["message"])
  };
}

// src/generated/models/SlackGetChannelsResponseSchema.ts
function SlackGetChannelsResponseSchemaFromJSON(json) {
  return SlackGetChannelsResponseSchemaFromJSONTyped(json, false);
}
function SlackGetChannelsResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "channels": json["channels"].map(SlackChannelOptionFromJSON)
  };
}

// src/generated/models/SlackGetUsersResponseSchemaUsersInner.ts
function SlackGetUsersResponseSchemaUsersInnerFromJSON(json) {
  return SlackGetUsersResponseSchemaUsersInnerFromJSONTyped(json, false);
}
function SlackGetUsersResponseSchemaUsersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "teamId": json["teamId"],
    "realName": json["realName"]
  };
}

// src/generated/models/SlackGetUsersResponseSchema.ts
function SlackGetUsersResponseSchemaFromJSON(json) {
  return SlackGetUsersResponseSchemaFromJSONTyped(json, false);
}
function SlackGetUsersResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "users": json["users"].map(SlackGetUsersResponseSchemaUsersInnerFromJSON)
  };
}

// src/generated/models/SlackSendCreditNoteNotificationRequest.ts
function SlackSendCreditNoteNotificationRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "userId": value.userId,
    "creditLedgerEntryId": value.creditLedgerEntryId
  };
}

// src/generated/models/SlackSendCreditNoteNotificationResponse.ts
function SlackSendCreditNoteNotificationResponseFromJSON(json) {
  return SlackSendCreditNoteNotificationResponseFromJSONTyped(json, false);
}
function SlackSendCreditNoteNotificationResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"]
  };
}

// src/generated/models/SlackSendInvoiceApprovalMessageRequestSchema.ts
function SlackSendInvoiceApprovalMessageRequestSchemaToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "userId": value.userId,
    "invoice": value.invoice
  };
}

// src/generated/models/SlackSendInvoiceApprovalMessageResponseSchema.ts
function SlackSendInvoiceApprovalMessageResponseSchemaFromJSON(json) {
  return SlackSendInvoiceApprovalMessageResponseSchemaFromJSONTyped(json, false);
}
function SlackSendInvoiceApprovalMessageResponseSchemaFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"]
  };
}

// src/generated/models/SoftUpdatePlanRequest.ts
function SoftUpdatePlanRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "billingData": PlanBillingDataToJSON(value.billingData),
    "purchaseOrder": value.purchaseOrder
  };
}

// src/generated/models/SoftUpdatePlanResponse.ts
function SoftUpdatePlanResponseFromJSON(json) {
  return SoftUpdatePlanResponseFromJSONTyped(json, false);
}
function SoftUpdatePlanResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "planId": json["planId"]
  };
}

// src/generated/models/StripeConnectRequest.ts
function StripeConnectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "apiToken": value.apiToken
  };
}

// src/generated/models/StripeCreateCustomerResponse.ts
function StripeCreateCustomerResponseFromJSON(json) {
  return StripeCreateCustomerResponseFromJSONTyped(json, false);
}
function StripeCreateCustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "createdStripeCustomerId": json["createdStripeCustomerId"]
  };
}

// src/generated/models/StripeCreateInvoiceRequest.ts
function StripeCreateInvoiceRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoicesIds": value.invoicesIds
  };
}

// src/generated/models/StripeCreateInvoiceResponseInner.ts
function StripeCreateInvoiceResponseInnerFromJSON(json) {
  return StripeCreateInvoiceResponseInnerFromJSONTyped(json, false);
}
function StripeCreateInvoiceResponseInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"],
    "stripeInvoiceId": json["stripeInvoiceId"]
  };
}

// src/generated/models/StripeGetCustomersResponse.ts
function StripeGetCustomersResponseFromJSON(json) {
  return StripeGetCustomersResponseFromJSONTyped(json, false);
}
function StripeGetCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"]
  };
}

// src/generated/models/TerminateContractRequest.ts
function TerminateContractRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "terminationOption": value.terminationOption,
    "terminationDate": value.terminationDate === void 0 ? void 0 : value.terminationDate.toISOString()
  };
}

// src/generated/models/TriggerReportJobRequestOneOf.ts
function instanceOfTriggerReportJobRequestOneOf(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  isInstance = isInstance && "upToDate" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOfToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName,
    "upToDate": value.upToDate.toISOString(),
    "startDate": value.startDate === void 0 ? void 0 : value.startDate.toISOString()
  };
}

// src/generated/models/TriggerReportJobRequestOneOf1.ts
function instanceOfTriggerReportJobRequestOneOf1(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  isInstance = isInstance && "period" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOf1ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName,
    "period": PeriodToJSON(value.period)
  };
}

// src/generated/models/TriggerReportJobRequestOneOf2.ts
function instanceOfTriggerReportJobRequestOneOf2(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  isInstance = isInstance && "period" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOf2ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName,
    "period": PeriodToJSON(value.period)
  };
}

// src/generated/models/TriggerReportJobRequestOneOf3.ts
function instanceOfTriggerReportJobRequestOneOf3(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOf3ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName
  };
}

// src/generated/models/TriggerReportJobRequestOneOf4.ts
function instanceOfTriggerReportJobRequestOneOf4(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOf4ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName
  };
}

// src/generated/models/TriggerReportJobRequestOneOf5.ts
function instanceOfTriggerReportJobRequestOneOf5(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  isInstance = isInstance && "period" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOf5ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName,
    "period": PeriodToJSON(value.period)
  };
}

// src/generated/models/TriggerReportJobRequestOneOf6.ts
function instanceOfTriggerReportJobRequestOneOf6(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOf6ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName
  };
}

// src/generated/models/TriggerReportJobRequestOneOf7.ts
function instanceOfTriggerReportJobRequestOneOf7(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOf7ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName
  };
}

// src/generated/models/TriggerReportJobRequestOneOf8.ts
function instanceOfTriggerReportJobRequestOneOf8(value) {
  let isInstance = true;
  isInstance = isInstance && "reportJobType" in value;
  return isInstance;
}
function TriggerReportJobRequestOneOf8ToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "reportJobType": value.reportJobType,
    "reportName": value.reportName
  };
}

// src/generated/models/TriggerReportJobRequest.ts
function TriggerReportJobRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  if (instanceOfTriggerReportJobRequestOneOf(value)) {
    return TriggerReportJobRequestOneOfToJSON(value);
  }
  if (instanceOfTriggerReportJobRequestOneOf1(value)) {
    return TriggerReportJobRequestOneOf1ToJSON(value);
  }
  if (instanceOfTriggerReportJobRequestOneOf2(value)) {
    return TriggerReportJobRequestOneOf2ToJSON(value);
  }
  if (instanceOfTriggerReportJobRequestOneOf3(value)) {
    return TriggerReportJobRequestOneOf3ToJSON(value);
  }
  if (instanceOfTriggerReportJobRequestOneOf4(value)) {
    return TriggerReportJobRequestOneOf4ToJSON(value);
  }
  if (instanceOfTriggerReportJobRequestOneOf5(value)) {
    return TriggerReportJobRequestOneOf5ToJSON(value);
  }
  if (instanceOfTriggerReportJobRequestOneOf6(value)) {
    return TriggerReportJobRequestOneOf6ToJSON(value);
  }
  if (instanceOfTriggerReportJobRequestOneOf7(value)) {
    return TriggerReportJobRequestOneOf7ToJSON(value);
  }
  if (instanceOfTriggerReportJobRequestOneOf8(value)) {
    return TriggerReportJobRequestOneOf8ToJSON(value);
  }
  return {};
}

// src/generated/models/TriggerReportJobResponse.ts
function TriggerReportJobResponseFromJSON(json) {
  return TriggerReportJobResponseFromJSONTyped(json, false);
}
function TriggerReportJobResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "status": json["status"],
    "reportName": !exists(json, "reportName") ? void 0 : json["reportName"],
    "type": json["type"],
    "invocationType": json["invocationType"],
    "createdAt": new Date(json["createdAt"])
  };
}

// src/generated/models/UndoLineItemPriceOverrideResponse.ts
function UndoLineItemPriceOverrideResponseFromJSON(json) {
  return UndoLineItemPriceOverrideResponseFromJSONTyped(json, false);
}
function UndoLineItemPriceOverrideResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "lineItem": LineItemFromJSON(json["lineItem"])
  };
}

// src/generated/models/UpdateAccountLogoRequest.ts
function UpdateAccountLogoRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "logo": value.logo
  };
}

// src/generated/models/UpdateAccountRequest.ts
function UpdateAccountRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "account": NewAccountToJSON(value.account)
  };
}

// src/generated/models/UpdateAccountResponse.ts
function UpdateAccountResponseFromJSON(json) {
  return UpdateAccountResponseFromJSONTyped(json, false);
}
function UpdateAccountResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"]
  };
}

// src/generated/models/UpdateBillingCycleRequest.ts
function UpdateBillingCycleRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "billingDay": value.billingDay,
    "status": BillingCycleStatusToJSON(value.status),
    "customersIds": value.customersIds
  };
}

// src/generated/models/UpdateBillingCycleResponse.ts
function UpdateBillingCycleResponseFromJSON(json) {
  return UpdateBillingCycleResponseFromJSONTyped(json, false);
}
function UpdateBillingCycleResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "billingCycle": BillingCycleFromJSON(json["billingCycle"])
  };
}

// src/generated/models/UpdateCatalogProductsRequest.ts
function UpdateCatalogProductsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "accountId": value.accountId,
    "name": value.name,
    "description": value.description,
    "isTaxable": value.isTaxable,
    "products": value.products === void 0 ? void 0 : value.products.map(ProductToJSON),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "externalIntegration": ProductExternalIntegrationToJSON(value.externalIntegration),
    "creditTypeIds": value.creditTypeIds
  };
}

// src/generated/models/UpdateCatalogProductsResponse.ts
function UpdateCatalogProductsResponseFromJSON(json) {
  return UpdateCatalogProductsResponseFromJSONTyped(json, false);
}
function UpdateCatalogProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "catalogProduct": CatalogProductsFromJSON(json["catalogProduct"])
  };
}

// src/generated/models/UpdateContractCustomFieldValueRequest.ts
function UpdateContractCustomFieldValueRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "value": CustomFieldValueValueToJSON(value.value)
  };
}

// src/generated/models/UpdateContractCustomFieldValueResponse.ts
function UpdateContractCustomFieldValueResponseFromJSON(json) {
  return UpdateContractCustomFieldValueResponseFromJSONTyped(json, false);
}
function UpdateContractCustomFieldValueResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customFieldValues": json["customFieldValues"].map(CustomFieldValueFromJSON)
  };
}

// src/generated/models/UpdateContractEndDateRequest.ts
function UpdateContractEndDateRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "endDate": value.endDate.toISOString()
  };
}

// src/generated/models/UpdateContractLabelsRequest.ts
function UpdateContractLabelsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "labelIds": value.labelIds
  };
}

// src/generated/models/UpdateContractLabelsResponseContract.ts
function UpdateContractLabelsResponseContractFromJSON(json) {
  return UpdateContractLabelsResponseContractFromJSONTyped(json, false);
}
function UpdateContractLabelsResponseContractFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "labelIds": json["labelIds"]
  };
}

// src/generated/models/UpdateContractLabelsResponse.ts
function UpdateContractLabelsResponseFromJSON(json) {
  return UpdateContractLabelsResponseFromJSONTyped(json, false);
}
function UpdateContractLabelsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract": UpdateContractLabelsResponseContractFromJSON(json["contract"])
  };
}

// src/generated/models/UpdateContractMemoRequest.ts
function UpdateContractMemoRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "notes": value.notes
  };
}

// src/generated/models/UpdateContractMemoResponse.ts
function UpdateContractMemoResponseFromJSON(json) {
  return UpdateContractMemoResponseFromJSONTyped(json, false);
}
function UpdateContractMemoResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"],
    "notes": !exists(json, "notes") ? void 0 : json["notes"]
  };
}

// src/generated/models/UpdateContractRequestPlan.ts
function UpdateContractRequestPlanToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "products": value.products.map(NewPlanProductsInnerToJSON),
    "billingData": PlanBillingDataToJSON(value.billingData),
    "status": PlanStatusToJSON(value.status),
    "basedFromPlanId": value.basedFromPlanId,
    "trial": PlanTrialToJSON(value.trial),
    "purchaseOrder": value.purchaseOrder,
    "rawSyncData": PlanRawSyncDataToJSON(value.rawSyncData),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(IntegrationEntityToJSON)
  };
}

// src/generated/models/UpdateContractRequest.ts
function UpdateContractRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "plan": UpdateContractRequestPlanToJSON(value.plan),
    "startDate": value.startDate.toISOString(),
    "currencyOverride": CurrencyToJSON(value.currencyOverride),
    "signatureDate": value.signatureDate === void 0 ? void 0 : value.signatureDate.toISOString(),
    "parentAgreementSettings": ParentAgreementSettingsToJSON(value.parentAgreementSettings),
    "credits": value.credits === void 0 ? void 0 : value.credits.map(CreditPurchaseConfigToJSON)
  };
}

// src/generated/models/UpdateContractResponse.ts
function UpdateContractResponseFromJSON(json) {
  return UpdateContractResponseFromJSONTyped(json, false);
}
function UpdateContractResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contract": ContractFromJSON(json["contract"])
  };
}

// src/generated/models/UpdateContractStatusRequest.ts
function UpdateContractStatusRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "status": value.status
  };
}

// src/generated/models/UpdateContractStatusResponse.ts
function UpdateContractStatusResponseFromJSON(json) {
  return UpdateContractStatusResponseFromJSONTyped(json, false);
}
function UpdateContractStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "contractId": json["contractId"]
  };
}

// src/generated/models/UpdateCreditTypeRequest.ts
function UpdateCreditTypeRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "units": value.units,
    "isTaxable": value.isTaxable
  };
}

// src/generated/models/UpdateCreditTypeResponse.ts
function UpdateCreditTypeResponseFromJSON(json) {
  return UpdateCreditTypeResponseFromJSONTyped(json, false);
}
function UpdateCreditTypeResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "creditType": CreditTypeFromJSON(json["creditType"])
  };
}

// src/generated/models/UpdateCustomerLabelsRequest.ts
function UpdateCustomerLabelsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "labelIds": value.labelIds
  };
}

// src/generated/models/UpdateCustomerLabelsResponse.ts
function UpdateCustomerLabelsResponseFromJSON(json) {
  return UpdateCustomerLabelsResponseFromJSONTyped(json, false);
}
function UpdateCustomerLabelsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": UpdateContractLabelsResponseContractFromJSON(json["customer"])
  };
}

// src/generated/models/UpdateCustomerRequest.ts
function UpdateCustomerRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "legalName": value.legalName,
    "externalId": value.externalId,
    "aliases": value.aliases,
    "taxIds": value.taxIds,
    "crmId": value.crmId,
    "crmMetadata": CrmMetadataToJSON(value.crmMetadata),
    "erpMetadata": ErpMetadataToJSON(value.erpMetadata),
    "address": AddressToJSON(value.address),
    "contacts": value.contacts === void 0 ? void 0 : value.contacts === null ? null : value.contacts.map(ContactToJSON),
    "settings": CustomerSettingsToJSON(value.settings),
    "revenueBreakdown": CustomerRevenueBreakdownToJSON(value.revenueBreakdown),
    "status": CustomerStatusToJSON(value.status),
    "source": CustomerSourceToJSON(value.source),
    "subsidiaryId": value.subsidiaryId,
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(CustomerIntegrationEntityToJSON),
    "externalIntegration": value.externalIntegration === void 0 ? void 0 : value.externalIntegration === null ? null : value.externalIntegration.map(CustomerExternalIntegrationInnerToJSON),
    "accountOwnerId": value.accountOwnerId,
    "customFieldValues": value.customFieldValues === void 0 ? void 0 : value.customFieldValues.map(CustomFieldValueToJSON),
    "childrenRelations": value.childrenRelations === void 0 ? void 0 : value.childrenRelations.map(CustomerChildrenRelationsInnerToJSON)
  };
}

// src/generated/models/UpdateCustomerResponse.ts
function UpdateCustomerResponseFromJSON(json) {
  return UpdateCustomerResponseFromJSONTyped(json, false);
}
function UpdateCustomerResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customer": CustomerFromJSON(json["customer"])
  };
}

// src/generated/models/UpdateIntegrationSettings.ts
function UpdateIntegrationSettingsToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integrationProvider": value.integrationProvider,
    "integrationConfiguration": value.integrationConfiguration
  };
}

// src/generated/models/UpdateIntegrationConfigurationRequest.ts
function UpdateIntegrationConfigurationRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integrationId": value.integrationId,
    "integrationSettings": UpdateIntegrationSettingsToJSON(value.integrationSettings)
  };
}

// src/generated/models/UpdateIntegrationConfigurationResponse.ts
function UpdateIntegrationConfigurationResponseFromJSON(json) {
  return UpdateIntegrationConfigurationResponseFromJSONTyped(json, false);
}
function UpdateIntegrationConfigurationResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "integrationSettings": VersionedIntegrationSettingsSchemaFromJSON(json["integrationSettings"])
  };
}

// src/generated/models/UpdateInvoiceAdditionalDetailsRequest.ts
function UpdateInvoiceAdditionalDetailsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "id": value.id,
    "purchaseOrder": value.purchaseOrder,
    "notes": value.notes,
    "invoiceNumber": value.invoiceNumber
  };
}

// src/generated/models/UpdateInvoiceAdditionalDetailsResponse.ts
function UpdateInvoiceAdditionalDetailsResponseFromJSON(json) {
  return UpdateInvoiceAdditionalDetailsResponseFromJSONTyped(json, false);
}
function UpdateInvoiceAdditionalDetailsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"]
  };
}

// src/generated/models/UpdateInvoiceCurrencyRequest.ts
function UpdateInvoiceCurrencyRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "modifiedCurrency": CurrencyToJSON(value.modifiedCurrency),
    "modifiedExchangeRate": value.modifiedExchangeRate
  };
}

// src/generated/models/UpdateInvoiceCurrencyResponse.ts
function UpdateInvoiceCurrencyResponseFromJSON(json) {
  return UpdateInvoiceCurrencyResponseFromJSONTyped(json, false);
}
function UpdateInvoiceCurrencyResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"]
  };
}

// src/generated/models/UpdateInvoiceIssueDateRequest.ts
function UpdateInvoiceIssueDateRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "issuedAt": value.issuedAt === null ? null : value.issuedAt.toISOString()
  };
}

// src/generated/models/UpdateInvoiceIssueDateResponse.ts
function UpdateInvoiceIssueDateResponseFromJSON(json) {
  return UpdateInvoiceIssueDateResponseFromJSONTyped(json, false);
}
function UpdateInvoiceIssueDateResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceId": json["invoiceId"]
  };
}

// src/generated/models/UpdateInvoicesAdditionalDetailsRequest.ts
function UpdateInvoicesAdditionalDetailsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceIds": value.invoiceIds,
    "purchaseOrder": value.purchaseOrder,
    "notes": value.notes
  };
}

// src/generated/models/UpdateInvoicesAdditionalDetailsResponse.ts
function UpdateInvoicesAdditionalDetailsResponseFromJSON(json) {
  return UpdateInvoicesAdditionalDetailsResponseFromJSONTyped(json, false);
}
function UpdateInvoicesAdditionalDetailsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoiceIds": json["invoiceIds"]
  };
}

// src/generated/models/UpdateInvoicesBillingStatusesRequest.ts
function UpdateInvoicesBillingStatusesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoicesByNewStatus": value.invoicesByNewStatus
  };
}

// src/generated/models/UpdateInvoicesBillingStatusesResponse.ts
function UpdateInvoicesBillingStatusesResponseFromJSON(json) {
  return UpdateInvoicesBillingStatusesResponseFromJSONTyped(json, false);
}
function UpdateInvoicesBillingStatusesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoicesIds": json["invoicesIds"]
  };
}

// src/generated/models/UpdateInvoicesReviewStatusesRequest.ts
function UpdateInvoicesReviewStatusesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoicesByNewStatus": value.invoicesByNewStatus
  };
}

// src/generated/models/UpdateInvoicesReviewStatusesResponse.ts
function UpdateInvoicesReviewStatusesResponseFromJSON(json) {
  return UpdateInvoicesReviewStatusesResponseFromJSONTyped(json, false);
}
function UpdateInvoicesReviewStatusesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "invoicesIds": json["invoicesIds"]
  };
}

// src/generated/models/UpdateJobNotificationsReadStatusRequest.ts
function UpdateJobNotificationsReadStatusRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "ids": value.ids,
    "status": value.status
  };
}

// src/generated/models/UpdateLabelRequest.ts
function UpdateLabelRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "color": value.color,
    "backgroundColor": value.backgroundColor
  };
}

// src/generated/models/UpdateLabelResponse.ts
function UpdateLabelResponseFromJSON(json) {
  return UpdateLabelResponseFromJSONTyped(json, false);
}
function UpdateLabelResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "label": LabelFromJSON(json["label"])
  };
}

// src/generated/models/UpdateLineItemIntegrationEntitiesRequest.ts
function UpdateLineItemIntegrationEntitiesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(IntegrationEntityToJSON)
  };
}

// src/generated/models/UpdateLineItemRequest.ts
function UpdateLineItemRequestToJSON(value) {
  return value;
}

// src/generated/models/UpdateLineItemResponse.ts
function UpdateLineItemResponseFromJSON(json) {
  return UpdateLineItemResponseFromJSONTyped(json, false);
}
function UpdateLineItemResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "lineItem": LineItemFromJSON(json["lineItem"])
  };
}

// src/generated/models/UpdateLineItemsRequest.ts
function UpdateLineItemsRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "lineItems": value.lineItems.map(LineItemInputToJSON)
  };
}

// src/generated/models/UpdateLineItemsResponse.ts
function UpdateLineItemsResponseFromJSON(json) {
  return UpdateLineItemsResponseFromJSONTyped(json, false);
}
function UpdateLineItemsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "lineItems": json["lineItems"].map(LineItemFromJSON)
  };
}

// src/generated/models/UpdateMeasurementRequest.ts
function UpdateMeasurementRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "units": value.units
  };
}

// src/generated/models/UpdateMeasurementResponse.ts
function UpdateMeasurementResponseFromJSON(json) {
  return UpdateMeasurementResponseFromJSONTyped(json, false);
}
function UpdateMeasurementResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "accountId": json["accountId"],
    "period": FullDayPeriodFromJSON(json["period"]),
    "meterId": json["meterId"],
    "customerId": json["customerId"],
    "value": json["value"],
    "price": !exists(json, "price") ? void 0 : json["price"],
    "measurementPriceId": !exists(json, "measurementPriceId") ? void 0 : json["measurementPriceId"],
    "instanceKey": !exists(json, "instanceKey") ? void 0 : json["instanceKey"],
    "measurementTimeSlot": !exists(json, "measurementTimeSlot") ? void 0 : MeasurementMeasurementTimeSlotFromJSON(json["measurementTimeSlot"]),
    "id": json["id"],
    "createdAt": new Date(json["createdAt"]),
    "updatedAt": new Date(json["updatedAt"])
  };
}

// src/generated/models/UpdateMeterRequest.ts
function UpdateMeterRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "eventName": value.eventName,
    "name": value.name,
    "description": value.description,
    "unitsType": value.unitsType,
    "filter": FilterToJSON(value.filter),
    "aggregationMethod": AggregationMethodToJSON(value.aggregationMethod),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities.map(ProductIntegrationEntityToJSON),
    "creditTypeIds": value.creditTypeIds,
    "isTaxable": value.isTaxable
  };
}

// src/generated/models/UpdateNotificationAlertStatusRequest.ts
function UpdateNotificationAlertStatusRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "status": NotificationAlertStatusToJSON(value.status)
  };
}

// src/generated/models/UpdateNotificationAlertStatusResponse.ts
function UpdateNotificationAlertStatusResponseFromJSON(json) {
  return UpdateNotificationAlertStatusResponseFromJSONTyped(json, false);
}
function UpdateNotificationAlertStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "status": NotificationAlertStatusFromJSON(json["status"]),
    "channelType": ChannelTypeFromJSON(json["channelType"])
  };
}

// src/generated/models/UpdatePlanRequest.ts
function UpdatePlanRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "name": value.name,
    "description": value.description,
    "products": value.products === void 0 ? void 0 : value.products.map(ProductInputToJSON),
    "billingData": PlanBillingDataToJSON(value.billingData),
    "status": PlanStatusToJSON(value.status),
    "basedFromPlanId": value.basedFromPlanId,
    "trial": PlanTrialToJSON(value.trial),
    "purchaseOrder": value.purchaseOrder,
    "rawSyncData": PlanRawSyncDataToJSON(value.rawSyncData),
    "integrationEntities": value.integrationEntities === void 0 ? void 0 : value.integrationEntities === null ? null : value.integrationEntities.map(IntegrationEntityToJSON)
  };
}

// src/generated/models/UpdatePlanResponse.ts
function UpdatePlanResponseFromJSON(json) {
  return UpdatePlanResponseFromJSONTyped(json, false);
}
function UpdatePlanResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "plan": PlanFromJSON(json["plan"])
  };
}

// src/generated/models/UpdateProductIntegrationEntitiesRequest.ts
function UpdateProductIntegrationEntitiesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "integrationEntities": value.integrationEntities.map(ProductIntegrationEntityToJSON)
  };
}

// src/generated/models/UpdateProductIntegrationEntitiesResponseProduct.ts
function UpdateProductIntegrationEntitiesResponseProductFromJSON(json) {
  return UpdateProductIntegrationEntitiesResponseProductFromJSONTyped(json, false);
}
function UpdateProductIntegrationEntitiesResponseProductFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "integrationEntities": json["integrationEntities"].map(ProductIntegrationEntityFromJSON)
  };
}

// src/generated/models/UpdateProductIntegrationEntitiesResponse.ts
function UpdateProductIntegrationEntitiesResponseFromJSON(json) {
  return UpdateProductIntegrationEntitiesResponseFromJSONTyped(json, false);
}
function UpdateProductIntegrationEntitiesResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "product": UpdateProductIntegrationEntitiesResponseProductFromJSON(json["product"])
  };
}

// src/generated/models/UpdateSubsidiaryRequest.ts
function UpdateSubsidiaryRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "subsidiary": NewSubsidiaryToJSON(value.subsidiary)
  };
}

// src/generated/models/UpdateSubsidiaryResponse.ts
function UpdateSubsidiaryResponseFromJSON(json) {
  return UpdateSubsidiaryResponseFromJSONTyped(json, false);
}
function UpdateSubsidiaryResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "subsidiary": SubsidiaryFromJSON(json["subsidiary"])
  };
}

// src/generated/models/UpdateUserRequest.ts
function UpdateUserRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "role": RoleToJSON(value.role),
    "firstName": value.firstName,
    "lastName": value.lastName
  };
}

// src/generated/models/UpdateUserResponse.ts
function UpdateUserResponseFromJSON(json) {
  return UpdateUserResponseFromJSONTyped(json, false);
}
function UpdateUserResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "user": UserFromJSON(json["user"])
  };
}

// src/generated/models/UploadMeasurementsJsonRequest.ts
function UploadMeasurementsJsonRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "rows": value.rows.map(MeasurementRowToJSON)
  };
}

// src/generated/models/UploadMeasurementsJsonResponse.ts
function UploadMeasurementsJsonResponseFromJSON(json) {
  return UploadMeasurementsJsonResponseFromJSONTyped(json, false);
}
function UploadMeasurementsJsonResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"]
  };
}

// src/generated/models/UploadMeasurementsResponse.ts
function UploadMeasurementsResponseFromJSON(json) {
  return UploadMeasurementsResponseFromJSONTyped(json, false);
}
function UploadMeasurementsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": json["message"]
  };
}

// src/generated/models/UpsertPhaseLabelRequest.ts
function UpsertPhaseLabelRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "type": PhaseTypeToJSON(value.type),
    "textLabel": value.textLabel,
    "color": value.color,
    "backgroundColor": value.backgroundColor
  };
}

// src/generated/models/UpsertPhaseLabelResponse.ts
function UpsertPhaseLabelResponseFromJSON(json) {
  return UpsertPhaseLabelResponseFromJSONTyped(json, false);
}
function UpsertPhaseLabelResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "phaseLabel": PhaseLabelFromJSON(json["phaseLabel"])
  };
}

// src/generated/models/UpsertRevenueRecognitionOverrideRequest.ts
function UpsertRevenueRecognitionOverrideRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "billedOverride": value.billedOverride === void 0 ? void 0 : value.billedOverride.map(UpsertRevenueRecognitionOverrideRequestBilledOverrideInnerToJSON),
    "revenueOverride": value.revenueOverride === void 0 ? void 0 : value.revenueOverride.map(UpsertRevenueRecognitionOverrideRequestBilledOverrideInnerToJSON),
    "recognitionTypeOverride": value.recognitionTypeOverride
  };
}

// src/generated/models/UpsertRevenueRecognitionOverrideResponse.ts
function UpsertRevenueRecognitionOverrideResponseFromJSON(json) {
  return UpsertRevenueRecognitionOverrideResponseFromJSONTyped(json, false);
}
function UpsertRevenueRecognitionOverrideResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "success": json["success"]
  };
}

// src/generated/models/ValidateMeasurementDataResponse.ts
function ValidateMeasurementDataResponseFromJSON(json) {
  return ValidateMeasurementDataResponseFromJSONTyped(json, false);
}
function ValidateMeasurementDataResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "newCustomers": !exists(json, "newCustomers") ? void 0 : json["newCustomers"],
    "mergingMeasurements": !exists(json, "mergingMeasurements") ? void 0 : json["mergingMeasurements"].map(MergingMeasurementFromJSON)
  };
}

// src/generated/models/ValidateMeasurementsJsonRequest.ts
function ValidateMeasurementsJsonRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "rows": value.rows.map(MeasurementRowToJSON)
  };
}

// src/generated/models/ValidateMeasurementsJsonResponse.ts
function ValidateMeasurementsJsonResponseFromJSON(json) {
  return ValidateMeasurementsJsonResponseFromJSONTyped(json, false);
}
function ValidateMeasurementsJsonResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "message": !exists(json, "message") ? void 0 : json["message"],
    "newCustomers": !exists(json, "newCustomers") ? void 0 : json["newCustomers"],
    "mergingMeasurements": !exists(json, "mergingMeasurements") ? void 0 : json["mergingMeasurements"].map(MergingMeasurementFromJSON)
  };
}

// src/generated/models/XeroAuthConnectRequest.ts
function XeroAuthConnectRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "clientId": value.clientId,
    "clientSecret": value.clientSecret,
    "environment": value.environment
  };
}

// src/generated/models/XeroAuthConnectResponse.ts
function XeroAuthConnectResponseFromJSON(json) {
  return XeroAuthConnectResponseFromJSONTyped(json, false);
}
function XeroAuthConnectResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "redirectUrl": json["redirectUrl"]
  };
}

// src/generated/models/XeroExportCreditMemoRequest.ts
function XeroExportCreditMemoRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "creditLedgerEntryId": value.creditLedgerEntryId
  };
}

// src/generated/models/XeroExportInvoicesRequest.ts
function XeroExportInvoicesRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    "invoiceIds": value.invoiceIds
  };
}

// src/generated/models/XeroGetCustomersResponseCustomersInner.ts
function XeroGetCustomersResponseCustomersInnerFromJSON(json) {
  return XeroGetCustomersResponseCustomersInnerFromJSONTyped(json, false);
}
function XeroGetCustomersResponseCustomersInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "email": !exists(json, "email") ? void 0 : json["email"],
    "isActive": !exists(json, "isActive") ? void 0 : json["isActive"]
  };
}

// src/generated/models/XeroGetCustomersResponse.ts
function XeroGetCustomersResponseFromJSON(json) {
  return XeroGetCustomersResponseFromJSONTyped(json, false);
}
function XeroGetCustomersResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "customers": json["customers"].map(XeroGetCustomersResponseCustomersInnerFromJSON)
  };
}

// src/generated/models/XeroGetDepositToAccountsResponseDepositToAccountsInner.ts
function XeroGetDepositToAccountsResponseDepositToAccountsInnerFromJSON(json) {
  return XeroGetDepositToAccountsResponseDepositToAccountsInnerFromJSONTyped(json, false);
}
function XeroGetDepositToAccountsResponseDepositToAccountsInnerFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "id": json["id"],
    "name": json["name"],
    "code": !exists(json, "code") ? void 0 : json["code"]
  };
}

// src/generated/models/XeroGetDepositToAccountsResponse.ts
function XeroGetDepositToAccountsResponseFromJSON(json) {
  return XeroGetDepositToAccountsResponseFromJSONTyped(json, false);
}
function XeroGetDepositToAccountsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "depositToAccounts": json["depositToAccounts"].map(XeroGetDepositToAccountsResponseDepositToAccountsInnerFromJSON)
  };
}

// src/generated/models/XeroGetProductsResponse.ts
function XeroGetProductsResponseFromJSON(json) {
  return XeroGetProductsResponseFromJSONTyped(json, false);
}
function XeroGetProductsResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    "products": json["products"].map(XeroGetDepositToAccountsResponseDepositToAccountsInnerFromJSON)
  };
}

// src/generated/apis/DefaultApi.ts
var DefaultApi = class extends BaseAPI {
  /**
   */
  async anrokBackfillTransactionsRaw(requestParameters, initOverrides) {
    if (requestParameters.anrokBackfillTransactionsRequest === null || requestParameters.anrokBackfillTransactionsRequest === void 0) {
      throw new RequiredError("anrokBackfillTransactionsRequest", "Required parameter requestParameters.anrokBackfillTransactionsRequest was null or undefined when calling anrokBackfillTransactions.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/anrok/backfill-transactions`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AnrokBackfillTransactionsRequestToJSON(requestParameters.anrokBackfillTransactionsRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async anrokBackfillTransactions(requestParameters, initOverrides) {
    await this.anrokBackfillTransactionsRaw(requestParameters, initOverrides);
  }
  /**
   */
  async anrokConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.anrokConnectRequest === null || requestParameters.anrokConnectRequest === void 0) {
      throw new RequiredError("anrokConnectRequest", "Required parameter requestParameters.anrokConnectRequest was null or undefined when calling anrokConnect.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/anrok/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: AnrokConnectRequestToJSON(requestParameters.anrokConnectRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async anrokConnect(requestParameters, initOverrides) {
    await this.anrokConnectRaw(requestParameters, initOverrides);
  }
  /**
   */
  async applyCreditsRaw(requestParameters, initOverrides) {
    if (requestParameters.applyCreditsRequest === null || requestParameters.applyCreditsRequest === void 0) {
      throw new RequiredError("applyCreditsRequest", "Required parameter requestParameters.applyCreditsRequest was null or undefined when calling applyCredits.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/apply-credits`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ApplyCreditsRequestToJSON(requestParameters.applyCreditsRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async applyCredits(requestParameters, initOverrides) {
    await this.applyCreditsRaw(requestParameters, initOverrides);
  }
  /**
   */
  async assignPaymentToInvoiceRaw(requestParameters, initOverrides) {
    if (requestParameters.paymentId === null || requestParameters.paymentId === void 0) {
      throw new RequiredError("paymentId", "Required parameter requestParameters.paymentId was null or undefined when calling assignPaymentToInvoice.");
    }
    if (requestParameters.assignPaymentToInvoiceRequest === null || requestParameters.assignPaymentToInvoiceRequest === void 0) {
      throw new RequiredError("assignPaymentToInvoiceRequest", "Required parameter requestParameters.assignPaymentToInvoiceRequest was null or undefined when calling assignPaymentToInvoice.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/payments/{paymentId}/assign-invoice`.replace(`{${"paymentId"}}`, encodeURIComponent(String(requestParameters.paymentId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: AssignPaymentToInvoiceRequestToJSON(requestParameters.assignPaymentToInvoiceRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => AssignPaymentToInvoiceResponseFromJSON(jsonValue));
  }
  /**
   */
  async assignPaymentToInvoice(requestParameters, initOverrides) {
    const response = await this.assignPaymentToInvoiceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async cancelInvitationRaw(requestParameters, initOverrides) {
    if (requestParameters.invitationId === null || requestParameters.invitationId === void 0) {
      throw new RequiredError("invitationId", "Required parameter requestParameters.invitationId was null or undefined when calling cancelInvitation.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/invitations/{invitationId}`.replace(`{${"invitationId"}}`, encodeURIComponent(String(requestParameters.invitationId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async cancelInvitation(requestParameters, initOverrides) {
    await this.cancelInvitationRaw(requestParameters, initOverrides);
  }
  /**
   */
  async confirmPasswordResetRaw(requestParameters, initOverrides) {
    if (requestParameters.confirmPasswordResetRequest === null || requestParameters.confirmPasswordResetRequest === void 0) {
      throw new RequiredError("confirmPasswordResetRequest", "Required parameter requestParameters.confirmPasswordResetRequest was null or undefined when calling confirmPasswordReset.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/auth/confirm-password-reset`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConfirmPasswordResetRequestToJSON(requestParameters.confirmPasswordResetRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ConfirmPasswordResetResponseFromJSON(jsonValue));
  }
  /**
   */
  async confirmPasswordReset(requestParameters, initOverrides) {
    const response = await this.confirmPasswordResetRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async confirmUserRaw(requestParameters, initOverrides) {
    if (requestParameters.confirmRequest === null || requestParameters.confirmRequest === void 0) {
      throw new RequiredError("confirmRequest", "Required parameter requestParameters.confirmRequest was null or undefined when calling confirmUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/auth/confirm`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConfirmRequestToJSON(requestParameters.confirmRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async confirmUser(requestParameters, initOverrides) {
    await this.confirmUserRaw(requestParameters, initOverrides);
  }
  /**
   */
  async connactConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.connactConnectRequest === null || requestParameters.connactConnectRequest === void 0) {
      throw new RequiredError("connactConnectRequest", "Required parameter requestParameters.connactConnectRequest was null or undefined when calling connactConnect.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/connact/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ConnactConnectRequestToJSON(requestParameters.connactConnectRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async connactConnect(requestParameters, initOverrides) {
    await this.connactConnectRaw(requestParameters, initOverrides);
  }
  /**
   */
  async contactUsRaw(requestParameters, initOverrides) {
    if (requestParameters.contactUsRequest === null || requestParameters.contactUsRequest === void 0) {
      throw new RequiredError("contactUsRequest", "Required parameter requestParameters.contactUsRequest was null or undefined when calling contactUs.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/contact-us/`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ContactUsRequestToJSON(requestParameters.contactUsRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async contactUs(requestParameters, initOverrides) {
    await this.contactUsRaw(requestParameters, initOverrides);
  }
  /**
   */
  async createBillingCycleRaw(requestParameters, initOverrides) {
    if (requestParameters.createBillingCycleRequest === null || requestParameters.createBillingCycleRequest === void 0) {
      throw new RequiredError("createBillingCycleRequest", "Required parameter requestParameters.createBillingCycleRequest was null or undefined when calling createBillingCycle.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/billing-cycles`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateBillingCycleRequestToJSON(requestParameters.createBillingCycleRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateBillingCycleResponseFromJSON(jsonValue));
  }
  /**
   */
  async createBillingCycle(requestParameters, initOverrides) {
    const response = await this.createBillingCycleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createCatalogProductsRaw(requestParameters, initOverrides) {
    if (requestParameters.createCatalogProductsRequest === null || requestParameters.createCatalogProductsRequest === void 0) {
      throw new RequiredError("createCatalogProductsRequest", "Required parameter requestParameters.createCatalogProductsRequest was null or undefined when calling createCatalogProducts.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/catalog-products`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateCatalogProductsRequestToJSON(requestParameters.createCatalogProductsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateCatalogProductsResponseFromJSON(jsonValue));
  }
  /**
   */
  async createCatalogProducts(requestParameters, initOverrides) {
    const response = await this.createCatalogProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createContractsRaw(requestParameters, initOverrides) {
    if (requestParameters.createContractsRequest === null || requestParameters.createContractsRequest === void 0) {
      throw new RequiredError("createContractsRequest", "Required parameter requestParameters.createContractsRequest was null or undefined when calling createContracts.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contracts`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateContractsRequestToJSON(requestParameters.createContractsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateContractsResponseFromJSON(jsonValue));
  }
  /**
   */
  async createContracts(requestParameters, initOverrides) {
    const response = await this.createContractsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createCreditTypeRaw(requestParameters, initOverrides) {
    if (requestParameters.createCreditTypeRequest === null || requestParameters.createCreditTypeRequest === void 0) {
      throw new RequiredError("createCreditTypeRequest", "Required parameter requestParameters.createCreditTypeRequest was null or undefined when calling createCreditType.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-types`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateCreditTypeRequestToJSON(requestParameters.createCreditTypeRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateCreditTypeResponseFromJSON(jsonValue));
  }
  /**
   */
  async createCreditType(requestParameters, initOverrides) {
    const response = await this.createCreditTypeRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createCustomerRaw(requestParameters, initOverrides) {
    if (requestParameters.createCustomerRequest === null || requestParameters.createCustomerRequest === void 0) {
      throw new RequiredError("createCustomerRequest", "Required parameter requestParameters.createCustomerRequest was null or undefined when calling createCustomer.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateCustomerRequestToJSON(requestParameters.createCustomerRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateCustomerResponseFromJSON(jsonValue));
  }
  /**
   */
  async createCustomer(requestParameters, initOverrides) {
    const response = await this.createCustomerRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createCustomerNoteRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling createCustomerNote.");
    }
    if (requestParameters.createCustomerNoteRequest === null || requestParameters.createCustomerNoteRequest === void 0) {
      throw new RequiredError("createCustomerNoteRequest", "Required parameter requestParameters.createCustomerNoteRequest was null or undefined when calling createCustomerNote.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer-note/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateCustomerNoteRequestToJSON(requestParameters.createCustomerNoteRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateCustomerNoteResponseFromJSON(jsonValue));
  }
  /**
   */
  async createCustomerNote(requestParameters, initOverrides) {
    const response = await this.createCustomerNoteRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createInvoiceRaw(requestParameters, initOverrides) {
    if (requestParameters.createInvoiceRequest === null || requestParameters.createInvoiceRequest === void 0) {
      throw new RequiredError("createInvoiceRequest", "Required parameter requestParameters.createInvoiceRequest was null or undefined when calling createInvoice.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateInvoiceRequestToJSON(requestParameters.createInvoiceRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateInvoiceResponseFromJSON(jsonValue));
  }
  /**
   */
  async createInvoice(requestParameters, initOverrides) {
    const response = await this.createInvoiceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createLabelRaw(requestParameters, initOverrides) {
    if (requestParameters.createLabelRequest === null || requestParameters.createLabelRequest === void 0) {
      throw new RequiredError("createLabelRequest", "Required parameter requestParameters.createLabelRequest was null or undefined when calling createLabel.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/labels`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateLabelRequestToJSON(requestParameters.createLabelRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateLabelResponseFromJSON(jsonValue));
  }
  /**
   */
  async createLabel(requestParameters, initOverrides) {
    const response = await this.createLabelRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createLineItemRaw(requestParameters, initOverrides) {
    if (requestParameters.createLineItemRequest === null || requestParameters.createLineItemRequest === void 0) {
      throw new RequiredError("createLineItemRequest", "Required parameter requestParameters.createLineItemRequest was null or undefined when calling createLineItem.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/line-item`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateLineItemRequestToJSON(requestParameters.createLineItemRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateLineItemResponseFromJSON(jsonValue));
  }
  /**
   */
  async createLineItem(requestParameters, initOverrides) {
    const response = await this.createLineItemRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createMeterRaw(requestParameters, initOverrides) {
    if (requestParameters.createMeterRequest === null || requestParameters.createMeterRequest === void 0) {
      throw new RequiredError("createMeterRequest", "Required parameter requestParameters.createMeterRequest was null or undefined when calling createMeter.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/meter`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateMeterRequestToJSON(requestParameters.createMeterRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async createMeter(requestParameters, initOverrides) {
    await this.createMeterRaw(requestParameters, initOverrides);
  }
  /**
   */
  async createPlanRaw(requestParameters, initOverrides) {
    if (requestParameters.createPlanRequest === null || requestParameters.createPlanRequest === void 0) {
      throw new RequiredError("createPlanRequest", "Required parameter requestParameters.createPlanRequest was null or undefined when calling createPlan.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plan`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreatePlanRequestToJSON(requestParameters.createPlanRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreatePlanResponseFromJSON(jsonValue));
  }
  /**
   */
  async createPlan(requestParameters, initOverrides) {
    const response = await this.createPlanRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createPublicApiKeyRaw(requestParameters, initOverrides) {
    if (requestParameters.createPublicApiKeyRequest === null || requestParameters.createPublicApiKeyRequest === void 0) {
      throw new RequiredError("createPublicApiKeyRequest", "Required parameter requestParameters.createPublicApiKeyRequest was null or undefined when calling createPublicApiKey.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/public-api-keys`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreatePublicApiKeyRequestToJSON(requestParameters.createPublicApiKeyRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreatePublicApiKeyResponseFromJSON(jsonValue));
  }
  /**
   */
  async createPublicApiKey(requestParameters, initOverrides) {
    const response = await this.createPublicApiKeyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createSubsidiaryRaw(requestParameters, initOverrides) {
    if (requestParameters.createSubsidiaryRequest === null || requestParameters.createSubsidiaryRequest === void 0) {
      throw new RequiredError("createSubsidiaryRequest", "Required parameter requestParameters.createSubsidiaryRequest was null or undefined when calling createSubsidiary.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/subsidiaries`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateSubsidiaryRequestToJSON(requestParameters.createSubsidiaryRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateSubsidiaryResponseFromJSON(jsonValue));
  }
  /**
   */
  async createSubsidiary(requestParameters, initOverrides) {
    const response = await this.createSubsidiaryRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createWebhookSubscriptionRaw(requestParameters, initOverrides) {
    if (requestParameters.createWebhookSubscriptionRequest === null || requestParameters.createWebhookSubscriptionRequest === void 0) {
      throw new RequiredError("createWebhookSubscriptionRequest", "Required parameter requestParameters.createWebhookSubscriptionRequest was null or undefined when calling createWebhookSubscription.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/webhook-subscriptions`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateWebhookSubscriptionRequestToJSON(requestParameters.createWebhookSubscriptionRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateWebhookSubscriptionResponseFromJSON(jsonValue));
  }
  /**
   */
  async createWebhookSubscription(requestParameters, initOverrides) {
    const response = await this.createWebhookSubscriptionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createWorkflowRaw(requestParameters, initOverrides) {
    if (requestParameters.createWorkflowRequest === null || requestParameters.createWorkflowRequest === void 0) {
      throw new RequiredError("createWorkflowRequest", "Required parameter requestParameters.createWorkflowRequest was null or undefined when calling createWorkflow.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateWorkflowRequestToJSON(requestParameters.createWorkflowRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateWorkflowResponseFromJSON(jsonValue));
  }
  /**
   */
  async createWorkflow(requestParameters, initOverrides) {
    const response = await this.createWorkflowRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async createWorkflowVersionRaw(requestParameters, initOverrides) {
    if (requestParameters.publishedWorkflowId === null || requestParameters.publishedWorkflowId === void 0) {
      throw new RequiredError("publishedWorkflowId", "Required parameter requestParameters.publishedWorkflowId was null or undefined when calling createWorkflowVersion.");
    }
    if (requestParameters.createWorkflowVersionRequest === null || requestParameters.createWorkflowVersionRequest === void 0) {
      throw new RequiredError("createWorkflowVersionRequest", "Required parameter requestParameters.createWorkflowVersionRequest was null or undefined when calling createWorkflowVersion.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows/from/{publishedWorkflowId}`.replace(`{${"publishedWorkflowId"}}`, encodeURIComponent(String(requestParameters.publishedWorkflowId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: CreateWorkflowVersionRequestToJSON(requestParameters.createWorkflowVersionRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => CreateWorkflowVersionResponseFromJSON(jsonValue));
  }
  /**
   */
  async createWorkflowVersion(requestParameters, initOverrides) {
    const response = await this.createWorkflowVersionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteCatalogProductsRaw(requestParameters, initOverrides) {
    if (requestParameters.catalogProductId === null || requestParameters.catalogProductId === void 0) {
      throw new RequiredError("catalogProductId", "Required parameter requestParameters.catalogProductId was null or undefined when calling deleteCatalogProducts.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/catalog-products/{catalogProductId}`.replace(`{${"catalogProductId"}}`, encodeURIComponent(String(requestParameters.catalogProductId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteCatalogProductsResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteCatalogProducts(requestParameters, initOverrides) {
    const response = await this.deleteCatalogProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteContractRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling deleteContract.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteContractResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteContract(requestParameters, initOverrides) {
    const response = await this.deleteContractRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteCreditNoteRaw(requestParameters, initOverrides) {
    if (requestParameters.creditLedgerEntryId === null || requestParameters.creditLedgerEntryId === void 0) {
      throw new RequiredError("creditLedgerEntryId", "Required parameter requestParameters.creditLedgerEntryId was null or undefined when calling deleteCreditNote.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-ledger/{creditLedgerEntryId}`.replace(`{${"creditLedgerEntryId"}}`, encodeURIComponent(String(requestParameters.creditLedgerEntryId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async deleteCreditNote(requestParameters, initOverrides) {
    await this.deleteCreditNoteRaw(requestParameters, initOverrides);
  }
  /**
   */
  async deleteCreditTypeRaw(requestParameters, initOverrides) {
    if (requestParameters.creditTypeId === null || requestParameters.creditTypeId === void 0) {
      throw new RequiredError("creditTypeId", "Required parameter requestParameters.creditTypeId was null or undefined when calling deleteCreditType.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-types/{creditTypeId}`.replace(`{${"creditTypeId"}}`, encodeURIComponent(String(requestParameters.creditTypeId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async deleteCreditType(requestParameters, initOverrides) {
    await this.deleteCreditTypeRaw(requestParameters, initOverrides);
  }
  /**
   */
  async deleteCustomerRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling deleteCustomer.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteCustomerResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteCustomer(requestParameters, initOverrides) {
    const response = await this.deleteCustomerRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteInvoiceRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling deleteInvoice.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteInvoiceResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteInvoice(requestParameters, initOverrides) {
    const response = await this.deleteInvoiceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteLabelRaw(requestParameters, initOverrides) {
    if (requestParameters.labelId === null || requestParameters.labelId === void 0) {
      throw new RequiredError("labelId", "Required parameter requestParameters.labelId was null or undefined when calling deleteLabel.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/labels/{labelId}`.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters.labelId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response);
  }
  /**
   */
  async deleteLabel(requestParameters, initOverrides) {
    const response = await this.deleteLabelRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteLineItemRaw(requestParameters, initOverrides) {
    if (requestParameters.lineItemId === null || requestParameters.lineItemId === void 0) {
      throw new RequiredError("lineItemId", "Required parameter requestParameters.lineItemId was null or undefined when calling deleteLineItem.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/line-item/{lineItemId}`.replace(`{${"lineItemId"}}`, encodeURIComponent(String(requestParameters.lineItemId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteLineItemResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteLineItem(requestParameters, initOverrides) {
    const response = await this.deleteLineItemRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteMeasurementRaw(requestParameters, initOverrides) {
    if (requestParameters.measurementId === null || requestParameters.measurementId === void 0) {
      throw new RequiredError("measurementId", "Required parameter requestParameters.measurementId was null or undefined when calling deleteMeasurement.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurement/{measurementId}`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters.measurementId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => MeasurementDeleteResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteMeasurement(requestParameters, initOverrides) {
    const response = await this.deleteMeasurementRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteMeasurementsRaw(requestParameters, initOverrides) {
    if (requestParameters.deleteMeasurementsRequest === null || requestParameters.deleteMeasurementsRequest === void 0) {
      throw new RequiredError("deleteMeasurementsRequest", "Required parameter requestParameters.deleteMeasurementsRequest was null or undefined when calling deleteMeasurements.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurements`,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
      body: DeleteMeasurementsRequestToJSON(requestParameters.deleteMeasurementsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(MeasurementFromJSON));
  }
  /**
   */
  async deleteMeasurements(requestParameters, initOverrides) {
    const response = await this.deleteMeasurementsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteMeterRaw(requestParameters, initOverrides) {
    if (requestParameters.meterId === null || requestParameters.meterId === void 0) {
      throw new RequiredError("meterId", "Required parameter requestParameters.meterId was null or undefined when calling deleteMeter.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/meter/{meterId}`.replace(`{${"meterId"}}`, encodeURIComponent(String(requestParameters.meterId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => MeterDeleteResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteMeter(requestParameters, initOverrides) {
    const response = await this.deleteMeterRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deletePlanRaw(requestParameters, initOverrides) {
    if (requestParameters.planId === null || requestParameters.planId === void 0) {
      throw new RequiredError("planId", "Required parameter requestParameters.planId was null or undefined when calling deletePlan.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plan/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async deletePlan(requestParameters, initOverrides) {
    await this.deletePlanRaw(requestParameters, initOverrides);
  }
  /**
   */
  async deletePublicApiKeyRaw(requestParameters, initOverrides) {
    if (requestParameters.publicApiKeyId === null || requestParameters.publicApiKeyId === void 0) {
      throw new RequiredError("publicApiKeyId", "Required parameter requestParameters.publicApiKeyId was null or undefined when calling deletePublicApiKey.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/public-api-keys/{publicApiKeyId}`.replace(`{${"publicApiKeyId"}}`, encodeURIComponent(String(requestParameters.publicApiKeyId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeletePublicApiKeyResponseFromJSON(jsonValue));
  }
  /**
   */
  async deletePublicApiKey(requestParameters, initOverrides) {
    const response = await this.deletePublicApiKeyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteReportRaw(requestParameters, initOverrides) {
    if (requestParameters.reportId === null || requestParameters.reportId === void 0) {
      throw new RequiredError("reportId", "Required parameter requestParameters.reportId was null or undefined when calling deleteReport.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/{reportId}`.replace(`{${"reportId"}}`, encodeURIComponent(String(requestParameters.reportId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteReport(requestParameters, initOverrides) {
    const response = await this.deleteReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteRevenueRecognitionOverrideRaw(requestParameters, initOverrides) {
    if (requestParameters.variantId === null || requestParameters.variantId === void 0) {
      throw new RequiredError("variantId", "Required parameter requestParameters.variantId was null or undefined when calling deleteRevenueRecognitionOverride.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/revenue-recognition-override/{variantId}`.replace(`{${"variantId"}}`, encodeURIComponent(String(requestParameters.variantId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteRevenueRecognitionOverrideResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteRevenueRecognitionOverride(requestParameters, initOverrides) {
    const response = await this.deleteRevenueRecognitionOverrideRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteRevisionRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling deleteRevision.");
    }
    if (requestParameters.revisionId === null || requestParameters.revisionId === void 0) {
      throw new RequiredError("revisionId", "Required parameter requestParameters.revisionId was null or undefined when calling deleteRevision.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/revision/{revisionId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))).replace(`{${"revisionId"}}`, encodeURIComponent(String(requestParameters.revisionId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteRevisionResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteRevision(requestParameters, initOverrides) {
    const response = await this.deleteRevisionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async deleteWebhookSubscriptionRaw(requestParameters, initOverrides) {
    if (requestParameters.webhookSubscriptionId === null || requestParameters.webhookSubscriptionId === void 0) {
      throw new RequiredError("webhookSubscriptionId", "Required parameter requestParameters.webhookSubscriptionId was null or undefined when calling deleteWebhookSubscription.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/webhook-subscriptions/{webhookSubscriptionId}`.replace(`{${"webhookSubscriptionId"}}`, encodeURIComponent(String(requestParameters.webhookSubscriptionId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DeleteWebhookSubscriptionResponseFromJSON(jsonValue));
  }
  /**
   */
  async deleteWebhookSubscription(requestParameters, initOverrides) {
    const response = await this.deleteWebhookSubscriptionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async disablePlanRaw(requestParameters, initOverrides) {
    if (requestParameters.planId === null || requestParameters.planId === void 0) {
      throw new RequiredError("planId", "Required parameter requestParameters.planId was null or undefined when calling disablePlan.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plan/disable/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DisablePlanResponseFromJSON(jsonValue));
  }
  /**
   */
  async disablePlan(requestParameters, initOverrides) {
    const response = await this.disablePlanRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async disableWorkflowRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling disableWorkflow.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DisableWorkflowResponseFromJSON(jsonValue));
  }
  /**
   */
  async disableWorkflow(requestParameters, initOverrides) {
    const response = await this.disableWorkflowRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async disconnectIntegrationRaw(requestParameters, initOverrides) {
    if (requestParameters.integrationId === null || requestParameters.integrationId === void 0) {
      throw new RequiredError("integrationId", "Required parameter requestParameters.integrationId was null or undefined when calling disconnectIntegration.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/{integrationId}/disconnect`.replace(`{${"integrationId"}}`, encodeURIComponent(String(requestParameters.integrationId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async disconnectIntegration(requestParameters, initOverrides) {
    await this.disconnectIntegrationRaw(requestParameters, initOverrides);
  }
  /**
   */
  async dismissJobNotificationRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling dismissJobNotification.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/notifications/dismiss`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => DismissJobNotificationResponseFromJSON(jsonValue));
  }
  /**
   */
  async dismissJobNotification(requestParameters, initOverrides) {
    const response = await this.dismissJobNotificationRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async eventHandlerRaw(requestParameters, initOverrides) {
    if (requestParameters.slackEventHandlerRequestSchema === null || requestParameters.slackEventHandlerRequestSchema === void 0) {
      throw new RequiredError("slackEventHandlerRequestSchema", "Required parameter requestParameters.slackEventHandlerRequestSchema was null or undefined when calling eventHandler.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/integrations/slack/events`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SlackEventHandlerRequestSchemaToJSON(requestParameters.slackEventHandlerRequestSchema)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SlackEventHandlerResponseFromJSON(jsonValue));
  }
  /**
   */
  async eventHandler(requestParameters, initOverrides) {
    const response = await this.eventHandlerRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async executeWorkflowRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling executeWorkflow.");
    }
    if (requestParameters.body === null || requestParameters.body === void 0) {
      throw new RequiredError("body", "Required parameter requestParameters.body was null or undefined when calling executeWorkflow.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows/{id}/execute`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.body
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ExecuteWorkflowResponseFromJSON(jsonValue));
  }
  /**
   */
  async executeWorkflow(requestParameters, initOverrides) {
    const response = await this.executeWorkflowRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async exportNetSuiteSalesOrderRaw(requestParameters, initOverrides) {
    if (requestParameters.netSuiteExportSalesOrderRequest === null || requestParameters.netSuiteExportSalesOrderRequest === void 0) {
      throw new RequiredError("netSuiteExportSalesOrderRequest", "Required parameter requestParameters.netSuiteExportSalesOrderRequest was null or undefined when calling exportNetSuiteSalesOrder.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/export-sales-order`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: NetSuiteExportSalesOrderRequestToJSON(requestParameters.netSuiteExportSalesOrderRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async exportNetSuiteSalesOrder(requestParameters, initOverrides) {
    await this.exportNetSuiteSalesOrderRaw(requestParameters, initOverrides);
  }
  /**
   */
  async exportUsageToMarketplaceRaw(requestParameters, initOverrides) {
    if (requestParameters.exportUsageToMarketplaceRequest === null || requestParameters.exportUsageToMarketplaceRequest === void 0) {
      throw new RequiredError("exportUsageToMarketplaceRequest", "Required parameter requestParameters.exportUsageToMarketplaceRequest was null or undefined when calling exportUsageToMarketplace.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/export-usage-to-marketplace`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ExportUsageToMarketplaceRequestToJSON(requestParameters.exportUsageToMarketplaceRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async exportUsageToMarketplace(requestParameters, initOverrides) {
    await this.exportUsageToMarketplaceRaw(requestParameters, initOverrides);
  }
  /**
   */
  async extractContractRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contracts/extract`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ExtractContractResponseFromJSON(jsonValue));
  }
  /**
   */
  async extractContract(initOverrides) {
    const response = await this.extractContractRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async extractPlanRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plan/extract`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ExtractPlanResponseFromJSON(jsonValue));
  }
  /**
   */
  async extractPlan(initOverrides) {
    const response = await this.extractPlanRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async filterSampleEventsRaw(requestParameters, initOverrides) {
    if (requestParameters.filterSampleEventsRequest === null || requestParameters.filterSampleEventsRequest === void 0) {
      throw new RequiredError("filterSampleEventsRequest", "Required parameter requestParameters.filterSampleEventsRequest was null or undefined when calling filterSampleEvents.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/events/sample`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: FilterSampleEventsRequestToJSON(requestParameters.filterSampleEventsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => FilterSampleEventsResponseFromJSON(jsonValue));
  }
  /**
   */
  async filterSampleEvents(requestParameters, initOverrides) {
    const response = await this.filterSampleEventsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async generateMeasurementsRaw(requestParameters, initOverrides) {
    if (requestParameters.generateMeasurementsRequest === null || requestParameters.generateMeasurementsRequest === void 0) {
      throw new RequiredError("generateMeasurementsRequest", "Required parameter requestParameters.generateMeasurementsRequest was null or undefined when calling generateMeasurements.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurements/generate`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GenerateMeasurementsRequestToJSON(requestParameters.generateMeasurementsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GenerateMeasurementsResponseFromJSON(jsonValue));
  }
  /**
   */
  async generateMeasurements(requestParameters, initOverrides) {
    const response = await this.generateMeasurementsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async generateTokenRaw(requestParameters, initOverrides) {
    if (requestParameters.generateTokenRequest === null || requestParameters.generateTokenRequest === void 0) {
      throw new RequiredError("generateTokenRequest", "Required parameter requestParameters.generateTokenRequest was null or undefined when calling generateToken.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer-portal/generate-token`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GenerateTokenRequestToJSON(requestParameters.generateTokenRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GenerateTokenResponseFromJSON(jsonValue));
  }
  /**
   */
  async generateToken(requestParameters, initOverrides) {
    const response = await this.generateTokenRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getAccountRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/account`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetAccountResponseFromJSON(jsonValue));
  }
  /**
   */
  async getAccount(initOverrides) {
    const response = await this.getAccountRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getAffectedMeteredEventsRaw(requestParameters, initOverrides) {
    if (requestParameters.eventRef === null || requestParameters.eventRef === void 0) {
      throw new RequiredError("eventRef", "Required parameter requestParameters.eventRef was null or undefined when calling getAffectedMeteredEvents.");
    }
    const queryParameters = {};
    if (requestParameters.eventRef !== void 0) {
      queryParameters["eventRef"] = requestParameters.eventRef;
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/events/affected-metered-events`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetAffectedMeteredEventsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getAffectedMeteredEvents(requestParameters, initOverrides) {
    const response = await this.getAffectedMeteredEventsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getAnonymousCustomersReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/anonymous-customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetAnonymousCustomersReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getAnonymousCustomersReport(requestParameters = {}, initOverrides) {
    const response = await this.getAnonymousCustomersReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getApprovalFlowInvoicesListRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceTypes === null || requestParameters.invoiceTypes === void 0) {
      throw new RequiredError("invoiceTypes", "Required parameter requestParameters.invoiceTypes was null or undefined when calling getApprovalFlowInvoicesList.");
    }
    const queryParameters = {};
    if (requestParameters.invoiceTypes !== void 0) {
      queryParameters["invoiceTypes"] = requestParameters.invoiceTypes;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/approval-flow`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(GetApprovalFlowInvoicesListResponseInnerFromJSON));
  }
  /**
   */
  async getApprovalFlowInvoicesList(requestParameters, initOverrides) {
    const response = await this.getApprovalFlowInvoicesListRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getArAgingReportRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/ar-aging`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetArAgingReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getArAgingReport(initOverrides) {
    const response = await this.getArAgingReportRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getBillingCycleInvoicesRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.billingCycleInvoiceType !== void 0) {
      queryParameters["billingCycleInvoiceType"] = requestParameters.billingCycleInvoiceType;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/billing-cycle`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetBillingCycleInvoicesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getBillingCycleInvoices(requestParameters = {}, initOverrides) {
    const response = await this.getBillingCycleInvoicesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getBillingCycleOverviewsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/billing-cycles/overviews`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetBillingCyclesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getBillingCycleOverviews(requestParameters = {}, initOverrides) {
    const response = await this.getBillingCycleOverviewsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getBillingCyclePageRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/pages/billing-cycle`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetBillingCyclePageResponseFromJSON(jsonValue));
  }
  /**
   */
  async getBillingCyclePage(requestParameters = {}, initOverrides) {
    const response = await this.getBillingCyclePageRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCatalogProductsRaw(requestParameters, initOverrides) {
    if (requestParameters.catalogProductId === null || requestParameters.catalogProductId === void 0) {
      throw new RequiredError("catalogProductId", "Required parameter requestParameters.catalogProductId was null or undefined when calling getCatalogProducts.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/catalog-products/{catalogProductId}`.replace(`{${"catalogProductId"}}`, encodeURIComponent(String(requestParameters.catalogProductId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCatalogProductsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCatalogProducts(requestParameters, initOverrides) {
    const response = await this.getCatalogProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCatalogProductsListRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/catalog-products`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCatalogProductsListResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCatalogProductsList(initOverrides) {
    const response = await this.getCatalogProductsListRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getCommitmentReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/commitment`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCommitmentReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCommitmentReport(requestParameters = {}, initOverrides) {
    const response = await this.getCommitmentReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCommitmentVsUsageRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/commitment-vs-usage`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCommitmentVsUsageResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCommitmentVsUsage(requestParameters = {}, initOverrides) {
    const response = await this.getCommitmentVsUsageRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getConnectedIntegrationsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/connected`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(IntegrationProvidersFromJSON));
  }
  /**
   */
  async getConnectedIntegrations(initOverrides) {
    const response = await this.getConnectedIntegrationsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContract.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContract(requestParameters, initOverrides) {
    const response = await this.getContractRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractBillingScheduleRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractBillingSchedule.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/billing-schedule/`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractBillingScheduleResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractBillingSchedule(requestParameters, initOverrides) {
    const response = await this.getContractBillingScheduleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractCustomFieldsRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractCustomFields.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/custom-fields`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractCustomFieldsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractCustomFields(requestParameters, initOverrides) {
    const response = await this.getContractCustomFieldsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractPageDataRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractPageData.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/pages/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractPageDataResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractPageData(requestParameters, initOverrides) {
    const response = await this.getContractPageDataRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractPdfRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractPdf.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/pdf/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractPdfResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractPdf(requestParameters, initOverrides) {
    const response = await this.getContractPdfRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractProductsConsumptionRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractProductsConsumption.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/products-consumption/`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractProductsConsumptionResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractProductsConsumption(requestParameters, initOverrides) {
    const response = await this.getContractProductsConsumptionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractProductsOverviewsRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractProductsOverviews.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/products-overviews/{contractId}/`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractProductsOverviewsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractProductsOverviews(requestParameters, initOverrides) {
    const response = await this.getContractProductsOverviewsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractRevenueScheduleReportRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractRevenueScheduleReport.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/contract-revenue-schedule/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractRevenueScheduleReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractRevenueScheduleReport(requestParameters, initOverrides) {
    const response = await this.getContractRevenueScheduleReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractUsageBreakdownRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractUsageBreakdown.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/usage-breakdown`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractUsageBreakdownResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractUsageBreakdown(requestParameters, initOverrides) {
    const response = await this.getContractUsageBreakdownRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractVersionRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getContractVersion.");
    }
    const queryParameters = {};
    if (requestParameters.versionId !== void 0) {
      queryParameters["versionId"] = requestParameters.versionId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/version`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractVersionResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractVersion(requestParameters, initOverrides) {
    const response = await this.getContractVersionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    if (requestParameters.contractStatuses !== void 0) {
      queryParameters["contractStatuses"] = requestParameters.contractStatuses;
    }
    if (requestParameters.syncStatuses !== void 0) {
      queryParameters["syncStatuses"] = requestParameters.syncStatuses;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    if (requestParameters.additionalFilters !== void 0) {
      queryParameters["additionalFilters"] = requestParameters.additionalFilters;
    }
    if (requestParameters.contractFilters !== void 0) {
      queryParameters["contractFilters"] = requestParameters.contractFilters;
    }
    if (requestParameters.includeContracts !== void 0) {
      queryParameters["includeContracts"] = requestParameters.includeContracts;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contracts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContracts(requestParameters = {}, initOverrides) {
    const response = await this.getContractsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractsOverviewsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.contractStatuses !== void 0) {
      queryParameters["contractStatuses"] = requestParameters.contractStatuses;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contracts/overviews`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractsOverviewsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractsOverviews(requestParameters = {}, initOverrides) {
    const response = await this.getContractsOverviewsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getContractsReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/contracts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetContractsReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getContractsReport(requestParameters = {}, initOverrides) {
    const response = await this.getContractsReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCreditLedgePdfRaw(requestParameters, initOverrides) {
    if (requestParameters.creditLedgerId === null || requestParameters.creditLedgerId === void 0) {
      throw new RequiredError("creditLedgerId", "Required parameter requestParameters.creditLedgerId was null or undefined when calling getCreditLedgePdf.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-ledger/pdf/{creditLedgerId}`.replace(`{${"creditLedgerId"}}`, encodeURIComponent(String(requestParameters.creditLedgerId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCreditLedgerPdfResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCreditLedgePdf(requestParameters, initOverrides) {
    const response = await this.getCreditLedgePdfRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCreditLedgerOverviewRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling getCreditLedgerOverview.");
    }
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-ledger/overview`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCreditLedgerOverviewResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCreditLedgerOverview(requestParameters, initOverrides) {
    const response = await this.getCreditLedgerOverviewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCreditNotesRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling getCreditNotes.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-ledger/{customerId}/credit-notes`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCreditNotesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCreditNotes(requestParameters, initOverrides) {
    const response = await this.getCreditNotesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCreditTypeRaw(requestParameters, initOverrides) {
    if (requestParameters.creditTypeId === null || requestParameters.creditTypeId === void 0) {
      throw new RequiredError("creditTypeId", "Required parameter requestParameters.creditTypeId was null or undefined when calling getCreditType.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-types/{creditTypeId}`.replace(`{${"creditTypeId"}}`, encodeURIComponent(String(requestParameters.creditTypeId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCreditTypeResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCreditType(requestParameters, initOverrides) {
    const response = await this.getCreditTypeRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomFieldDefinitionsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/custom-field-definitions`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomFieldDefinitionsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomFieldDefinitions(initOverrides) {
    const response = await this.getCustomFieldDefinitionsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling getCustomer.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomer(requestParameters, initOverrides) {
    const response = await this.getCustomerRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerCommitmentUsageRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/data-dashboard/customer-commitment-usage`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerCommitmentUsageResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomerCommitmentUsage(initOverrides) {
    const response = await this.getCustomerCommitmentUsageRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerContractsOverviewPageRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling getCustomerContractsOverviewPage.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/pages/customers/{customerId}/contracts`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCustomerContractsOverviewPageResponseInnerFromJSON));
  }
  /**
   */
  async getCustomerContractsOverviewPage(requestParameters, initOverrides) {
    const response = await this.getCustomerContractsOverviewPageRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerInvoicePageDataRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getCustomerInvoicePageData.");
    }
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling getCustomerInvoicePageData.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/pages/customers/{customerId}/invoice/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))).replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerInvoicePageDataResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomerInvoicePageData(requestParameters, initOverrides) {
    const response = await this.getCustomerInvoicePageDataRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerMasterReportRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/customer-master`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerMasterReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomerMasterReport(initOverrides) {
    const response = await this.getCustomerMasterReportRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerPortalCreditPoolsRaw(requestParameters, initOverrides) {
    if (requestParameters.token === null || requestParameters.token === void 0) {
      throw new RequiredError("token", "Required parameter requestParameters.token was null or undefined when calling getCustomerPortalCreditPools.");
    }
    const queryParameters = {};
    if (requestParameters.token !== void 0) {
      queryParameters["token"] = requestParameters.token;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/customer-portal/credit-pools`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerPortalCreditPoolsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomerPortalCreditPools(requestParameters, initOverrides) {
    const response = await this.getCustomerPortalCreditPoolsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerPortalDailyUsageDataRaw(requestParameters, initOverrides) {
    if (requestParameters.token === null || requestParameters.token === void 0) {
      throw new RequiredError("token", "Required parameter requestParameters.token was null or undefined when calling getCustomerPortalDailyUsageData.");
    }
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getCustomerPortalDailyUsageData.");
    }
    const queryParameters = {};
    if (requestParameters.token !== void 0) {
      queryParameters["token"] = requestParameters.token;
    }
    if (requestParameters.invoiceId !== void 0) {
      queryParameters["invoiceId"] = requestParameters.invoiceId;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/customer-portal/get-daily-usage-data`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCustomerPortalDailyUsageDataResponseInnerFromJSON));
  }
  /**
   */
  async getCustomerPortalDailyUsageData(requestParameters, initOverrides) {
    const response = await this.getCustomerPortalDailyUsageDataRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerPortalDataRaw(requestParameters, initOverrides) {
    if (requestParameters.token === null || requestParameters.token === void 0) {
      throw new RequiredError("token", "Required parameter requestParameters.token was null or undefined when calling getCustomerPortalData.");
    }
    const queryParameters = {};
    if (requestParameters.token !== void 0) {
      queryParameters["token"] = requestParameters.token;
    }
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/customer-portal/get-data`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerPortalDataResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomerPortalData(requestParameters, initOverrides) {
    const response = await this.getCustomerPortalDataRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerPortalInvoiceCheckoutLinkRaw(requestParameters, initOverrides) {
    if (requestParameters.token === null || requestParameters.token === void 0) {
      throw new RequiredError("token", "Required parameter requestParameters.token was null or undefined when calling getCustomerPortalInvoiceCheckoutLink.");
    }
    const queryParameters = {};
    if (requestParameters.token !== void 0) {
      queryParameters["token"] = requestParameters.token;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/customer-portal/invoice/stripe/checkout-link`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerPortalDataResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomerPortalInvoiceCheckoutLink(requestParameters, initOverrides) {
    const response = await this.getCustomerPortalInvoiceCheckoutLinkRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerPortalInvoicePdfRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getCustomerPortalInvoicePdf.");
    }
    if (requestParameters.token === null || requestParameters.token === void 0) {
      throw new RequiredError("token", "Required parameter requestParameters.token was null or undefined when calling getCustomerPortalInvoicePdf.");
    }
    const queryParameters = {};
    if (requestParameters.token !== void 0) {
      queryParameters["token"] = requestParameters.token;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/customer-portal/pdf/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerPortalInvoicePdfResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomerPortalInvoicePdf(requestParameters, initOverrides) {
    const response = await this.getCustomerPortalInvoicePdfRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerPortalMonthlyUsageDataRaw(requestParameters, initOverrides) {
    if (requestParameters.token === null || requestParameters.token === void 0) {
      throw new RequiredError("token", "Required parameter requestParameters.token was null or undefined when calling getCustomerPortalMonthlyUsageData.");
    }
    const queryParameters = {};
    if (requestParameters.token !== void 0) {
      queryParameters["token"] = requestParameters.token;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/customer-portal/get-monthly-usage-data`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCustomerPortalDailyUsageDataResponseInnerFromJSON));
  }
  /**
   */
  async getCustomerPortalMonthlyUsageData(requestParameters, initOverrides) {
    const response = await this.getCustomerPortalMonthlyUsageDataRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerRevenueReportRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/customer-revenue`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomerRevenueReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomerRevenueReport(initOverrides) {
    const response = await this.getCustomerRevenueReportRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomerStatusCountsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customers/status-counts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCustomerStatusCountsResponseInnerFromJSON));
  }
  /**
   */
  async getCustomerStatusCounts(initOverrides) {
    const response = await this.getCustomerStatusCountsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomersRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomers(requestParameters = {}, initOverrides) {
    const response = await this.getCustomersRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomersNamesRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customers/names`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomersNamesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomersNames(requestParameters = {}, initOverrides) {
    const response = await this.getCustomersNamesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomersOverviewsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.filters !== void 0) {
      queryParameters["filters"] = requestParameters.filters;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customers/overviews`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomersOverviewsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomersOverviews(requestParameters = {}, initOverrides) {
    const response = await this.getCustomersOverviewsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomersOverviewsNewRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.customerFilters !== void 0) {
      queryParameters["customerFilters"] = requestParameters.customerFilters;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customers/overviews-new`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomersOverviewsNewResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomersOverviewsNew(requestParameters = {}, initOverrides) {
    const response = await this.getCustomersOverviewsNewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getCustomersReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetCustomersReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getCustomersReport(requestParameters = {}, initOverrides) {
    const response = await this.getCustomersReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getDailyEventsDigestedRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/data-dashboard/daily-events-digested`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetDailyEventsDigestedResponseFromJSON(jsonValue));
  }
  /**
   */
  async getDailyEventsDigested(initOverrides) {
    const response = await this.getDailyEventsDigestedRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getDepositToRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/payments/deposit-to`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetDepositToResponseFromJSON(jsonValue));
  }
  /**
   */
  async getDepositTo(requestParameters = {}, initOverrides) {
    const response = await this.getDepositToRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getDynamicInvoiceRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getDynamicInvoice.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/dynamic/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetDynamicInvoiceResponseFromJSON(jsonValue));
  }
  /**
   */
  async getDynamicInvoice(requestParameters, initOverrides) {
    const response = await this.getDynamicInvoiceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getDynamicInvoiceByDiscriminatorRaw(requestParameters, initOverrides) {
    if (requestParameters.discriminator === null || requestParameters.discriminator === void 0) {
      throw new RequiredError("discriminator", "Required parameter requestParameters.discriminator was null or undefined when calling getDynamicInvoiceByDiscriminator.");
    }
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getDynamicInvoiceByDiscriminator.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/dynamic/{discriminator}/{id}`.replace(`{${"discriminator"}}`, encodeURIComponent(String(requestParameters.discriminator))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetDynamicInvoiceResponseFromJSON(jsonValue));
  }
  /**
   */
  async getDynamicInvoiceByDiscriminator(requestParameters, initOverrides) {
    const response = await this.getDynamicInvoiceByDiscriminatorRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getEventFieldValuesRaw(requestParameters, initOverrides) {
    if (requestParameters.eventName === null || requestParameters.eventName === void 0) {
      throw new RequiredError("eventName", "Required parameter requestParameters.eventName was null or undefined when calling getEventFieldValues.");
    }
    if (requestParameters.fieldName === null || requestParameters.fieldName === void 0) {
      throw new RequiredError("fieldName", "Required parameter requestParameters.fieldName was null or undefined when calling getEventFieldValues.");
    }
    const queryParameters = {};
    if (requestParameters.eventName !== void 0) {
      queryParameters["eventName"] = requestParameters.eventName;
    }
    if (requestParameters.fieldName !== void 0) {
      queryParameters["fieldName"] = requestParameters.fieldName;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/event-fields/event-field-values`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetEventFieldValuesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getEventFieldValues(requestParameters, initOverrides) {
    const response = await this.getEventFieldValuesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getEventFieldsRaw(requestParameters, initOverrides) {
    if (requestParameters.eventName === null || requestParameters.eventName === void 0) {
      throw new RequiredError("eventName", "Required parameter requestParameters.eventName was null or undefined when calling getEventFields.");
    }
    const queryParameters = {};
    if (requestParameters.eventName !== void 0) {
      queryParameters["eventName"] = requestParameters.eventName;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/event-fields`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetEventFieldsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getEventFields(requestParameters, initOverrides) {
    const response = await this.getEventFieldsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getEventNamesRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/event-fields/names`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetEventNamesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getEventNames(initOverrides) {
    const response = await this.getEventNamesRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getExchangeRatesRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/exchange-rates`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetExchangeRatesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getExchangeRates(initOverrides) {
    const response = await this.getExchangeRatesRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getExchangeRatesMatrixRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/exchange-rates/matrix`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetExchangeRatesMatrixResponseFromJSON(jsonValue));
  }
  /**
   */
  async getExchangeRatesMatrix(initOverrides) {
    const response = await this.getExchangeRatesMatrixRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getExportedIntegrationsRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getExportedIntegrations.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/exported-integrations/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(GetExportedIntegrationsResponseInnerFromJSON));
  }
  /**
   */
  async getExportedIntegrations(requestParameters, initOverrides) {
    const response = await this.getExportedIntegrationsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getExternalApiTokenRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/auth/external-api-token`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetExternalApiTokenResponseFromJSON(jsonValue));
  }
  /**
   */
  async getExternalApiToken(initOverrides) {
    const response = await this.getExternalApiTokenRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getExternalLinkRaw(requestParameters, initOverrides) {
    if (requestParameters.linkProvider === null || requestParameters.linkProvider === void 0) {
      throw new RequiredError("linkProvider", "Required parameter requestParameters.linkProvider was null or undefined when calling getExternalLink.");
    }
    if (requestParameters.entityType === null || requestParameters.entityType === void 0) {
      throw new RequiredError("entityType", "Required parameter requestParameters.entityType was null or undefined when calling getExternalLink.");
    }
    if (requestParameters.entityId === null || requestParameters.entityId === void 0) {
      throw new RequiredError("entityId", "Required parameter requestParameters.entityId was null or undefined when calling getExternalLink.");
    }
    const queryParameters = {};
    if (requestParameters.linkProvider !== void 0) {
      queryParameters["linkProvider"] = requestParameters.linkProvider;
    }
    if (requestParameters.entityType !== void 0) {
      queryParameters["entityType"] = requestParameters.entityType;
    }
    if (requestParameters.entityId !== void 0) {
      queryParameters["entityId"] = requestParameters.entityId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/external-link`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetExternalLinkResponseFromJSON(jsonValue));
  }
  /**
   */
  async getExternalLink(requestParameters, initOverrides) {
    const response = await this.getExternalLinkRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getFailedInvoiceDeliveriesReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/failed-invoice-deliveries`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetFailedInvoiceDeliveriesReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getFailedInvoiceDeliveriesReport(requestParameters = {}, initOverrides) {
    const response = await this.getFailedInvoiceDeliveriesReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getHomePageAccountSummaryRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/pages/home/account-summary`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetHomePageAccountSummaryResponseFromJSON(jsonValue));
  }
  /**
   */
  async getHomePageAccountSummary(initOverrides) {
    const response = await this.getHomePageAccountSummaryRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getIntegrationsSettingsRaw(requestParameters, initOverrides) {
    if (requestParameters.provider === null || requestParameters.provider === void 0) {
      throw new RequiredError("provider", "Required parameter requestParameters.provider was null or undefined when calling getIntegrationsSettings.");
    }
    const queryParameters = {};
    if (requestParameters.provider !== void 0) {
      queryParameters["provider"] = requestParameters.provider;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/settings`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetIntegrationsSettingsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getIntegrationsSettings(requestParameters, initOverrides) {
    const response = await this.getIntegrationsSettingsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvitationsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/invitations`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvitationsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvitations(initOverrides) {
    const response = await this.getInvitationsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoiceRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getInvoice.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoiceResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoice(requestParameters, initOverrides) {
    const response = await this.getInvoiceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoicePdfRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getInvoicePdf.");
    }
    const queryParameters = {};
    if (requestParameters.type !== void 0) {
      queryParameters["type"] = requestParameters.type;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/pdf/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoicePdfResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoicePdf(requestParameters, initOverrides) {
    const response = await this.getInvoicePdfRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoiceProductsIntegrationEntitiesRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getInvoiceProductsIntegrationEntities.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/{invoiceId}/products-integration-entities`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoiceProductsIntegrationEntitiesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoiceProductsIntegrationEntities(requestParameters, initOverrides) {
    const response = await this.getInvoiceProductsIntegrationEntitiesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoiceProductsIntegrationsRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getInvoiceProductsIntegrations.");
    }
    if (requestParameters.integration === null || requestParameters.integration === void 0) {
      throw new RequiredError("integration", "Required parameter requestParameters.integration was null or undefined when calling getInvoiceProductsIntegrations.");
    }
    const queryParameters = {};
    if (requestParameters.integration !== void 0) {
      queryParameters["integration"] = requestParameters.integration;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/invoice/{invoiceId}/products`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoiceProductsIntegrationsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoiceProductsIntegrations(requestParameters, initOverrides) {
    const response = await this.getInvoiceProductsIntegrationsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoiceUsageEventsReportRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling getInvoiceUsageEventsReport.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/{invoiceId}/usage-events-report`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async getInvoiceUsageEventsReport(requestParameters, initOverrides) {
    await this.getInvoiceUsageEventsReportRaw(requestParameters, initOverrides);
  }
  /**
   */
  async getInvoicesArHealthRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/ar-health`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoicesArHealthResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoicesArHealth(initOverrides) {
    const response = await this.getInvoicesArHealthRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoicesBreakdownStatsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/breakdown-stats`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoicesBreakdownStatsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoicesBreakdownStats(requestParameters = {}, initOverrides) {
    const response = await this.getInvoicesBreakdownStatsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoicesHighlightsStatisticsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    if (requestParameters.issuedDates !== void 0) {
      queryParameters["issuedDates"] = requestParameters.issuedDates;
    }
    if (requestParameters.filters !== void 0) {
      queryParameters["filters"] = requestParameters.filters;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/highlights-statistics`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoicesHighlightsStatisticsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoicesHighlightsStatistics(requestParameters = {}, initOverrides) {
    const response = await this.getInvoicesHighlightsStatisticsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoicesOverviewsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    if (requestParameters.dates !== void 0) {
      queryParameters["dates"] = requestParameters.dates;
    }
    if (requestParameters.reviewStatuses !== void 0) {
      queryParameters["reviewStatuses"] = requestParameters.reviewStatuses;
    }
    if (requestParameters.billingStatuses !== void 0) {
      queryParameters["billingStatuses"] = requestParameters.billingStatuses;
    }
    if (requestParameters.additionalFilters !== void 0) {
      queryParameters["additionalFilters"] = requestParameters.additionalFilters;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    if (requestParameters.contractId !== void 0) {
      queryParameters["contractId"] = requestParameters.contractId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/overviews`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoicesOverviewsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoicesOverviews(requestParameters = {}, initOverrides) {
    const response = await this.getInvoicesOverviewsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoicesOverviewsNewRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    if (requestParameters.issuedDates !== void 0) {
      queryParameters["issuedDates"] = requestParameters.issuedDates;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    if (requestParameters.filters !== void 0) {
      queryParameters["filters"] = requestParameters.filters;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/overviews-new`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoicesOverviewsNewResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoicesOverviewsNew(requestParameters = {}, initOverrides) {
    const response = await this.getInvoicesOverviewsNewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoicesStatisticsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/statistics`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoicesStatisticsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoicesStatistics(requestParameters = {}, initOverrides) {
    const response = await this.getInvoicesStatisticsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoicesSummaryRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/summary`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response);
  }
  /**
   */
  async getInvoicesSummary(requestParameters = {}, initOverrides) {
    const response = await this.getInvoicesSummaryRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getInvoicesSummaryReportRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/invoices-summary`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetInvoicesSummaryReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getInvoicesSummaryReport(initOverrides) {
    const response = await this.getInvoicesSummaryReportRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getJournalEntriesReportRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/journal-entries`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetJournalEntriesReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getJournalEntriesReport(initOverrides) {
    const response = await this.getJournalEntriesReportRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getLabelsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/labels`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetLabelsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getLabels(initOverrides) {
    const response = await this.getLabelsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getLatestContractRenewalRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling getLatestContractRenewal.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/renewals/latest`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetLatestContractRenewalResponseFromJSON(jsonValue));
  }
  /**
   */
  async getLatestContractRenewal(requestParameters, initOverrides) {
    const response = await this.getLatestContractRenewalRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getLatestEventsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    if (requestParameters.eventNames !== void 0) {
      queryParameters["eventNames"] = requestParameters.eventNames;
    }
    if (requestParameters.customerAlias !== void 0) {
      queryParameters["customerAlias"] = requestParameters.customerAlias;
    }
    if (requestParameters.ref !== void 0) {
      queryParameters["ref"] = requestParameters.ref;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/events/latest`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetLatestEventsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getLatestEvents(requestParameters = {}, initOverrides) {
    const response = await this.getLatestEventsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getLightInvoicesRaw(requestParameters, initOverrides) {
    if (requestParameters.invoicesIds === null || requestParameters.invoicesIds === void 0) {
      throw new RequiredError("invoicesIds", "Required parameter requestParameters.invoicesIds was null or undefined when calling getLightInvoices.");
    }
    const queryParameters = {};
    if (requestParameters.invoicesIds !== void 0) {
      queryParameters["invoicesIds"] = requestParameters.invoicesIds;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/light`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetLightInvoicesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getLightInvoices(requestParameters, initOverrides) {
    const response = await this.getLightInvoicesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getMeasurementsRaw(requestParameters, initOverrides) {
    if (requestParameters.startTime === null || requestParameters.startTime === void 0) {
      throw new RequiredError("startTime", "Required parameter requestParameters.startTime was null or undefined when calling getMeasurements.");
    }
    if (requestParameters.endTime === null || requestParameters.endTime === void 0) {
      throw new RequiredError("endTime", "Required parameter requestParameters.endTime was null or undefined when calling getMeasurements.");
    }
    const queryParameters = {};
    if (requestParameters.customersIds !== void 0) {
      queryParameters["customersIds"] = requestParameters.customersIds;
    }
    if (requestParameters.metersIds !== void 0) {
      queryParameters["metersIds"] = requestParameters.metersIds;
    }
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurements`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetMeasurementsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getMeasurements(requestParameters, initOverrides) {
    const response = await this.getMeasurementsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getMeasurementsStatsRaw(requestParameters, initOverrides) {
    if (requestParameters.startTime === null || requestParameters.startTime === void 0) {
      throw new RequiredError("startTime", "Required parameter requestParameters.startTime was null or undefined when calling getMeasurementsStats.");
    }
    if (requestParameters.endTime === null || requestParameters.endTime === void 0) {
      throw new RequiredError("endTime", "Required parameter requestParameters.endTime was null or undefined when calling getMeasurementsStats.");
    }
    const queryParameters = {};
    if (requestParameters.customersIds !== void 0) {
      queryParameters["customersIds"] = requestParameters.customersIds;
    }
    if (requestParameters.metersIds !== void 0) {
      queryParameters["metersIds"] = requestParameters.metersIds;
    }
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    if (requestParameters.eventNames !== void 0) {
      queryParameters["eventNames"] = requestParameters.eventNames;
    }
    if (requestParameters.mode !== void 0) {
      queryParameters["mode"] = requestParameters.mode;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurements/stats`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetMeasurementsStatsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getMeasurementsStats(requestParameters, initOverrides) {
    const response = await this.getMeasurementsStatsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getMeterDescriptionRaw(requestParameters, initOverrides) {
    if (requestParameters.getMeterDescriptionRequest === null || requestParameters.getMeterDescriptionRequest === void 0) {
      throw new RequiredError("getMeterDescriptionRequest", "Required parameter requestParameters.getMeterDescriptionRequest was null or undefined when calling getMeterDescription.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/meter/describe`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: GetMeterDescriptionRequestToJSON(requestParameters.getMeterDescriptionRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetMeterDescriptionResponseFromJSON(jsonValue));
  }
  /**
   */
  async getMeterDescription(requestParameters, initOverrides) {
    const response = await this.getMeterDescriptionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getMeterInstanceKeysRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling getMeterInstanceKeys.");
    }
    if (requestParameters.productId === null || requestParameters.productId === void 0) {
      throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling getMeterInstanceKeys.");
    }
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    if (requestParameters.productId !== void 0) {
      queryParameters["productId"] = requestParameters.productId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/meter/instance-keys`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetMeterInstanceKeysResponseFromJSON(jsonValue));
  }
  /**
   */
  async getMeterInstanceKeys(requestParameters, initOverrides) {
    const response = await this.getMeterInstanceKeysRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getMetersRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/meters`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetMetersResponseFromJSON(jsonValue));
  }
  /**
   */
  async getMeters(initOverrides) {
    const response = await this.getMetersRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getMonthlyClouserReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/monthly-closure`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetMonthlyClouserReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getMonthlyClouserReport(requestParameters = {}, initOverrides) {
    const response = await this.getMonthlyClouserReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getMrrWaterfallRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.month !== void 0) {
      queryParameters["month"] = requestParameters.month;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/revenue/mrr-waterfall`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetMrrWaterfallResponseFromJSON(jsonValue));
  }
  /**
   */
  async getMrrWaterfall(requestParameters = {}, initOverrides) {
    const response = await this.getMrrWaterfallRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getNetSuiteSubsidiariesRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.erpId !== void 0) {
      queryParameters["erpId"] = requestParameters.erpId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/subsidiaries`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetNetSuiteSubsidiariesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getNetSuiteSubsidiaries(requestParameters = {}, initOverrides) {
    const response = await this.getNetSuiteSubsidiariesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getNotificationAlertsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/notification-alerts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(GetNotificationAlertsResponseInnerFromJSON));
  }
  /**
   */
  async getNotificationAlerts(initOverrides) {
    const response = await this.getNotificationAlertsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getPaymentMethodsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/payments/payment-methods`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPaymentMethodsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPaymentMethods(requestParameters = {}, initOverrides) {
    const response = await this.getPaymentMethodsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getPaymentOverviewsRaw(requestParameters, initOverrides) {
    if (requestParameters.startTime === null || requestParameters.startTime === void 0) {
      throw new RequiredError("startTime", "Required parameter requestParameters.startTime was null or undefined when calling getPaymentOverviews.");
    }
    if (requestParameters.endTime === null || requestParameters.endTime === void 0) {
      throw new RequiredError("endTime", "Required parameter requestParameters.endTime was null or undefined when calling getPaymentOverviews.");
    }
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/payments/overviews`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPaymentOverviewsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPaymentOverviews(requestParameters, initOverrides) {
    const response = await this.getPaymentOverviewsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getPaymentsNewRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.paymentFilters !== void 0) {
      queryParameters["paymentFilters"] = requestParameters.paymentFilters;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/payments/overviews-new`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPaymentsNewResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPaymentsNew(requestParameters = {}, initOverrides) {
    const response = await this.getPaymentsNewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getPhaseLabelsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/phase-labels`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPhaseLabelsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPhaseLabels(initOverrides) {
    const response = await this.getPhaseLabelsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getPlanRaw(requestParameters, initOverrides) {
    if (requestParameters.planId === null || requestParameters.planId === void 0) {
      throw new RequiredError("planId", "Required parameter requestParameters.planId was null or undefined when calling getPlan.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plan/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPlanResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPlan(requestParameters, initOverrides) {
    const response = await this.getPlanRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getPlanOverviewRaw(requestParameters, initOverrides) {
    if (requestParameters.planId === null || requestParameters.planId === void 0) {
      throw new RequiredError("planId", "Required parameter requestParameters.planId was null or undefined when calling getPlanOverview.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plan/{planId}/overview`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPlanOverviewResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPlanOverview(requestParameters, initOverrides) {
    const response = await this.getPlanOverviewRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getPlanOverviewsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.planStatuses !== void 0) {
      queryParameters["planStatuses"] = requestParameters.planStatuses;
    }
    if (requestParameters.sort !== void 0) {
      queryParameters["sort"] = requestParameters.sort;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plans/overviews`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPlanOverviewsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPlanOverviews(requestParameters = {}, initOverrides) {
    const response = await this.getPlanOverviewsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getPotentialChildCustomersRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customers/potential-children`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPotentialChildCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPotentialChildCustomers(initOverrides) {
    const response = await this.getPotentialChildCustomersRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getPricingTemplatesRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/pricing/templates`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPricingTemplatesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPricingTemplates(initOverrides) {
    const response = await this.getPricingTemplatesRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getProductUsageByDateBreakdownRaw(requestParameters, initOverrides) {
    if (requestParameters.variantId === null || requestParameters.variantId === void 0) {
      throw new RequiredError("variantId", "Required parameter requestParameters.variantId was null or undefined when calling getProductUsageByDateBreakdown.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/product/variant/{variantId}/usage-by-date-breakdown`.replace(`{${"variantId"}}`, encodeURIComponent(String(requestParameters.variantId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetProductUsageByDateBreakdownResponseFromJSON(jsonValue));
  }
  /**
   */
  async getProductUsageByDateBreakdown(requestParameters, initOverrides) {
    const response = await this.getProductUsageByDateBreakdownRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getProductUsageChartDataRaw(requestParameters, initOverrides) {
    if (requestParameters.productId === null || requestParameters.productId === void 0) {
      throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling getProductUsageChartData.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/product/{productId}/usage-chart-data`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetProductUsageChartDataResponseFromJSON(jsonValue));
  }
  /**
   */
  async getProductUsageChartData(requestParameters, initOverrides) {
    const response = await this.getProductUsageChartDataRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getProductsPageDataRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    if (requestParameters.page !== void 0) {
      queryParameters["page"] = requestParameters.page;
    }
    if (requestParameters.pageSize !== void 0) {
      queryParameters["pageSize"] = requestParameters.pageSize;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/pages/products`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetProductsPageDataResponseFromJSON(jsonValue));
  }
  /**
   */
  async getProductsPageData(requestParameters = {}, initOverrides) {
    const response = await this.getProductsPageDataRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getProductsUsageReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/products-usage`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetProductsUsageReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getProductsUsageReport(requestParameters = {}, initOverrides) {
    const response = await this.getProductsUsageReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getPublicApiKeysRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/public-api-keys`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetPublicApiKeysResponseFromJSON(jsonValue));
  }
  /**
   */
  async getPublicApiKeys(initOverrides) {
    const response = await this.getPublicApiKeysRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getRecurringRevenueRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    if (requestParameters.contractId !== void 0) {
      queryParameters["contractId"] = requestParameters.contractId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/revenue/recurring`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetRecurringRevenueResponseFromJSON(jsonValue));
  }
  /**
   */
  async getRecurringRevenue(requestParameters = {}, initOverrides) {
    const response = await this.getRecurringRevenueRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getRecurringRevenueReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/recurring-revenue`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetRecurringRevenueReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getRecurringRevenueReport(requestParameters = {}, initOverrides) {
    const response = await this.getRecurringRevenueReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getReportsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/reports`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReportsResponseInnerFromJSON));
  }
  /**
   */
  async getReports(initOverrides) {
    const response = await this.getReportsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getRevenueByCurrencyRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/data-dashboard/revenue-by-currency`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetRevenueByCurrencyResponseFromJSON(jsonValue));
  }
  /**
   */
  async getRevenueByCurrency(initOverrides) {
    const response = await this.getRevenueByCurrencyRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getSandboxUserRaw(requestParameters, initOverrides) {
    if (requestParameters.environment === null || requestParameters.environment === void 0) {
      throw new RequiredError("environment", "Required parameter requestParameters.environment was null or undefined when calling getSandboxUser.");
    }
    const queryParameters = {};
    if (requestParameters.environment !== void 0) {
      queryParameters["environment"] = requestParameters.environment;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/users/sandbox`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SandboxUserResponseFromJSON(jsonValue));
  }
  /**
   */
  async getSandboxUser(requestParameters, initOverrides) {
    const response = await this.getSandboxUserRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getSlackChannelsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/slack/channels`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SlackGetChannelsResponseSchemaFromJSON(jsonValue));
  }
  /**
   */
  async getSlackChannels(initOverrides) {
    const response = await this.getSlackChannelsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getSlackUsersRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/slack/users`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SlackGetUsersResponseSchemaFromJSON(jsonValue));
  }
  /**
   */
  async getSlackUsers(initOverrides) {
    const response = await this.getSlackUsersRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getStepTypesRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/step-types`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetStepTypesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getStepTypes(initOverrides) {
    const response = await this.getStepTypesRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getSubsidiariesRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/subsidiaries`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetSubsidiariesResponseFromJSON(jsonValue));
  }
  /**
   */
  async getSubsidiaries(initOverrides) {
    const response = await this.getSubsidiariesRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getTopOverdueCustomersRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customers/top-overdue-customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetTopOverdueCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async getTopOverdueCustomers(initOverrides) {
    const response = await this.getTopOverdueCustomersRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getUnapprovedInvoicesReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/unapproved-invoices`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new BlobApiResponse(response);
  }
  /**
   */
  async getUnapprovedInvoicesReport(requestParameters = {}, initOverrides) {
    const response = await this.getUnapprovedInvoicesReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getUnchargedUsageReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/uncharged-usage`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetUnchargedUsageReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getUnchargedUsageReport(requestParameters = {}, initOverrides) {
    const response = await this.getUnchargedUsageReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getUnmeteredEventsReportRaw(requestParameters, initOverrides) {
    if (requestParameters.startTime === null || requestParameters.startTime === void 0) {
      throw new RequiredError("startTime", "Required parameter requestParameters.startTime was null or undefined when calling getUnmeteredEventsReport.");
    }
    if (requestParameters.endTime === null || requestParameters.endTime === void 0) {
      throw new RequiredError("endTime", "Required parameter requestParameters.endTime was null or undefined when calling getUnmeteredEventsReport.");
    }
    const queryParameters = {};
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/unmetered-events`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetUnmeteredEventsReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getUnmeteredEventsReport(requestParameters, initOverrides) {
    const response = await this.getUnmeteredEventsReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getUpcomingInvoicesReportRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/upcoming-invoices`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetUpcomingInvoicesReportResponseFromJSON(jsonValue));
  }
  /**
   */
  async getUpcomingInvoicesReport(initOverrides) {
    const response = await this.getUpcomingInvoicesReportRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getUsageByMeterRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/data-dashboard/usage-by-meter`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetUsageByMeterResponseFromJSON(jsonValue));
  }
  /**
   */
  async getUsageByMeter(initOverrides) {
    const response = await this.getUsageByMeterRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getUsageEventsReportConfigurationRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/account/usage-events-report-configuration`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetUsageEventsReportConfigurationResponseFromJSON(jsonValue));
  }
  /**
   */
  async getUsageEventsReportConfiguration(initOverrides) {
    const response = await this.getUsageEventsReportConfigurationRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getUsageReportRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.reportId !== void 0) {
      queryParameters["reportId"] = requestParameters.reportId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/usage`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new BlobApiResponse(response);
  }
  /**
   */
  async getUsageReport(requestParameters = {}, initOverrides) {
    const response = await this.getUsageReportRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getUsageReportV2Raw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.startTime !== void 0) {
      queryParameters["startTime"] = requestParameters.startTime.toISOString();
    }
    if (requestParameters.endTime !== void 0) {
      queryParameters["endTime"] = requestParameters.endTime.toISOString();
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/usage-report-v2`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetUsageReportV2ResponseFromJSON(jsonValue));
  }
  /**
   */
  async getUsageReportV2(requestParameters = {}, initOverrides) {
    const response = await this.getUsageReportV2Raw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getUsersRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetUsersResponseFromJSON(jsonValue));
  }
  /**
   */
  async getUsers(initOverrides) {
    const response = await this.getUsersRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getWebhookSubscriptionsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/webhook-subscriptions`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWebhookSubscriptionsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getWebhookSubscriptions(initOverrides) {
    const response = await this.getWebhookSubscriptionsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getWorkflowRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getWorkflow.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWorkflowResponseFromJSON(jsonValue));
  }
  /**
   */
  async getWorkflow(requestParameters, initOverrides) {
    const response = await this.getWorkflowRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getWorkflowExecutionRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getWorkflowExecution.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflow-executions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWorkflowExecutionResponseFromJSON(jsonValue));
  }
  /**
   */
  async getWorkflowExecution(requestParameters, initOverrides) {
    const response = await this.getWorkflowExecutionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getWorkflowExecutionsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.workflowId !== void 0) {
      queryParameters["workflowId"] = requestParameters.workflowId;
    }
    if (requestParameters.definitionId !== void 0) {
      queryParameters["definitionId"] = requestParameters.definitionId;
    }
    if (requestParameters.status !== void 0) {
      queryParameters["status"] = requestParameters.status;
    }
    if (requestParameters.from !== void 0) {
      queryParameters["from"] = requestParameters.from.toISOString();
    }
    if (requestParameters.to !== void 0) {
      queryParameters["to"] = requestParameters.to.toISOString();
    }
    if (requestParameters.limit !== void 0) {
      queryParameters["limit"] = requestParameters.limit;
    }
    if (requestParameters.skip !== void 0) {
      queryParameters["skip"] = requestParameters.skip;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflow-executions`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWorkflowExecutionsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getWorkflowExecutions(requestParameters = {}, initOverrides) {
    const response = await this.getWorkflowExecutionsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getWorkflowStarterRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getWorkflowStarter.");
    }
    const queryParameters = {};
    if (requestParameters.action !== void 0) {
      queryParameters["action"] = requestParameters.action;
    }
    if (requestParameters.parameters !== void 0) {
      queryParameters["parameters"] = requestParameters.parameters;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflow-starters/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWorkflowStarterResponseFromJSON(jsonValue));
  }
  /**
   */
  async getWorkflowStarter(requestParameters, initOverrides) {
    const response = await this.getWorkflowStarterRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getWorkflowStartersRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflow-starters`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWorkflowStartersResponseFromJSON(jsonValue));
  }
  /**
   */
  async getWorkflowStarters(initOverrides) {
    const response = await this.getWorkflowStartersRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async getWorkflowVersionsRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getWorkflowVersions.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows/definitions/{id}/versions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWorkflowVersionsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getWorkflowVersions(requestParameters, initOverrides) {
    const response = await this.getWorkflowVersionsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getWorkflowsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.status !== void 0) {
      queryParameters["status"] = requestParameters.status;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetWorkflowsResponseFromJSON(jsonValue));
  }
  /**
   */
  async getWorkflows(requestParameters = {}, initOverrides) {
    const response = await this.getWorkflowsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getYtdBilledRevenueRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    if (requestParameters.contractId !== void 0) {
      queryParameters["contractId"] = requestParameters.contractId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/revenue/ytd-billed`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetYtdBilledRevenueResponseFromJSON(jsonValue));
  }
  /**
   */
  async getYtdBilledRevenue(requestParameters = {}, initOverrides) {
    const response = await this.getYtdBilledRevenueRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async getYtdRevenueTaxRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    if (requestParameters.contractId !== void 0) {
      queryParameters["contractId"] = requestParameters.contractId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/revenue/ytd-revenue-tax`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => GetYtdRevenueTaxResponseFromJSON(jsonValue));
  }
  /**
   */
  async getYtdRevenueTax(requestParameters = {}, initOverrides) {
    const response = await this.getYtdRevenueTaxRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async hubspotAuthCallbackRaw(requestParameters, initOverrides) {
    if (requestParameters.code === null || requestParameters.code === void 0) {
      throw new RequiredError("code", "Required parameter requestParameters.code was null or undefined when calling hubspotAuthCallback.");
    }
    if (requestParameters.state === null || requestParameters.state === void 0) {
      throw new RequiredError("state", "Required parameter requestParameters.state was null or undefined when calling hubspotAuthCallback.");
    }
    const queryParameters = {};
    if (requestParameters.code !== void 0) {
      queryParameters["code"] = requestParameters.code;
    }
    if (requestParameters.state !== void 0) {
      queryParameters["state"] = requestParameters.state;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/integrations/hubspot/auth/callback`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async hubspotAuthCallback(requestParameters, initOverrides) {
    await this.hubspotAuthCallbackRaw(requestParameters, initOverrides);
  }
  /**
   */
  async hubspotAuthConnectRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/hubspot/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => HubspotAuthConnectResponseFromJSON(jsonValue));
  }
  /**
   */
  async hubspotAuthConnect(initOverrides) {
    const response = await this.hubspotAuthConnectRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async hubspotSyncCustomersRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/hubspot/sync-customers`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async hubspotSyncCustomers(initOverrides) {
    await this.hubspotSyncCustomersRaw(initOverrides);
  }
  /**
   */
  async invalidateExternalApiTokenRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/auth/external-api-token/invalidate`,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async invalidateExternalApiToken(initOverrides) {
    await this.invalidateExternalApiTokenRaw(initOverrides);
  }
  /**
   */
  async inviteUserRaw(requestParameters, initOverrides) {
    if (requestParameters.inviteUserRequest === null || requestParameters.inviteUserRequest === void 0) {
      throw new RequiredError("inviteUserRequest", "Required parameter requestParameters.inviteUserRequest was null or undefined when calling inviteUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/invite`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: InviteUserRequestToJSON(requestParameters.inviteUserRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async inviteUser(requestParameters, initOverrides) {
    await this.inviteUserRaw(requestParameters, initOverrides);
  }
  /**
   */
  async listContractCreditPoolsRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling listContractCreditPools.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/credit-pools`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ListContractCreditPoolsResponseFromJSON(jsonValue));
  }
  /**
   */
  async listContractCreditPools(requestParameters, initOverrides) {
    const response = await this.listContractCreditPoolsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async listCreditPoolsRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling listCreditPools.");
    }
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-pools`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ListCreditPoolsResponseFromJSON(jsonValue));
  }
  /**
   */
  async listCreditPools(requestParameters, initOverrides) {
    const response = await this.listCreditPoolsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async listCreditTypesRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.nameSearch !== void 0) {
      queryParameters["nameSearch"] = requestParameters.nameSearch;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-types`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ListCreditTypesResponseFromJSON(jsonValue));
  }
  /**
   */
  async listCreditTypes(requestParameters = {}, initOverrides) {
    const response = await this.listCreditTypesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async listCustomerNotesRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling listCustomerNotes.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer-notes/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ListCustomerNotesResponseFromJSON(jsonValue));
  }
  /**
   */
  async listCustomerNotes(requestParameters, initOverrides) {
    const response = await this.listCustomerNotesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async listJobTasksRaw(requestParameters, initOverrides) {
    if (requestParameters.jobId === null || requestParameters.jobId === void 0) {
      throw new RequiredError("jobId", "Required parameter requestParameters.jobId was null or undefined when calling listJobTasks.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/{jobId}/tasks`.replace(`{${"jobId"}}`, encodeURIComponent(String(requestParameters.jobId))),
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ListJobTasksResponseInnerFromJSON));
  }
  /**
   */
  async listJobTasks(requestParameters, initOverrides) {
    const response = await this.listJobTasksRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async listJobsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ListJobsResponseInnerFromJSON));
  }
  /**
   */
  async listJobs(initOverrides) {
    const response = await this.listJobsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async loginRaw(requestParameters, initOverrides) {
    if (requestParameters.loginRequest === null || requestParameters.loginRequest === void 0) {
      throw new RequiredError("loginRequest", "Required parameter requestParameters.loginRequest was null or undefined when calling login.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/auth/login`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: LoginRequestToJSON(requestParameters.loginRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
  }
  /**
   */
  async login(requestParameters, initOverrides) {
    const response = await this.loginRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async migrateToAutomaticTaxRaw(requestParameters, initOverrides) {
    if (requestParameters.migrateToAutomaticTaxRequest === null || requestParameters.migrateToAutomaticTaxRequest === void 0) {
      throw new RequiredError("migrateToAutomaticTaxRequest", "Required parameter requestParameters.migrateToAutomaticTaxRequest was null or undefined when calling migrateToAutomaticTax.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customers/migrate-to-automatic-tax`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: MigrateToAutomaticTaxRequestToJSON(requestParameters.migrateToAutomaticTaxRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => MigrateToAutomaticTaxResponseFromJSON(jsonValue));
  }
  /**
   */
  async migrateToAutomaticTax(requestParameters, initOverrides) {
    const response = await this.migrateToAutomaticTaxRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async modifyCustomerNoteRaw(requestParameters, initOverrides) {
    if (requestParameters.noteId === null || requestParameters.noteId === void 0) {
      throw new RequiredError("noteId", "Required parameter requestParameters.noteId was null or undefined when calling modifyCustomerNote.");
    }
    if (requestParameters.modifyCustomerNoteRequest === null || requestParameters.modifyCustomerNoteRequest === void 0) {
      throw new RequiredError("modifyCustomerNoteRequest", "Required parameter requestParameters.modifyCustomerNoteRequest was null or undefined when calling modifyCustomerNote.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer-note/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters.noteId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: ModifyCustomerNoteRequestToJSON(requestParameters.modifyCustomerNoteRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ModifyCustomerNoteResponseFromJSON(jsonValue));
  }
  /**
   */
  async modifyCustomerNote(requestParameters, initOverrides) {
    const response = await this.modifyCustomerNoteRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async modifyExternalProductRaw(requestParameters, initOverrides) {
    if (requestParameters.productId === null || requestParameters.productId === void 0) {
      throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling modifyExternalProduct.");
    }
    if (requestParameters.integration === null || requestParameters.integration === void 0) {
      throw new RequiredError("integration", "Required parameter requestParameters.integration was null or undefined when calling modifyExternalProduct.");
    }
    const queryParameters = {};
    if (requestParameters.integration !== void 0) {
      queryParameters["integration"] = requestParameters.integration;
    }
    if (requestParameters.externalId !== void 0) {
      queryParameters["externalId"] = requestParameters.externalId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/product/{productId}/external-integration`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async modifyExternalProduct(requestParameters, initOverrides) {
    await this.modifyExternalProductRaw(requestParameters, initOverrides);
  }
  /**
   */
  async modifyWorkflowRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling modifyWorkflow.");
    }
    if (requestParameters.modifyWorkflowRequest === null || requestParameters.modifyWorkflowRequest === void 0) {
      throw new RequiredError("modifyWorkflowRequest", "Required parameter requestParameters.modifyWorkflowRequest was null or undefined when calling modifyWorkflow.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: ModifyWorkflowRequestToJSON(requestParameters.modifyWorkflowRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ModifyWorkflowResponseFromJSON(jsonValue));
  }
  /**
   */
  async modifyWorkflow(requestParameters, initOverrides) {
    const response = await this.modifyWorkflowRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async morningConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.morningConnectRequest === null || requestParameters.morningConnectRequest === void 0) {
      throw new RequiredError("morningConnectRequest", "Required parameter requestParameters.morningConnectRequest was null or undefined when calling morningConnect.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/morning/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: MorningConnectRequestToJSON(requestParameters.morningConnectRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async morningConnect(requestParameters, initOverrides) {
    await this.morningConnectRaw(requestParameters, initOverrides);
  }
  /**
   */
  async morningExportInvoicesRaw(requestParameters, initOverrides) {
    if (requestParameters.morningExportInvoicesRequest === null || requestParameters.morningExportInvoicesRequest === void 0) {
      throw new RequiredError("morningExportInvoicesRequest", "Required parameter requestParameters.morningExportInvoicesRequest was null or undefined when calling morningExportInvoices.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/morning/export-invoices`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: MorningExportInvoicesRequestToJSON(requestParameters.morningExportInvoicesRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async morningExportInvoices(requestParameters, initOverrides) {
    await this.morningExportInvoicesRaw(requestParameters, initOverrides);
  }
  /**
   */
  async morningGetCustomersRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/morning/get-customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => MorningGetCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async morningGetCustomers(requestParameters = {}, initOverrides) {
    const response = await this.morningGetCustomersRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async netSuiteConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.netSuiteConnectRequest === null || requestParameters.netSuiteConnectRequest === void 0) {
      throw new RequiredError("netSuiteConnectRequest", "Required parameter requestParameters.netSuiteConnectRequest was null or undefined when calling netSuiteConnect.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: NetSuiteConnectRequestToJSON(requestParameters.netSuiteConnectRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async netSuiteConnect(requestParameters, initOverrides) {
    await this.netSuiteConnectRaw(requestParameters, initOverrides);
  }
  /**
   */
  async netSuiteExportCreditMemoRaw(requestParameters, initOverrides) {
    if (requestParameters.netSuiteExportCreditMemoRequest === null || requestParameters.netSuiteExportCreditMemoRequest === void 0) {
      throw new RequiredError("netSuiteExportCreditMemoRequest", "Required parameter requestParameters.netSuiteExportCreditMemoRequest was null or undefined when calling netSuiteExportCreditMemo.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/export-credit-memo`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: NetSuiteExportCreditMemoRequestToJSON(requestParameters.netSuiteExportCreditMemoRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async netSuiteExportCreditMemo(requestParameters, initOverrides) {
    await this.netSuiteExportCreditMemoRaw(requestParameters, initOverrides);
  }
  /**
   */
  async netSuiteGetClassesRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.subsidiaryId !== void 0) {
      queryParameters["subsidiaryId"] = requestParameters.subsidiaryId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/classes`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => NetSuiteGetClassesResponseFromJSON(jsonValue));
  }
  /**
   */
  async netSuiteGetClasses(requestParameters = {}, initOverrides) {
    const response = await this.netSuiteGetClassesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async netSuiteGetCreditItemsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/credit-items`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(BillingCycleCustomersInnerFromJSON));
  }
  /**
   */
  async netSuiteGetCreditItems(initOverrides) {
    const response = await this.netSuiteGetCreditItemsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async netSuiteGetCustomerRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling netSuiteGetCustomer.");
    }
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/customer`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => NetSuiteGetCustomerResponseFromJSON(jsonValue));
  }
  /**
   */
  async netSuiteGetCustomer(requestParameters, initOverrides) {
    const response = await this.netSuiteGetCustomerRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async netSuiteGetCustomersRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => NetSuiteGetCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async netSuiteGetCustomers(requestParameters = {}, initOverrides) {
    const response = await this.netSuiteGetCustomersRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async netSuiteGetDepositToAccountsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/deposit-to-accounts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => NetSuiteGetDepositToAccountsResponseFromJSON(jsonValue));
  }
  /**
   */
  async netSuiteGetDepositToAccounts(initOverrides) {
    const response = await this.netSuiteGetDepositToAccountsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async netSuiteGetInvoiceDashboardUrlRaw(requestParameters, initOverrides) {
    if (requestParameters.vayuInvoiceId === null || requestParameters.vayuInvoiceId === void 0) {
      throw new RequiredError("vayuInvoiceId", "Required parameter requestParameters.vayuInvoiceId was null or undefined when calling netSuiteGetInvoiceDashboardUrl.");
    }
    const queryParameters = {};
    if (requestParameters.vayuInvoiceId !== void 0) {
      queryParameters["vayuInvoiceId"] = requestParameters.vayuInvoiceId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/invoice-dashboard-url`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => NetSuiteGetInvoiceDashboardUrlResponseFromJSON(jsonValue));
  }
  /**
   */
  async netSuiteGetInvoiceDashboardUrl(requestParameters, initOverrides) {
    const response = await this.netSuiteGetInvoiceDashboardUrlRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async netSuiteGetProductsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.customerId !== void 0) {
      queryParameters["customerId"] = requestParameters.customerId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/products`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => NetSuiteGetProductsResponseFromJSON(jsonValue));
  }
  /**
   */
  async netSuiteGetProducts(requestParameters = {}, initOverrides) {
    const response = await this.netSuiteGetProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async netSuiteSyncInvoicesRaw(requestParameters, initOverrides) {
    if (requestParameters.netSuiteSyncInvoicesRequest === null || requestParameters.netSuiteSyncInvoicesRequest === void 0) {
      throw new RequiredError("netSuiteSyncInvoicesRequest", "Required parameter requestParameters.netSuiteSyncInvoicesRequest was null or undefined when calling netSuiteSyncInvoices.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/sync-invoices`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: NetSuiteSyncInvoicesRequestToJSON(requestParameters.netSuiteSyncInvoicesRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async netSuiteSyncInvoices(requestParameters, initOverrides) {
    await this.netSuiteSyncInvoicesRaw(requestParameters, initOverrides);
  }
  /**
   */
  async netSuiteSyncInvoicesSalesOrderRaw(requestParameters, initOverrides) {
    if (requestParameters.netSuiteSyncInvoicesSalesOrderRequest === null || requestParameters.netSuiteSyncInvoicesSalesOrderRequest === void 0) {
      throw new RequiredError("netSuiteSyncInvoicesSalesOrderRequest", "Required parameter requestParameters.netSuiteSyncInvoicesSalesOrderRequest was null or undefined when calling netSuiteSyncInvoicesSalesOrder.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/sync-invoices-sales-order`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: NetSuiteSyncInvoicesSalesOrderRequestToJSON(requestParameters.netSuiteSyncInvoicesSalesOrderRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async netSuiteSyncInvoicesSalesOrder(requestParameters, initOverrides) {
    await this.netSuiteSyncInvoicesSalesOrderRaw(requestParameters, initOverrides);
  }
  /**
   */
  async netSuiteUpdateSalesOrderRaw(requestParameters, initOverrides) {
    if (requestParameters.netSuiteUpdateSalesOrderRequest === null || requestParameters.netSuiteUpdateSalesOrderRequest === void 0) {
      throw new RequiredError("netSuiteUpdateSalesOrderRequest", "Required parameter requestParameters.netSuiteUpdateSalesOrderRequest was null or undefined when calling netSuiteUpdateSalesOrder.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/net-suite/update-sales-order`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: NetSuiteUpdateSalesOrderRequestToJSON(requestParameters.netSuiteUpdateSalesOrderRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async netSuiteUpdateSalesOrder(requestParameters, initOverrides) {
    await this.netSuiteUpdateSalesOrderRaw(requestParameters, initOverrides);
  }
  /**
   */
  async paddleConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.paddleConnectRequest === null || requestParameters.paddleConnectRequest === void 0) {
      throw new RequiredError("paddleConnectRequest", "Required parameter requestParameters.paddleConnectRequest was null or undefined when calling paddleConnect.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/paddle/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PaddleConnectRequestToJSON(requestParameters.paddleConnectRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async paddleConnect(requestParameters, initOverrides) {
    await this.paddleConnectRaw(requestParameters, initOverrides);
  }
  /**
   */
  async paddleEventRaw(requestParameters, initOverrides) {
    if (requestParameters.paddleEventAccountId === null || requestParameters.paddleEventAccountId === void 0) {
      throw new RequiredError("paddleEventAccountId", "Required parameter requestParameters.paddleEventAccountId was null or undefined when calling paddleEvent.");
    }
    if (requestParameters.body === null || requestParameters.body === void 0) {
      throw new RequiredError("body", "Required parameter requestParameters.body was null or undefined when calling paddleEvent.");
    }
    const queryParameters = {};
    if (requestParameters.paddleEventAccountId !== void 0) {
      queryParameters["paddleEventAccountId"] = requestParameters.paddleEventAccountId;
    }
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/integrations/paddle/event`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.body
    }, initOverrides);
    return new JSONApiResponse(response);
  }
  /**
   */
  async paddleEvent(requestParameters, initOverrides) {
    const response = await this.paddleEventRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async paddleExportInvoicesRaw(requestParameters, initOverrides) {
    if (requestParameters.paddleExportInvoicesRequest === null || requestParameters.paddleExportInvoicesRequest === void 0) {
      throw new RequiredError("paddleExportInvoicesRequest", "Required parameter requestParameters.paddleExportInvoicesRequest was null or undefined when calling paddleExportInvoices.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/paddle/export-invoices`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: PaddleExportInvoicesRequestToJSON(requestParameters.paddleExportInvoicesRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async paddleExportInvoices(requestParameters, initOverrides) {
    await this.paddleExportInvoicesRaw(requestParameters, initOverrides);
  }
  /**
   */
  async paddleGetCustomersRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/paddle/customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PaddleGetCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async paddleGetCustomers(requestParameters = {}, initOverrides) {
    const response = await this.paddleGetCustomersRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async paddleGetProductsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/paddle/products`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PaddleGetProductsResponseFromJSON(jsonValue));
  }
  /**
   */
  async paddleGetProducts(initOverrides) {
    const response = await this.paddleGetProductsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async paddleGetTransactionUrlRaw(requestParameters, initOverrides) {
    if (requestParameters.vayuInvoiceId === null || requestParameters.vayuInvoiceId === void 0) {
      throw new RequiredError("vayuInvoiceId", "Required parameter requestParameters.vayuInvoiceId was null or undefined when calling paddleGetTransactionUrl.");
    }
    const queryParameters = {};
    if (requestParameters.vayuInvoiceId !== void 0) {
      queryParameters["vayuInvoiceId"] = requestParameters.vayuInvoiceId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/paddle/transaction-url`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PaddleGetTransactionUrlResponseFromJSON(jsonValue));
  }
  /**
   */
  async paddleGetTransactionUrl(requestParameters, initOverrides) {
    const response = await this.paddleGetTransactionUrlRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async pingWebhookSubscriptionRaw(requestParameters, initOverrides) {
    if (requestParameters.webhookSubscriptionId === null || requestParameters.webhookSubscriptionId === void 0) {
      throw new RequiredError("webhookSubscriptionId", "Required parameter requestParameters.webhookSubscriptionId was null or undefined when calling pingWebhookSubscription.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/webhook-subscriptions/{webhookSubscriptionId}/ping`.replace(`{${"webhookSubscriptionId"}}`, encodeURIComponent(String(requestParameters.webhookSubscriptionId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PingWebhookSubscriptionResponseFromJSON(jsonValue));
  }
  /**
   */
  async pingWebhookSubscription(requestParameters, initOverrides) {
    const response = await this.pingWebhookSubscriptionRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async postCreditNoteRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling postCreditNote.");
    }
    if (requestParameters.issueCreditNoteRequest === null || requestParameters.issueCreditNoteRequest === void 0) {
      throw new RequiredError("issueCreditNoteRequest", "Required parameter requestParameters.issueCreditNoteRequest was null or undefined when calling postCreditNote.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-ledger/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: IssueCreditNoteRequestToJSON(requestParameters.issueCreditNoteRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => IssueCreditNoteResponseFromJSON(jsonValue));
  }
  /**
   */
  async postCreditNote(requestParameters, initOverrides) {
    const response = await this.postCreditNoteRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async publishWorkflowRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling publishWorkflow.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows/{id}/publish`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => PublishWorkflowResponseFromJSON(jsonValue));
  }
  /**
   */
  async publishWorkflow(requestParameters, initOverrides) {
    const response = await this.publishWorkflowRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async quickbooksAuthCallbackRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.code !== void 0) {
      queryParameters["code"] = requestParameters.code;
    }
    if (requestParameters.state !== void 0) {
      queryParameters["state"] = requestParameters.state;
    }
    if (requestParameters.realmId !== void 0) {
      queryParameters["realmId"] = requestParameters.realmId;
    }
    if (requestParameters.error !== void 0) {
      queryParameters["error"] = requestParameters.error;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/integrations/quickbooks/auth/callback`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async quickbooksAuthCallback(requestParameters = {}, initOverrides) {
    await this.quickbooksAuthCallbackRaw(requestParameters, initOverrides);
  }
  /**
   */
  async quickbooksConnectRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/quickbooks/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => QuickBooksConnectResponseFromJSON(jsonValue));
  }
  /**
   */
  async quickbooksConnect(initOverrides) {
    const response = await this.quickbooksConnectRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async quickbooksExportCreditMemoRaw(requestParameters, initOverrides) {
    if (requestParameters.quickBooksExportCreditMemoRequest === null || requestParameters.quickBooksExportCreditMemoRequest === void 0) {
      throw new RequiredError("quickBooksExportCreditMemoRequest", "Required parameter requestParameters.quickBooksExportCreditMemoRequest was null or undefined when calling quickbooksExportCreditMemo.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/quickbooks/export-credit-memo`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: QuickBooksExportCreditMemoRequestToJSON(requestParameters.quickBooksExportCreditMemoRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async quickbooksExportCreditMemo(requestParameters, initOverrides) {
    await this.quickbooksExportCreditMemoRaw(requestParameters, initOverrides);
  }
  /**
   */
  async quickbooksExportInvoicesRaw(requestParameters, initOverrides) {
    if (requestParameters.quickBooksExportInvoicesRequest === null || requestParameters.quickBooksExportInvoicesRequest === void 0) {
      throw new RequiredError("quickBooksExportInvoicesRequest", "Required parameter requestParameters.quickBooksExportInvoicesRequest was null or undefined when calling quickbooksExportInvoices.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/quickbooks/export-invoices`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: QuickBooksExportInvoicesRequestToJSON(requestParameters.quickBooksExportInvoicesRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async quickbooksExportInvoices(requestParameters, initOverrides) {
    await this.quickbooksExportInvoicesRaw(requestParameters, initOverrides);
  }
  /**
   */
  async quickbooksGetCustomersRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/quickbooks/customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => QuickBooksGetCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async quickbooksGetCustomers(requestParameters = {}, initOverrides) {
    const response = await this.quickbooksGetCustomersRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async quickbooksGetDepositToAccountsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/quickbooks/deposit-to-accounts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => QuickBooksGetDepositToAccountsResponseFromJSON(jsonValue));
  }
  /**
   */
  async quickbooksGetDepositToAccounts(initOverrides) {
    const response = await this.quickbooksGetDepositToAccountsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async quickbooksGetProductsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/quickbooks/products`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => QuickBooksGetProductsResponseFromJSON(jsonValue));
  }
  /**
   */
  async quickbooksGetProducts(requestParameters = {}, initOverrides) {
    const response = await this.quickbooksGetProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async rawSignupRaw(requestParameters, initOverrides) {
    if (requestParameters.signupRawRequest === null || requestParameters.signupRawRequest === void 0) {
      throw new RequiredError("signupRawRequest", "Required parameter requestParameters.signupRawRequest was null or undefined when calling rawSignup.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/auth/signup/raw`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SignupRawRequestToJSON(requestParameters.signupRawRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SignupRawResponseFromJSON(jsonValue));
  }
  /**
   */
  async rawSignup(requestParameters, initOverrides) {
    const response = await this.rawSignupRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async receivePaymentRaw(requestParameters, initOverrides) {
    if (requestParameters.receivePaymentRequest === null || requestParameters.receivePaymentRequest === void 0) {
      throw new RequiredError("receivePaymentRequest", "Required parameter requestParameters.receivePaymentRequest was null or undefined when calling receivePayment.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/receive-payment`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ReceivePaymentRequestToJSON(requestParameters.receivePaymentRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async receivePayment(requestParameters, initOverrides) {
    await this.receivePaymentRaw(requestParameters, initOverrides);
  }
  /**
   */
  async refreshTokenRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request({
      path: `/auth/refresh-token`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RefreshTokenResponseFromJSON(jsonValue));
  }
  /**
   */
  async refreshToken(initOverrides) {
    const response = await this.refreshTokenRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async refundInvoiceRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling refundInvoice.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/refund/{invoiceId}`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RefundInvoiceResponseFromJSON(jsonValue));
  }
  /**
   */
  async refundInvoice(requestParameters, initOverrides) {
    const response = await this.refundInvoiceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async removeCustomerNoteRaw(requestParameters, initOverrides) {
    if (requestParameters.noteId === null || requestParameters.noteId === void 0) {
      throw new RequiredError("noteId", "Required parameter requestParameters.noteId was null or undefined when calling removeCustomerNote.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer-note/{noteId}`.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters.noteId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RemoveCustomerNoteResponseFromJSON(jsonValue));
  }
  /**
   */
  async removeCustomerNote(requestParameters, initOverrides) {
    const response = await this.removeCustomerNoteRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async removeUserRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling removeUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async removeUser(requestParameters, initOverrides) {
    await this.removeUserRaw(requestParameters, initOverrides);
  }
  /**
   */
  async removeWorkflowRaw(requestParameters, initOverrides) {
    if (requestParameters.id === null || requestParameters.id === void 0) {
      throw new RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling removeWorkflow.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/workflows/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response);
  }
  /**
   */
  async removeWorkflow(requestParameters, initOverrides) {
    const response = await this.removeWorkflowRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async renewContractRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling renewContract.");
    }
    if (requestParameters.renewContractRequest === null || requestParameters.renewContractRequest === void 0) {
      throw new RequiredError("renewContractRequest", "Required parameter requestParameters.renewContractRequest was null or undefined when calling renewContract.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/renew/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RenewContractRequestToJSON(requestParameters.renewContractRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => RenewContractResponseFromJSON(jsonValue));
  }
  /**
   */
  async renewContract(requestParameters, initOverrides) {
    const response = await this.renewContractRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async resetPasswordRaw(requestParameters, initOverrides) {
    if (requestParameters.resetPasswordRequest === null || requestParameters.resetPasswordRequest === void 0) {
      throw new RequiredError("resetPasswordRequest", "Required parameter requestParameters.resetPasswordRequest was null or undefined when calling resetPassword.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/auth/reset-password`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ResetPasswordRequestToJSON(requestParameters.resetPasswordRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ResetPasswordResponseFromJSON(jsonValue));
  }
  /**
   */
  async resetPassword(requestParameters, initOverrides) {
    const response = await this.resetPasswordRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async reviseContractRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling reviseContract.");
    }
    if (requestParameters.reviseContractRequest === null || requestParameters.reviseContractRequest === void 0) {
      throw new RequiredError("reviseContractRequest", "Required parameter requestParameters.reviseContractRequest was null or undefined when calling reviseContract.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/revise/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ReviseContractRequestToJSON(requestParameters.reviseContractRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async reviseContract(requestParameters, initOverrides) {
    await this.reviseContractRaw(requestParameters, initOverrides);
  }
  /**
   */
  async revokeTokenRaw(requestParameters, initOverrides) {
    if (requestParameters.revokeTokenRequest === null || requestParameters.revokeTokenRequest === void 0) {
      throw new RequiredError("revokeTokenRequest", "Required parameter requestParameters.revokeTokenRequest was null or undefined when calling revokeToken.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer-portal/revoke-token`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: RevokeTokenRequestToJSON(requestParameters.revokeTokenRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async revokeToken(requestParameters, initOverrides) {
    await this.revokeTokenRaw(requestParameters, initOverrides);
  }
  /**
   */
  async salesforceConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.salesforceConnectRequest === null || requestParameters.salesforceConnectRequest === void 0) {
      throw new RequiredError("salesforceConnectRequest", "Required parameter requestParameters.salesforceConnectRequest was null or undefined when calling salesforceConnect.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/salesforce/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SalesforceConnectRequestToJSON(requestParameters.salesforceConnectRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async salesforceConnect(requestParameters, initOverrides) {
    await this.salesforceConnectRaw(requestParameters, initOverrides);
  }
  /**
   */
  async salesforceGetContractCustomFieldsRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling salesforceGetContractCustomFields.");
    }
    const queryParameters = {};
    if (requestParameters.contractId !== void 0) {
      queryParameters["contractId"] = requestParameters.contractId;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/salesforce/contract-custom-fields`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SalesforceGetContractContractCustomFieldsResponseFromJSON(jsonValue));
  }
  /**
   */
  async salesforceGetContractCustomFields(requestParameters, initOverrides) {
    const response = await this.salesforceGetContractCustomFieldsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async salesforceImportCustomersRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/salesforce/import-customers`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(SalesforceImportCustomersResponseInnerFromJSON));
  }
  /**
   */
  async salesforceImportCustomers(initOverrides) {
    const response = await this.salesforceImportCustomersRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async sendGridEventHandlerRaw(requestParameters, initOverrides) {
    if (requestParameters.sendGridEventHandlerRequestSchemaInner === null || requestParameters.sendGridEventHandlerRequestSchemaInner === void 0) {
      throw new RequiredError("sendGridEventHandlerRequestSchemaInner", "Required parameter requestParameters.sendGridEventHandlerRequestSchemaInner was null or undefined when calling sendGridEventHandler.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/sendgrid/events`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.sendGridEventHandlerRequestSchemaInner.map(SendGridEventHandlerRequestSchemaInnerToJSON)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SendGridEventHandlerResponseFromJSON(jsonValue));
  }
  /**
   */
  async sendGridEventHandler(requestParameters, initOverrides) {
    const response = await this.sendGridEventHandlerRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async sendReminderEmailRaw(requestParameters, initOverrides) {
    if (requestParameters.sendReminderEmailRequestSchema === null || requestParameters.sendReminderEmailRequestSchema === void 0) {
      throw new RequiredError("sendReminderEmailRequestSchema", "Required parameter requestParameters.sendReminderEmailRequestSchema was null or undefined when calling sendReminderEmail.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/email/send-reminder`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SendReminderEmailRequestSchemaToJSON(requestParameters.sendReminderEmailRequestSchema)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async sendReminderEmail(requestParameters, initOverrides) {
    await this.sendReminderEmailRaw(requestParameters, initOverrides);
  }
  /**
   */
  async sendSlackCreditNoteNotificationRaw(requestParameters, initOverrides) {
    if (requestParameters.slackSendCreditNoteNotificationRequest === null || requestParameters.slackSendCreditNoteNotificationRequest === void 0) {
      throw new RequiredError("slackSendCreditNoteNotificationRequest", "Required parameter requestParameters.slackSendCreditNoteNotificationRequest was null or undefined when calling sendSlackCreditNoteNotification.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/slack/credit-note-notification`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SlackSendCreditNoteNotificationRequestToJSON(requestParameters.slackSendCreditNoteNotificationRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SlackSendCreditNoteNotificationResponseFromJSON(jsonValue));
  }
  /**
   */
  async sendSlackCreditNoteNotification(requestParameters, initOverrides) {
    const response = await this.sendSlackCreditNoteNotificationRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async sendSlackInvoiceApprovalMessageRaw(requestParameters, initOverrides) {
    if (requestParameters.slackSendInvoiceApprovalMessageRequestSchema === null || requestParameters.slackSendInvoiceApprovalMessageRequestSchema === void 0) {
      throw new RequiredError("slackSendInvoiceApprovalMessageRequestSchema", "Required parameter requestParameters.slackSendInvoiceApprovalMessageRequestSchema was null or undefined when calling sendSlackInvoiceApprovalMessage.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/slack/invoice-approval`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SlackSendInvoiceApprovalMessageRequestSchemaToJSON(requestParameters.slackSendInvoiceApprovalMessageRequestSchema)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SlackSendInvoiceApprovalMessageResponseSchemaFromJSON(jsonValue));
  }
  /**
   */
  async sendSlackInvoiceApprovalMessage(requestParameters, initOverrides) {
    const response = await this.sendSlackInvoiceApprovalMessageRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async setContractAutoRenewalRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling setContractAutoRenewal.");
    }
    if (requestParameters.setContractAutoRenewalRequest === null || requestParameters.setContractAutoRenewalRequest === void 0) {
      throw new RequiredError("setContractAutoRenewalRequest", "Required parameter requestParameters.setContractAutoRenewalRequest was null or undefined when calling setContractAutoRenewal.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/auto-renewal/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SetContractAutoRenewalRequestToJSON(requestParameters.setContractAutoRenewalRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async setContractAutoRenewal(requestParameters, initOverrides) {
    await this.setContractAutoRenewalRaw(requestParameters, initOverrides);
  }
  /**
   */
  async setLineItemCalculationStateRaw(requestParameters, initOverrides) {
    if (requestParameters.lineItemId === null || requestParameters.lineItemId === void 0) {
      throw new RequiredError("lineItemId", "Required parameter requestParameters.lineItemId was null or undefined when calling setLineItemCalculationState.");
    }
    if (requestParameters.setLineItemCalculationStateRequest === null || requestParameters.setLineItemCalculationStateRequest === void 0) {
      throw new RequiredError("setLineItemCalculationStateRequest", "Required parameter requestParameters.setLineItemCalculationStateRequest was null or undefined when calling setLineItemCalculationState.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/line-item/{lineItemId}/calculation-state`.replace(`{${"lineItemId"}}`, encodeURIComponent(String(requestParameters.lineItemId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SetLineItemCalculationStateRequestToJSON(requestParameters.setLineItemCalculationStateRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SetLineItemCalculationStateResponseFromJSON(jsonValue));
  }
  /**
   */
  async setLineItemCalculationState(requestParameters, initOverrides) {
    const response = await this.setLineItemCalculationStateRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async shareCreditNotesRaw(requestParameters, initOverrides) {
    if (requestParameters.shareCreditNotesRequest === null || requestParameters.shareCreditNotesRequest === void 0) {
      throw new RequiredError("shareCreditNotesRequest", "Required parameter requestParameters.shareCreditNotesRequest was null or undefined when calling shareCreditNotes.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-ledger/share`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.shareCreditNotesRequest.map(ShareCreditNotesRequestToJSON)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async shareCreditNotes(requestParameters, initOverrides) {
    await this.shareCreditNotesRaw(requestParameters, initOverrides);
  }
  /**
   */
  async shareInvoicesRaw(requestParameters, initOverrides) {
    if (requestParameters.shareInvoicesRequest === null || requestParameters.shareInvoicesRequest === void 0) {
      throw new RequiredError("shareInvoicesRequest", "Required parameter requestParameters.shareInvoicesRequest was null or undefined when calling shareInvoices.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/share`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.shareInvoicesRequest.map(ShareInvoicesRequestToJSON)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async shareInvoices(requestParameters, initOverrides) {
    await this.shareInvoicesRaw(requestParameters, initOverrides);
  }
  /**
   */
  async signupRaw(requestParameters, initOverrides) {
    if (requestParameters.signupRequest === null || requestParameters.signupRequest === void 0) {
      throw new RequiredError("signupRequest", "Required parameter requestParameters.signupRequest was null or undefined when calling signup.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/auth/signup`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SignupRequestToJSON(requestParameters.signupRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SignupResponseFromJSON(jsonValue));
  }
  /**
   */
  async signup(requestParameters, initOverrides) {
    const response = await this.signupRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async slackCallbackRaw(requestParameters, initOverrides) {
    if (requestParameters.code === null || requestParameters.code === void 0) {
      throw new RequiredError("code", "Required parameter requestParameters.code was null or undefined when calling slackCallback.");
    }
    if (requestParameters.state === null || requestParameters.state === void 0) {
      throw new RequiredError("state", "Required parameter requestParameters.state was null or undefined when calling slackCallback.");
    }
    const queryParameters = {};
    if (requestParameters.code !== void 0) {
      queryParameters["code"] = requestParameters.code;
    }
    if (requestParameters.state !== void 0) {
      queryParameters["state"] = requestParameters.state;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/integrations/slack/auth/callback`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async slackCallback(requestParameters, initOverrides) {
    await this.slackCallbackRaw(requestParameters, initOverrides);
  }
  /**
   */
  async slackConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.redirectUrl === null || requestParameters.redirectUrl === void 0) {
      throw new RequiredError("redirectUrl", "Required parameter requestParameters.redirectUrl was null or undefined when calling slackConnect.");
    }
    const queryParameters = {};
    if (requestParameters.redirectUrl !== void 0) {
      queryParameters["redirectUrl"] = requestParameters.redirectUrl;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/slack/auth/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SlackAuthConnectRedirectResponseSchemaFromJSON(jsonValue));
  }
  /**
   */
  async slackConnect(requestParameters, initOverrides) {
    const response = await this.slackConnectRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async softUpdatePlanRaw(requestParameters, initOverrides) {
    if (requestParameters.planId === null || requestParameters.planId === void 0) {
      throw new RequiredError("planId", "Required parameter requestParameters.planId was null or undefined when calling softUpdatePlan.");
    }
    if (requestParameters.softUpdatePlanRequest === null || requestParameters.softUpdatePlanRequest === void 0) {
      throw new RequiredError("softUpdatePlanRequest", "Required parameter requestParameters.softUpdatePlanRequest was null or undefined when calling softUpdatePlan.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plan/soft/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: SoftUpdatePlanRequestToJSON(requestParameters.softUpdatePlanRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => SoftUpdatePlanResponseFromJSON(jsonValue));
  }
  /**
   */
  async softUpdatePlan(requestParameters, initOverrides) {
    const response = await this.softUpdatePlanRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async stripeConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.stripeConnectRequest === null || requestParameters.stripeConnectRequest === void 0) {
      throw new RequiredError("stripeConnectRequest", "Required parameter requestParameters.stripeConnectRequest was null or undefined when calling stripeConnect.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/stripe/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: StripeConnectRequestToJSON(requestParameters.stripeConnectRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async stripeConnect(requestParameters, initOverrides) {
    await this.stripeConnectRaw(requestParameters, initOverrides);
  }
  /**
   */
  async stripeCreateCustomerRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling stripeCreateCustomer.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/stripe/customer/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => StripeCreateCustomerResponseFromJSON(jsonValue));
  }
  /**
   */
  async stripeCreateCustomer(requestParameters, initOverrides) {
    const response = await this.stripeCreateCustomerRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async stripeCreateInvoiceRaw(requestParameters, initOverrides) {
    if (requestParameters.stripeCreateInvoiceRequest === null || requestParameters.stripeCreateInvoiceRequest === void 0) {
      throw new RequiredError("stripeCreateInvoiceRequest", "Required parameter requestParameters.stripeCreateInvoiceRequest was null or undefined when calling stripeCreateInvoice.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/stripe/invoice`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: StripeCreateInvoiceRequestToJSON(requestParameters.stripeCreateInvoiceRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(StripeCreateInvoiceResponseInnerFromJSON));
  }
  /**
   */
  async stripeCreateInvoice(requestParameters, initOverrides) {
    const response = await this.stripeCreateInvoiceRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async stripeEventRaw(requestParameters, initOverrides) {
    if (requestParameters.stripeEventAccountId === null || requestParameters.stripeEventAccountId === void 0) {
      throw new RequiredError("stripeEventAccountId", "Required parameter requestParameters.stripeEventAccountId was null or undefined when calling stripeEvent.");
    }
    if (requestParameters.body === null || requestParameters.body === void 0) {
      throw new RequiredError("body", "Required parameter requestParameters.body was null or undefined when calling stripeEvent.");
    }
    const queryParameters = {};
    if (requestParameters.stripeEventAccountId !== void 0) {
      queryParameters["stripeEventAccountId"] = requestParameters.stripeEventAccountId;
    }
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    const response = await this.request({
      path: `/integrations/stripe/event`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: requestParameters.body
    }, initOverrides);
    return new JSONApiResponse(response);
  }
  /**
   */
  async stripeEvent(requestParameters, initOverrides) {
    const response = await this.stripeEventRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async stripeGetCustomersRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.searchTerm !== void 0) {
      queryParameters["searchTerm"] = requestParameters.searchTerm;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/stripe/customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => StripeGetCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async stripeGetCustomers(requestParameters = {}, initOverrides) {
    const response = await this.stripeGetCustomersRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async terminateContractRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling terminateContract.");
    }
    if (requestParameters.terminateContractRequest === null || requestParameters.terminateContractRequest === void 0) {
      throw new RequiredError("terminateContractRequest", "Required parameter requestParameters.terminateContractRequest was null or undefined when calling terminateContract.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/terminate/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TerminateContractRequestToJSON(requestParameters.terminateContractRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async terminateContract(requestParameters, initOverrides) {
    await this.terminateContractRaw(requestParameters, initOverrides);
  }
  /**
   */
  async triggerLineItemsCalculatorRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/line-items/trigger-calculator`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async triggerLineItemsCalculator(initOverrides) {
    await this.triggerLineItemsCalculatorRaw(initOverrides);
  }
  /**
   */
  async triggerReportJobRaw(requestParameters, initOverrides) {
    if (requestParameters.triggerReportJobRequest === null || requestParameters.triggerReportJobRequest === void 0) {
      throw new RequiredError("triggerReportJobRequest", "Required parameter requestParameters.triggerReportJobRequest was null or undefined when calling triggerReportJob.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/trigger`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TriggerReportJobRequestToJSON(requestParameters.triggerReportJobRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => TriggerReportJobResponseFromJSON(jsonValue));
  }
  /**
   */
  async triggerReportJob(requestParameters, initOverrides) {
    const response = await this.triggerReportJobRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async undoLineItemPriceOverrideRaw(requestParameters, initOverrides) {
    if (requestParameters.lineItemId === null || requestParameters.lineItemId === void 0) {
      throw new RequiredError("lineItemId", "Required parameter requestParameters.lineItemId was null or undefined when calling undoLineItemPriceOverride.");
    }
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/line-item/{lineItemId}/undo-price-override`.replace(`{${"lineItemId"}}`, encodeURIComponent(String(requestParameters.lineItemId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UndoLineItemPriceOverrideResponseFromJSON(jsonValue));
  }
  /**
   */
  async undoLineItemPriceOverride(requestParameters, initOverrides) {
    const response = await this.undoLineItemPriceOverrideRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateAccountRaw(requestParameters, initOverrides) {
    if (requestParameters.updateAccountRequest === null || requestParameters.updateAccountRequest === void 0) {
      throw new RequiredError("updateAccountRequest", "Required parameter requestParameters.updateAccountRequest was null or undefined when calling updateAccount.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/account`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateAccountRequestToJSON(requestParameters.updateAccountRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateAccountResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateAccount(requestParameters, initOverrides) {
    const response = await this.updateAccountRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateAccountLogoRaw(requestParameters, initOverrides) {
    if (requestParameters.updateAccountLogoRequest === null || requestParameters.updateAccountLogoRequest === void 0) {
      throw new RequiredError("updateAccountLogoRequest", "Required parameter requestParameters.updateAccountLogoRequest was null or undefined when calling updateAccountLogo.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/account/logo`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateAccountLogoRequestToJSON(requestParameters.updateAccountLogoRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async updateAccountLogo(requestParameters, initOverrides) {
    await this.updateAccountLogoRaw(requestParameters, initOverrides);
  }
  /**
   */
  async updateBillingCycleRaw(requestParameters, initOverrides) {
    if (requestParameters.billingCycleId === null || requestParameters.billingCycleId === void 0) {
      throw new RequiredError("billingCycleId", "Required parameter requestParameters.billingCycleId was null or undefined when calling updateBillingCycle.");
    }
    if (requestParameters.updateBillingCycleRequest === null || requestParameters.updateBillingCycleRequest === void 0) {
      throw new RequiredError("updateBillingCycleRequest", "Required parameter requestParameters.updateBillingCycleRequest was null or undefined when calling updateBillingCycle.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/billing-cycle/{billingCycleId}`.replace(`{${"billingCycleId"}}`, encodeURIComponent(String(requestParameters.billingCycleId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateBillingCycleRequestToJSON(requestParameters.updateBillingCycleRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateBillingCycleResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateBillingCycle(requestParameters, initOverrides) {
    const response = await this.updateBillingCycleRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateCatalogProductsRaw(requestParameters, initOverrides) {
    if (requestParameters.catalogProductId === null || requestParameters.catalogProductId === void 0) {
      throw new RequiredError("catalogProductId", "Required parameter requestParameters.catalogProductId was null or undefined when calling updateCatalogProducts.");
    }
    if (requestParameters.updateCatalogProductsRequest === null || requestParameters.updateCatalogProductsRequest === void 0) {
      throw new RequiredError("updateCatalogProductsRequest", "Required parameter requestParameters.updateCatalogProductsRequest was null or undefined when calling updateCatalogProducts.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/catalog-products/{catalogProductId}`.replace(`{${"catalogProductId"}}`, encodeURIComponent(String(requestParameters.catalogProductId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateCatalogProductsRequestToJSON(requestParameters.updateCatalogProductsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateCatalogProductsResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateCatalogProducts(requestParameters, initOverrides) {
    const response = await this.updateCatalogProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateContractRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling updateContract.");
    }
    if (requestParameters.updateContractRequest === null || requestParameters.updateContractRequest === void 0) {
      throw new RequiredError("updateContractRequest", "Required parameter requestParameters.updateContractRequest was null or undefined when calling updateContract.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateContractRequestToJSON(requestParameters.updateContractRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateContractResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateContract(requestParameters, initOverrides) {
    const response = await this.updateContractRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateContractCustomFieldValueRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling updateContractCustomFieldValue.");
    }
    if (requestParameters.customFieldDefinitionId === null || requestParameters.customFieldDefinitionId === void 0) {
      throw new RequiredError("customFieldDefinitionId", "Required parameter requestParameters.customFieldDefinitionId was null or undefined when calling updateContractCustomFieldValue.");
    }
    if (requestParameters.updateContractCustomFieldValueRequest === null || requestParameters.updateContractCustomFieldValueRequest === void 0) {
      throw new RequiredError("updateContractCustomFieldValueRequest", "Required parameter requestParameters.updateContractCustomFieldValueRequest was null or undefined when calling updateContractCustomFieldValue.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/custom-fields/{customFieldDefinitionId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))).replace(`{${"customFieldDefinitionId"}}`, encodeURIComponent(String(requestParameters.customFieldDefinitionId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateContractCustomFieldValueRequestToJSON(requestParameters.updateContractCustomFieldValueRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateContractCustomFieldValueResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateContractCustomFieldValue(requestParameters, initOverrides) {
    const response = await this.updateContractCustomFieldValueRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateContractEndDateRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling updateContractEndDate.");
    }
    if (requestParameters.updateContractEndDateRequest === null || requestParameters.updateContractEndDateRequest === void 0) {
      throw new RequiredError("updateContractEndDateRequest", "Required parameter requestParameters.updateContractEndDateRequest was null or undefined when calling updateContractEndDate.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/end-date/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateContractEndDateRequestToJSON(requestParameters.updateContractEndDateRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async updateContractEndDate(requestParameters, initOverrides) {
    await this.updateContractEndDateRaw(requestParameters, initOverrides);
  }
  /**
   */
  async updateContractLabelsRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling updateContractLabels.");
    }
    if (requestParameters.updateContractLabelsRequest === null || requestParameters.updateContractLabelsRequest === void 0) {
      throw new RequiredError("updateContractLabelsRequest", "Required parameter requestParameters.updateContractLabelsRequest was null or undefined when calling updateContractLabels.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/{contractId}/labels`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateContractLabelsRequestToJSON(requestParameters.updateContractLabelsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateContractLabelsResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateContractLabels(requestParameters, initOverrides) {
    const response = await this.updateContractLabelsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateContractMemoRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling updateContractMemo.");
    }
    if (requestParameters.updateContractMemoRequest === null || requestParameters.updateContractMemoRequest === void 0) {
      throw new RequiredError("updateContractMemoRequest", "Required parameter requestParameters.updateContractMemoRequest was null or undefined when calling updateContractMemo.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/memo/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateContractMemoRequestToJSON(requestParameters.updateContractMemoRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateContractMemoResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateContractMemo(requestParameters, initOverrides) {
    const response = await this.updateContractMemoRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateContractStatusRaw(requestParameters, initOverrides) {
    if (requestParameters.contractId === null || requestParameters.contractId === void 0) {
      throw new RequiredError("contractId", "Required parameter requestParameters.contractId was null or undefined when calling updateContractStatus.");
    }
    if (requestParameters.updateContractStatusRequest === null || requestParameters.updateContractStatusRequest === void 0) {
      throw new RequiredError("updateContractStatusRequest", "Required parameter requestParameters.updateContractStatusRequest was null or undefined when calling updateContractStatus.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/contract/status/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters.contractId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateContractStatusRequestToJSON(requestParameters.updateContractStatusRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateContractStatusResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateContractStatus(requestParameters, initOverrides) {
    const response = await this.updateContractStatusRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateCreditTypeRaw(requestParameters, initOverrides) {
    if (requestParameters.creditTypeId === null || requestParameters.creditTypeId === void 0) {
      throw new RequiredError("creditTypeId", "Required parameter requestParameters.creditTypeId was null or undefined when calling updateCreditType.");
    }
    if (requestParameters.updateCreditTypeRequest === null || requestParameters.updateCreditTypeRequest === void 0) {
      throw new RequiredError("updateCreditTypeRequest", "Required parameter requestParameters.updateCreditTypeRequest was null or undefined when calling updateCreditType.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/credit-types/{creditTypeId}`.replace(`{${"creditTypeId"}}`, encodeURIComponent(String(requestParameters.creditTypeId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateCreditTypeRequestToJSON(requestParameters.updateCreditTypeRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateCreditTypeResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateCreditType(requestParameters, initOverrides) {
    const response = await this.updateCreditTypeRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateCustomerRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling updateCustomer.");
    }
    if (requestParameters.updateCustomerRequest === null || requestParameters.updateCustomerRequest === void 0) {
      throw new RequiredError("updateCustomerRequest", "Required parameter requestParameters.updateCustomerRequest was null or undefined when calling updateCustomer.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer/{customerId}`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateCustomerRequestToJSON(requestParameters.updateCustomerRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateCustomerResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateCustomer(requestParameters, initOverrides) {
    const response = await this.updateCustomerRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateCustomerLabelsRaw(requestParameters, initOverrides) {
    if (requestParameters.customerId === null || requestParameters.customerId === void 0) {
      throw new RequiredError("customerId", "Required parameter requestParameters.customerId was null or undefined when calling updateCustomerLabels.");
    }
    if (requestParameters.updateCustomerLabelsRequest === null || requestParameters.updateCustomerLabelsRequest === void 0) {
      throw new RequiredError("updateCustomerLabelsRequest", "Required parameter requestParameters.updateCustomerLabelsRequest was null or undefined when calling updateCustomerLabels.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/customer/{customerId}/labels`.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters.customerId))),
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateCustomerLabelsRequestToJSON(requestParameters.updateCustomerLabelsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateCustomerLabelsResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateCustomerLabels(requestParameters, initOverrides) {
    const response = await this.updateCustomerLabelsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateIntegrationConfigurationRaw(requestParameters, initOverrides) {
    if (requestParameters.updateIntegrationConfigurationRequest === null || requestParameters.updateIntegrationConfigurationRequest === void 0) {
      throw new RequiredError("updateIntegrationConfigurationRequest", "Required parameter requestParameters.updateIntegrationConfigurationRequest was null or undefined when calling updateIntegrationConfiguration.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/configuration`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateIntegrationConfigurationRequestToJSON(requestParameters.updateIntegrationConfigurationRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateIntegrationConfigurationResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateIntegrationConfiguration(requestParameters, initOverrides) {
    const response = await this.updateIntegrationConfigurationRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateInvoiceAdditionalDetailsRaw(requestParameters, initOverrides) {
    if (requestParameters.updateInvoiceAdditionalDetailsRequest === null || requestParameters.updateInvoiceAdditionalDetailsRequest === void 0) {
      throw new RequiredError("updateInvoiceAdditionalDetailsRequest", "Required parameter requestParameters.updateInvoiceAdditionalDetailsRequest was null or undefined when calling updateInvoiceAdditionalDetails.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/additional-details`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateInvoiceAdditionalDetailsRequestToJSON(requestParameters.updateInvoiceAdditionalDetailsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateInvoiceAdditionalDetailsResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateInvoiceAdditionalDetails(requestParameters, initOverrides) {
    const response = await this.updateInvoiceAdditionalDetailsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateInvoiceCurrencyRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling updateInvoiceCurrency.");
    }
    if (requestParameters.updateInvoiceCurrencyRequest === null || requestParameters.updateInvoiceCurrencyRequest === void 0) {
      throw new RequiredError("updateInvoiceCurrencyRequest", "Required parameter requestParameters.updateInvoiceCurrencyRequest was null or undefined when calling updateInvoiceCurrency.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/{invoiceId}/currency`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateInvoiceCurrencyRequestToJSON(requestParameters.updateInvoiceCurrencyRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateInvoiceCurrencyResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateInvoiceCurrency(requestParameters, initOverrides) {
    const response = await this.updateInvoiceCurrencyRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateInvoiceIssueDateRaw(requestParameters, initOverrides) {
    if (requestParameters.invoiceId === null || requestParameters.invoiceId === void 0) {
      throw new RequiredError("invoiceId", "Required parameter requestParameters.invoiceId was null or undefined when calling updateInvoiceIssueDate.");
    }
    if (requestParameters.updateInvoiceIssueDateRequest === null || requestParameters.updateInvoiceIssueDateRequest === void 0) {
      throw new RequiredError("updateInvoiceIssueDateRequest", "Required parameter requestParameters.updateInvoiceIssueDateRequest was null or undefined when calling updateInvoiceIssueDate.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoice/{invoiceId}/issue-date`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateInvoiceIssueDateRequestToJSON(requestParameters.updateInvoiceIssueDateRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateInvoiceIssueDateResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateInvoiceIssueDate(requestParameters, initOverrides) {
    const response = await this.updateInvoiceIssueDateRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateInvoicesAdditionalDetailsRaw(requestParameters, initOverrides) {
    if (requestParameters.updateInvoicesAdditionalDetailsRequest === null || requestParameters.updateInvoicesAdditionalDetailsRequest === void 0) {
      throw new RequiredError("updateInvoicesAdditionalDetailsRequest", "Required parameter requestParameters.updateInvoicesAdditionalDetailsRequest was null or undefined when calling updateInvoicesAdditionalDetails.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/additional-details`,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateInvoicesAdditionalDetailsRequestToJSON(requestParameters.updateInvoicesAdditionalDetailsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateInvoicesAdditionalDetailsResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateInvoicesAdditionalDetails(requestParameters, initOverrides) {
    const response = await this.updateInvoicesAdditionalDetailsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateInvoicesBillingStatusesRaw(requestParameters, initOverrides) {
    if (requestParameters.updateInvoicesBillingStatusesRequest === null || requestParameters.updateInvoicesBillingStatusesRequest === void 0) {
      throw new RequiredError("updateInvoicesBillingStatusesRequest", "Required parameter requestParameters.updateInvoicesBillingStatusesRequest was null or undefined when calling updateInvoicesBillingStatuses.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/billing-statuses`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateInvoicesBillingStatusesRequestToJSON(requestParameters.updateInvoicesBillingStatusesRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateInvoicesBillingStatusesResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateInvoicesBillingStatuses(requestParameters, initOverrides) {
    const response = await this.updateInvoicesBillingStatusesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateInvoicesReviewStatusesRaw(requestParameters, initOverrides) {
    if (requestParameters.updateInvoicesReviewStatusesRequest === null || requestParameters.updateInvoicesReviewStatusesRequest === void 0) {
      throw new RequiredError("updateInvoicesReviewStatusesRequest", "Required parameter requestParameters.updateInvoicesReviewStatusesRequest was null or undefined when calling updateInvoicesReviewStatuses.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/invoices/review-statuses`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateInvoicesReviewStatusesRequestToJSON(requestParameters.updateInvoicesReviewStatusesRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateInvoicesReviewStatusesResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateInvoicesReviewStatuses(requestParameters, initOverrides) {
    const response = await this.updateInvoicesReviewStatusesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateJobNotificationsReadStatusRaw(requestParameters, initOverrides) {
    if (requestParameters.updateJobNotificationsReadStatusRequest === null || requestParameters.updateJobNotificationsReadStatusRequest === void 0) {
      throw new RequiredError("updateJobNotificationsReadStatusRequest", "Required parameter requestParameters.updateJobNotificationsReadStatusRequest was null or undefined when calling updateJobNotificationsReadStatus.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/jobs/notifications/read-status`,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateJobNotificationsReadStatusRequestToJSON(requestParameters.updateJobNotificationsReadStatusRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => jsonValue.map(ListJobsResponseInnerNotificationFromJSON));
  }
  /**
   */
  async updateJobNotificationsReadStatus(requestParameters, initOverrides) {
    const response = await this.updateJobNotificationsReadStatusRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateLabelRaw(requestParameters, initOverrides) {
    if (requestParameters.labelId === null || requestParameters.labelId === void 0) {
      throw new RequiredError("labelId", "Required parameter requestParameters.labelId was null or undefined when calling updateLabel.");
    }
    if (requestParameters.updateLabelRequest === null || requestParameters.updateLabelRequest === void 0) {
      throw new RequiredError("updateLabelRequest", "Required parameter requestParameters.updateLabelRequest was null or undefined when calling updateLabel.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/labels/{labelId}`.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters.labelId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateLabelRequestToJSON(requestParameters.updateLabelRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateLabelResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateLabel(requestParameters, initOverrides) {
    const response = await this.updateLabelRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateLineItemRaw(requestParameters, initOverrides) {
    if (requestParameters.lineItemId === null || requestParameters.lineItemId === void 0) {
      throw new RequiredError("lineItemId", "Required parameter requestParameters.lineItemId was null or undefined when calling updateLineItem.");
    }
    if (requestParameters.updateLineItemRequest === null || requestParameters.updateLineItemRequest === void 0) {
      throw new RequiredError("updateLineItemRequest", "Required parameter requestParameters.updateLineItemRequest was null or undefined when calling updateLineItem.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/line-item/{lineItemId}`.replace(`{${"lineItemId"}}`, encodeURIComponent(String(requestParameters.lineItemId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateLineItemRequestToJSON(requestParameters.updateLineItemRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateLineItemResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateLineItem(requestParameters, initOverrides) {
    const response = await this.updateLineItemRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateLineItemIntegrationEntitiesRaw(requestParameters, initOverrides) {
    if (requestParameters.lineItemId === null || requestParameters.lineItemId === void 0) {
      throw new RequiredError("lineItemId", "Required parameter requestParameters.lineItemId was null or undefined when calling updateLineItemIntegrationEntities.");
    }
    if (requestParameters.updateLineItemIntegrationEntitiesRequest === null || requestParameters.updateLineItemIntegrationEntitiesRequest === void 0) {
      throw new RequiredError("updateLineItemIntegrationEntitiesRequest", "Required parameter requestParameters.updateLineItemIntegrationEntitiesRequest was null or undefined when calling updateLineItemIntegrationEntities.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/line-item/{lineItemId}/integration-entities`.replace(`{${"lineItemId"}}`, encodeURIComponent(String(requestParameters.lineItemId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateLineItemIntegrationEntitiesRequestToJSON(requestParameters.updateLineItemIntegrationEntitiesRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async updateLineItemIntegrationEntities(requestParameters, initOverrides) {
    await this.updateLineItemIntegrationEntitiesRaw(requestParameters, initOverrides);
  }
  /**
   */
  async updateLineItemsRaw(requestParameters, initOverrides) {
    if (requestParameters.updateLineItemsRequest === null || requestParameters.updateLineItemsRequest === void 0) {
      throw new RequiredError("updateLineItemsRequest", "Required parameter requestParameters.updateLineItemsRequest was null or undefined when calling updateLineItems.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/line-items/bulk-update`,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateLineItemsRequestToJSON(requestParameters.updateLineItemsRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateLineItemsResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateLineItems(requestParameters, initOverrides) {
    const response = await this.updateLineItemsRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateMeasurementRaw(requestParameters, initOverrides) {
    if (requestParameters.measurementId === null || requestParameters.measurementId === void 0) {
      throw new RequiredError("measurementId", "Required parameter requestParameters.measurementId was null or undefined when calling updateMeasurement.");
    }
    if (requestParameters.updateMeasurementRequest === null || requestParameters.updateMeasurementRequest === void 0) {
      throw new RequiredError("updateMeasurementRequest", "Required parameter requestParameters.updateMeasurementRequest was null or undefined when calling updateMeasurement.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurement/{measurementId}`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters.measurementId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateMeasurementRequestToJSON(requestParameters.updateMeasurementRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateMeasurementResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateMeasurement(requestParameters, initOverrides) {
    const response = await this.updateMeasurementRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateMeterRaw(requestParameters, initOverrides) {
    if (requestParameters.meterId === null || requestParameters.meterId === void 0) {
      throw new RequiredError("meterId", "Required parameter requestParameters.meterId was null or undefined when calling updateMeter.");
    }
    if (requestParameters.updateMeterRequest === null || requestParameters.updateMeterRequest === void 0) {
      throw new RequiredError("updateMeterRequest", "Required parameter requestParameters.updateMeterRequest was null or undefined when calling updateMeter.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/meter/{meterId}`.replace(`{${"meterId"}}`, encodeURIComponent(String(requestParameters.meterId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateMeterRequestToJSON(requestParameters.updateMeterRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async updateMeter(requestParameters, initOverrides) {
    await this.updateMeterRaw(requestParameters, initOverrides);
  }
  /**
   */
  async updateNotificationAlertStatusRaw(requestParameters, initOverrides) {
    if (requestParameters.notificationAlertId === null || requestParameters.notificationAlertId === void 0) {
      throw new RequiredError("notificationAlertId", "Required parameter requestParameters.notificationAlertId was null or undefined when calling updateNotificationAlertStatus.");
    }
    if (requestParameters.updateNotificationAlertStatusRequest === null || requestParameters.updateNotificationAlertStatusRequest === void 0) {
      throw new RequiredError("updateNotificationAlertStatusRequest", "Required parameter requestParameters.updateNotificationAlertStatusRequest was null or undefined when calling updateNotificationAlertStatus.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/notification-alert/{notificationAlertId}/status`.replace(`{${"notificationAlertId"}}`, encodeURIComponent(String(requestParameters.notificationAlertId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateNotificationAlertStatusRequestToJSON(requestParameters.updateNotificationAlertStatusRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateNotificationAlertStatusResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateNotificationAlertStatus(requestParameters, initOverrides) {
    const response = await this.updateNotificationAlertStatusRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updatePlanRaw(requestParameters, initOverrides) {
    if (requestParameters.planId === null || requestParameters.planId === void 0) {
      throw new RequiredError("planId", "Required parameter requestParameters.planId was null or undefined when calling updatePlan.");
    }
    if (requestParameters.updatePlanRequest === null || requestParameters.updatePlanRequest === void 0) {
      throw new RequiredError("updatePlanRequest", "Required parameter requestParameters.updatePlanRequest was null or undefined when calling updatePlan.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/plan/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters.planId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdatePlanRequestToJSON(requestParameters.updatePlanRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdatePlanResponseFromJSON(jsonValue));
  }
  /**
   */
  async updatePlan(requestParameters, initOverrides) {
    const response = await this.updatePlanRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateProductIntegrationEntitiesRaw(requestParameters, initOverrides) {
    if (requestParameters.productId === null || requestParameters.productId === void 0) {
      throw new RequiredError("productId", "Required parameter requestParameters.productId was null or undefined when calling updateProductIntegrationEntities.");
    }
    if (requestParameters.updateProductIntegrationEntitiesRequest === null || requestParameters.updateProductIntegrationEntitiesRequest === void 0) {
      throw new RequiredError("updateProductIntegrationEntitiesRequest", "Required parameter requestParameters.updateProductIntegrationEntitiesRequest was null or undefined when calling updateProductIntegrationEntities.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/product/{productId}/integration-entities`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters.productId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateProductIntegrationEntitiesRequestToJSON(requestParameters.updateProductIntegrationEntitiesRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateProductIntegrationEntitiesResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateProductIntegrationEntities(requestParameters, initOverrides) {
    const response = await this.updateProductIntegrationEntitiesRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateSubsidiaryRaw(requestParameters, initOverrides) {
    if (requestParameters.subsidiaryId === null || requestParameters.subsidiaryId === void 0) {
      throw new RequiredError("subsidiaryId", "Required parameter requestParameters.subsidiaryId was null or undefined when calling updateSubsidiary.");
    }
    if (requestParameters.updateSubsidiaryRequest === null || requestParameters.updateSubsidiaryRequest === void 0) {
      throw new RequiredError("updateSubsidiaryRequest", "Required parameter requestParameters.updateSubsidiaryRequest was null or undefined when calling updateSubsidiary.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/subsidiaries/{subsidiaryId}`.replace(`{${"subsidiaryId"}}`, encodeURIComponent(String(requestParameters.subsidiaryId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateSubsidiaryRequestToJSON(requestParameters.updateSubsidiaryRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateSubsidiaryResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateSubsidiary(requestParameters, initOverrides) {
    const response = await this.updateSubsidiaryRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async updateUserRaw(requestParameters, initOverrides) {
    if (requestParameters.userId === null || requestParameters.userId === void 0) {
      throw new RequiredError("userId", "Required parameter requestParameters.userId was null or undefined when calling updateUser.");
    }
    if (requestParameters.updateUserRequest === null || requestParameters.updateUserRequest === void 0) {
      throw new RequiredError("updateUserRequest", "Required parameter requestParameters.updateUserRequest was null or undefined when calling updateUser.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/users/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UpdateUserRequestToJSON(requestParameters.updateUserRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpdateUserResponseFromJSON(jsonValue));
  }
  /**
   */
  async updateUser(requestParameters, initOverrides) {
    const response = await this.updateUserRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async uploadMeasurementsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurements/upload`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UploadMeasurementsResponseFromJSON(jsonValue));
  }
  /**
   */
  async uploadMeasurements(initOverrides) {
    const response = await this.uploadMeasurementsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async uploadMeasurementsJsonRaw(requestParameters, initOverrides) {
    if (requestParameters.uploadMeasurementsJsonRequest === null || requestParameters.uploadMeasurementsJsonRequest === void 0) {
      throw new RequiredError("uploadMeasurementsJsonRequest", "Required parameter requestParameters.uploadMeasurementsJsonRequest was null or undefined when calling uploadMeasurementsJson.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurements/upload-json`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UploadMeasurementsJsonRequestToJSON(requestParameters.uploadMeasurementsJsonRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UploadMeasurementsJsonResponseFromJSON(jsonValue));
  }
  /**
   */
  async uploadMeasurementsJson(requestParameters, initOverrides) {
    const response = await this.uploadMeasurementsJsonRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async upsertPhaseLabelRaw(requestParameters, initOverrides) {
    if (requestParameters.upsertPhaseLabelRequest === null || requestParameters.upsertPhaseLabelRequest === void 0) {
      throw new RequiredError("upsertPhaseLabelRequest", "Required parameter requestParameters.upsertPhaseLabelRequest was null or undefined when calling upsertPhaseLabel.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/phase-labels`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UpsertPhaseLabelRequestToJSON(requestParameters.upsertPhaseLabelRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpsertPhaseLabelResponseFromJSON(jsonValue));
  }
  /**
   */
  async upsertPhaseLabel(requestParameters, initOverrides) {
    const response = await this.upsertPhaseLabelRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async upsertRevenueRecognitionOverrideRaw(requestParameters, initOverrides) {
    if (requestParameters.variantId === null || requestParameters.variantId === void 0) {
      throw new RequiredError("variantId", "Required parameter requestParameters.variantId was null or undefined when calling upsertRevenueRecognitionOverride.");
    }
    if (requestParameters.upsertRevenueRecognitionOverrideRequest === null || requestParameters.upsertRevenueRecognitionOverrideRequest === void 0) {
      throw new RequiredError("upsertRevenueRecognitionOverrideRequest", "Required parameter requestParameters.upsertRevenueRecognitionOverrideRequest was null or undefined when calling upsertRevenueRecognitionOverride.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/report/revenue-recognition-override/{variantId}`.replace(`{${"variantId"}}`, encodeURIComponent(String(requestParameters.variantId))),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UpsertRevenueRecognitionOverrideRequestToJSON(requestParameters.upsertRevenueRecognitionOverrideRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => UpsertRevenueRecognitionOverrideResponseFromJSON(jsonValue));
  }
  /**
   */
  async upsertRevenueRecognitionOverride(requestParameters, initOverrides) {
    const response = await this.upsertRevenueRecognitionOverrideRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async validateMeasurementDataRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurements/validate`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ValidateMeasurementDataResponseFromJSON(jsonValue));
  }
  /**
   */
  async validateMeasurementData(initOverrides) {
    const response = await this.validateMeasurementDataRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async validateMeasurementsJsonRaw(requestParameters, initOverrides) {
    if (requestParameters.validateMeasurementsJsonRequest === null || requestParameters.validateMeasurementsJsonRequest === void 0) {
      throw new RequiredError("validateMeasurementsJsonRequest", "Required parameter requestParameters.validateMeasurementsJsonRequest was null or undefined when calling validateMeasurementsJson.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/measurements/validate-json`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ValidateMeasurementsJsonRequestToJSON(requestParameters.validateMeasurementsJsonRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => ValidateMeasurementsJsonResponseFromJSON(jsonValue));
  }
  /**
   */
  async validateMeasurementsJson(requestParameters, initOverrides) {
    const response = await this.validateMeasurementsJsonRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async xeroAuthCallbackRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.code !== void 0) {
      queryParameters["code"] = requestParameters.code;
    }
    if (requestParameters.state !== void 0) {
      queryParameters["state"] = requestParameters.state;
    }
    if (requestParameters.error !== void 0) {
      queryParameters["error"] = requestParameters.error;
    }
    const headerParameters = {};
    const response = await this.request({
      path: `/integrations/xero/auth/callback`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async xeroAuthCallback(requestParameters = {}, initOverrides) {
    await this.xeroAuthCallbackRaw(requestParameters, initOverrides);
  }
  /**
   */
  async xeroAuthConnectRaw(requestParameters, initOverrides) {
    if (requestParameters.xeroAuthConnectRequest === null || requestParameters.xeroAuthConnectRequest === void 0) {
      throw new RequiredError("xeroAuthConnectRequest", "Required parameter requestParameters.xeroAuthConnectRequest was null or undefined when calling xeroAuthConnect.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/xero/connect`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: XeroAuthConnectRequestToJSON(requestParameters.xeroAuthConnectRequest)
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => XeroAuthConnectResponseFromJSON(jsonValue));
  }
  /**
   */
  async xeroAuthConnect(requestParameters, initOverrides) {
    const response = await this.xeroAuthConnectRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async xeroExportCreditMemoRaw(requestParameters, initOverrides) {
    if (requestParameters.xeroExportCreditMemoRequest === null || requestParameters.xeroExportCreditMemoRequest === void 0) {
      throw new RequiredError("xeroExportCreditMemoRequest", "Required parameter requestParameters.xeroExportCreditMemoRequest was null or undefined when calling xeroExportCreditMemo.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/xero/export-credit-memo`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: XeroExportCreditMemoRequestToJSON(requestParameters.xeroExportCreditMemoRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async xeroExportCreditMemo(requestParameters, initOverrides) {
    await this.xeroExportCreditMemoRaw(requestParameters, initOverrides);
  }
  /**
   */
  async xeroExportInvoicesRaw(requestParameters, initOverrides) {
    if (requestParameters.xeroExportInvoicesRequest === null || requestParameters.xeroExportInvoicesRequest === void 0) {
      throw new RequiredError("xeroExportInvoicesRequest", "Required parameter requestParameters.xeroExportInvoicesRequest was null or undefined when calling xeroExportInvoices.");
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/xero/export-invoices`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: XeroExportInvoicesRequestToJSON(requestParameters.xeroExportInvoicesRequest)
    }, initOverrides);
    return new VoidApiResponse(response);
  }
  /**
   */
  async xeroExportInvoices(requestParameters, initOverrides) {
    await this.xeroExportInvoicesRaw(requestParameters, initOverrides);
  }
  /**
   */
  async xeroGetCustomersRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/xero/customers`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => XeroGetCustomersResponseFromJSON(jsonValue));
  }
  /**
   */
  async xeroGetCustomers(requestParameters = {}, initOverrides) {
    const response = await this.xeroGetCustomersRaw(requestParameters, initOverrides);
    return await response.value();
  }
  /**
   */
  async xeroGetDepositToAccountsRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/xero/deposit-to-accounts`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => XeroGetDepositToAccountsResponseFromJSON(jsonValue));
  }
  /**
   */
  async xeroGetDepositToAccounts(initOverrides) {
    const response = await this.xeroGetDepositToAccountsRaw(initOverrides);
    return await response.value();
  }
  /**
   */
  async xeroGetProductsRaw(requestParameters, initOverrides) {
    const queryParameters = {};
    if (requestParameters.search !== void 0) {
      queryParameters["search"] = requestParameters.search;
    }
    const headerParameters = {};
    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("BearerAuthorizer", []);
      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request({
      path: `/integrations/xero/products`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters
    }, initOverrides);
    return new JSONApiResponse(response, (jsonValue) => XeroGetProductsResponseFromJSON(jsonValue));
  }
  /**
   */
  async xeroGetProducts(requestParameters = {}, initOverrides) {
    const response = await this.xeroGetProductsRaw(requestParameters, initOverrides);
    return await response.value();
  }
};

// src/index.ts
function getApi(parameters) {
  const apiConfiguration = new Configuration(parameters);
  return new DefaultApi(apiConfiguration);
}
export {
  DefaultApi as WeftApi,
  getApi
};
